import { baseQueriesApi as api } from "./baseQueriesApi";
export const addTagTypes = [
  "Health Check API",
  "Patient Sign Up API",
  "Device Alert API",
  "Command API",
  "Usage Session API",
  "Usage Session Remote Control API",
  "Endpoint API",
  "Temporary Token Operation API",
  "Temporary Credentials API",
  "Device API",
  "Device Certificate API",
  "Interception API",
  "Subscription API",
  "Analytics DB Connection API",
  "Analytics DB API",
  "Analytics DB State API",
  "Report API",
  "File API",
  "Multiple Part File API",
  "Generic Entity API",
  "Measurements API",
  "Measurements V2 API",
  "Email API",
  "Configuration API",
  "SMS API",
  "Invitation API",
  "Landing Page API",
  "Organization API",
  "Registration Code API",
  "Caregiver API",
  "Organization User API",
  "Patient API",
  "Patient Alert API",
  "User API",
  "Code Snippet API",
  "Export Import Configuration API",
  "Entity API",
  "Interception Configuration API",
  "Locale API",
  "Backup API",
  "System API",
  "Template API",
  "Translation API",
  "Plugin-V2 API",
  "Security API",
  "Service User API",
  "Login API",
  "MFA Login API",
  "Self User API",
] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      facadehealthCheck: build.query<FacadehealthCheckApiResponse, FacadehealthCheckApiArg>({
        query: () => ({ url: `/api-gateway/system/healthCheck` }),
        providesTags: ["Health Check API"],
      }),
      assignDevice: build.mutation<AssignDeviceApiResponse, AssignDeviceApiArg>({
        query: (queryArg) => ({
          url: `/api-gateway/v1/devices/assign`,
          method: "POST",
          body: queryArg.assignDeviceFacadeRequest,
        }),
        invalidatesTags: ["Patient Sign Up API"],
      }),
      patientSelfSignUp: build.mutation<PatientSelfSignUpApiResponse, PatientSelfSignUpApiArg>({
        query: (queryArg) => ({
          url: `/api-gateway/v1/sign-up`,
          method: "POST",
          body: queryArg.patientSelfSignUpFacadeRequest,
        }),
        invalidatesTags: ["Patient Sign Up API"],
      }),
      patientAnonymousSelfSignUp: build.mutation<
        PatientAnonymousSelfSignUpApiResponse,
        PatientAnonymousSelfSignUpApiArg
      >({
        query: (queryArg) => ({
          url: `/api-gateway/v1/sign-up/anonymous`,
          method: "POST",
          body: queryArg.patientAnonymousSelfSignUpFacadeRequest,
        }),
        invalidatesTags: ["Patient Sign Up API"],
      }),
      healthCheck: build.query<HealthCheckApiResponse, HealthCheckApiArg>({
        query: () => ({ url: `/device/system/healthCheck` }),
        providesTags: ["Health Check API"],
      }),
      createAlert: build.mutation<CreateAlertApiResponse, CreateAlertApiArg>({
        query: (queryArg) => ({
          url: `/device/v1/devices/${queryArg.deviceId}/alerts`,
          method: "POST",
          body: queryArg.createAlertRequest,
        }),
        invalidatesTags: ["Device Alert API"],
      }),
      deleteAlert: build.mutation<DeleteAlertApiResponse, DeleteAlertApiArg>({
        query: (queryArg) => ({
          url: `/device/v1/devices/${queryArg.deviceId}/alerts/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["Device Alert API"],
      }),
      getAlert: build.query<GetAlertApiResponse, GetAlertApiArg>({
        query: (queryArg) => ({ url: `/device/v1/devices/${queryArg.deviceId}/alerts/${queryArg.id}` }),
        providesTags: ["Device Alert API"],
      }),
      updateAlert: build.mutation<UpdateAlertApiResponse, UpdateAlertApiArg>({
        query: (queryArg) => ({
          url: `/device/v1/devices/${queryArg.deviceId}/alerts/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.updateAlertRequest,
        }),
        invalidatesTags: ["Device Alert API"],
      }),
      createAlertByTemplateName: build.mutation<CreateAlertByTemplateNameApiResponse, CreateAlertByTemplateNameApiArg>({
        query: (queryArg) => ({
          url: `/device/v1/devices/${queryArg.deviceId}/alerts/${queryArg.templateName}`,
          method: "POST",
          body: queryArg.createAlertByTemplateNameRequest,
        }),
        invalidatesTags: ["Device Alert API"],
      }),
      deleteCommand: build.mutation<DeleteCommandApiResponse, DeleteCommandApiArg>({
        query: (queryArg) => ({
          url: `/device/v1/devices/${queryArg.deviceId}/commands/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["Command API"],
      }),
      getCommand: build.query<GetCommandApiResponse, GetCommandApiArg>({
        query: (queryArg) => ({ url: `/device/v1/devices/${queryArg.deviceId}/commands/${queryArg.id}` }),
        providesTags: ["Command API"],
      }),
      stopCommand: build.mutation<StopCommandApiResponse, StopCommandApiArg>({
        query: (queryArg) => ({
          url: `/device/v1/devices/${queryArg.deviceId}/commands/${queryArg.id}/stop`,
          method: "POST",
        }),
        invalidatesTags: ["Command API"],
      }),
      startCommandByTemplateName: build.mutation<
        StartCommandByTemplateNameApiResponse,
        StartCommandByTemplateNameApiArg
      >({
        query: (queryArg) => ({
          url: `/device/v1/devices/${queryArg.deviceId}/commands/${queryArg.templateName}/start`,
          method: "POST",
          body: queryArg.startCommandByTemplateNameRequest,
        }),
        invalidatesTags: ["Command API"],
      }),
      startCommand: build.mutation<StartCommandApiResponse, StartCommandApiArg>({
        query: (queryArg) => ({
          url: `/device/v1/devices/${queryArg.deviceId}/commands/start`,
          method: "POST",
          body: queryArg.startCommandRequest,
        }),
        invalidatesTags: ["Command API"],
      }),
      createSession: build.mutation<CreateSessionApiResponse, CreateSessionApiArg>({
        query: (queryArg) => ({
          url: `/device/v1/devices/${queryArg.deviceId}/usage-sessions`,
          method: "POST",
          body: queryArg.createSessionRequestV2,
        }),
        invalidatesTags: ["Usage Session API"],
      }),
      deleteSession: build.mutation<DeleteSessionApiResponse, DeleteSessionApiArg>({
        query: (queryArg) => ({
          url: `/device/v1/devices/${queryArg.deviceId}/usage-sessions/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["Usage Session API"],
      }),
      getSession: build.query<GetSessionApiResponse, GetSessionApiArg>({
        query: (queryArg) => ({ url: `/device/v1/devices/${queryArg.deviceId}/usage-sessions/${queryArg.id}` }),
        providesTags: ["Usage Session API"],
      }),
      updateSession: build.mutation<UpdateSessionApiResponse, UpdateSessionApiArg>({
        query: (queryArg) => ({
          url: `/device/v1/devices/${queryArg.deviceId}/usage-sessions/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.updateSessionRequestV2,
        }),
        invalidatesTags: ["Usage Session API"],
      }),
      pauseSession: build.mutation<PauseSessionApiResponse, PauseSessionApiArg>({
        query: (queryArg) => ({
          url: `/device/v1/devices/${queryArg.deviceId}/usage-sessions/${queryArg.id}/remote-control/pause`,
          method: "POST",
        }),
        invalidatesTags: ["Usage Session Remote Control API"],
      }),
      resumeSession: build.mutation<ResumeSessionApiResponse, ResumeSessionApiArg>({
        query: (queryArg) => ({
          url: `/device/v1/devices/${queryArg.deviceId}/usage-sessions/${queryArg.id}/remote-control/resume`,
          method: "POST",
        }),
        invalidatesTags: ["Usage Session Remote Control API"],
      }),
      stopSession: build.mutation<StopSessionApiResponse, StopSessionApiArg>({
        query: (queryArg) => ({
          url: `/device/v1/devices/${queryArg.deviceId}/usage-sessions/${queryArg.id}/remote-control/stop`,
          method: "POST",
        }),
        invalidatesTags: ["Usage Session Remote Control API"],
      }),
      startSession: build.mutation<StartSessionApiResponse, StartSessionApiArg>({
        query: (queryArg) => ({
          url: `/device/v1/devices/${queryArg.deviceId}/usage-sessions/remote-control/start`,
          method: "POST",
          body: queryArg.startSessionRequestV2,
        }),
        invalidatesTags: ["Usage Session Remote Control API"],
      }),
      createSessionByUsageType: build.mutation<CreateSessionByUsageTypeApiResponse, CreateSessionByUsageTypeApiArg>({
        query: (queryArg) => ({
          url: `/device/v1/devices/${queryArg.deviceId}/usage-sessions/usage-type/${queryArg.usageType}`,
          method: "POST",
          body: queryArg.createSessionByUsageTypeRequestV2,
        }),
        invalidatesTags: ["Usage Session API"],
      }),
      searchAlerts: build.query<SearchAlertsApiResponse, SearchAlertsApiArg>({
        query: (queryArg) => ({ url: `/device/v1/devices/alerts`, params: { searchRequest: queryArg.searchRequest } }),
        providesTags: ["Device Alert API"],
      }),
      searchCommands: build.query<SearchCommandsApiResponse, SearchCommandsApiArg>({
        query: (queryArg) => ({
          url: `/device/v1/devices/commands`,
          params: { searchRequest: queryArg.searchRequest },
        }),
        providesTags: ["Command API"],
      }),
      searchCurrentAlerts: build.query<SearchCurrentAlertsApiResponse, SearchCurrentAlertsApiArg>({
        query: (queryArg) => ({
          url: `/device/v1/devices/current/alerts`,
          params: { searchRequest: queryArg.searchRequest },
        }),
        providesTags: ["Device Alert API"],
      }),
      searchDeviceSessions: build.query<SearchDeviceSessionsApiResponse, SearchDeviceSessionsApiArg>({
        query: (queryArg) => ({
          url: `/device/v1/devices/current/usage-sessions`,
          params: { searchRequest: queryArg.searchRequest },
        }),
        providesTags: ["Usage Session API"],
      }),
      searchSessions: build.query<SearchSessionsApiResponse, SearchSessionsApiArg>({
        query: (queryArg) => ({
          url: `/device/v1/devices/usage-sessions`,
          params: { searchRequest: queryArg.searchRequest },
        }),
        providesTags: ["Usage Session API"],
      }),
      deleteOrphanSessions: build.mutation<DeleteOrphanSessionsApiResponse, DeleteOrphanSessionsApiArg>({
        query: (queryArg) => ({
          url: `/device/v1/devices/usage-sessions/maintenance/orphans/${queryArg.deleteOrphanSessionsEnum}`,
          method: "DELETE",
        }),
        invalidatesTags: ["Usage Session API"],
      }),
      getEndPoint: build.query<GetEndPointApiResponse, GetEndPointApiArg>({
        query: () => ({ url: `/device/v1/endpoint` }),
        providesTags: ["Endpoint API"],
      }),
      validateTokenOperation: build.query<ValidateTokenOperationApiResponse, ValidateTokenOperationApiArg>({
        query: (queryArg) => ({
          url: `/device/v1/tokens/${queryArg.token}`,
          params: { operation: queryArg.operation, entityId: queryArg.entityId },
        }),
        providesTags: ["Temporary Token Operation API"],
      }),
      executeTokenOperation: build.mutation<ExecuteTokenOperationApiResponse, ExecuteTokenOperationApiArg>({
        query: (queryArg) => ({
          url: `/device/v1/tokens/${queryArg.token}`,
          method: "POST",
          body: queryArg.body,
          params: { operation: queryArg.operation, entityId: queryArg.entityId },
        }),
        invalidatesTags: ["Temporary Token Operation API"],
      }),
      executeTokenOperationGet: build.query<ExecuteTokenOperationGetApiResponse, ExecuteTokenOperationGetApiArg>({
        query: (queryArg) => ({
          url: `/device/v1/tokens/${queryArg.token}/execute`,
          params: { operation: queryArg.operation, entityId: queryArg.entityId, operationData: queryArg.operationData },
        }),
        providesTags: ["Temporary Token Operation API"],
      }),
      getTempCredentialsForOrganizationClient: build.query<
        GetTempCredentialsForOrganizationClientApiResponse,
        GetTempCredentialsForOrganizationClientApiArg
      >({
        query: () => ({ url: `/device/v2/credentials/organization` }),
        providesTags: ["Temporary Credentials API"],
      }),
      searchDevices: build.query<SearchDevicesApiResponse, SearchDevicesApiArg>({
        query: (queryArg) => ({ url: `/device/v2/devices`, params: { searchRequest: queryArg.searchRequest } }),
        providesTags: ["Device API"],
      }),
      registerDevice: build.mutation<RegisterDeviceApiResponse, RegisterDeviceApiArg>({
        query: (queryArg) => ({ url: `/device/v2/devices`, method: "POST", body: queryArg.registerDeviceRequest }),
        invalidatesTags: ["Device API"],
      }),
      deleteDevice: build.mutation<DeleteDeviceApiResponse, DeleteDeviceApiArg>({
        query: (queryArg) => ({ url: `/device/v2/devices/${queryArg.id}`, method: "DELETE" }),
        invalidatesTags: ["Device API"],
      }),
      getDevice: build.query<GetDeviceApiResponse, GetDeviceApiArg>({
        query: (queryArg) => ({ url: `/device/v2/devices/${queryArg.id}` }),
        providesTags: ["Device API"],
      }),
      updateDevice: build.mutation<UpdateDeviceApiResponse, UpdateDeviceApiArg>({
        query: (queryArg) => ({
          url: `/device/v2/devices/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.updateDeviceRequest,
        }),
        invalidatesTags: ["Device API"],
      }),
      deleteCertificate: build.mutation<DeleteCertificateApiResponse, DeleteCertificateApiArg>({
        query: (queryArg) => ({
          url: `/device/v2/devices/${queryArg.id}/certificate`,
          method: "DELETE",
          params: { type: queryArg["type"] },
        }),
        invalidatesTags: ["Device Certificate API"],
      }),
      createCertificate: build.mutation<CreateCertificateApiResponse, CreateCertificateApiArg>({
        query: (queryArg) => ({
          url: `/device/v2/devices/${queryArg.id}/certificate`,
          method: "POST",
          params: { type: queryArg["type"] },
        }),
        invalidatesTags: ["Device Certificate API"],
      }),
      activateCertificate: build.mutation<ActivateCertificateApiResponse, ActivateCertificateApiArg>({
        query: (queryArg) => ({
          url: `/device/v2/devices/${queryArg.id}/certificate/activate`,
          method: "POST",
          params: { type: queryArg["type"] },
        }),
        invalidatesTags: ["Device Certificate API"],
      }),
      getConnectionDetails: build.query<GetConnectionDetailsApiResponse, GetConnectionDetailsApiArg>({
        query: (queryArg) => ({ url: `/device/v2/devices/${queryArg.id}/connection/details` }),
        providesTags: ["Device API"],
      }),
      getTempCredentialsForDevice: build.query<
        GetTempCredentialsForDeviceApiResponse,
        GetTempCredentialsForDeviceApiArg
      >({
        query: (queryArg) => ({ url: `/device/v2/devices/${queryArg.id}/mqtt-credentials` }),
        providesTags: ["Temporary Credentials API"],
      }),
      registerDeviceWithTemplateName: build.mutation<
        RegisterDeviceWithTemplateNameApiResponse,
        RegisterDeviceWithTemplateNameApiArg
      >({
        query: (queryArg) => ({
          url: `/device/v2/devices/templates/${queryArg.templateName}`,
          method: "POST",
          body: queryArg.registerDeviceByTemplateNameRequest,
        }),
        invalidatesTags: ["Device API"],
      }),
      dispatcherhealthCheck: build.query<DispatcherhealthCheckApiResponse, DispatcherhealthCheckApiArg>({
        query: () => ({ url: `/dispatcher/system/healthCheck` }),
        providesTags: ["Health Check API"],
      }),
      searchInterceptions: build.query<SearchInterceptionsApiResponse, SearchInterceptionsApiArg>({
        query: (queryArg) => ({
          url: `/dispatcher/v1/hooks/interceptions`,
          params: { searchRequest: queryArg.searchRequest },
        }),
        providesTags: ["Interception API"],
      }),
      createInterception: build.mutation<CreateInterceptionApiResponse, CreateInterceptionApiArg>({
        query: (queryArg) => ({
          url: `/dispatcher/v1/hooks/interceptions/subscribe`,
          method: "POST",
          body: queryArg.createInterceptionRequest,
        }),
        invalidatesTags: ["Interception API"],
      }),
      deleteInterception: build.mutation<DeleteInterceptionApiResponse, DeleteInterceptionApiArg>({
        query: (queryArg) => ({
          url: `/dispatcher/v1/hooks/interceptions/unsubscribe`,
          method: "POST",
          body: queryArg.deleteInterceptionRequest,
        }),
        invalidatesTags: ["Interception API"],
      }),
      searchSubscriptions: build.query<SearchSubscriptionsApiResponse, SearchSubscriptionsApiArg>({
        query: (queryArg) => ({
          url: `/dispatcher/v1/hooks/notifications`,
          params: { searchRequest: queryArg.searchRequest },
        }),
        providesTags: ["Subscription API"],
      }),
      subscribe: build.mutation<SubscribeApiResponse, SubscribeApiArg>({
        query: (queryArg) => ({
          url: `/dispatcher/v1/hooks/notifications/subscribe`,
          method: "POST",
          body: queryArg.subscribeRequest,
        }),
        invalidatesTags: ["Subscription API"],
      }),
      unsubscribe: build.mutation<UnsubscribeApiResponse, UnsubscribeApiArg>({
        query: (queryArg) => ({
          url: `/dispatcher/v1/hooks/notifications/unsubscribe`,
          method: "POST",
          body: queryArg.unsubscribeRequest,
        }),
        invalidatesTags: ["Subscription API"],
      }),
      dmshealthCheck: build.query<DmshealthCheckApiResponse, DmshealthCheckApiArg>({
        query: () => ({ url: `/dms/system/healthCheck` }),
        providesTags: ["Health Check API"],
      }),
      getAnalyticsDbConnectionDetails: build.query<
        GetAnalyticsDbConnectionDetailsApiResponse,
        GetAnalyticsDbConnectionDetailsApiArg
      >({
        query: () => ({ url: `/dms/v1/analytics/db/connection/details` }),
        providesTags: ["Analytics DB Connection API"],
      }),
      getAnalyticsDbConnectionDetailsOld: build.query<
        GetAnalyticsDbConnectionDetailsOldApiResponse,
        GetAnalyticsDbConnectionDetailsOldApiArg
      >({
        query: () => ({ url: `/dms/v1/analytics/db/connection-details` }),
        providesTags: ["Analytics DB API"],
      }),
      getAnalyticsDbInformationOld: build.query<
        GetAnalyticsDbInformationOldApiResponse,
        GetAnalyticsDbInformationOldApiArg
      >({
        query: () => ({ url: `/dms/v1/analytics/db/information` }),
        providesTags: ["Analytics DB API"],
      }),
      startAnalyticsDbInitializationOld: build.mutation<
        StartAnalyticsDbInitializationOldApiResponse,
        StartAnalyticsDbInitializationOldApiArg
      >({
        query: () => ({ url: `/dms/v1/analytics/db/initialization/start`, method: "POST" }),
        invalidatesTags: ["Analytics DB API"],
      }),
      stopAnalyticsDbInitializationOld: build.mutation<
        StopAnalyticsDbInitializationOldApiResponse,
        StopAnalyticsDbInitializationOldApiArg
      >({
        query: () => ({ url: `/dms/v1/analytics/db/initialization/stop`, method: "POST" }),
        invalidatesTags: ["Analytics DB API"],
      }),
      getAnalyticsDbState: build.query<GetAnalyticsDbStateApiResponse, GetAnalyticsDbStateApiArg>({
        query: () => ({ url: `/dms/v1/analytics/db/state` }),
        providesTags: ["Analytics DB State API"],
      }),
      startAnalyticsDbInitialization: build.mutation<
        StartAnalyticsDbInitializationApiResponse,
        StartAnalyticsDbInitializationApiArg
      >({
        query: () => ({ url: `/dms/v1/analytics/db/state/initialization/start`, method: "POST" }),
        invalidatesTags: ["Analytics DB State API"],
      }),
      stopAnalyticsDbInitialization: build.mutation<
        StopAnalyticsDbInitializationApiResponse,
        StopAnalyticsDbInitializationApiArg
      >({
        query: () => ({ url: `/dms/v1/analytics/db/state/initialization/stop`, method: "POST" }),
        invalidatesTags: ["Analytics DB State API"],
      }),
      stopAnalyticsDbSynchronization: build.mutation<
        StopAnalyticsDbSynchronizationApiResponse,
        StopAnalyticsDbSynchronizationApiArg
      >({
        query: () => ({ url: `/dms/v1/analytics/db/state/synchronization/stop`, method: "POST" }),
        invalidatesTags: ["Analytics DB State API"],
      }),
      stopAnalyticsDbSynchronizationOld: build.mutation<
        StopAnalyticsDbSynchronizationOldApiResponse,
        StopAnalyticsDbSynchronizationOldApiArg
      >({
        query: () => ({ url: `/dms/v1/analytics/db/synchronization/stop`, method: "POST" }),
        invalidatesTags: ["Analytics DB API"],
      }),
      searchReports: build.query<SearchReportsApiResponse, SearchReportsApiArg>({
        query: (queryArg) => ({ url: `/dms/v1/data/reports`, params: { searchRequest: queryArg.searchRequest } }),
        providesTags: ["Report API"],
      }),
      deleteReport: build.mutation<DeleteReportApiResponse, DeleteReportApiArg>({
        query: (queryArg) => ({ url: `/dms/v1/data/reports/${queryArg.id}`, method: "DELETE" }),
        invalidatesTags: ["Report API"],
      }),
      getReport: build.query<GetReportApiResponse, GetReportApiArg>({
        query: (queryArg) => ({ url: `/dms/v1/data/reports/${queryArg.id}` }),
        providesTags: ["Report API"],
      }),
      cancelReport: build.mutation<CancelReportApiResponse, CancelReportApiArg>({
        query: (queryArg) => ({ url: `/dms/v1/data/reports/${queryArg.id}/cancel`, method: "POST" }),
        invalidatesTags: ["Report API"],
      }),
      createReport: build.mutation<CreateReportApiResponse, CreateReportApiArg>({
        query: (queryArg) => ({
          url: `/dms/v1/data/reports/export`,
          method: "POST",
          body: queryArg.createReportRequest,
        }),
        invalidatesTags: ["Report API"],
      }),
      dmsvalidateTokenOperation: build.query<DmsvalidateTokenOperationApiResponse, DmsvalidateTokenOperationApiArg>({
        query: (queryArg) => ({
          url: `/dms/v1/tokens/${queryArg.token}`,
          params: { operation: queryArg.operation, entityId: queryArg.entityId },
        }),
        providesTags: ["Temporary Token Operation API"],
      }),
      dmsexecuteTokenOperation: build.mutation<DmsexecuteTokenOperationApiResponse, DmsexecuteTokenOperationApiArg>({
        query: (queryArg) => ({
          url: `/dms/v1/tokens/${queryArg.token}`,
          method: "POST",
          body: queryArg.body,
          params: { operation: queryArg.operation, entityId: queryArg.entityId },
        }),
        invalidatesTags: ["Temporary Token Operation API"],
      }),
      dmsexecuteTokenOperationGet: build.query<
        DmsexecuteTokenOperationGetApiResponse,
        DmsexecuteTokenOperationGetApiArg
      >({
        query: (queryArg) => ({
          url: `/dms/v1/tokens/${queryArg.token}/execute`,
          params: { operation: queryArg.operation, entityId: queryArg.entityId, operationData: queryArg.operationData },
        }),
        providesTags: ["Temporary Token Operation API"],
      }),
      entityhealthCheck: build.query<EntityhealthCheckApiResponse, EntityhealthCheckApiArg>({
        query: () => ({ url: `/entity/system/healthCheck` }),
        providesTags: ["Health Check API"],
      }),
      filehealthCheck: build.query<FilehealthCheckApiResponse, FilehealthCheckApiArg>({
        query: () => ({ url: `/file/system/healthCheck` }),
        providesTags: ["Health Check API"],
      }),
      getDownloadFileUrl: build.query<GetDownloadFileUrlApiResponse, GetDownloadFileUrlApiArg>({
        query: (queryArg) => ({
          url: `/file/v1/files/${queryArg.id}/download`,
          params: { contentDisposition: queryArg.contentDisposition },
        }),
        providesTags: ["File API"],
      }),
      createUploadFileUrl: build.mutation<CreateUploadFileUrlApiResponse, CreateUploadFileUrlApiArg>({
        query: (queryArg) => ({ url: `/file/v1/files/upload`, method: "POST", body: queryArg.uploadFileUrlRequest }),
        invalidatesTags: ["File API"],
      }),
      createMultiplePartUploadFileUrl: build.mutation<
        CreateMultiplePartUploadFileUrlApiResponse,
        CreateMultiplePartUploadFileUrlApiArg
      >({
        query: (queryArg) => ({
          url: `/file/v1/files/upload/parts`,
          method: "POST",
          body: queryArg.multiplePartUploadFileUrlRequest,
        }),
        invalidatesTags: ["Multiple Part File API"],
      }),
      generateSignedUrlsForMultiplePartFileUpload: build.mutation<
        GenerateSignedUrlsForMultiplePartFileUploadApiResponse,
        GenerateSignedUrlsForMultiplePartFileUploadApiArg
      >({
        query: (queryArg) => ({
          url: `/file/v1/files/upload/parts/${queryArg.id}`,
          method: "POST",
          body: queryArg.multiplePartUploadFileGenerateSignedUrlsRequest,
        }),
        invalidatesTags: ["Multiple Part File API"],
      }),
      saveETagsForMultiplePartFileUpload: build.mutation<
        SaveETagsForMultiplePartFileUploadApiResponse,
        SaveETagsForMultiplePartFileUploadApiArg
      >({
        query: (queryArg) => ({
          url: `/file/v1/files/upload/parts/${queryArg.id}`,
          method: "PUT",
          body: queryArg.multiplePartUploadFileSaveETagRequest,
        }),
        invalidatesTags: ["Multiple Part File API"],
      }),
      cancelMultiplePartUploadFile: build.mutation<
        CancelMultiplePartUploadFileApiResponse,
        CancelMultiplePartUploadFileApiArg
      >({
        query: (queryArg) => ({ url: `/file/v1/files/upload/parts/${queryArg.id}/cancel`, method: "DELETE" }),
        invalidatesTags: ["Multiple Part File API"],
      }),
      completeMultiplePartUploadFile: build.mutation<
        CompleteMultiplePartUploadFileApiResponse,
        CompleteMultiplePartUploadFileApiArg
      >({
        query: (queryArg) => ({
          url: `/file/v1/files/upload/parts/${queryArg.id}/complete`,
          method: "POST",
          body: queryArg.completeMultiplePartUploadFileRequest,
        }),
        invalidatesTags: ["Multiple Part File API"],
      }),
      getGenericEntitySystemHealthCheck: build.query<
        GetGenericEntitySystemHealthCheckApiResponse,
        GetGenericEntitySystemHealthCheckApiArg
      >({
        query: () => ({ url: `/generic-entity/system/healthCheck` }),
        providesTags: ["Health Check API"],
      }),
      searchGenericEntities: build.query<SearchGenericEntitiesApiResponse, SearchGenericEntitiesApiArg>({
        query: (queryArg) => ({
          url: `/generic-entity/v1/generic-entities`,
          params: { searchRequest: queryArg.searchRequest },
        }),
        providesTags: ["Generic Entity API"],
      }),
      createGenericEntity: build.mutation<CreateGenericEntityApiResponse, CreateGenericEntityApiArg>({
        query: (queryArg) => ({
          url: `/generic-entity/v1/generic-entities`,
          method: "POST",
          body: queryArg.createGenericEntityRequest,
        }),
        invalidatesTags: ["Generic Entity API"],
      }),
      deleteGenericEntity: build.mutation<DeleteGenericEntityApiResponse, DeleteGenericEntityApiArg>({
        query: (queryArg) => ({ url: `/generic-entity/v1/generic-entities/${queryArg.id}`, method: "DELETE" }),
        invalidatesTags: ["Generic Entity API"],
      }),
      getGenericEntity: build.query<GetGenericEntityApiResponse, GetGenericEntityApiArg>({
        query: (queryArg) => ({ url: `/generic-entity/v1/generic-entities/${queryArg.id}` }),
        providesTags: ["Generic Entity API"],
      }),
      updateGenericEntity: build.mutation<UpdateGenericEntityApiResponse, UpdateGenericEntityApiArg>({
        query: (queryArg) => ({
          url: `/generic-entity/v1/generic-entities/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.updateGenericEntityRequest,
        }),
        invalidatesTags: ["Generic Entity API"],
      }),
      createGenericEntityByTemplateName: build.mutation<
        CreateGenericEntityByTemplateNameApiResponse,
        CreateGenericEntityByTemplateNameApiArg
      >({
        query: (queryArg) => ({
          url: `/generic-entity/v1/generic-entities/templates/${queryArg.templateName}`,
          method: "POST",
          body: queryArg.createGenericEntityByTemplateNameRequest,
        }),
        invalidatesTags: ["Generic Entity API"],
      }),
      measurementhealthCheck: build.query<MeasurementhealthCheckApiResponse, MeasurementhealthCheckApiArg>({
        query: () => ({ url: `/measurement/system/healthCheck` }),
        providesTags: ["Health Check API"],
      }),
      saveMeasurement: build.mutation<SaveMeasurementApiResponse, SaveMeasurementApiArg>({
        query: (queryArg) => ({
          url: `/measurement/v1/measurements`,
          method: "POST",
          body: queryArg.measurementMessageFromDevice,
        }),
        invalidatesTags: ["Measurements API"],
      }),
      getMeasurements: build.query<GetMeasurementsApiResponse, GetMeasurementsApiArg>({
        query: (queryArg) => ({
          url: `/measurement/v1/measurements/aggregated`,
          params: {
            binIntervalSeconds: queryArg.binIntervalSeconds,
            attributes: queryArg.attributes,
            patientId: queryArg.patientId,
            sourceEntityId: queryArg.sourceEntityId,
            sessionId: queryArg.sessionId,
            startTime: queryArg.startTime,
            endTime: queryArg.endTime,
          },
        }),
        providesTags: ["Measurements API"],
      }),
      saveMeasurementsBulk: build.mutation<SaveMeasurementsBulkApiResponse, SaveMeasurementsBulkApiArg>({
        query: (queryArg) => ({
          url: `/measurement/v1/measurements/bulk`,
          method: "POST",
          body: queryArg.measurementBulkRequest,
        }),
        invalidatesTags: ["Measurements API"],
      }),
      getRawMeasurements: build.query<GetRawMeasurementsApiResponse, GetRawMeasurementsApiArg>({
        query: (queryArg) => ({
          url: `/measurement/v1/measurements/raw`,
          params: {
            attributes: queryArg.attributes,
            patientId: queryArg.patientId,
            sourceEntityId: queryArg.sourceEntityId,
            sessionId: queryArg.sessionId,
            startTime: queryArg.startTime,
            endTime: queryArg.endTime,
          },
        }),
        providesTags: ["Measurements API"],
      }),
      getAggregatedMeasurements: build.query<GetAggregatedMeasurementsApiResponse, GetAggregatedMeasurementsApiArg>({
        query: (queryArg) => ({
          url: `/measurement/v2/measurements/aggregated`,
          params: { searchRequest: queryArg.searchRequest },
        }),
        providesTags: ["Measurements V2 API"],
      }),
      getRawMeasurements2: build.query<GetRawMeasurements2ApiResponse, GetRawMeasurements2ApiArg>({
        query: (queryArg) => ({
          url: `/measurement/v2/measurements/raw`,
          params: { searchRequest: queryArg.searchRequest },
        }),
        providesTags: ["Measurements V2 API"],
      }),
      notificationhealthCheck: build.query<NotificationhealthCheckApiResponse, NotificationhealthCheckApiArg>({
        query: () => ({ url: `/notification/system/healthCheck` }),
        providesTags: ["Health Check API"],
      }),
      addAttachment: build.mutation<AddAttachmentApiResponse, AddAttachmentApiArg>({
        query: (queryArg) => ({ url: `/notification/v1/attachment`, method: "POST", body: queryArg.body }),
        invalidatesTags: ["Email API"],
      }),
      getConfiguration: build.query<GetConfigurationApiResponse, GetConfigurationApiArg>({
        query: () => ({ url: `/notification/v1/configuration` }),
        providesTags: ["Configuration API"],
      }),
      setConfiguration: build.mutation<SetConfigurationApiResponse, SetConfigurationApiArg>({
        query: (queryArg) => ({
          url: `/notification/v1/configuration`,
          method: "PUT",
          body: queryArg.configurationRequest,
        }),
        invalidatesTags: ["Configuration API"],
      }),
      getSmsProviderConfiguration: build.query<
        GetSmsProviderConfigurationApiResponse,
        GetSmsProviderConfigurationApiArg
      >({
        query: () => ({ url: `/notification/v1/configuration/sms-provider-configuration` }),
        providesTags: ["Configuration API"],
      }),
      sendEmail: build.mutation<SendEmailApiResponse, SendEmailApiArg>({
        query: (queryArg) => ({ url: `/notification/v1/send-email`, method: "POST", body: queryArg.emailRequest }),
        invalidatesTags: ["Email API"],
      }),
      sendSms: build.mutation<SendSmsApiResponse, SendSmsApiArg>({
        query: (queryArg) => ({ url: `/notification/v1/sms/send`, method: "POST", body: queryArg.sendSmsRequest }),
        invalidatesTags: ["SMS API"],
      }),
      organizationhealthCheck: build.query<OrganizationhealthCheckApiResponse, OrganizationhealthCheckApiArg>({
        query: () => ({ url: `/organization/system/healthCheck` }),
        providesTags: ["Health Check API"],
      }),
      resendInvitation: build.mutation<ResendInvitationApiResponse, ResendInvitationApiArg>({
        query: (queryArg) => ({ url: `/organization/v1/invitations/${queryArg.userId}`, method: "POST" }),
        invalidatesTags: ["Invitation API"],
      }),
      deleteLandingPages: build.mutation<DeleteLandingPagesApiResponse, DeleteLandingPagesApiArg>({
        query: (queryArg) => ({
          url: `/organization/v1/landing-pages/${queryArg.landingPageType}`,
          method: "DELETE",
          body: queryArg.deleteLandingPageRequest,
        }),
        invalidatesTags: ["Landing Page API"],
      }),
      getLandingPages: build.query<GetLandingPagesApiResponse, GetLandingPagesApiArg>({
        query: (queryArg) => ({ url: `/organization/v1/landing-pages/${queryArg.landingPageType}` }),
        providesTags: ["Landing Page API"],
      }),
      setLandingPages: build.mutation<SetLandingPagesApiResponse, SetLandingPagesApiArg>({
        query: (queryArg) => ({
          url: `/organization/v1/landing-pages/${queryArg.landingPageType}`,
          method: "PUT",
          body: queryArg.setLandingPageRequest,
        }),
        invalidatesTags: ["Landing Page API"],
      }),
      searchOrganizations: build.query<SearchOrganizationsApiResponse, SearchOrganizationsApiArg>({
        query: (queryArg) => ({
          url: `/organization/v1/organizations`,
          params: { searchRequest: queryArg.searchRequest },
        }),
        providesTags: ["Organization API"],
      }),
      createOrganization: build.mutation<CreateOrganizationApiResponse, CreateOrganizationApiArg>({
        query: (queryArg) => ({
          url: `/organization/v1/organizations`,
          method: "POST",
          body: queryArg.createOrganizationRequest,
        }),
        invalidatesTags: ["Organization API"],
      }),
      deleteOrganization: build.mutation<DeleteOrganizationApiResponse, DeleteOrganizationApiArg>({
        query: (queryArg) => ({ url: `/organization/v1/organizations/${queryArg.id}`, method: "DELETE" }),
        invalidatesTags: ["Organization API"],
      }),
      getOrganization: build.query<GetOrganizationApiResponse, GetOrganizationApiArg>({
        query: (queryArg) => ({ url: `/organization/v1/organizations/${queryArg.id}` }),
        providesTags: ["Organization API"],
      }),
      updateOrganization: build.mutation<UpdateOrganizationApiResponse, UpdateOrganizationApiArg>({
        query: (queryArg) => ({
          url: `/organization/v1/organizations/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.updateOrganizationRequest,
        }),
        invalidatesTags: ["Organization API"],
      }),
      changeOrganizationAdmin: build.mutation<ChangeOrganizationAdminApiResponse, ChangeOrganizationAdminApiArg>({
        query: (queryArg) => ({ url: `/organization/v1/organizations/admin/${queryArg.newAdminId}`, method: "POST" }),
        invalidatesTags: ["Organization API"],
      }),
      createOrganizationByTemplateName: build.mutation<
        CreateOrganizationByTemplateNameApiResponse,
        CreateOrganizationByTemplateNameApiArg
      >({
        query: (queryArg) => ({
          url: `/organization/v1/organizations/templates/${queryArg.templateName}`,
          method: "POST",
          body: queryArg.createOrganizationByTemplateNameRequest,
        }),
        invalidatesTags: ["Organization API"],
      }),
      searchRegistrationCodes: build.query<SearchRegistrationCodesApiResponse, SearchRegistrationCodesApiArg>({
        query: (queryArg) => ({
          url: `/organization/v1/registration-codes`,
          params: { searchRequest: queryArg.searchRequest },
        }),
        providesTags: ["Registration Code API"],
      }),
      createRegistrationCode: build.mutation<CreateRegistrationCodeApiResponse, CreateRegistrationCodeApiArg>({
        query: (queryArg) => ({
          url: `/organization/v1/registration-codes`,
          method: "POST",
          body: queryArg.createRegistrationCodeRequest,
        }),
        invalidatesTags: ["Registration Code API"],
      }),
      deleteRegistrationCode: build.mutation<DeleteRegistrationCodeApiResponse, DeleteRegistrationCodeApiArg>({
        query: (queryArg) => ({ url: `/organization/v1/registration-codes/${queryArg.id}`, method: "DELETE" }),
        invalidatesTags: ["Registration Code API"],
      }),
      getRegistrationCode: build.query<GetRegistrationCodeApiResponse, GetRegistrationCodeApiArg>({
        query: (queryArg) => ({ url: `/organization/v1/registration-codes/${queryArg.id}` }),
        providesTags: ["Registration Code API"],
      }),
      updateRegistrationCode: build.mutation<UpdateRegistrationCodeApiResponse, UpdateRegistrationCodeApiArg>({
        query: (queryArg) => ({
          url: `/organization/v1/registration-codes/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.updateRegistrationCodeRequest,
        }),
        invalidatesTags: ["Registration Code API"],
      }),
      createRegistrationCodeByTemplateName: build.mutation<
        CreateRegistrationCodeByTemplateNameApiResponse,
        CreateRegistrationCodeByTemplateNameApiArg
      >({
        query: (queryArg) => ({
          url: `/organization/v1/registration-codes/templates/${queryArg.templateName}`,
          method: "POST",
          body: queryArg.createRegistrationCodeByTemplateNameRequest,
        }),
        invalidatesTags: ["Registration Code API"],
      }),
      organizationvalidateTokenOperation: build.query<
        OrganizationvalidateTokenOperationApiResponse,
        OrganizationvalidateTokenOperationApiArg
      >({
        query: (queryArg) => ({
          url: `/organization/v1/tokens/${queryArg.token}`,
          params: { operation: queryArg.operation, entityId: queryArg.entityId },
        }),
        providesTags: ["Temporary Token Operation API"],
      }),
      organizationexecuteTokenOperation: build.mutation<
        OrganizationexecuteTokenOperationApiResponse,
        OrganizationexecuteTokenOperationApiArg
      >({
        query: (queryArg) => ({
          url: `/organization/v1/tokens/${queryArg.token}`,
          method: "POST",
          body: queryArg.body,
          params: { operation: queryArg.operation, entityId: queryArg.entityId },
        }),
        invalidatesTags: ["Temporary Token Operation API"],
      }),
      organizationexecuteTokenOperationGet: build.query<
        OrganizationexecuteTokenOperationGetApiResponse,
        OrganizationexecuteTokenOperationGetApiArg
      >({
        query: (queryArg) => ({
          url: `/organization/v1/tokens/${queryArg.token}/execute`,
          params: { operation: queryArg.operation, entityId: queryArg.entityId, operationData: queryArg.operationData },
        }),
        providesTags: ["Temporary Token Operation API"],
      }),
      searchCaregivers: build.query<SearchCaregiversApiResponse, SearchCaregiversApiArg>({
        query: (queryArg) => ({
          url: `/organization/v1/users/caregivers`,
          params: { searchRequest: queryArg.searchRequest },
        }),
        providesTags: ["Caregiver API"],
      }),
      createCaregiver: build.mutation<CreateCaregiverApiResponse, CreateCaregiverApiArg>({
        query: (queryArg) => ({
          url: `/organization/v1/users/caregivers`,
          method: "POST",
          body: queryArg.createCaregiverRequest,
        }),
        invalidatesTags: ["Caregiver API"],
      }),
      deleteCaregiver: build.mutation<DeleteCaregiverApiResponse, DeleteCaregiverApiArg>({
        query: (queryArg) => ({ url: `/organization/v1/users/caregivers/${queryArg.id}`, method: "DELETE" }),
        invalidatesTags: ["Caregiver API"],
      }),
      getCaregiver: build.query<GetCaregiverApiResponse, GetCaregiverApiArg>({
        query: (queryArg) => ({ url: `/organization/v1/users/caregivers/${queryArg.id}` }),
        providesTags: ["Caregiver API"],
      }),
      updateCaregiver: build.mutation<UpdateCaregiverApiResponse, UpdateCaregiverApiArg>({
        query: (queryArg) => ({
          url: `/organization/v1/users/caregivers/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.updateCaregiverRequest,
        }),
        invalidatesTags: ["Caregiver API"],
      }),
      changeCaregiverEnabledState: build.mutation<
        ChangeCaregiverEnabledStateApiResponse,
        ChangeCaregiverEnabledStateApiArg
      >({
        query: (queryArg) => ({
          url: `/organization/v1/users/caregivers/${queryArg.id}/enabled-state/${queryArg.state}`,
          method: "POST",
        }),
        invalidatesTags: ["Caregiver API"],
      }),
      getCaregiverSelf: build.query<GetCaregiverSelfApiResponse, GetCaregiverSelfApiArg>({
        query: () => ({ url: `/organization/v1/users/caregivers/self` }),
        providesTags: ["Caregiver API"],
      }),
      createCaregiverByTemplateName: build.mutation<
        CreateCaregiverByTemplateNameApiResponse,
        CreateCaregiverByTemplateNameApiArg
      >({
        query: (queryArg) => ({
          url: `/organization/v1/users/caregivers/templates/${queryArg.templateName}`,
          method: "POST",
          body: queryArg.createCaregiverByTemplateNameRequest,
        }),
        invalidatesTags: ["Caregiver API"],
      }),
      searchOrganizationUsers: build.query<SearchOrganizationUsersApiResponse, SearchOrganizationUsersApiArg>({
        query: (queryArg) => ({
          url: `/organization/v1/users/organizations`,
          params: { searchRequest: queryArg.searchRequest },
        }),
        providesTags: ["Organization User API"],
      }),
      createOrganizationUser: build.mutation<CreateOrganizationUserApiResponse, CreateOrganizationUserApiArg>({
        query: (queryArg) => ({
          url: `/organization/v1/users/organizations`,
          method: "POST",
          body: queryArg.createOrganizationUserRequest,
        }),
        invalidatesTags: ["Organization User API"],
      }),
      deleteOrganizationUser: build.mutation<DeleteOrganizationUserApiResponse, DeleteOrganizationUserApiArg>({
        query: (queryArg) => ({ url: `/organization/v1/users/organizations/${queryArg.id}`, method: "DELETE" }),
        invalidatesTags: ["Organization User API"],
      }),
      getOrganizationUser: build.query<GetOrganizationUserApiResponse, GetOrganizationUserApiArg>({
        query: (queryArg) => ({ url: `/organization/v1/users/organizations/${queryArg.id}` }),
        providesTags: ["Organization User API"],
      }),
      updateOrganizationUser: build.mutation<UpdateOrganizationUserApiResponse, UpdateOrganizationUserApiArg>({
        query: (queryArg) => ({
          url: `/organization/v1/users/organizations/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.updateOrganizationUserRequest,
        }),
        invalidatesTags: ["Organization User API"],
      }),
      changeOrganizationUserEnabledState: build.mutation<
        ChangeOrganizationUserEnabledStateApiResponse,
        ChangeOrganizationUserEnabledStateApiArg
      >({
        query: (queryArg) => ({
          url: `/organization/v1/users/organizations/${queryArg.id}/enabled-state/${queryArg.state}`,
          method: "POST",
        }),
        invalidatesTags: ["Organization User API"],
      }),
      getOrganizationUserSelf: build.query<GetOrganizationUserSelfApiResponse, GetOrganizationUserSelfApiArg>({
        query: () => ({ url: `/organization/v1/users/organizations/self` }),
        providesTags: ["Organization User API"],
      }),
      createOrganizationUserByTemplateName: build.mutation<
        CreateOrganizationUserByTemplateNameApiResponse,
        CreateOrganizationUserByTemplateNameApiArg
      >({
        query: (queryArg) => ({
          url: `/organization/v1/users/organizations/templates/${queryArg.templateName}`,
          method: "POST",
          body: queryArg.createOrganizationUserByTemplateNameRequest,
        }),
        invalidatesTags: ["Organization User API"],
      }),
      searchPatients: build.query<SearchPatientsApiResponse, SearchPatientsApiArg>({
        query: (queryArg) => ({
          url: `/organization/v1/users/patients`,
          params: { searchRequest: queryArg.searchRequest },
        }),
        providesTags: ["Patient API"],
      }),
      createPatient: build.mutation<CreatePatientApiResponse, CreatePatientApiArg>({
        query: (queryArg) => ({
          url: `/organization/v1/users/patients`,
          method: "POST",
          body: queryArg.createPatientRequest,
        }),
        invalidatesTags: ["Patient API"],
      }),
      deletePatient: build.mutation<DeletePatientApiResponse, DeletePatientApiArg>({
        query: (queryArg) => ({ url: `/organization/v1/users/patients/${queryArg.id}`, method: "DELETE" }),
        invalidatesTags: ["Patient API"],
      }),
      getPatient: build.query<GetPatientApiResponse, GetPatientApiArg>({
        query: (queryArg) => ({ url: `/organization/v1/users/patients/${queryArg.id}` }),
        providesTags: ["Patient API"],
      }),
      updatePatient: build.mutation<UpdatePatientApiResponse, UpdatePatientApiArg>({
        query: (queryArg) => ({
          url: `/organization/v1/users/patients/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.updatePatientRequest,
        }),
        invalidatesTags: ["Patient API"],
      }),
      changePatientEnabledState: build.mutation<ChangePatientEnabledStateApiResponse, ChangePatientEnabledStateApiArg>({
        query: (queryArg) => ({
          url: `/organization/v1/users/patients/${queryArg.id}/enabled-state/${queryArg.state}`,
          method: "POST",
        }),
        invalidatesTags: ["Patient API"],
      }),
      organizationcreateAlert: build.mutation<OrganizationcreateAlertApiResponse, OrganizationcreateAlertApiArg>({
        query: (queryArg) => ({
          url: `/organization/v1/users/patients/${queryArg.patientId}/alerts`,
          method: "POST",
          body: queryArg.createAlertRequest,
        }),
        invalidatesTags: ["Patient Alert API"],
      }),
      organizationdeleteAlert: build.mutation<OrganizationdeleteAlertApiResponse, OrganizationdeleteAlertApiArg>({
        query: (queryArg) => ({
          url: `/organization/v1/users/patients/${queryArg.patientId}/alerts/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["Patient Alert API"],
      }),
      organizationgetAlert: build.query<OrganizationgetAlertApiResponse, OrganizationgetAlertApiArg>({
        query: (queryArg) => ({ url: `/organization/v1/users/patients/${queryArg.patientId}/alerts/${queryArg.id}` }),
        providesTags: ["Patient Alert API"],
      }),
      organizationupdateAlert: build.mutation<OrganizationupdateAlertApiResponse, OrganizationupdateAlertApiArg>({
        query: (queryArg) => ({
          url: `/organization/v1/users/patients/${queryArg.patientId}/alerts/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.updateAlertRequest,
        }),
        invalidatesTags: ["Patient Alert API"],
      }),
      organizationcreateAlertByTemplateName: build.mutation<
        OrganizationcreateAlertByTemplateNameApiResponse,
        OrganizationcreateAlertByTemplateNameApiArg
      >({
        query: (queryArg) => ({
          url: `/organization/v1/users/patients/${queryArg.patientId}/alerts/${queryArg.templateName}`,
          method: "POST",
          body: queryArg.createAlertByTemplateNameRequest,
        }),
        invalidatesTags: ["Patient Alert API"],
      }),
      organizationsearchAlerts: build.query<OrganizationsearchAlertsApiResponse, OrganizationsearchAlertsApiArg>({
        query: (queryArg) => ({
          url: `/organization/v1/users/patients/alerts`,
          params: { searchRequest: queryArg.searchRequest },
        }),
        providesTags: ["Patient Alert API"],
      }),
      organizationsearchCurrentAlerts: build.query<
        OrganizationsearchCurrentAlertsApiResponse,
        OrganizationsearchCurrentAlertsApiArg
      >({
        query: (queryArg) => ({
          url: `/organization/v1/users/patients/current/alerts`,
          params: { searchRequest: queryArg.searchRequest },
        }),
        providesTags: ["Patient Alert API"],
      }),
      getPatientSelf: build.query<GetPatientSelfApiResponse, GetPatientSelfApiArg>({
        query: () => ({ url: `/organization/v1/users/patients/self` }),
        providesTags: ["Patient API"],
      }),
      searchAvailableOrganizationsForSignUp: build.query<
        SearchAvailableOrganizationsForSignUpApiResponse,
        SearchAvailableOrganizationsForSignUpApiArg
      >({
        query: (queryArg) => ({
          url: `/organization/v1/users/patients/sign-up/organizations`,
          params: { searchRequest: queryArg.searchRequest },
        }),
        providesTags: ["Patient API"],
      }),
      createPatientByTemplateName: build.mutation<
        CreatePatientByTemplateNameApiResponse,
        CreatePatientByTemplateNameApiArg
      >({
        query: (queryArg) => ({
          url: `/organization/v1/users/patients/templates/${queryArg.templateName}`,
          method: "POST",
          body: queryArg.createPatientByTemplateNameRequest,
        }),
        invalidatesTags: ["Patient API"],
      }),
      getSelf: build.query<GetSelfApiResponse, GetSelfApiArg>({
        query: () => ({ url: `/organization/v1/users/self` }),
        providesTags: ["User API"],
      }),
      xxx: build.query<XxxApiResponse, XxxApiArg>({
        query: (queryArg) => ({ url: `/search/`, params: { searchRequest: queryArg.searchRequest } }),
      }),
      settingshealthCheck: build.query<SettingshealthCheckApiResponse, SettingshealthCheckApiArg>({
        query: () => ({ url: `/settings/system/healthCheck` }),
        providesTags: ["Health Check API"],
      }),
      search3: build.query<Search3ApiResponse, Search3ApiArg>({
        query: (queryArg) => ({ url: `/settings/v1/code-snippets`, params: { searchRequest: queryArg.searchRequest } }),
        providesTags: ["Code Snippet API"],
      }),
      createCodeSnippet: build.mutation<CreateCodeSnippetApiResponse, CreateCodeSnippetApiArg>({
        query: (queryArg) => ({
          url: `/settings/v1/code-snippets`,
          method: "POST",
          body: queryArg.createCodeSnippetRequest,
        }),
        invalidatesTags: ["Code Snippet API"],
      }),
      deleteCodeSnippet: build.mutation<DeleteCodeSnippetApiResponse, DeleteCodeSnippetApiArg>({
        query: (queryArg) => ({ url: `/settings/v1/code-snippets/${queryArg.id}`, method: "DELETE" }),
        invalidatesTags: ["Code Snippet API"],
      }),
      getCodeSnippet: build.query<GetCodeSnippetApiResponse, GetCodeSnippetApiArg>({
        query: (queryArg) => ({ url: `/settings/v1/code-snippets/${queryArg.id}` }),
        providesTags: ["Code Snippet API"],
      }),
      getLastExportExecution: build.query<GetLastExportExecutionApiResponse, GetLastExportExecutionApiArg>({
        query: () => ({ url: `/settings/v1/configuration/exports/executions/last` }),
        providesTags: ["Export Import Configuration API"],
      }),
      getExportsMetadata: build.query<GetExportsMetadataApiResponse, GetExportsMetadataApiArg>({
        query: () => ({ url: `/settings/v1/configuration/exports/metadata` }),
        providesTags: ["Export Import Configuration API"],
      }),
      startExport: build.mutation<StartExportApiResponse, StartExportApiArg>({
        query: (queryArg) => ({
          url: `/settings/v1/configuration/exports/start`,
          method: "POST",
          body: queryArg.startExportConfigurationRequest,
        }),
        invalidatesTags: ["Export Import Configuration API"],
      }),
      getLastImportExecution: build.query<GetLastImportExecutionApiResponse, GetLastImportExecutionApiArg>({
        query: () => ({ url: `/settings/v1/configuration/imports/executions/last` }),
        providesTags: ["Export Import Configuration API"],
      }),
      startImport: build.mutation<StartImportApiResponse, StartImportApiArg>({
        query: (queryArg) => ({
          url: `/settings/v1/configuration/imports/start`,
          method: "POST",
          body: queryArg.startImportConfigurationRequest,
        }),
        invalidatesTags: ["Export Import Configuration API"],
      }),
      getEntityTypes: build.query<GetEntityTypesApiResponse, GetEntityTypesApiArg>({
        query: () => ({ url: `/settings/v1/entity-types` }),
        providesTags: ["Entity API"],
      }),
      getNotifiableActions1: build.query<GetNotifiableActions1ApiResponse, GetNotifiableActions1ApiArg>({
        query: () => ({ url: `/settings/v1/entity-types/action-notifications` }),
        providesTags: ["Entity API"],
      }),
      search2: build.query<Search2ApiResponse, Search2ApiArg>({
        query: (queryArg) => ({ url: `/settings/v1/interceptions`, params: { searchRequest: queryArg.searchRequest } }),
        providesTags: ["Interception Configuration API"],
      }),
      addLocale: build.mutation<AddLocaleApiResponse, AddLocaleApiArg>({
        query: (queryArg) => ({ url: `/settings/v1/locales`, method: "POST", body: queryArg.addLocaleRequest }),
        invalidatesTags: ["Locale API"],
      }),
      deleteLocale: build.mutation<DeleteLocaleApiResponse, DeleteLocaleApiArg>({
        query: (queryArg) => ({ url: `/settings/v1/locales/${queryArg.id}`, method: "DELETE" }),
        invalidatesTags: ["Locale API"],
      }),
      getLocales: build.query<GetLocalesApiResponse, GetLocalesApiArg>({
        query: () => ({ url: `/settings/v1/locales/configuration` }),
        providesTags: ["Locale API"],
      }),
      updateLocales: build.mutation<UpdateLocalesApiResponse, UpdateLocalesApiArg>({
        query: (queryArg) => ({
          url: `/settings/v1/locales/configuration`,
          method: "PATCH",
          body: queryArg.updateLocalesRequest,
        }),
        invalidatesTags: ["Locale API"],
      }),
      backup: build.mutation<BackupApiResponse, BackupApiArg>({
        query: (queryArg) => ({ url: `/settings/v1/system/backup`, method: "POST", body: queryArg.backupRequest }),
        invalidatesTags: ["Backup API"],
      }),
      searchBackupExecutions: build.query<SearchBackupExecutionsApiResponse, SearchBackupExecutionsApiArg>({
        query: (queryArg) => ({
          url: `/settings/v1/system/backup/executions`,
          params: { searchRequest: queryArg.searchRequest },
        }),
        providesTags: ["Backup API"],
      }),
      getSystemProperties: build.query<GetSystemPropertiesApiResponse, GetSystemPropertiesApiArg>({
        query: () => ({ url: `/settings/v1/system/properties` }),
        providesTags: ["System API"],
      }),
      resetSystem: build.mutation<ResetSystemApiResponse, ResetSystemApiArg>({
        query: (queryArg) => ({ url: `/settings/v1/system/reset`, method: "POST", body: queryArg.resetSystemRequest }),
        invalidatesTags: ["System API"],
      }),
      searchRestoreExecutions: build.query<SearchRestoreExecutionsApiResponse, SearchRestoreExecutionsApiArg>({
        query: (queryArg) => ({
          url: `/settings/v1/system/restore/executions`,
          params: { searchRequest: queryArg.searchRequest },
        }),
        providesTags: ["Backup API"],
      }),
      search1: build.query<Search1ApiResponse, Search1ApiArg>({
        query: (queryArg) => ({ url: `/settings/v1/templates`, params: { searchRequest: queryArg.searchRequest } }),
        providesTags: ["Template API"],
      }),
      createTemplate: build.mutation<CreateTemplateApiResponse, CreateTemplateApiArg>({
        query: (queryArg) => ({
          url: `/settings/v1/templates`,
          method: "POST",
          body: queryArg.createTemplateRequest,
          params: { force: queryArg.force },
        }),
        invalidatesTags: ["Template API"],
      }),
      deleteTemplate: build.mutation<DeleteTemplateApiResponse, DeleteTemplateApiArg>({
        query: (queryArg) => ({
          url: `/settings/v1/templates/${queryArg.templateId}`,
          method: "DELETE",
          params: { force: queryArg.force },
        }),
        invalidatesTags: ["Template API"],
      }),
      getTemplate: build.query<GetTemplateApiResponse, GetTemplateApiArg>({
        query: (queryArg) => ({ url: `/settings/v1/templates/${queryArg.templateId}` }),
        providesTags: ["Template API"],
      }),
      updateTemplate: build.mutation<UpdateTemplateApiResponse, UpdateTemplateApiArg>({
        query: (queryArg) => ({
          url: `/settings/v1/templates/${queryArg.templateId}`,
          method: "PUT",
          body: queryArg.updateTemplateRequest,
          params: { force: queryArg.force },
        }),
        invalidatesTags: ["Template API"],
      }),
      getTemplateOverview: build.query<GetTemplateOverviewApiResponse, GetTemplateOverviewApiArg>({
        query: (queryArg) => ({ url: `/settings/v1/templates/${queryArg.templateId}/overview` }),
        providesTags: ["Template API"],
      }),
      minimalSearch: build.query<MinimalSearchApiResponse, MinimalSearchApiArg>({
        query: (queryArg) => ({
          url: `/settings/v1/templates/minimized`,
          params: { searchRequest: queryArg.searchRequest },
        }),
        providesTags: ["Template API"],
      }),
      deleteLocaleTranslations: build.mutation<DeleteLocaleTranslationsApiResponse, DeleteLocaleTranslationsApiArg>({
        query: (queryArg) => ({ url: `/settings/v1/translations/${queryArg.locale}`, method: "DELETE" }),
        invalidatesTags: ["Translation API"],
      }),
      downloadLocaleTranslationFile: build.query<
        DownloadLocaleTranslationFileApiResponse,
        DownloadLocaleTranslationFileApiArg
      >({
        query: (queryArg) => ({ url: `/settings/v1/translations/${queryArg.locale}/download` }),
        providesTags: ["Translation API"],
      }),
      updateLocaleTranslations: build.mutation<UpdateLocaleTranslationsApiResponse, UpdateLocaleTranslationsApiArg>({
        query: (queryArg) => ({
          url: `/settings/v1/translations/${queryArg.locale}/update`,
          method: "PATCH",
          body: queryArg.body,
        }),
        invalidatesTags: ["Translation API"],
      }),
      validateLocaleTranslations: build.mutation<
        ValidateLocaleTranslationsApiResponse,
        ValidateLocaleTranslationsApiArg
      >({
        query: (queryArg) => ({
          url: `/settings/v1/translations/${queryArg.locale}/validate`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["Translation API"],
      }),
      searchLocaleTranslationOverviews: build.query<
        SearchLocaleTranslationOverviewsApiResponse,
        SearchLocaleTranslationOverviewsApiArg
      >({
        query: (queryArg) => ({
          url: `/settings/v1/translations/overviews`,
          params: { searchRequest: queryArg.searchRequest },
        }),
        providesTags: ["Translation API"],
      }),
      searchEntityTypes: build.query<SearchEntityTypesApiResponse, SearchEntityTypesApiArg>({
        query: (queryArg) => ({ url: `/settings/v2/entity-types`, params: { searchRequest: queryArg.searchRequest } }),
        providesTags: ["Entity API"],
      }),
      getNotifiableActions: build.query<GetNotifiableActionsApiResponse, GetNotifiableActionsApiArg>({
        query: () => ({ url: `/settings/v2/entity-types/action-notifications` }),
        providesTags: ["Entity API"],
      }),
      search: build.query<SearchApiResponse, SearchApiArg>({
        query: (queryArg) => ({ url: `/settings/v2/plugins`, params: { searchRequest: queryArg.searchRequest } }),
        providesTags: ["Plugin-V2 API"],
      }),
      create: build.mutation<CreateApiResponse, CreateApiArg>({
        query: (queryArg) => ({ url: `/settings/v2/plugins`, method: "POST", body: queryArg.body }),
        invalidatesTags: ["Plugin-V2 API"],
      }),
      deleteSettingsV2PluginsByName: build.mutation<
        DeleteSettingsV2PluginsByNameApiResponse,
        DeleteSettingsV2PluginsByNameApiArg
      >({
        query: (queryArg) => ({ url: `/settings/v2/plugins/${queryArg.name}`, method: "DELETE" }),
        invalidatesTags: ["Plugin-V2 API"],
      }),
      getSettingsV2PluginsByName: build.query<GetSettingsV2PluginsByNameApiResponse, GetSettingsV2PluginsByNameApiArg>({
        query: (queryArg) => ({ url: `/settings/v2/plugins/${queryArg.name}` }),
        providesTags: ["Plugin-V2 API"],
      }),
      partialUpdate: build.mutation<PartialUpdateApiResponse, PartialUpdateApiArg>({
        query: (queryArg) => ({ url: `/settings/v2/plugins/${queryArg.name}`, method: "PATCH", body: queryArg.body }),
        invalidatesTags: ["Plugin-V2 API"],
      }),
      getDockerRepositoryTempCredentials: build.query<
        GetDockerRepositoryTempCredentialsApiResponse,
        GetDockerRepositoryTempCredentialsApiArg
      >({
        query: () => ({ url: `/settings/v2/plugins/docker-repository/temp-credentials` }),
        providesTags: ["Plugin-V2 API"],
      }),
      umshealthCheck: build.query<UmshealthCheckApiResponse, UmshealthCheckApiArg>({
        query: () => ({ url: `/ums/system/healthCheck` }),
        providesTags: ["Health Check API"],
      }),
      getPublicKey: build.query<GetPublicKeyApiResponse, GetPublicKeyApiArg>({
        query: () => ({ url: `/ums/v1/security/public-key` }),
        providesTags: ["Security API"],
      }),
      getTempCredentialsForOrganization: build.query<
        GetTempCredentialsForOrganizationApiResponse,
        GetTempCredentialsForOrganizationApiArg
      >({
        query: () => ({ url: `/ums/v1/temp-credentials/organization` }),
        providesTags: ["Temporary Credentials API"],
      }),
      umsvalidateTokenOperation: build.query<UmsvalidateTokenOperationApiResponse, UmsvalidateTokenOperationApiArg>({
        query: (queryArg) => ({
          url: `/ums/v1/tokens/${queryArg.token}`,
          params: { operation: queryArg.operation, entityId: queryArg.entityId },
        }),
        providesTags: ["Temporary Token Operation API"],
      }),
      umsexecuteTokenOperation: build.mutation<UmsexecuteTokenOperationApiResponse, UmsexecuteTokenOperationApiArg>({
        query: (queryArg) => ({
          url: `/ums/v1/tokens/${queryArg.token}`,
          method: "POST",
          body: queryArg.body,
          params: { operation: queryArg.operation, entityId: queryArg.entityId },
        }),
        invalidatesTags: ["Temporary Token Operation API"],
      }),
      umsexecuteTokenOperationGet: build.query<
        UmsexecuteTokenOperationGetApiResponse,
        UmsexecuteTokenOperationGetApiArg
      >({
        query: (queryArg) => ({
          url: `/ums/v1/tokens/${queryArg.token}/execute`,
          params: { operation: queryArg.operation, entityId: queryArg.entityId, operationData: queryArg.operationData },
        }),
        providesTags: ["Temporary Token Operation API"],
      }),
      searchServiceUsers: build.query<SearchServiceUsersApiResponse, SearchServiceUsersApiArg>({
        query: (queryArg) => ({ url: `/ums/v2/services`, params: { searchRequest: queryArg.searchRequest } }),
        providesTags: ["Service User API"],
      }),
      createServiceUser: build.mutation<CreateServiceUserApiResponse, CreateServiceUserApiArg>({
        query: (queryArg) => ({ url: `/ums/v2/services`, method: "POST", body: queryArg.createServiceUserRequest }),
        invalidatesTags: ["Service User API"],
      }),
      deleteServiceUser: build.mutation<DeleteServiceUserApiResponse, DeleteServiceUserApiArg>({
        query: (queryArg) => ({ url: `/ums/v2/services/${queryArg.id}`, method: "DELETE" }),
        invalidatesTags: ["Service User API"],
      }),
      getServiceUserById: build.query<GetServiceUserByIdApiResponse, GetServiceUserByIdApiArg>({
        query: (queryArg) => ({ url: `/ums/v2/services/${queryArg.id}` }),
        providesTags: ["Service User API"],
      }),
      updateServiceUser: build.mutation<UpdateServiceUserApiResponse, UpdateServiceUserApiArg>({
        query: (queryArg) => ({
          url: `/ums/v2/services/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.updateServiceUserV2Request,
        }),
        invalidatesTags: ["Service User API"],
      }),
      createSecretKey: build.mutation<CreateSecretKeyApiResponse, CreateSecretKeyApiArg>({
        query: (queryArg) => ({ url: `/ums/v2/services/${queryArg.id}/secret-keys`, method: "POST" }),
        invalidatesTags: ["Service User API"],
      }),
      deleteSecretKey: build.mutation<DeleteSecretKeyApiResponse, DeleteSecretKeyApiArg>({
        query: (queryArg) => ({
          url: `/ums/v2/services/${queryArg.id}/secret-keys/${queryArg.secretKeyId}`,
          method: "DELETE",
        }),
        invalidatesTags: ["Service User API"],
      }),
      serviceUserLogin: build.mutation<ServiceUserLoginApiResponse, ServiceUserLoginApiArg>({
        query: (queryArg) => ({
          url: `/ums/v2/services/accessToken`,
          method: "POST",
          body: queryArg.serviceUserAccessTokenRequest,
        }),
        invalidatesTags: ["Service User API"],
      }),
      umssearch: build.query<UmssearchApiResponse, UmssearchApiArg>({
        query: (queryArg) => ({ url: `/ums/v2/users`, params: { searchRequest: queryArg.searchRequest } }),
        providesTags: ["User API"],
      }),
      umsdelete: build.mutation<UmsdeleteApiResponse, UmsdeleteApiArg>({
        query: (queryArg) => ({ url: `/ums/v2/users/${queryArg.id}`, method: "DELETE" }),
        invalidatesTags: ["User API"],
      }),
      getUser: build.query<GetUserApiResponse, GetUserApiArg>({
        query: (queryArg) => ({ url: `/ums/v2/users/${queryArg.id}` }),
        providesTags: ["User API"],
      }),
      updateUser: build.mutation<UpdateUserApiResponse, UpdateUserApiArg>({
        query: (queryArg) => ({
          url: `/ums/v2/users/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.updateUserRequest,
        }),
        invalidatesTags: ["User API"],
      }),
      generateUserPassword: build.mutation<GenerateUserPasswordApiResponse, GenerateUserPasswordApiArg>({
        query: (queryArg) => ({ url: `/ums/v2/users/${queryArg.id}/password/generate`, method: "POST" }),
        invalidatesTags: ["User API"],
      }),
      validateUserCredentials: build.mutation<ValidateUserCredentialsApiResponse, ValidateUserCredentialsApiArg>({
        query: (queryArg) => ({
          url: `/ums/v2/users/credentials/validate`,
          method: "POST",
          body: queryArg.validateUserCredentialsRequest,
        }),
        invalidatesTags: ["User API"],
      }),
      login: build.mutation<LoginApiResponse, LoginApiArg>({
        query: (queryArg) => ({ url: `/ums/v2/users/login`, method: "POST", body: queryArg.loginRequestV2 }),
        invalidatesTags: ["Login API"],
      }),
      mfaLogin: build.mutation<MfaLoginApiResponse, MfaLoginApiArg>({
        query: (queryArg) => ({ url: `/ums/v2/users/login/mfa`, method: "POST", body: queryArg.mfaLoginRequestV2 }),
        invalidatesTags: ["MFA Login API"],
      }),
      mfaResend: build.mutation<MfaResendApiResponse, MfaResendApiArg>({
        query: () => ({ url: `/ums/v2/users/login/mfa/resend`, method: "POST" }),
        invalidatesTags: ["MFA Login API"],
      }),
      logout: build.mutation<LogoutApiResponse, LogoutApiArg>({
        query: (queryArg) => ({ url: `/ums/v2/users/logout`, method: "POST", body: queryArg.logoutRequest }),
        invalidatesTags: ["Login API"],
      }),
      generateOtp: build.mutation<GenerateOtpApiResponse, GenerateOtpApiArg>({
        query: (queryArg) => ({ url: `/ums/v2/users/otp/generate`, method: "POST", body: queryArg.generateOtpRequest }),
        invalidatesTags: ["Login API"],
      }),
      otpLogin: build.mutation<OtpLoginApiResponse, OtpLoginApiArg>({
        query: (queryArg) => ({ url: `/ums/v2/users/otp/login`, method: "POST", body: queryArg.otpLoginRequest }),
        invalidatesTags: ["Login API"],
      }),
      selfDeleteUser: build.mutation<SelfDeleteUserApiResponse, SelfDeleteUserApiArg>({
        query: () => ({ url: `/ums/v2/users/self`, method: "DELETE" }),
        invalidatesTags: ["Self User API"],
      }),
      selfGetUser: build.query<SelfGetUserApiResponse, SelfGetUserApiArg>({
        query: () => ({ url: `/ums/v2/users/self` }),
        providesTags: ["Self User API"],
      }),
      selfUpdateUser: build.mutation<SelfUpdateUserApiResponse, SelfUpdateUserApiArg>({
        query: (queryArg) => ({ url: `/ums/v2/users/self`, method: "PATCH", body: queryArg.selfUpdateUserRequest }),
        invalidatesTags: ["Self User API"],
      }),
      selfRegisterUser: build.mutation<SelfRegisterUserApiResponse, SelfRegisterUserApiArg>({
        query: (queryArg) => ({
          url: `/ums/v2/users/self`,
          method: "POST",
          body: queryArg.selfRegisterUserRequest,
          headers: { "Owner-Organization-Id": queryArg["Owner-Organization-Id"] },
        }),
        invalidatesTags: ["Self User API"],
      }),
      forgotPassword: build.mutation<ForgotPasswordApiResponse, ForgotPasswordApiArg>({
        query: (queryArg) => ({
          url: `/ums/v2/users/self/password/forgot`,
          method: "POST",
          body: queryArg.forgotPasswordRequestV2,
        }),
        invalidatesTags: ["Self User API"],
      }),
      tokenLogin: build.mutation<TokenLoginApiResponse, TokenLoginApiArg>({
        query: (queryArg) => ({
          url: `/ums/v2/users/token/login`,
          method: "POST",
          body: queryArg.loginWithTokenRequest,
        }),
        invalidatesTags: ["Login API"],
      }),
      refreshToken: build.mutation<RefreshTokenApiResponse, RefreshTokenApiArg>({
        query: (queryArg) => ({
          url: `/ums/v2/users/token/refresh`,
          method: "POST",
          body: queryArg.refreshTokenRequest,
        }),
        invalidatesTags: ["Login API"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as queriesApi };
export type FacadehealthCheckApiResponse = /** status 200 OK */ VersionResponse;
export type FacadehealthCheckApiArg = void;
export type AssignDeviceApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|_description|string|Device description||
|_timezone|string|A java time zone supported by the java runtime environment|Europe/Oslo|
|_id|string|The id of the device||
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_ownerOrganization.name|string|The caption of the referenced entity||
|_template|object|||
|_template.name|string|The name of the template||
|_template.displayName|string|The display name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.name|string|||
|_template.id|string|The id of the template||
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_configuration|object|An object that holds the entity configuration attributes||
|_status|object|||
|_status._fwVersion|string|||
|_status._hwVersion|string|||
|_status._certificateStatus|string| Values:NOT_INSTALLED,BOOTSTRAP,PERMANENT||
|_status._bootTime|string|A UTC date in the ISO-8601 format||
|_status._connection|object|||
|_status._connection._connected|boolean|If the device is connected to the MQTT the value is true, otherwise false|true|
|_status._connection._ipAddress|string|The IP Address of the connected device|2007-12-20|
|_status._connection._lastConnectedTime|string|The last time that the device was connected||
|_status._operational|object|||
|_status._operational._status|string|Operational status of the device Values:OK,MINOR,MAJOR,CRITICAL||
|_status._operational._message|string|Operational status message||
|_patient|object|||
|_patient.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_patient.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_patient.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_patient.templateName|string|The name of the referenced entity template||
|_patient.name|string|The caption of the referenced entity||
|_registrationCode|object|||
|_registrationCode.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_registrationCode.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_registrationCode.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_registrationCode.templateName|string|The name of the referenced entity template||
|_registrationCode.name|string|The caption of the referenced entity||
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_caption|string|The caption of the command instance|mydevice1|
 */ DeviceResponse;
export type AssignDeviceApiArg = {
  assignDeviceFacadeRequest: AssignDeviceFacadeRequest;
};
export type PatientSelfSignUpApiResponse = /** status 201 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|device|object|||
|device._description|string|Device description||
|device._timezone|string|A java time zone supported by the java runtime environment|Europe/Oslo|
|device._id|string|The id of the device||
|device._ownerOrganization|object|||
|device._ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|device._ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|device._ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|device._ownerOrganization.templateName|string|The name of the referenced entity template||
|device._ownerOrganization.name|string|The caption of the referenced entity||
|device._template|object|||
|device._template.name|string|The name of the template||
|device._template.displayName|string|The display name of the template||
|device._template.parentTemplate|object|||
|device._template.parentTemplate.id|string|||
|device._template.parentTemplate.displayName|string|||
|device._template.parentTemplate.name|string|||
|device._template.id|string|The id of the template||
|device._referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|device._configuration|object|An object that holds the entity configuration attributes||
|device._status|object|||
|device._status._fwVersion|string|||
|device._status._hwVersion|string|||
|device._status._certificateStatus|string| Values:NOT_INSTALLED,BOOTSTRAP,PERMANENT||
|device._status._bootTime|string|A UTC date in the ISO-8601 format||
|device._status._connection|object|||
|device._status._connection._connected|boolean|If the device is connected to the MQTT the value is true, otherwise false|true|
|device._status._connection._ipAddress|string|The IP Address of the connected device|2007-12-20|
|device._status._connection._lastConnectedTime|string|The last time that the device was connected||
|device._status._operational|object|||
|device._status._operational._status|string|Operational status of the device Values:OK,MINOR,MAJOR,CRITICAL||
|device._status._operational._message|string|Operational status message||
|device._patient|object|||
|device._patient.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|device._patient.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|device._patient.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|device._patient.templateName|string|The name of the referenced entity template||
|device._patient.name|string|The caption of the referenced entity||
|device._registrationCode|object|||
|device._registrationCode.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|device._registrationCode.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|device._registrationCode.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|device._registrationCode.templateName|string|The name of the referenced entity template||
|device._registrationCode.name|string|The caption of the referenced entity||
|device._creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|device._lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|device._caption|string|The caption of the command instance|mydevice1|
|patient|object|||
|patient._name|object|||
|patient._name.firstName|string|A person's first name|John|
|patient._name.lastName|string|A person's last name|Smith|
|patient._description|string|A description, can be up to 5000 characters long|Lorem Ipsum|
|patient._email|string|An email address in the RFC-5322 specification|john.smith@biot-med.com|
|patient._phone|string|A person's phone An E.164 formatted phone number|+12345678901|
|patient._locale|string|A person's locale Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase.|en-us|
|patient._gender|string|A persons gender Values:MALE,FEMALE,UNDISCLOSED|FEMALE|
|patient._dateOfBirth|string|A person's date of birth A UTC date in the ISO-8601 format|Thu Dec 20 00:00:00 UTC 2007|
|patient._address|object|||
|patient._address.countryCode|string|A 2-letter country code defined in ISO-3166|US|
|patient._address.state|string|A state|Massachusetts|
|patient._address.city|string|A city|Boston|
|patient._address.zipCode|string|A zipcode|02101|
|patient._address.address1|string|An address|11 Main St.|
|patient._address.address2|string|An address's specifics|Entry B, Apartment 1|
|patient._mfa|object|||
|patient._mfa.enabled|boolean|MFA login enabled or disabled||
|patient._mfa.expirationInMinutes|integer|MFA expiration time in minutes||
|patient._credentialType|string|What type of credentials is used when logging in to the system. Default:PASSWORD Values:PASSWORD,OTP||
|patient._additionalPhone|string|An E.164 formatted phone number|+12345678901|
|patient._nationalId|string|A person's national ID|123456789|
|patient._id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|patient._ownerOrganization|object|||
|patient._ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|patient._ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|patient._ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|patient._ownerOrganization.templateName|string|The name of the referenced entity template||
|patient._ownerOrganization.name|string|The caption of the referenced entity||
|patient._caregiver|object|||
|patient._caregiver.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|patient._caregiver.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|patient._caregiver.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|patient._caregiver.templateName|string|The name of the referenced entity template||
|patient._caregiver.name|string|The caption of the referenced entity||
|patient._creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|patient._lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|patient._invitationAccepted|boolean|Has invitation been accepted||
|patient._template|object|||
|patient._template.name|string|The name of the template||
|patient._template.displayName|string|The display name of the template||
|patient._template.parentTemplate|object|||
|patient._template.parentTemplate.id|string|||
|patient._template.parentTemplate.displayName|string|||
|patient._template.parentTemplate.name|string|||
|patient._template.id|string|The id of the template||
|patient._referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|patient._enabled|string|Is the user enabled Values:DISABLED,ENABLED|ENABLED|DISABLED|
|patient._username|string|User's username. Can be an email or a regular username. With this username you login to the system.|john@biotmail.com or john123|
|patient._registrationSource|string|The source of the registration. Possible values: INVITATION / SELF|INVITATION|
|patient._canLogin|boolean|Determine whether a patient has the ability to login to the system or not||
|patient._nickname|string|The patient nickname. Used for anonymous users.||
|patient._caption|string|||
 */ PatientSelfSignUpFacadeResponse;
export type PatientSelfSignUpApiArg = {
  patientSelfSignUpFacadeRequest: PatientSelfSignUpFacadeRequest;
};
export type PatientAnonymousSelfSignUpApiResponse = /** status 201 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|device|object|||
|device._description|string|Device description||
|device._timezone|string|A java time zone supported by the java runtime environment|Europe/Oslo|
|device._id|string|The id of the device||
|device._ownerOrganization|object|||
|device._ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|device._ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|device._ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|device._ownerOrganization.templateName|string|The name of the referenced entity template||
|device._ownerOrganization.name|string|The caption of the referenced entity||
|device._template|object|||
|device._template.name|string|The name of the template||
|device._template.displayName|string|The display name of the template||
|device._template.parentTemplate|object|||
|device._template.parentTemplate.id|string|||
|device._template.parentTemplate.displayName|string|||
|device._template.parentTemplate.name|string|||
|device._template.id|string|The id of the template||
|device._referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|device._configuration|object|An object that holds the entity configuration attributes||
|device._status|object|||
|device._status._fwVersion|string|||
|device._status._hwVersion|string|||
|device._status._certificateStatus|string| Values:NOT_INSTALLED,BOOTSTRAP,PERMANENT||
|device._status._bootTime|string|A UTC date in the ISO-8601 format||
|device._status._connection|object|||
|device._status._connection._connected|boolean|If the device is connected to the MQTT the value is true, otherwise false|true|
|device._status._connection._ipAddress|string|The IP Address of the connected device|2007-12-20|
|device._status._connection._lastConnectedTime|string|The last time that the device was connected||
|device._status._operational|object|||
|device._status._operational._status|string|Operational status of the device Values:OK,MINOR,MAJOR,CRITICAL||
|device._status._operational._message|string|Operational status message||
|device._patient|object|||
|device._patient.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|device._patient.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|device._patient.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|device._patient.templateName|string|The name of the referenced entity template||
|device._patient.name|string|The caption of the referenced entity||
|device._registrationCode|object|||
|device._registrationCode.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|device._registrationCode.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|device._registrationCode.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|device._registrationCode.templateName|string|The name of the referenced entity template||
|device._registrationCode.name|string|The caption of the referenced entity||
|device._creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|device._lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|device._caption|string|The caption of the command instance|mydevice1|
|patient|object|||
|patient._name|object|||
|patient._name.firstName|string|A person's first name|John|
|patient._name.lastName|string|A person's last name|Smith|
|patient._description|string|A description, can be up to 5000 characters long|Lorem Ipsum|
|patient._email|string|An email address in the RFC-5322 specification|john.smith@biot-med.com|
|patient._phone|string|A person's phone An E.164 formatted phone number|+12345678901|
|patient._locale|string|A person's locale Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase.|en-us|
|patient._gender|string|A persons gender Values:MALE,FEMALE,UNDISCLOSED|FEMALE|
|patient._dateOfBirth|string|A person's date of birth A UTC date in the ISO-8601 format|Thu Dec 20 00:00:00 UTC 2007|
|patient._address|object|||
|patient._address.countryCode|string|A 2-letter country code defined in ISO-3166|US|
|patient._address.state|string|A state|Massachusetts|
|patient._address.city|string|A city|Boston|
|patient._address.zipCode|string|A zipcode|02101|
|patient._address.address1|string|An address|11 Main St.|
|patient._address.address2|string|An address's specifics|Entry B, Apartment 1|
|patient._mfa|object|||
|patient._mfa.enabled|boolean|MFA login enabled or disabled||
|patient._mfa.expirationInMinutes|integer|MFA expiration time in minutes||
|patient._credentialType|string|What type of credentials is used when logging in to the system. Default:PASSWORD Values:PASSWORD,OTP||
|patient._additionalPhone|string|An E.164 formatted phone number|+12345678901|
|patient._nationalId|string|A person's national ID|123456789|
|patient._id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|patient._ownerOrganization|object|||
|patient._ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|patient._ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|patient._ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|patient._ownerOrganization.templateName|string|The name of the referenced entity template||
|patient._ownerOrganization.name|string|The caption of the referenced entity||
|patient._caregiver|object|||
|patient._caregiver.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|patient._caregiver.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|patient._caregiver.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|patient._caregiver.templateName|string|The name of the referenced entity template||
|patient._caregiver.name|string|The caption of the referenced entity||
|patient._creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|patient._lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|patient._invitationAccepted|boolean|Has invitation been accepted||
|patient._template|object|||
|patient._template.name|string|The name of the template||
|patient._template.displayName|string|The display name of the template||
|patient._template.parentTemplate|object|||
|patient._template.parentTemplate.id|string|||
|patient._template.parentTemplate.displayName|string|||
|patient._template.parentTemplate.name|string|||
|patient._template.id|string|The id of the template||
|patient._referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|patient._enabled|string|Is the user enabled Values:DISABLED,ENABLED|ENABLED|DISABLED|
|patient._username|string|User's username. Can be an email or a regular username. With this username you login to the system.|john@biotmail.com or john123|
|patient._registrationSource|string|The source of the registration. Possible values: INVITATION / SELF|INVITATION|
|patient._canLogin|boolean|Determine whether a patient has the ability to login to the system or not||
|patient._nickname|string|The patient nickname. Used for anonymous users.||
|patient._caption|string|||
 */ PatientSelfSignUpFacadeResponse;
export type PatientAnonymousSelfSignUpApiArg = {
  patientAnonymousSelfSignUpFacadeRequest: PatientAnonymousSelfSignUpFacadeRequest;
};
export type HealthCheckApiResponse = /** status 200 OK */ VersionResponse;
export type HealthCheckApiArg = void;
export type CreateAlertApiResponse = /** status 201 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Regular custom attribute 1 value||
|&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Regular custom attribute N value||
|_caption|string|||
|_clearDateTime|string|Clear Date time of the alert|2007-12-20T10:15:30Z|
|_clearNotes|string|Clear notes||
|_clearTrigger|string|The alert cleared trigger type Values:MANUAL,AUTOMATIC|AUTOMATIC|
|_clearedBy|object|||
|_clearedBy.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_clearedBy.name|string|The caption of the referenced entity||
|_clearedBy.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_clearedBy.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_clearedBy.templateName|string|The name of the referenced entity template||
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_device|object|||
|_device.id|string|||
|_device.name|string|The caption of the referenced entity||
|_device.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_device.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_device.templateName|string|The name of the referenced entity template||
|_id|string|The id of the alert instance|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_name|string|The name of the alert||
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.name|string|The caption of the referenced entity||
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_setDateTime|string|Set Date time of the alert|2007-12-20T10:15:30Z|
|_severity|string|The alert wanted severity Values:CRITICAL,MAJOR,MINOR,INFO Default:INFO|MAJOR|
|_state|string|The alert wanted state Values:ACTIVE,CLEARED,SUSPENDED Default:ACTIVE|ACTIVE|
|_template|object|||
|_template.displayName|string|The display name of the template||
|_template.id|string|The id of the template||
|_template.name|string|The name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.name|string|||
 */ DeviceAlertResponse;
export type CreateAlertApiArg = {
  deviceId: string;
  createAlertRequest: CreateAlertRequest;
};
export type DeleteAlertApiResponse = /** status 204 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Regular custom attribute 1 value||
|&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Regular custom attribute N value||
 */ void;
export type DeleteAlertApiArg = {
  deviceId: string;
  /** Device Alert ID that needs to be deleted */
  id: string;
};
export type GetAlertApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Regular custom attribute 1 value||
|&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Regular custom attribute N value||
|_caption|string|||
|_clearDateTime|string|Clear Date time of the alert|2007-12-20T10:15:30Z|
|_clearNotes|string|Clear notes||
|_clearTrigger|string|The alert cleared trigger type Values:MANUAL,AUTOMATIC|AUTOMATIC|
|_clearedBy|object|||
|_clearedBy.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_clearedBy.name|string|The caption of the referenced entity||
|_clearedBy.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_clearedBy.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_clearedBy.templateName|string|The name of the referenced entity template||
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_device|object|||
|_device.id|string|||
|_device.name|string|The caption of the referenced entity||
|_device.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_device.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_device.templateName|string|The name of the referenced entity template||
|_id|string|The id of the alert instance|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_name|string|The name of the alert||
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.name|string|The caption of the referenced entity||
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_setDateTime|string|Set Date time of the alert|2007-12-20T10:15:30Z|
|_severity|string|The alert wanted severity Values:CRITICAL,MAJOR,MINOR,INFO Default:INFO|MAJOR|
|_state|string|The alert wanted state Values:ACTIVE,CLEARED,SUSPENDED Default:ACTIVE|ACTIVE|
|_template|object|||
|_template.displayName|string|The display name of the template||
|_template.id|string|The id of the template||
|_template.name|string|The name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.name|string|||
 */ DeviceAlertResponse;
export type GetAlertApiArg = {
  deviceId: string;
  /** Device Alert ID that needs to be fetched */
  id: string;
};
export type UpdateAlertApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Regular custom attribute 1 value||
|&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Regular custom attribute N value||
|_caption|string|||
|_clearDateTime|string|Clear Date time of the alert|2007-12-20T10:15:30Z|
|_clearNotes|string|Clear notes||
|_clearTrigger|string|The alert cleared trigger type Values:MANUAL,AUTOMATIC|AUTOMATIC|
|_clearedBy|object|||
|_clearedBy.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_clearedBy.name|string|The caption of the referenced entity||
|_clearedBy.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_clearedBy.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_clearedBy.templateName|string|The name of the referenced entity template||
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_device|object|||
|_device.id|string|||
|_device.name|string|The caption of the referenced entity||
|_device.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_device.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_device.templateName|string|The name of the referenced entity template||
|_id|string|The id of the alert instance|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_name|string|The name of the alert||
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.name|string|The caption of the referenced entity||
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_setDateTime|string|Set Date time of the alert|2007-12-20T10:15:30Z|
|_severity|string|The alert wanted severity Values:CRITICAL,MAJOR,MINOR,INFO Default:INFO|MAJOR|
|_state|string|The alert wanted state Values:ACTIVE,CLEARED,SUSPENDED Default:ACTIVE|ACTIVE|
|_template|object|||
|_template.displayName|string|The display name of the template||
|_template.id|string|The id of the template||
|_template.name|string|The name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.name|string|||
 */ DeviceAlertResponse;
export type UpdateAlertApiArg = {
  deviceId: string;
  /** Device Alert ID that needs to be updated */
  id: string;
  updateAlertRequest: UpdateAlertRequest;
};
export type CreateAlertByTemplateNameApiResponse = /** status 201 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Regular custom attribute 1 value||
|&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Regular custom attribute N value||
|_caption|string|||
|_clearDateTime|string|Clear Date time of the alert|2007-12-20T10:15:30Z|
|_clearNotes|string|Clear notes||
|_clearTrigger|string|The alert cleared trigger type Values:MANUAL,AUTOMATIC|AUTOMATIC|
|_clearedBy|object|||
|_clearedBy.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_clearedBy.name|string|The caption of the referenced entity||
|_clearedBy.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_clearedBy.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_clearedBy.templateName|string|The name of the referenced entity template||
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_device|object|||
|_device.id|string|||
|_device.name|string|The caption of the referenced entity||
|_device.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_device.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_device.templateName|string|The name of the referenced entity template||
|_id|string|The id of the alert instance|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_name|string|The name of the alert||
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.name|string|The caption of the referenced entity||
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_setDateTime|string|Set Date time of the alert|2007-12-20T10:15:30Z|
|_severity|string|The alert wanted severity Values:CRITICAL,MAJOR,MINOR,INFO Default:INFO|MAJOR|
|_state|string|The alert wanted state Values:ACTIVE,CLEARED,SUSPENDED Default:ACTIVE|ACTIVE|
|_template|object|||
|_template.displayName|string|The display name of the template||
|_template.id|string|The id of the template||
|_template.name|string|The name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.name|string|||
 */ DeviceAlertResponse;
export type CreateAlertByTemplateNameApiArg = {
  deviceId: string;
  templateName: string;
  createAlertByTemplateNameRequest: CreateAlertByTemplateNameRequest;
};
export type DeleteCommandApiResponse = /** status 204 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
 */ void;
export type DeleteCommandApiArg = {
  deviceId: string;
  /** Command ID that needs to be deleted */
  id: string;
};
export type GetCommandApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|_id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_device|object|||
|_device.id|string|||
|_device.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_device.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_device.templateName|string|The name of the referenced entity template||
|_device.name|string|The caption of the referenced entity||
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_ownerOrganization.name|string|The caption of the referenced entity||
|_startTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_endTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_state|string|The Action state Values:STARTING,IN_PROGRESS,COMPLETED,FAILED,TIMEOUT,STOPPING,ABORTED|IN_PROGRESS|
|_errorMessage|string|Error message||
|_supportStop|boolean|Is the template support stop command|false|
|_timeoutInSeconds|integer|The timeout of the command in seconds|10|
|_template|object|||
|_template.name|string|The name of the template||
|_template.displayName|string|The display name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.name|string|||
|_template.id|string|The id of the template||
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_configuration|object|An object that holds the entity configuration attributes||
|_summary|object|||
|_status|object|||
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_name|string|The name of the command||
|_caption|string|||
 */ CommandResponse;
export type GetCommandApiArg = {
  deviceId: string;
  /** Command ID that needs to be fetched */
  id: string;
};
export type StopCommandApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|_id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_device|object|||
|_device.id|string|||
|_device.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_device.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_device.templateName|string|The name of the referenced entity template||
|_device.name|string|The caption of the referenced entity||
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_ownerOrganization.name|string|The caption of the referenced entity||
|_startTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_endTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_state|string|The Action state Values:STARTING,IN_PROGRESS,COMPLETED,FAILED,TIMEOUT,STOPPING,ABORTED|IN_PROGRESS|
|_errorMessage|string|Error message||
|_supportStop|boolean|Is the template support stop command|false|
|_timeoutInSeconds|integer|The timeout of the command in seconds|10|
|_template|object|||
|_template.name|string|The name of the template||
|_template.displayName|string|The display name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.name|string|||
|_template.id|string|The id of the template||
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_configuration|object|An object that holds the entity configuration attributes||
|_summary|object|||
|_status|object|||
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_name|string|The name of the command||
|_caption|string|||
 */ CommandResponse;
export type StopCommandApiArg = {
  deviceId: string;
  /** Command ID */
  id: string;
};
export type StartCommandByTemplateNameApiResponse = /** status 201 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|_id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_device|object|||
|_device.id|string|||
|_device.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_device.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_device.templateName|string|The name of the referenced entity template||
|_device.name|string|The caption of the referenced entity||
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_ownerOrganization.name|string|The caption of the referenced entity||
|_startTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_endTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_state|string|The Action state Values:STARTING,IN_PROGRESS,COMPLETED,FAILED,TIMEOUT,STOPPING,ABORTED|IN_PROGRESS|
|_errorMessage|string|Error message||
|_supportStop|boolean|Is the template support stop command|false|
|_timeoutInSeconds|integer|The timeout of the command in seconds|10|
|_template|object|||
|_template.name|string|The name of the template||
|_template.displayName|string|The display name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.name|string|||
|_template.id|string|The id of the template||
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_configuration|object|An object that holds the entity configuration attributes||
|_summary|object|||
|_status|object|||
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_name|string|The name of the command||
|_caption|string|||
 */ CommandResponse;
export type StartCommandByTemplateNameApiArg = {
  deviceId: string;
  templateName: string;
  startCommandByTemplateNameRequest: StartCommandByTemplateNameRequest;
};
export type StartCommandApiResponse = /** status 201 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Regular custom attribute 1 value||
|&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Regular custom attribute N value||
|_caption|string|||
|_configuration|object|An object that holds the entity configuration attributes||
|_configuration.&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Configuration custom attribute 1 value||
|_configuration.&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Configuration custom attribute N value||
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_device|object|||
|_device.id|string|||
|_device.name|string|The caption of the referenced entity||
|_device.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_device.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_device.templateName|string|The name of the referenced entity template||
|_endTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_errorMessage|string|Error message||
|_id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_name|string|The name of the command||
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.name|string|The caption of the referenced entity||
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_startTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_state|string|The Action state Values:STARTING,IN_PROGRESS,COMPLETED,FAILED,TIMEOUT,STOPPING,ABORTED|IN_PROGRESS|
|_status|object|||
|_status.&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Status custom attribute 1 value||
|_status.&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Status custom attribute N value||
|_summary|object|||
|_summary.&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Summary custom attribute 1 value||
|_summary.&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Summary custom attribute N value||
|_supportStop|boolean|Is the template support stop command|false|
|_template|object|||
|_template.displayName|string|The display name of the template||
|_template.id|string|The id of the template||
|_template.name|string|The name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.name|string|||
|_timeoutInSeconds|integer|The timeout of the command in seconds|10|
 */ CommandResponse;
export type StartCommandApiArg = {
  deviceId: string;
  startCommandRequest: StartCommandRequest;
};
export type CreateSessionApiResponse = /** status 201 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Regular custom attribute 1 value||
|&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Regular custom attribute N value||
|_caption|string|||
|_configuration|object|An object that holds the entity configuration attributes||
|_configuration.&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Configuration custom attribute 1 value||
|_configuration.&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Configuration custom attribute N value||
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_device|object|||
|_device.id|string|||
|_device.name|string|The caption of the referenced entity||
|_device.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_device.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_device.templateName|string|The name of the referenced entity template||
|_endTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_id|string|Session ID|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_initiator|string|What API initiated the session Values:REMOTE_CONTROL,EXTERNAL|EXTERNAL|
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_name|string|The name of the session||
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.name|string|The caption of the referenced entity||
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_patient|object|||
|_patient.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_patient.name|string|The caption of the referenced entity||
|_patient.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_patient.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_patient.templateName|string|The name of the referenced entity template||
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_requiredMeasurementIntervalMilliseconds|integer|The interval between measurements in milliseconds|1000|
|_sessionContext|string|The context that is linked to the current session and should be sent in a measurement message||
|_startTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_state|string|The Sessions state Values:ACTIVE,DONE,PAUSED,ACTIVATING,PAUSING,RESUMING,STOPPING|ACTIVE|
|_summary|object|||
|_summary.&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Summary custom attribute 1 value||
|_summary.&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Summary custom attribute N value||
|_summary._stopReason|string|The reason the session was stopped|Manual Stop|
|_summary._stopReasonCode|string|The code of the stop reason Values:COMPLETION,GENERAL_DEVICE_ERROR,TIMEOUT|COMPLETION|
|_template|object|||
|_template.displayName|string|The display name of the template||
|_template.id|string|The id of the template||
|_template.name|string|The name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.name|string|||
 */ SessionResponseV2;
export type CreateSessionApiArg = {
  deviceId: string;
  createSessionRequestV2: CreateSessionRequestV2;
};
export type DeleteSessionApiResponse = /** status 204 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
 */ void;
export type DeleteSessionApiArg = {
  deviceId: string;
  /** Usage Session ID that needs to be deleted */
  id: string;
};
export type GetSessionApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Regular custom attribute 1 value||
|&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Regular custom attribute N value||
|_caption|string|||
|_configuration|object|An object that holds the entity configuration attributes||
|_configuration.&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Configuration custom attribute 1 value||
|_configuration.&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Configuration custom attribute N value||
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_device|object|||
|_device.id|string|||
|_device.name|string|The caption of the referenced entity||
|_device.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_device.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_device.templateName|string|The name of the referenced entity template||
|_endTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_id|string|Session ID|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_initiator|string|What API initiated the session Values:REMOTE_CONTROL,EXTERNAL|EXTERNAL|
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_name|string|The name of the session||
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.name|string|The caption of the referenced entity||
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_patient|object|||
|_patient.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_patient.name|string|The caption of the referenced entity||
|_patient.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_patient.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_patient.templateName|string|The name of the referenced entity template||
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_requiredMeasurementIntervalMilliseconds|integer|The interval between measurements in milliseconds|1000|
|_sessionContext|string|The context that is linked to the current session and should be sent in a measurement message||
|_startTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_state|string|The Sessions state Values:ACTIVE,DONE,PAUSED,ACTIVATING,PAUSING,RESUMING,STOPPING|ACTIVE|
|_summary|object|||
|_summary.&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Summary custom attribute 1 value||
|_summary.&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Summary custom attribute N value||
|_summary._stopReason|string|The reason the session was stopped|Manual Stop|
|_summary._stopReasonCode|string|The code of the stop reason Values:COMPLETION,GENERAL_DEVICE_ERROR,TIMEOUT|COMPLETION|
|_template|object|||
|_template.displayName|string|The display name of the template||
|_template.id|string|The id of the template||
|_template.name|string|The name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.name|string|||
 */ SessionResponseV2;
export type GetSessionApiArg = {
  deviceId: string;
  /** Usage Session ID that needs to be fetched */
  id: string;
};
export type UpdateSessionApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Regular custom attribute 1 value||
|&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Regular custom attribute N value||
|_caption|string|||
|_configuration|object|An object that holds the entity configuration attributes||
|_configuration.&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Configuration custom attribute 1 value||
|_configuration.&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Configuration custom attribute N value||
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_device|object|||
|_device.id|string|||
|_device.name|string|The caption of the referenced entity||
|_device.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_device.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_device.templateName|string|The name of the referenced entity template||
|_endTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_id|string|Session ID|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_initiator|string|What API initiated the session Values:REMOTE_CONTROL,EXTERNAL|EXTERNAL|
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_name|string|The name of the session||
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.name|string|The caption of the referenced entity||
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_patient|object|||
|_patient.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_patient.name|string|The caption of the referenced entity||
|_patient.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_patient.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_patient.templateName|string|The name of the referenced entity template||
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_requiredMeasurementIntervalMilliseconds|integer|The interval between measurements in milliseconds|1000|
|_sessionContext|string|The context that is linked to the current session and should be sent in a measurement message||
|_startTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_state|string|The Sessions state Values:ACTIVE,DONE,PAUSED,ACTIVATING,PAUSING,RESUMING,STOPPING|ACTIVE|
|_summary|object|||
|_summary.&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Summary custom attribute 1 value||
|_summary.&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Summary custom attribute N value||
|_summary._stopReason|string|The reason the session was stopped|Manual Stop|
|_summary._stopReasonCode|string|The code of the stop reason Values:COMPLETION,GENERAL_DEVICE_ERROR,TIMEOUT|COMPLETION|
|_template|object|||
|_template.displayName|string|The display name of the template||
|_template.id|string|The id of the template||
|_template.name|string|The name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.name|string|||
 */ SessionResponseV2;
export type UpdateSessionApiArg = {
  deviceId: string;
  /** Usage Session ID that needs to be updated */
  id: string;
  updateSessionRequestV2: UpdateSessionRequestV2;
};
export type PauseSessionApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Regular custom attribute 1 value||
|&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Regular custom attribute N value||
|_caption|string|||
|_configuration|object|An object that holds the entity configuration attributes||
|_configuration.&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Configuration custom attribute 1 value||
|_configuration.&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Configuration custom attribute N value||
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_device|object|||
|_device.id|string|||
|_device.name|string|The caption of the referenced entity||
|_device.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_device.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_device.templateName|string|The name of the referenced entity template||
|_endTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_id|string|Session ID|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_initiator|string|What API initiated the session Values:REMOTE_CONTROL,EXTERNAL|EXTERNAL|
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_name|string|The name of the session||
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.name|string|The caption of the referenced entity||
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_patient|object|||
|_patient.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_patient.name|string|The caption of the referenced entity||
|_patient.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_patient.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_patient.templateName|string|The name of the referenced entity template||
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_requiredMeasurementIntervalMilliseconds|integer|The interval between measurements in milliseconds|1000|
|_sessionContext|string|The context that is linked to the current session and should be sent in a measurement message||
|_startTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_state|string|The Sessions state Values:ACTIVE,DONE,PAUSED,ACTIVATING,PAUSING,RESUMING,STOPPING|ACTIVE|
|_summary|object|||
|_summary.&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Summary custom attribute 1 value||
|_summary.&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Summary custom attribute N value||
|_summary._stopReason|string|The reason the session was stopped|Manual Stop|
|_summary._stopReasonCode|string|The code of the stop reason Values:COMPLETION,GENERAL_DEVICE_ERROR,TIMEOUT|COMPLETION|
|_template|object|||
|_template.displayName|string|The display name of the template||
|_template.id|string|The id of the template||
|_template.name|string|The name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.name|string|||
 */ SessionResponseV2;
export type PauseSessionApiArg = {
  deviceId: string;
  /** Usage Session ID */
  id: string;
};
export type ResumeSessionApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Regular custom attribute 1 value||
|&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Regular custom attribute N value||
|_caption|string|||
|_configuration|object|An object that holds the entity configuration attributes||
|_configuration.&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Configuration custom attribute 1 value||
|_configuration.&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Configuration custom attribute N value||
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_device|object|||
|_device.id|string|||
|_device.name|string|The caption of the referenced entity||
|_device.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_device.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_device.templateName|string|The name of the referenced entity template||
|_endTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_id|string|Session ID|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_initiator|string|What API initiated the session Values:REMOTE_CONTROL,EXTERNAL|EXTERNAL|
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_name|string|The name of the session||
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.name|string|The caption of the referenced entity||
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_patient|object|||
|_patient.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_patient.name|string|The caption of the referenced entity||
|_patient.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_patient.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_patient.templateName|string|The name of the referenced entity template||
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_requiredMeasurementIntervalMilliseconds|integer|The interval between measurements in milliseconds|1000|
|_sessionContext|string|The context that is linked to the current session and should be sent in a measurement message||
|_startTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_state|string|The Sessions state Values:ACTIVE,DONE,PAUSED,ACTIVATING,PAUSING,RESUMING,STOPPING|ACTIVE|
|_summary|object|||
|_summary.&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Summary custom attribute 1 value||
|_summary.&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Summary custom attribute N value||
|_summary._stopReason|string|The reason the session was stopped|Manual Stop|
|_summary._stopReasonCode|string|The code of the stop reason Values:COMPLETION,GENERAL_DEVICE_ERROR,TIMEOUT|COMPLETION|
|_template|object|||
|_template.displayName|string|The display name of the template||
|_template.id|string|The id of the template||
|_template.name|string|The name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.name|string|||
 */ SessionResponseV2;
export type ResumeSessionApiArg = {
  deviceId: string;
  /** Usage Session ID */
  id: string;
};
export type StopSessionApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Regular custom attribute 1 value||
|&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Regular custom attribute N value||
|_caption|string|||
|_configuration|object|An object that holds the entity configuration attributes||
|_configuration.&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Configuration custom attribute 1 value||
|_configuration.&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Configuration custom attribute N value||
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_device|object|||
|_device.id|string|||
|_device.name|string|The caption of the referenced entity||
|_device.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_device.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_device.templateName|string|The name of the referenced entity template||
|_endTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_id|string|Session ID|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_initiator|string|What API initiated the session Values:REMOTE_CONTROL,EXTERNAL|EXTERNAL|
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_name|string|The name of the session||
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.name|string|The caption of the referenced entity||
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_patient|object|||
|_patient.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_patient.name|string|The caption of the referenced entity||
|_patient.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_patient.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_patient.templateName|string|The name of the referenced entity template||
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_requiredMeasurementIntervalMilliseconds|integer|The interval between measurements in milliseconds|1000|
|_sessionContext|string|The context that is linked to the current session and should be sent in a measurement message||
|_startTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_state|string|The Sessions state Values:ACTIVE,DONE,PAUSED,ACTIVATING,PAUSING,RESUMING,STOPPING|ACTIVE|
|_summary|object|||
|_summary.&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Summary custom attribute 1 value||
|_summary.&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Summary custom attribute N value||
|_summary._stopReason|string|The reason the session was stopped|Manual Stop|
|_summary._stopReasonCode|string|The code of the stop reason Values:COMPLETION,GENERAL_DEVICE_ERROR,TIMEOUT|COMPLETION|
|_template|object|||
|_template.displayName|string|The display name of the template||
|_template.id|string|The id of the template||
|_template.name|string|The name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.name|string|||
 */ SessionResponseV2;
export type StopSessionApiArg = {
  /** The device ID */
  deviceId: string;
  /** Usage Session ID */
  id: string;
};
export type StartSessionApiResponse = /** status 201 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Regular custom attribute 1 value||
|&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Regular custom attribute N value||
|_caption|string|||
|_configuration|object|An object that holds the entity configuration attributes||
|_configuration.&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Configuration custom attribute 1 value||
|_configuration.&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Configuration custom attribute N value||
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_device|object|||
|_device.id|string|||
|_device.name|string|The caption of the referenced entity||
|_device.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_device.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_device.templateName|string|The name of the referenced entity template||
|_endTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_id|string|Session ID|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_initiator|string|What API initiated the session Values:REMOTE_CONTROL,EXTERNAL|EXTERNAL|
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_name|string|The name of the session||
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.name|string|The caption of the referenced entity||
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_patient|object|||
|_patient.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_patient.name|string|The caption of the referenced entity||
|_patient.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_patient.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_patient.templateName|string|The name of the referenced entity template||
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_requiredMeasurementIntervalMilliseconds|integer|The interval between measurements in milliseconds|1000|
|_sessionContext|string|The context that is linked to the current session and should be sent in a measurement message||
|_startTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_state|string|The Sessions state Values:ACTIVE,DONE,PAUSED,ACTIVATING,PAUSING,RESUMING,STOPPING|ACTIVE|
|_summary|object|||
|_summary.&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Summary custom attribute 1 value||
|_summary.&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Summary custom attribute N value||
|_summary._stopReason|string|The reason the session was stopped|Manual Stop|
|_summary._stopReasonCode|string|The code of the stop reason Values:COMPLETION,GENERAL_DEVICE_ERROR,TIMEOUT|COMPLETION|
|_template|object|||
|_template.displayName|string|The display name of the template||
|_template.id|string|The id of the template||
|_template.name|string|The name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.name|string|||
 */ SessionResponseV2;
export type StartSessionApiArg = {
  deviceId: string;
  startSessionRequestV2: StartSessionRequestV2;
};
export type CreateSessionByUsageTypeApiResponse = /** status 201 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Regular custom attribute 1 value||
|&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Regular custom attribute N value||
|_caption|string|||
|_configuration|object|An object that holds the entity configuration attributes||
|_configuration.&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Configuration custom attribute 1 value||
|_configuration.&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Configuration custom attribute N value||
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_device|object|||
|_device.id|string|||
|_device.name|string|The caption of the referenced entity||
|_device.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_device.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_device.templateName|string|The name of the referenced entity template||
|_endTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_id|string|Session ID|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_initiator|string|What API initiated the session Values:REMOTE_CONTROL,EXTERNAL|EXTERNAL|
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_name|string|The name of the session||
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.name|string|The caption of the referenced entity||
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_patient|object|||
|_patient.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_patient.name|string|The caption of the referenced entity||
|_patient.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_patient.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_patient.templateName|string|The name of the referenced entity template||
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_requiredMeasurementIntervalMilliseconds|integer|The interval between measurements in milliseconds|1000|
|_sessionContext|string|The context that is linked to the current session and should be sent in a measurement message||
|_startTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_state|string|The Sessions state Values:ACTIVE,DONE,PAUSED,ACTIVATING,PAUSING,RESUMING,STOPPING|ACTIVE|
|_summary|object|||
|_summary.&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Summary custom attribute 1 value||
|_summary.&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Summary custom attribute N value||
|_summary._stopReason|string|The reason the session was stopped|Manual Stop|
|_summary._stopReasonCode|string|The code of the stop reason Values:COMPLETION,GENERAL_DEVICE_ERROR,TIMEOUT|COMPLETION|
|_template|object|||
|_template.displayName|string|The display name of the template||
|_template.id|string|The id of the template||
|_template.name|string|The name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.name|string|||
 */ SessionResponseV2;
export type CreateSessionByUsageTypeApiArg = {
  deviceId: string;
  usageType: string;
  createSessionByUsageTypeRequestV2: CreateSessionByUsageTypeRequestV2;
};
export type SearchAlertsApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|data|array|List of items that match the search request||
|data[index]|array|List of items that match the search request||
|data[index]._state|string|The alert wanted state Values:ACTIVE,CLEARED,SUSPENDED Default:ACTIVE|ACTIVE|
|data[index]._severity|string|The alert wanted severity Values:CRITICAL,MAJOR,MINOR,INFO Default:INFO|MAJOR|
|data[index]._clearNotes|string|Clear notes||
|data[index]._name|string|The name of the alert||
|data[index]._id|string|The id of the alert instance|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._template|object|||
|data[index]._template.name|string|The name of the template||
|data[index]._template.displayName|string|The display name of the template||
|data[index]._template.parentTemplate|object|||
|data[index]._template.parentTemplate.id|string|||
|data[index]._template.parentTemplate.displayName|string|||
|data[index]._template.parentTemplate.name|string|||
|data[index]._template.id|string|The id of the template||
|data[index]._referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|data[index]._ownerOrganization|object|||
|data[index]._ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|data[index]._ownerOrganization.templateName|string|The name of the referenced entity template||
|data[index]._ownerOrganization.name|string|The caption of the referenced entity||
|data[index]._clearDateTime|string|Clear Date time of the alert|2007-12-20T10:15:30Z|
|data[index]._clearTrigger|string|The alert cleared trigger type Values:MANUAL,AUTOMATIC|AUTOMATIC|
|data[index]._clearedBy|object|||
|data[index]._clearedBy.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._clearedBy.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._clearedBy.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|data[index]._clearedBy.templateName|string|The name of the referenced entity template||
|data[index]._clearedBy.name|string|The caption of the referenced entity||
|data[index]._creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|data[index]._lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|data[index]._device|object|||
|data[index]._device.id|string|||
|data[index]._device.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._device.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|data[index]._device.templateName|string|The name of the referenced entity template||
|data[index]._device.name|string|The caption of the referenced entity||
|data[index]._setDateTime|string|Set Date time of the alert|2007-12-20T10:15:30Z|
|data[index]._caption|string|||
|metadata|object|||
|metadata.sort|array|Sort that was passed in the request||
|metadata.sort[index]|array|Sort that was passed in the request||
|metadata.sort[index].prop|string|The property name for the sort||
|metadata.sort[index].order|string|The direction of sort. Default DESC Values:ASC,DESC|ASC|
|metadata.filter|object|The filter that was passed in the request||
|metadata.page|object|||
|metadata.page.totalResults|integer|The total number of items that match the query|145|
|metadata.page.page|integer|Page number|3|
|metadata.page.limit|integer|Number of items per page|100|
|metadata.freeTextSearch|string|Free text search strings that was passed in the request|cat dog|
 */ SearchResponseDeviceAlertResponse;
export type SearchAlertsApiArg = {
  /** Search request parameters: filter, sort and page */
  searchRequest?: string;
};
export type SearchCommandsApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|data|array|List of items that match the search request||
|data[index]|array|List of items that match the search request||
|data[index]._id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._device|object|||
|data[index]._device.id|string|||
|data[index]._device.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._device.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|data[index]._device.templateName|string|The name of the referenced entity template||
|data[index]._device.name|string|The caption of the referenced entity||
|data[index]._ownerOrganization|object|||
|data[index]._ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|data[index]._ownerOrganization.templateName|string|The name of the referenced entity template||
|data[index]._ownerOrganization.name|string|The caption of the referenced entity||
|data[index]._startTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|data[index]._endTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|data[index]._state|string|The Action state Values:STARTING,IN_PROGRESS,COMPLETED,FAILED,TIMEOUT,STOPPING,ABORTED|IN_PROGRESS|
|data[index]._errorMessage|string|Error message||
|data[index]._supportStop|boolean|Is the template support stop command|false|
|data[index]._timeoutInSeconds|integer|The timeout of the command in seconds|10|
|data[index]._template|object|||
|data[index]._template.name|string|The name of the template||
|data[index]._template.displayName|string|The display name of the template||
|data[index]._template.parentTemplate|object|||
|data[index]._template.parentTemplate.id|string|||
|data[index]._template.parentTemplate.displayName|string|||
|data[index]._template.parentTemplate.name|string|||
|data[index]._template.id|string|The id of the template||
|data[index]._referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|data[index]._configuration|object|An object that holds the entity configuration attributes||
|data[index]._summary|object|||
|data[index]._status|object|||
|data[index]._lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|data[index]._creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|data[index]._name|string|The name of the command||
|data[index]._caption|string|||
|metadata|object|||
|metadata.sort|array|Sort that was passed in the request||
|metadata.sort[index]|array|Sort that was passed in the request||
|metadata.sort[index].prop|string|The property name for the sort||
|metadata.sort[index].order|string|The direction of sort. Default DESC Values:ASC,DESC|ASC|
|metadata.filter|object|The filter that was passed in the request||
|metadata.page|object|||
|metadata.page.totalResults|integer|The total number of items that match the query|145|
|metadata.page.page|integer|Page number|3|
|metadata.page.limit|integer|Number of items per page|100|
|metadata.freeTextSearch|string|Free text search strings that was passed in the request|cat dog|
 */ SearchResponseCommandResponse;
export type SearchCommandsApiArg = {
  /** Search request parameters: filter, sort and page */
  searchRequest?: string;
};
export type SearchCurrentAlertsApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|data|array|List of items that match the search request||
|data[index]|array|List of items that match the search request||
|data[index]._device|object|||
|data[index]._device._description|string|Device description||
|data[index]._device._timezone|string|A java time zone supported by the java runtime environment|Europe/Oslo|
|data[index]._device._id|string|The id of the device||
|data[index]._device._ownerOrganization|object|||
|data[index]._device._ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._device._ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._device._ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|data[index]._device._ownerOrganization.templateName|string|The name of the referenced entity template||
|data[index]._device._ownerOrganization.name|string|The caption of the referenced entity||
|data[index]._device._template|object|||
|data[index]._device._template.name|string|The name of the template||
|data[index]._device._template.displayName|string|The display name of the template||
|data[index]._device._template.parentTemplate|object|||
|data[index]._device._template.parentTemplate.id|string|||
|data[index]._device._template.parentTemplate.displayName|string|||
|data[index]._device._template.parentTemplate.name|string|||
|data[index]._device._template.id|string|The id of the template||
|data[index]._device._referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|data[index]._device._configuration|object|An object that holds the entity configuration attributes||
|data[index]._device._status|object|||
|data[index]._device._status._fwVersion|string|||
|data[index]._device._status._hwVersion|string|||
|data[index]._device._status._certificateStatus|string| Values:NOT_INSTALLED,BOOTSTRAP,PERMANENT||
|data[index]._device._status._bootTime|string|A UTC date in the ISO-8601 format||
|data[index]._device._status._connection|object|||
|data[index]._device._status._connection._connected|boolean|If the device is connected to the MQTT the value is true, otherwise false|true|
|data[index]._device._status._connection._ipAddress|string|The IP Address of the connected device|2007-12-20|
|data[index]._device._status._connection._lastConnectedTime|string|The last time that the device was connected||
|data[index]._device._status._operational|object|||
|data[index]._device._status._operational._status|string|Operational status of the device Values:OK,MINOR,MAJOR,CRITICAL||
|data[index]._device._status._operational._message|string|Operational status message||
|data[index]._device._patient|object|||
|data[index]._device._patient.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._device._patient.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._device._patient.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|data[index]._device._patient.templateName|string|The name of the referenced entity template||
|data[index]._device._patient.name|string|The caption of the referenced entity||
|data[index]._device._registrationCode|object|||
|data[index]._device._registrationCode.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._device._registrationCode.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._device._registrationCode.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|data[index]._device._registrationCode.templateName|string|The name of the referenced entity template||
|data[index]._device._registrationCode.name|string|The caption of the referenced entity||
|data[index]._device._creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|data[index]._device._lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|data[index]._device._caption|string|The caption of the command instance|mydevice1|
|data[index]._alerts|array|||
|data[index]._alerts[index]|array|||
|data[index]._alerts[index]._state|string|The alert wanted state Values:ACTIVE,CLEARED,SUSPENDED Default:ACTIVE|ACTIVE|
|data[index]._alerts[index]._severity|string|The alert wanted severity Values:CRITICAL,MAJOR,MINOR,INFO Default:INFO|MAJOR|
|data[index]._alerts[index]._clearNotes|string|Clear notes||
|data[index]._alerts[index]._name|string|The name of the alert||
|data[index]._alerts[index]._id|string|The id of the alert instance|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._alerts[index]._template|object|||
|data[index]._alerts[index]._template.name|string|The name of the template||
|data[index]._alerts[index]._template.displayName|string|The display name of the template||
|data[index]._alerts[index]._template.parentTemplate|object|||
|data[index]._alerts[index]._template.parentTemplate.id|string|||
|data[index]._alerts[index]._template.parentTemplate.displayName|string|||
|data[index]._alerts[index]._template.parentTemplate.name|string|||
|data[index]._alerts[index]._template.id|string|The id of the template||
|data[index]._alerts[index]._referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|data[index]._alerts[index]._ownerOrganization|object|||
|data[index]._alerts[index]._ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._alerts[index]._ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._alerts[index]._ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|data[index]._alerts[index]._ownerOrganization.templateName|string|The name of the referenced entity template||
|data[index]._alerts[index]._ownerOrganization.name|string|The caption of the referenced entity||
|data[index]._alerts[index]._clearDateTime|string|Clear Date time of the alert|2007-12-20T10:15:30Z|
|data[index]._alerts[index]._clearTrigger|string|The alert cleared trigger type Values:MANUAL,AUTOMATIC|AUTOMATIC|
|data[index]._alerts[index]._clearedBy|object|||
|data[index]._alerts[index]._clearedBy.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._alerts[index]._clearedBy.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._alerts[index]._clearedBy.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|data[index]._alerts[index]._clearedBy.templateName|string|The name of the referenced entity template||
|data[index]._alerts[index]._clearedBy.name|string|The caption of the referenced entity||
|data[index]._alerts[index]._creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|data[index]._alerts[index]._lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|data[index]._alerts[index]._device|object|||
|data[index]._alerts[index]._device.id|string|||
|data[index]._alerts[index]._device.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._alerts[index]._device.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|data[index]._alerts[index]._device.templateName|string|The name of the referenced entity template||
|data[index]._alerts[index]._device.name|string|The caption of the referenced entity||
|data[index]._alerts[index]._setDateTime|string|Set Date time of the alert|2007-12-20T10:15:30Z|
|data[index]._alerts[index]._caption|string|||
|metadata|object|||
|metadata.sort|array|Sort that was passed in the request||
|metadata.sort[index]|array|Sort that was passed in the request||
|metadata.sort[index].prop|string|The property name for the sort||
|metadata.sort[index].order|string|The direction of sort. Default DESC Values:ASC,DESC|ASC|
|metadata.filter|object|The filter that was passed in the request||
|metadata.page|object|||
|metadata.page.totalResults|integer|The total number of items that match the query|145|
|metadata.page.page|integer|Page number|3|
|metadata.page.limit|integer|Number of items per page|100|
|metadata.freeTextSearch|string|Free text search strings that was passed in the request|cat dog|
 */ SearchResponseDeviceOwnedAlertResponse;
export type SearchCurrentAlertsApiArg = {
  /** Search request parameters: filter, sort and page */
  searchRequest?: string;
};
export type SearchDeviceSessionsApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|data|array|List of items that match the search request||
|data[index]|array|List of items that match the search request||
|data[index]._device|object|||
|data[index]._device._description|string|Device description||
|data[index]._device._timezone|string|A java time zone supported by the java runtime environment|Europe/Oslo|
|data[index]._device._id|string|The id of the device||
|data[index]._device._ownerOrganization|object|||
|data[index]._device._ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._device._ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._device._ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|data[index]._device._ownerOrganization.templateName|string|The name of the referenced entity template||
|data[index]._device._ownerOrganization.name|string|The caption of the referenced entity||
|data[index]._device._template|object|||
|data[index]._device._template.name|string|The name of the template||
|data[index]._device._template.displayName|string|The display name of the template||
|data[index]._device._template.parentTemplate|object|||
|data[index]._device._template.parentTemplate.id|string|||
|data[index]._device._template.parentTemplate.displayName|string|||
|data[index]._device._template.parentTemplate.name|string|||
|data[index]._device._template.id|string|The id of the template||
|data[index]._device._referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|data[index]._device._configuration|object|An object that holds the entity configuration attributes||
|data[index]._device._status|object|||
|data[index]._device._status._fwVersion|string|||
|data[index]._device._status._hwVersion|string|||
|data[index]._device._status._certificateStatus|string| Values:NOT_INSTALLED,BOOTSTRAP,PERMANENT||
|data[index]._device._status._bootTime|string|A UTC date in the ISO-8601 format||
|data[index]._device._status._connection|object|||
|data[index]._device._status._connection._connected|boolean|If the device is connected to the MQTT the value is true, otherwise false|true|
|data[index]._device._status._connection._ipAddress|string|The IP Address of the connected device|2007-12-20|
|data[index]._device._status._connection._lastConnectedTime|string|The last time that the device was connected||
|data[index]._device._status._operational|object|||
|data[index]._device._status._operational._status|string|Operational status of the device Values:OK,MINOR,MAJOR,CRITICAL||
|data[index]._device._status._operational._message|string|Operational status message||
|data[index]._device._patient|object|||
|data[index]._device._patient.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._device._patient.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._device._patient.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|data[index]._device._patient.templateName|string|The name of the referenced entity template||
|data[index]._device._patient.name|string|The caption of the referenced entity||
|data[index]._device._registrationCode|object|||
|data[index]._device._registrationCode.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._device._registrationCode.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._device._registrationCode.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|data[index]._device._registrationCode.templateName|string|The name of the referenced entity template||
|data[index]._device._registrationCode.name|string|The caption of the referenced entity||
|data[index]._device._creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|data[index]._device._lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|data[index]._device._caption|string|The caption of the command instance|mydevice1|
|data[index]._sessions|array|||
|data[index]._sessions[index]|array|||
|data[index]._sessions[index]._id|string|Session ID|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._sessions[index]._patient|object|||
|data[index]._sessions[index]._patient.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._sessions[index]._patient.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._sessions[index]._patient.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|data[index]._sessions[index]._patient.templateName|string|The name of the referenced entity template||
|data[index]._sessions[index]._patient.name|string|The caption of the referenced entity||
|data[index]._sessions[index]._device|object|||
|data[index]._sessions[index]._device.id|string|||
|data[index]._sessions[index]._device.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._sessions[index]._device.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|data[index]._sessions[index]._device.templateName|string|The name of the referenced entity template||
|data[index]._sessions[index]._device.name|string|The caption of the referenced entity||
|data[index]._sessions[index]._ownerOrganization|object|||
|data[index]._sessions[index]._ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._sessions[index]._ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._sessions[index]._ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|data[index]._sessions[index]._ownerOrganization.templateName|string|The name of the referenced entity template||
|data[index]._sessions[index]._ownerOrganization.name|string|The caption of the referenced entity||
|data[index]._sessions[index]._startTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|data[index]._sessions[index]._endTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|data[index]._sessions[index]._state|string|The Sessions state Values:ACTIVE,DONE,PAUSED,ACTIVATING,PAUSING,RESUMING,STOPPING|ACTIVE|
|data[index]._sessions[index]._initiator|string|What API initiated the session Values:REMOTE_CONTROL,EXTERNAL|EXTERNAL|
|data[index]._sessions[index]._requiredMeasurementIntervalMilliseconds|integer|The interval between measurements in milliseconds|1000|
|data[index]._sessions[index]._template|object|||
|data[index]._sessions[index]._template.name|string|The name of the template||
|data[index]._sessions[index]._template.displayName|string|The display name of the template||
|data[index]._sessions[index]._template.parentTemplate|object|||
|data[index]._sessions[index]._template.parentTemplate.id|string|||
|data[index]._sessions[index]._template.parentTemplate.displayName|string|||
|data[index]._sessions[index]._template.parentTemplate.name|string|||
|data[index]._sessions[index]._template.id|string|The id of the template||
|data[index]._sessions[index]._referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|data[index]._sessions[index]._configuration|object|An object that holds the entity configuration attributes||
|data[index]._sessions[index]._summary|object|||
|data[index]._sessions[index]._summary._stopReason|string|The reason the session was stopped|Manual Stop|
|data[index]._sessions[index]._summary._stopReasonCode|string|The code of the stop reason Values:COMPLETION,GENERAL_DEVICE_ERROR,TIMEOUT|COMPLETION|
|data[index]._sessions[index]._lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|data[index]._sessions[index]._creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|data[index]._sessions[index]._name|string|The name of the session||
|data[index]._sessions[index]._sessionContext|string|The context that is linked to the current session and should be sent in a measurement message||
|data[index]._sessions[index]._caption|string|||
|metadata|object|||
|metadata.sort|array|Sort that was passed in the request||
|metadata.sort[index]|array|Sort that was passed in the request||
|metadata.sort[index].prop|string|The property name for the sort||
|metadata.sort[index].order|string|The direction of sort. Default DESC Values:ASC,DESC|ASC|
|metadata.filter|object|The filter that was passed in the request||
|metadata.page|object|||
|metadata.page.totalResults|integer|The total number of items that match the query|145|
|metadata.page.page|integer|Page number|3|
|metadata.page.limit|integer|Number of items per page|100|
|metadata.freeTextSearch|string|Free text search strings that was passed in the request|cat dog|
 */ SearchResponseDeviceSessionsResponseV2;
export type SearchDeviceSessionsApiArg = {
  /** Search request parameters: filter, sort and page */
  searchRequest?: string;
};
export type SearchSessionsApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|data|array|List of items that match the search request||
|data[index]|array|List of items that match the search request||
|data[index]._id|string|Session ID|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._patient|object|||
|data[index]._patient.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._patient.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._patient.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|data[index]._patient.templateName|string|The name of the referenced entity template||
|data[index]._patient.name|string|The caption of the referenced entity||
|data[index]._device|object|||
|data[index]._device.id|string|||
|data[index]._device.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._device.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|data[index]._device.templateName|string|The name of the referenced entity template||
|data[index]._device.name|string|The caption of the referenced entity||
|data[index]._ownerOrganization|object|||
|data[index]._ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|data[index]._ownerOrganization.templateName|string|The name of the referenced entity template||
|data[index]._ownerOrganization.name|string|The caption of the referenced entity||
|data[index]._startTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|data[index]._endTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|data[index]._state|string|The Sessions state Values:ACTIVE,DONE,PAUSED,ACTIVATING,PAUSING,RESUMING,STOPPING|ACTIVE|
|data[index]._initiator|string|What API initiated the session Values:REMOTE_CONTROL,EXTERNAL|EXTERNAL|
|data[index]._requiredMeasurementIntervalMilliseconds|integer|The interval between measurements in milliseconds|1000|
|data[index]._template|object|||
|data[index]._template.name|string|The name of the template||
|data[index]._template.displayName|string|The display name of the template||
|data[index]._template.parentTemplate|object|||
|data[index]._template.parentTemplate.id|string|||
|data[index]._template.parentTemplate.displayName|string|||
|data[index]._template.parentTemplate.name|string|||
|data[index]._template.id|string|The id of the template||
|data[index]._referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|data[index]._configuration|object|An object that holds the entity configuration attributes||
|data[index]._summary|object|||
|data[index]._summary._stopReason|string|The reason the session was stopped|Manual Stop|
|data[index]._summary._stopReasonCode|string|The code of the stop reason Values:COMPLETION,GENERAL_DEVICE_ERROR,TIMEOUT|COMPLETION|
|data[index]._lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|data[index]._creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|data[index]._name|string|The name of the session||
|data[index]._sessionContext|string|The context that is linked to the current session and should be sent in a measurement message||
|data[index]._caption|string|||
|metadata|object|||
|metadata.sort|array|Sort that was passed in the request||
|metadata.sort[index]|array|Sort that was passed in the request||
|metadata.sort[index].prop|string|The property name for the sort||
|metadata.sort[index].order|string|The direction of sort. Default DESC Values:ASC,DESC|ASC|
|metadata.filter|object|The filter that was passed in the request||
|metadata.page|object|||
|metadata.page.totalResults|integer|The total number of items that match the query|145|
|metadata.page.page|integer|Page number|3|
|metadata.page.limit|integer|Number of items per page|100|
|metadata.freeTextSearch|string|Free text search strings that was passed in the request|cat dog|
 */ SearchResponseSessionResponseV2;
export type SearchSessionsApiArg = {
  /** Search request parameters: filter, sort and page */
  searchRequest?: string;
};
export type DeleteOrphanSessionsApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|deletedSessions|array|||
|deletedSessions[index]|array|||
|deletedSessions[index]._id|string|Session ID|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|deletedSessions[index]._patient|object|||
|deletedSessions[index]._patient.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|deletedSessions[index]._patient.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|deletedSessions[index]._patient.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|deletedSessions[index]._patient.templateName|string|The name of the referenced entity template||
|deletedSessions[index]._patient.name|string|The caption of the referenced entity||
|deletedSessions[index]._device|object|||
|deletedSessions[index]._device.id|string|||
|deletedSessions[index]._device.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|deletedSessions[index]._device.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|deletedSessions[index]._device.templateName|string|The name of the referenced entity template||
|deletedSessions[index]._device.name|string|The caption of the referenced entity||
|deletedSessions[index]._ownerOrganization|object|||
|deletedSessions[index]._ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|deletedSessions[index]._ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|deletedSessions[index]._ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|deletedSessions[index]._ownerOrganization.templateName|string|The name of the referenced entity template||
|deletedSessions[index]._ownerOrganization.name|string|The caption of the referenced entity||
|deletedSessions[index]._startTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|deletedSessions[index]._endTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|deletedSessions[index]._state|string|The Sessions state Values:ACTIVE,DONE,PAUSED,ACTIVATING,PAUSING,RESUMING,STOPPING|ACTIVE|
|deletedSessions[index]._initiator|string|What API initiated the session Values:REMOTE_CONTROL,EXTERNAL|EXTERNAL|
|deletedSessions[index]._requiredMeasurementIntervalMilliseconds|integer|The interval between measurements in milliseconds|1000|
|deletedSessions[index]._template|object|||
|deletedSessions[index]._template.name|string|The name of the template||
|deletedSessions[index]._template.displayName|string|The display name of the template||
|deletedSessions[index]._template.parentTemplate|object|||
|deletedSessions[index]._template.parentTemplate.id|string|||
|deletedSessions[index]._template.parentTemplate.displayName|string|||
|deletedSessions[index]._template.parentTemplate.name|string|||
|deletedSessions[index]._template.id|string|The id of the template||
|deletedSessions[index]._referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|deletedSessions[index]._configuration|object|An object that holds the entity configuration attributes||
|deletedSessions[index]._summary|object|||
|deletedSessions[index]._summary._stopReason|string|The reason the session was stopped|Manual Stop|
|deletedSessions[index]._summary._stopReasonCode|string|The code of the stop reason Values:COMPLETION,GENERAL_DEVICE_ERROR,TIMEOUT|COMPLETION|
|deletedSessions[index]._lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|deletedSessions[index]._creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|deletedSessions[index]._name|string|The name of the session||
|deletedSessions[index]._sessionContext|string|The context that is linked to the current session and should be sent in a measurement message||
|deletedSessions[index]._caption|string|||
 */ DeleteOrphanSessionsResponse;
export type DeleteOrphanSessionsApiArg = {
  deleteOrphanSessionsEnum: "PATIENT" | "DEVICE";
};
export type GetEndPointApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|endpoint|string|||
 */ EndpointResponse;
export type GetEndPointApiArg = void;
export type ValidateTokenOperationApiResponse = /** status 200 SUCCESS */ void;
export type ValidateTokenOperationApiArg = {
  /** Temporary token for calling this API */
  token: string;
  /** Operation name */
  operation: string;
  /** The entity id of the operation */
  entityId: string;
};
export type ExecuteTokenOperationApiResponse = /** status 200 SUCCESS */ TokenOperationResponse;
export type ExecuteTokenOperationApiArg = {
  /** Temporary token for calling this API */
  token: string;
  /** Operation name */
  operation: string;
  /** The entity id of the operation */
  entityId: string;
  body: string;
};
export type ExecuteTokenOperationGetApiResponse = /** status 200 SUCCESS */ TokenOperationResponse;
export type ExecuteTokenOperationGetApiArg = {
  /** Temporary token for calling this API */
  token: string;
  /** Operation name */
  operation: string;
  /** The entity id of the operation */
  entityId: string;
  operationData: {
    [key: string]: object;
  };
};
export type GetTempCredentialsForOrganizationClientApiResponse =
  /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
 */ TempCredentialsForOrganizationClientResponse;
export type GetTempCredentialsForOrganizationClientApiArg = void;
export type SearchDevicesApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|data|array|List of items that match the search request||
|data[index]|array|List of items that match the search request||
|data[index]._description|string|Device description||
|data[index]._timezone|string|A java time zone supported by the java runtime environment|Europe/Oslo|
|data[index]._id|string|The id of the device||
|data[index]._ownerOrganization|object|||
|data[index]._ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|data[index]._ownerOrganization.templateName|string|The name of the referenced entity template||
|data[index]._ownerOrganization.name|string|The caption of the referenced entity||
|data[index]._template|object|||
|data[index]._template.name|string|The name of the template||
|data[index]._template.displayName|string|The display name of the template||
|data[index]._template.parentTemplate|object|||
|data[index]._template.parentTemplate.id|string|||
|data[index]._template.parentTemplate.displayName|string|||
|data[index]._template.parentTemplate.name|string|||
|data[index]._template.id|string|The id of the template||
|data[index]._referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|data[index]._configuration|object|An object that holds the entity configuration attributes||
|data[index]._status|object|||
|data[index]._status._fwVersion|string|||
|data[index]._status._hwVersion|string|||
|data[index]._status._certificateStatus|string| Values:NOT_INSTALLED,BOOTSTRAP,PERMANENT||
|data[index]._status._bootTime|string|A UTC date in the ISO-8601 format||
|data[index]._status._connection|object|||
|data[index]._status._connection._connected|boolean|If the device is connected to the MQTT the value is true, otherwise false|true|
|data[index]._status._connection._ipAddress|string|The IP Address of the connected device|2007-12-20|
|data[index]._status._connection._lastConnectedTime|string|The last time that the device was connected||
|data[index]._status._operational|object|||
|data[index]._status._operational._status|string|Operational status of the device Values:OK,MINOR,MAJOR,CRITICAL||
|data[index]._status._operational._message|string|Operational status message||
|data[index]._patient|object|||
|data[index]._patient.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._patient.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._patient.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|data[index]._patient.templateName|string|The name of the referenced entity template||
|data[index]._patient.name|string|The caption of the referenced entity||
|data[index]._registrationCode|object|||
|data[index]._registrationCode.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._registrationCode.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._registrationCode.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|data[index]._registrationCode.templateName|string|The name of the referenced entity template||
|data[index]._registrationCode.name|string|The caption of the referenced entity||
|data[index]._creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|data[index]._lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|data[index]._caption|string|The caption of the command instance|mydevice1|
|metadata|object|||
|metadata.sort|array|Sort that was passed in the request||
|metadata.sort[index]|array|Sort that was passed in the request||
|metadata.sort[index].prop|string|The property name for the sort||
|metadata.sort[index].order|string|The direction of sort. Default DESC Values:ASC,DESC|ASC|
|metadata.filter|object|The filter that was passed in the request||
|metadata.page|object|||
|metadata.page.totalResults|integer|The total number of items that match the query|145|
|metadata.page.page|integer|Page number|3|
|metadata.page.limit|integer|Number of items per page|100|
|metadata.freeTextSearch|string|Free text search strings that was passed in the request|cat dog|
 */ SearchResponseDeviceResponse;
export type SearchDevicesApiArg = {
  /** Search request parameters: filter, sort and page */
  searchRequest?: string;
};
export type RegisterDeviceApiResponse = /** status 201 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Regular custom attribute 1 value||
|&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Regular custom attribute N value||
|_caption|string|The caption of the command instance|mydevice1|
|_configuration|object|An object that holds the entity configuration attributes||
|_configuration.&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Configuration custom attribute 1 value||
|_configuration.&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Configuration custom attribute N value||
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_description|string|Device description||
|_id|string|The id of the device||
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.name|string|The caption of the referenced entity||
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_patient|object|||
|_patient.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_patient.name|string|The caption of the referenced entity||
|_patient.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_patient.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_patient.templateName|string|The name of the referenced entity template||
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_registrationCode|object|||
|_registrationCode.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_registrationCode.name|string|The caption of the referenced entity||
|_registrationCode.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_registrationCode.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_registrationCode.templateName|string|The name of the referenced entity template||
|_status|object|||
|_status._connection._connected|boolean|If the device is connected to the MQTT the value is true, otherwise false|true|
|_status._connection._ipAddress|string|The IP Address of the connected device|2007-12-20|
|_status._connection._lastConnectedTime|string|The last time that the device was connected||
|_status._operational._message|string|Operational status message||
|_status._operational._status|string|Operational status of the device Values:OK,MINOR,MAJOR,CRITICAL||
|_template|object|||
|_template.displayName|string|The display name of the template||
|_template.id|string|The id of the template||
|_template.name|string|The name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.name|string|||
|_timezone|string|A java time zone supported by the java runtime environment|Europe/Oslo|
 */ DeviceResponse;
export type RegisterDeviceApiArg = {
  registerDeviceRequest: RegisterDeviceRequest;
};
export type DeleteDeviceApiResponse = /** status 204 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Regular custom attribute 1 value||
|&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Regular custom attribute N value||
|_configuration.&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Configuration custom attribute 1 value||
|_configuration.&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Configuration custom attribute N value||
|_status.&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Status custom attribute 1 value||
|_status.&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Status custom attribute N value||
 */ void;
export type DeleteDeviceApiArg = {
  /** Device ID that needs to be deleted */
  id: string;
};
export type GetDeviceApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Regular custom attribute 1 value||
|&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Regular custom attribute N value||
|_caption|string|The caption of the command instance|mydevice1|
|_configuration|object|An object that holds the entity configuration attributes||
|_configuration.&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Configuration custom attribute 1 value||
|_configuration.&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Configuration custom attribute N value||
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_description|string|Device description||
|_id|string|The id of the device||
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.name|string|The caption of the referenced entity||
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_patient|object|||
|_patient.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_patient.name|string|The caption of the referenced entity||
|_patient.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_patient.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_patient.templateName|string|The name of the referenced entity template||
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_registrationCode|object|||
|_registrationCode.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_registrationCode.name|string|The caption of the referenced entity||
|_registrationCode.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_registrationCode.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_registrationCode.templateName|string|The name of the referenced entity template||
|_status|object|||
|_status.&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Status custom attribute 1 value||
|_status.&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Status custom attribute N value||
|_status._bootTime|string|A UTC date in the ISO-8601 format||
|_status._certificateStatus|string| Values:NOT_INSTALLED,BOOTSTRAP,PERMANENT||
|_status._connection|object|||
|_status._connection._connected|boolean|If the device is connected to the MQTT the value is true, otherwise false|true|
|_status._connection._ipAddress|string|The IP Address of the connected device|2007-12-20|
|_status._connection._lastConnectedTime|string|The last time that the device was connected||
|_status._fwVersion|string|||
|_status._hwVersion|string|||
|_status._operational|object|||
|_status._operational._message|string|Operational status message||
|_status._operational._status|string|Operational status of the device Values:OK,MINOR,MAJOR,CRITICAL||
|_template|object|||
|_template.displayName|string|The display name of the template||
|_template.id|string|The id of the template||
|_template.name|string|The name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.name|string|||
|_timezone|string|A java time zone supported by the java runtime environment|Europe/Oslo|
 */ DeviceResponse;
export type GetDeviceApiArg = {
  /** Device ID that needs to be fetched */
  id: string;
};
export type UpdateDeviceApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Regular custom attribute 1 value||
|&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Regular custom attribute N value||
|_caption|string|The caption of the command instance|mydevice1|
|_configuration|object|An object that holds the entity configuration attributes||
|_configuration.&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Configuration custom attribute 1 value||
|_configuration.&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Configuration custom attribute N value||
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_description|string|Device description||
|_id|string|The id of the device||
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.name|string|The caption of the referenced entity||
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_patient|object|||
|_patient.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_patient.name|string|The caption of the referenced entity||
|_patient.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_patient.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_patient.templateName|string|The name of the referenced entity template||
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_registrationCode|object|||
|_registrationCode.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_registrationCode.name|string|The caption of the referenced entity||
|_registrationCode.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_registrationCode.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_registrationCode.templateName|string|The name of the referenced entity template||
|_status|object|||
|_status._connection._connected|boolean|If the device is connected to the MQTT the value is true, otherwise false|true|
|_status._connection._ipAddress|string|The IP Address of the connected device|2007-12-20|
|_status._connection._lastConnectedTime|string|The last time that the device was connected||
|_status._operational._message|string|Operational status message||
|_status._operational._status|string|Operational status of the device Values:OK,MINOR,MAJOR,CRITICAL||
|_template|object|||
|_template.displayName|string|The display name of the template||
|_template.id|string|The id of the template||
|_template.name|string|The name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.name|string|||
|_timezone|string|A java time zone supported by the java runtime environment|Europe/Oslo|
 */ DeviceResponse;
export type UpdateDeviceApiArg = {
  /** Device ID that needs to be updated */
  id: string;
  updateDeviceRequest: UpdateDeviceRequest;
};
export type DeleteCertificateApiResponse = /** status 204 NO_CONTENT */ void;
export type DeleteCertificateApiArg = {
  id: string;
  type?: "BOOTSTRAP" | "PRODUCTION";
};
export type CreateCertificateApiResponse = /** status 201 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|certificateId|string|The ID of the certificate||
|certificate|string|MQTT credentials - certificate||
|privateKey|string|MQTT credentials -  private key||
|caCertificate|string|MQTT credentials - CA Root certificate||
|connectionClientId|string|MQTT client ID||
|endPointUrl|string|MQTT endpoint||
 */ GenerateCertificateResponse;
export type CreateCertificateApiArg = {
  /** Device id */
  id: string;
  /** Supported values are: BOOTSTRAP, PRODUCTION, default value: PRODUCTION. BOOTSTRAP - temporary certificate for factory tests only. PRODUCTION - certificate for production devices */
  type?: "BOOTSTRAP" | "PRODUCTION";
};
export type ActivateCertificateApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
 */ void;
export type ActivateCertificateApiArg = {
  /** Device id */
  id: string;
  type?: "BOOTSTRAP" | "PRODUCTION";
};
export type GetConnectionDetailsApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|connectionClientId|string|||
|topicInfoList|array|||
|topicInfoList[index]|array|||
|topicInfoList[index].actionEnum|string| Values:STATUS,MEASUREMENT,TOKEN||
|topicInfoList[index].toDevice|string|||
|topicInfoList[index].fromDevice|string|||
 */ DeviceInfo;
export type GetConnectionDetailsApiArg = {
  /** Device id */
  id: string;
};
export type GetTempCredentialsForDeviceApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
 */ TempCredentialsForDeviceResponse;
export type GetTempCredentialsForDeviceApiArg = {
  /** Credentials ID */
  id: string;
};
export type RegisterDeviceWithTemplateNameApiResponse =
  /** status 201 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Regular custom attribute 1 value||
|&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Regular custom attribute N value||
|_caption|string|The caption of the command instance|mydevice1|
|_configuration|object|An object that holds the entity configuration attributes||
|_configuration.&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Configuration custom attribute 1 value||
|_configuration.&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Configuration custom attribute N value||
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_description|string|Device description||
|_id|string|The id of the device||
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.name|string|The caption of the referenced entity||
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_patient|object|||
|_patient.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_patient.name|string|The caption of the referenced entity||
|_patient.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_patient.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_patient.templateName|string|The name of the referenced entity template||
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_registrationCode|object|||
|_registrationCode.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_registrationCode.name|string|The caption of the referenced entity||
|_registrationCode.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_registrationCode.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_registrationCode.templateName|string|The name of the referenced entity template||
|_status|object|||
|_status._connection._connected|boolean|If the device is connected to the MQTT the value is true, otherwise false|true|
|_status._connection._ipAddress|string|The IP Address of the connected device|2007-12-20|
|_status._connection._lastConnectedTime|string|The last time that the device was connected||
|_status._operational._message|string|Operational status message||
|_status._operational._status|string|Operational status of the device Values:OK,MINOR,MAJOR,CRITICAL||
|_template|object|||
|_template.displayName|string|The display name of the template||
|_template.id|string|The id of the template||
|_template.name|string|The name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.name|string|||
|_timezone|string|A java time zone supported by the java runtime environment|Europe/Oslo|
 */ DeviceResponse;
export type RegisterDeviceWithTemplateNameApiArg = {
  templateName: string;
  registerDeviceByTemplateNameRequest: RegisterDeviceByTemplateNameRequest;
};
export type DispatcherhealthCheckApiResponse = /** status 200 OK */ VersionResponse;
export type DispatcherhealthCheckApiArg = void;
export type SearchInterceptionsApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|data|array|List of items that match the search request||
|data[index]|array|List of items that match the search request||
|data[index].type|string| Values:PRE_REQUEST,POST_REQUEST,ADAPT_ENTITY||
|data[index].apiId|string|Should only be provided if type=PRE_REQUEST or type=POST_REQUEST|POST/device/v1/devices|
|data[index].entityName|string|Should only be provided if type=ADAPT_ENTITY|device|
|data[index].endpoint|string||https://api.dev.biot-med.com/device-plugin/v1/devices/create-device-pre-interception|
|data[index].id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index].executionOrder|integer|||
|data[index].creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|data[index].lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|metadata|object|||
|metadata.sort|array|Sort that was passed in the request||
|metadata.sort[index]|array|Sort that was passed in the request||
|metadata.sort[index].prop|string|The property name for the sort||
|metadata.sort[index].order|string|The direction of sort. Default DESC Values:ASC,DESC|ASC|
|metadata.filter|object|The filter that was passed in the request||
|metadata.page|object|||
|metadata.page.totalResults|integer|The total number of items that match the query|145|
|metadata.page.page|integer|Page number|3|
|metadata.page.limit|integer|Number of items per page|100|
|metadata.freeTextSearch|string|Free text search strings that was passed in the request|cat dog|
 */ SearchResponseInterceptionResponse;
export type SearchInterceptionsApiArg = {
  /** Search request parameters: filter, sort and page */
  searchRequest?: string;
};
export type CreateInterceptionApiResponse = /** status 201 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|type|string| Values:PRE_REQUEST,POST_REQUEST,ADAPT_ENTITY||
|apiId|string|Should only be provided if type=PRE_REQUEST or type=POST_REQUEST|POST/device/v1/devices|
|entityName|string|Should only be provided if type=ADAPT_ENTITY|device|
|endpoint|string||https://api.dev.biot-med.com/device-plugin/v1/devices/create-device-pre-interception|
|id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|executionOrder|integer|||
|creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
 */ InterceptionResponse;
export type CreateInterceptionApiArg = {
  createInterceptionRequest: CreateInterceptionRequest;
};
export type DeleteInterceptionApiResponse = /** status 204 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
 */ void;
export type DeleteInterceptionApiArg = {
  deleteInterceptionRequest: DeleteInterceptionRequest;
};
export type SearchSubscriptionsApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|data|array|List of items that match the search request||
|data[index]|array|List of items that match the search request||
|data[index].entityTypeName|string| Values:device,organization,organization-user,caregiver,patient,usage-session,generic-entity,command,device-alert,patient-alert,registration-code||
|data[index].actionName|string| Values:_create,_update,_delete,_list,_command,_generateCertificate,_activateCertificate,_revokeCertificate,_operate,_read,_start,_stop,_remoteStart,_remoteStop,_remoteResume,_remotePause,_updateAdmin,_updateEnabledState,_login,_logout,_clear,_manage,_assign,_saveMeasurement,_monitor,_view,_saveMeasurementBulk,_incomingSms||
|data[index].endpoint|string|||
|data[index].id|string|||
|metadata|object|||
|metadata.sort|array|Sort that was passed in the request||
|metadata.sort[index]|array|Sort that was passed in the request||
|metadata.sort[index].prop|string|The property name for the sort||
|metadata.sort[index].order|string|The direction of sort. Default DESC Values:ASC,DESC|ASC|
|metadata.filter|object|The filter that was passed in the request||
|metadata.page|object|||
|metadata.page.totalResults|integer|The total number of items that match the query|145|
|metadata.page.page|integer|Page number|3|
|metadata.page.limit|integer|Number of items per page|100|
|metadata.freeTextSearch|string|Free text search strings that was passed in the request|cat dog|
 */ SearchResponseSubscribeResponse;
export type SearchSubscriptionsApiArg = {
  /** Search request parameters: filter, sort and page */
  searchRequest?: string;
};
export type SubscribeApiResponse = /** status 201 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|entityTypeName|string| Values:device,organization,organization-user,caregiver,patient,usage-session,generic-entity,command,device-alert,patient-alert,registration-code||
|actionName|string| Values:_create,_update,_delete,_list,_command,_generateCertificate,_activateCertificate,_revokeCertificate,_operate,_read,_start,_stop,_remoteStart,_remoteStop,_remoteResume,_remotePause,_updateAdmin,_updateEnabledState,_login,_logout,_clear,_manage,_assign,_saveMeasurement,_monitor,_view,_saveMeasurementBulk,_incomingSms||
|endpoint|string|||
|id|string|||
 */ SubscribeResponse;
export type SubscribeApiArg = {
  subscribeRequest: SubscribeRequest;
};
export type UnsubscribeApiResponse = /** status 204 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
 */ void;
export type UnsubscribeApiArg = {
  unsubscribeRequest: UnsubscribeRequest;
};
export type DmshealthCheckApiResponse = /** status 200 OK */ VersionResponse;
export type DmshealthCheckApiArg = void;
export type GetAnalyticsDbConnectionDetailsApiResponse =
  /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|userId|string|||
|host|string|||
|port|integer|||
|databaseName|string|||
|username|string|||
|password|string|||
|searchPath|string|||
 */ AnalyticsDbConnectionDetailsResponse;
export type GetAnalyticsDbConnectionDetailsApiArg = void;
export type GetAnalyticsDbConnectionDetailsOldApiResponse =
  /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|userId|string|||
|host|string|||
|port|integer|||
|databaseName|string|||
|username|string|||
|password|string|||
|searchPath|string|||
 */ AnalyticsDbConnectionDetailsResponse;
export type GetAnalyticsDbConnectionDetailsOldApiArg = void;
export type GetAnalyticsDbInformationOldApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|activationState|string|The activation state of the analytics DB Values:INACTIVE,INITIALIZING,STOPPING_INITIALIZATION,ACTIVE_AND_SYNC_ON,ACTIVE_AND_SYNC_OFF|INACTIVE|
|deploymentState|string|The deployment state of the analytics DB Values:NOT_DEPLOYED,DEPLOYED|NOT_DEPLOYED|
|lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
 */ AnalyticsDbInformationResponse;
export type GetAnalyticsDbInformationOldApiArg = void;
export type StartAnalyticsDbInitializationOldApiResponse =
  /** status 202 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|activationState|string|The activation state of the analytics DB Values:INACTIVE,INITIALIZING,STOPPING_INITIALIZATION,ACTIVE_AND_SYNC_ON,ACTIVE_AND_SYNC_OFF|INACTIVE|
|deploymentState|string|The deployment state of the analytics DB Values:NOT_DEPLOYED,DEPLOYED|NOT_DEPLOYED|
|lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
 */ AnalyticsDbInformationResponse;
export type StartAnalyticsDbInitializationOldApiArg = void;
export type StopAnalyticsDbInitializationOldApiResponse =
  /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|activationState|string|The activation state of the analytics DB Values:INACTIVE,INITIALIZING,STOPPING_INITIALIZATION,ACTIVE_AND_SYNC_ON,ACTIVE_AND_SYNC_OFF|INACTIVE|
|deploymentState|string|The deployment state of the analytics DB Values:NOT_DEPLOYED,DEPLOYED|NOT_DEPLOYED|
|lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
 */ AnalyticsDbInformationResponse;
export type StopAnalyticsDbInitializationOldApiArg = void;
export type GetAnalyticsDbStateApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|activationState|string|The activation state of the analytics DB Values:INACTIVE,INITIALIZING,STOPPING_INITIALIZATION,ACTIVE_AND_SYNC_ON,ACTIVE_AND_SYNC_OFF|INACTIVE|
|deploymentState|string|The deployment state of the analytics DB Values:NOT_DEPLOYED,DEPLOYED|NOT_DEPLOYED|
|lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
 */ AnalyticsDbInformationResponse;
export type GetAnalyticsDbStateApiArg = void;
export type StartAnalyticsDbInitializationApiResponse =
  /** status 202 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|activationState|string|The activation state of the analytics DB Values:INACTIVE,INITIALIZING,STOPPING_INITIALIZATION,ACTIVE_AND_SYNC_ON,ACTIVE_AND_SYNC_OFF|INACTIVE|
|deploymentState|string|The deployment state of the analytics DB Values:NOT_DEPLOYED,DEPLOYED|NOT_DEPLOYED|
|lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
 */ AnalyticsDbInformationResponse;
export type StartAnalyticsDbInitializationApiArg = void;
export type StopAnalyticsDbInitializationApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|activationState|string|The activation state of the analytics DB Values:INACTIVE,INITIALIZING,STOPPING_INITIALIZATION,ACTIVE_AND_SYNC_ON,ACTIVE_AND_SYNC_OFF|INACTIVE|
|deploymentState|string|The deployment state of the analytics DB Values:NOT_DEPLOYED,DEPLOYED|NOT_DEPLOYED|
|lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
 */ AnalyticsDbInformationResponse;
export type StopAnalyticsDbInitializationApiArg = void;
export type StopAnalyticsDbSynchronizationApiResponse =
  /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|activationState|string|The activation state of the analytics DB Values:INACTIVE,INITIALIZING,STOPPING_INITIALIZATION,ACTIVE_AND_SYNC_ON,ACTIVE_AND_SYNC_OFF|INACTIVE|
|deploymentState|string|The deployment state of the analytics DB Values:NOT_DEPLOYED,DEPLOYED|NOT_DEPLOYED|
|lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
 */ AnalyticsDbInformationResponse;
export type StopAnalyticsDbSynchronizationApiArg = void;
export type StopAnalyticsDbSynchronizationOldApiResponse =
  /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|activationState|string|The activation state of the analytics DB Values:INACTIVE,INITIALIZING,STOPPING_INITIALIZATION,ACTIVE_AND_SYNC_ON,ACTIVE_AND_SYNC_OFF|INACTIVE|
|deploymentState|string|The deployment state of the analytics DB Values:NOT_DEPLOYED,DEPLOYED|NOT_DEPLOYED|
|lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
 */ AnalyticsDbInformationResponse;
export type StopAnalyticsDbSynchronizationOldApiArg = void;
export type SearchReportsApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|data|array|List of items that match the search request||
|data[index]|array|List of items that match the search request||
|data[index].queries|array|A list that containing queries (filter) on the wanted data export. Supported filters: [_lastModifiedTime, _creationTime, _templateId]. Supported sorts: [_creationTime]||
|data[index].queries[index]|array|A list that containing queries (filter) on the wanted data export. Supported filters: [_lastModifiedTime, _creationTime, _templateId]. Supported sorts: [_creationTime]||
|data[index].queries[index].dataType|string|Data Type to be exported. Values:device,device-alert,usage-session,command,organization,patient,organization-user,caregiver,patient-alert,generic-entity,measurements,registration-code|device|
|data[index].queries[index].filter|object|Each additionalProp can filter one field, inside additionalProp there are many optional conditions that can be used for filtering that field. When multiple conditions are specified, they are bundled together using logical AND operators, this means that only the items that match all filter conditions for that field will be returned||
|data[index].queries[index].sort|array|Results can be sorted by multiple fields, the order of the fields in the sort request governs the hierarchy of the sort.The first field is the primary sort, the second is used when two values of the first field are the same, and so forth||
|data[index].queries[index].sort[index]|array|Results can be sorted by multiple fields, the order of the fields in the sort request governs the hierarchy of the sort.The first field is the primary sort, the second is used when two values of the first field are the same, and so forth||
|data[index].queries[index].sort[index].prop|string|The property name for the sort||
|data[index].queries[index].sort[index].order|string|The direction of sort. Default DESC Values:ASC,DESC|ASC|
|data[index].outputMetadata|object|||
|data[index].outputMetadata.maxFileSizeInBytes|integer|The maximum size (in bytes) that each output file should not exceed|500000|
|data[index].outputMetadata.exportFormat|string|The format in which to export the report Values:JSON,CSV|JSON|
|data[index].callbackEndpoint|string|URL endpoint to call when export process is finished|https://my-url.com/|
|data[index].name|string|Name of the report|BioT Devices Export|
|data[index].id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index].status|string|The report current status Values:IN_PROGRESS,COMPLETED,FAILED,CANCELING,CANCELED|IN_PROGRESS|
|data[index].fileOutput|object|||
|data[index].fileOutput.filesLocation|object|An object that holds for each data type exported, A list containing the paths to it's files||
|data[index].fileOutput.urlExpirationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|data[index].reportInitiator|object|||
|data[index].reportInitiator.userId|string|The user ID of the initiator of the report||
|data[index].reportInitiator.ownerOrganizationId|string|The owner organization ID of the initiator of the report||
|data[index].reportInitiator.userEntityType|string|The entity type of the initiator of the report||
|data[index].reportInitiator.templateId|string|The template ID of the initiator of the report||
|data[index].creationTime|string|||
|data[index].lastModifiedTime|string|||
|data[index].errorMessage|string|||
|metadata|object|||
|metadata.sort|array|Sort that was passed in the request||
|metadata.sort[index]|array|Sort that was passed in the request||
|metadata.sort[index].prop|string|The property name for the sort||
|metadata.sort[index].order|string|The direction of sort. Default DESC Values:ASC,DESC|ASC|
|metadata.filter|object|The filter that was passed in the request||
|metadata.page|object|||
|metadata.page.totalResults|integer|The total number of items that match the query|145|
|metadata.page.page|integer|Page number|3|
|metadata.page.limit|integer|Number of items per page|100|
|metadata.freeTextSearch|string|Free text search strings that was passed in the request|cat dog|
 */ SearchResponseReportResponse;
export type SearchReportsApiArg = {
  /** Search request parameters: filter, sort and page */
  searchRequest?: string;
};
export type DeleteReportApiResponse = /** status 204 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
 */ void;
export type DeleteReportApiArg = {
  /** Report ID that needs to be deleted */
  id: string;
};
export type GetReportApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|queries|array|A list that containing queries (filter) on the wanted data export. Supported filters: [_lastModifiedTime, _creationTime, _templateId]. Supported sorts: [_creationTime]||
|queries[index]|array|A list that containing queries (filter) on the wanted data export. Supported filters: [_lastModifiedTime, _creationTime, _templateId]. Supported sorts: [_creationTime]||
|queries[index].dataType|string|Data Type to be exported. Values:device,device-alert,usage-session,command,organization,patient,organization-user,caregiver,patient-alert,generic-entity,measurements,registration-code|device|
|queries[index].filter|object|Each additionalProp can filter one field, inside additionalProp there are many optional conditions that can be used for filtering that field. When multiple conditions are specified, they are bundled together using logical AND operators, this means that only the items that match all filter conditions for that field will be returned||
|queries[index].sort|array|Results can be sorted by multiple fields, the order of the fields in the sort request governs the hierarchy of the sort.The first field is the primary sort, the second is used when two values of the first field are the same, and so forth||
|queries[index].sort[index]|array|Results can be sorted by multiple fields, the order of the fields in the sort request governs the hierarchy of the sort.The first field is the primary sort, the second is used when two values of the first field are the same, and so forth||
|queries[index].sort[index].prop|string|The property name for the sort||
|queries[index].sort[index].order|string|The direction of sort. Default DESC Values:ASC,DESC|ASC|
|outputMetadata|object|||
|outputMetadata.maxFileSizeInBytes|integer|The maximum size (in bytes) that each output file should not exceed|500000|
|outputMetadata.exportFormat|string|The format in which to export the report Values:JSON,CSV|JSON|
|callbackEndpoint|string|URL endpoint to call when export process is finished|https://my-url.com/|
|name|string|Name of the report|BioT Devices Export|
|id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|status|string|The report current status Values:IN_PROGRESS,COMPLETED,FAILED,CANCELING,CANCELED|IN_PROGRESS|
|fileOutput|object|||
|fileOutput.filesLocation|object|An object that holds for each data type exported, A list containing the paths to it's files||
|fileOutput.urlExpirationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|reportInitiator|object|||
|reportInitiator.userId|string|The user ID of the initiator of the report||
|reportInitiator.ownerOrganizationId|string|The owner organization ID of the initiator of the report||
|reportInitiator.userEntityType|string|The entity type of the initiator of the report||
|reportInitiator.templateId|string|The template ID of the initiator of the report||
|creationTime|string|||
|lastModifiedTime|string|||
|errorMessage|string|||
 */ ReportResponse;
export type GetReportApiArg = {
  /** Report ID that needs to be fetched */
  id: string;
};
export type CancelReportApiResponse = /** status 202 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|queries|array|A list that containing queries (filter) on the wanted data export. Supported filters: [_lastModifiedTime, _creationTime, _templateId]. Supported sorts: [_creationTime]||
|queries[index]|array|A list that containing queries (filter) on the wanted data export. Supported filters: [_lastModifiedTime, _creationTime, _templateId]. Supported sorts: [_creationTime]||
|queries[index].dataType|string|Data Type to be exported. Values:device,device-alert,usage-session,command,organization,patient,organization-user,caregiver,patient-alert,generic-entity,measurements,registration-code|device|
|queries[index].filter|object|Each additionalProp can filter one field, inside additionalProp there are many optional conditions that can be used for filtering that field. When multiple conditions are specified, they are bundled together using logical AND operators, this means that only the items that match all filter conditions for that field will be returned||
|queries[index].sort|array|Results can be sorted by multiple fields, the order of the fields in the sort request governs the hierarchy of the sort.The first field is the primary sort, the second is used when two values of the first field are the same, and so forth||
|queries[index].sort[index]|array|Results can be sorted by multiple fields, the order of the fields in the sort request governs the hierarchy of the sort.The first field is the primary sort, the second is used when two values of the first field are the same, and so forth||
|queries[index].sort[index].prop|string|The property name for the sort||
|queries[index].sort[index].order|string|The direction of sort. Default DESC Values:ASC,DESC|ASC|
|outputMetadata|object|||
|outputMetadata.maxFileSizeInBytes|integer|The maximum size (in bytes) that each output file should not exceed|500000|
|outputMetadata.exportFormat|string|The format in which to export the report Values:JSON,CSV|JSON|
|callbackEndpoint|string|URL endpoint to call when export process is finished|https://my-url.com/|
|name|string|Name of the report|BioT Devices Export|
|id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|status|string|The report current status Values:IN_PROGRESS,COMPLETED,FAILED,CANCELING,CANCELED|IN_PROGRESS|
|fileOutput|object|||
|fileOutput.filesLocation|object|An object that holds for each data type exported, A list containing the paths to it's files||
|fileOutput.urlExpirationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|reportInitiator|object|||
|reportInitiator.userId|string|The user ID of the initiator of the report||
|reportInitiator.ownerOrganizationId|string|The owner organization ID of the initiator of the report||
|reportInitiator.userEntityType|string|The entity type of the initiator of the report||
|reportInitiator.templateId|string|The template ID of the initiator of the report||
|creationTime|string|||
|lastModifiedTime|string|||
|errorMessage|string|||
 */ ReportResponse;
export type CancelReportApiArg = {
  /** Report ID */
  id: string;
};
export type CreateReportApiResponse = /** status 201 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|queries|array|A list that containing queries (filter) on the wanted data export. Supported filters: [_lastModifiedTime, _creationTime, _templateId]. Supported sorts: [_creationTime]||
|queries[index]|array|A list that containing queries (filter) on the wanted data export. Supported filters: [_lastModifiedTime, _creationTime, _templateId]. Supported sorts: [_creationTime]||
|queries[index].dataType|string|Data Type to be exported. Values:device,device-alert,usage-session,command,organization,patient,organization-user,caregiver,patient-alert,generic-entity,measurements,registration-code|device|
|queries[index].filter|object|Each additionalProp can filter one field, inside additionalProp there are many optional conditions that can be used for filtering that field. When multiple conditions are specified, they are bundled together using logical AND operators, this means that only the items that match all filter conditions for that field will be returned||
|queries[index].sort|array|Results can be sorted by multiple fields, the order of the fields in the sort request governs the hierarchy of the sort.The first field is the primary sort, the second is used when two values of the first field are the same, and so forth||
|queries[index].sort[index]|array|Results can be sorted by multiple fields, the order of the fields in the sort request governs the hierarchy of the sort.The first field is the primary sort, the second is used when two values of the first field are the same, and so forth||
|queries[index].sort[index].prop|string|The property name for the sort||
|queries[index].sort[index].order|string|The direction of sort. Default DESC Values:ASC,DESC|ASC|
|outputMetadata|object|||
|outputMetadata.maxFileSizeInBytes|integer|The maximum size (in bytes) that each output file should not exceed|500000|
|outputMetadata.exportFormat|string|The format in which to export the report Values:JSON,CSV|JSON|
|callbackEndpoint|string|URL endpoint to call when export process is finished|https://my-url.com/|
|name|string|Name of the report|BioT Devices Export|
|id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|status|string|The report current status Values:IN_PROGRESS,COMPLETED,FAILED,CANCELING,CANCELED|IN_PROGRESS|
|fileOutput|object|||
|fileOutput.filesLocation|object|An object that holds for each data type exported, A list containing the paths to it's files||
|fileOutput.urlExpirationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|reportInitiator|object|||
|reportInitiator.userId|string|The user ID of the initiator of the report||
|reportInitiator.ownerOrganizationId|string|The owner organization ID of the initiator of the report||
|reportInitiator.userEntityType|string|The entity type of the initiator of the report||
|reportInitiator.templateId|string|The template ID of the initiator of the report||
|creationTime|string|||
|lastModifiedTime|string|||
|errorMessage|string|||
 */ ReportResponse;
export type CreateReportApiArg = {
  createReportRequest: CreateReportRequest;
};
export type DmsvalidateTokenOperationApiResponse = /** status 200 SUCCESS */ void;
export type DmsvalidateTokenOperationApiArg = {
  /** Temporary token for calling this API */
  token: string;
  /** Operation name */
  operation: string;
  /** The entity id of the operation */
  entityId: string;
};
export type DmsexecuteTokenOperationApiResponse = /** status 200 SUCCESS */ TokenOperationResponse;
export type DmsexecuteTokenOperationApiArg = {
  /** Temporary token for calling this API */
  token: string;
  /** Operation name */
  operation: string;
  /** The entity id of the operation */
  entityId: string;
  body: string;
};
export type DmsexecuteTokenOperationGetApiResponse = /** status 200 SUCCESS */ TokenOperationResponse;
export type DmsexecuteTokenOperationGetApiArg = {
  /** Temporary token for calling this API */
  token: string;
  /** Operation name */
  operation: string;
  /** The entity id of the operation */
  entityId: string;
  operationData: {
    [key: string]: object;
  };
};
export type EntityhealthCheckApiResponse = /** status 200 OK */ VersionResponse;
export type EntityhealthCheckApiArg = void;
export type FilehealthCheckApiResponse = /** status 200 OK */ VersionResponse;
export type FilehealthCheckApiArg = void;
export type GetDownloadFileUrlApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|name|string|||
|mimeType|string|||
|id|string|||
|signedUrl|string|||
 */ DownloadFileUrlResponse;
export type GetDownloadFileUrlApiArg = {
  /** File ID that needs to be fetched */
  id: string;
  /** Parameter to the signed URL. Indicates whether the file content should be displayed inline in the browser (INLINE) or downloaded as an attachment locally (ATTACHMENT). Default: INLINE */
  contentDisposition?: "INLINE" | "ATTACHMENT";
};
export type CreateUploadFileUrlApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|name|string|||
|mimeType|string|||
|id|string|||
|signedUrl|string|||
 */ UploadFileUrlResponse;
export type CreateUploadFileUrlApiArg = {
  uploadFileUrlRequest: UploadFileUrlRequest;
};
export type CreateMultiplePartUploadFileUrlApiResponse =
  /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|name|string|||
|mimeType|string|||
|id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|parts|integer|The total number of parts currently requested for this multiple part file upload. More can be requested|10|
|signedUrls|array|||
|signedUrls[index]|array|||
|signedUrls[index].signedUrl|string|The URL for which to send a PUT request with the file data as a binary stream, for the file part specified in partNumber||
|signedUrls[index].partNumber|integer|The part number for this URL|5|
|signedUrls[index].expirationTime|string|The expiration time for this URL, after which it is unusable. It is possible to request a new URL. A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
 */ MultiplePartUploadFileUrlResponse;
export type CreateMultiplePartUploadFileUrlApiArg = {
  multiplePartUploadFileUrlRequest: MultiplePartUploadFileUrlRequest;
};
export type GenerateSignedUrlsForMultiplePartFileUploadApiResponse =
  /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|name|string|||
|mimeType|string|||
|id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|parts|integer|The total number of parts currently requested for this multiple part file upload. More can be requested|10|
|signedUrls|array|||
|signedUrls[index]|array|||
|signedUrls[index].signedUrl|string|The URL for which to send a PUT request with the file data as a binary stream, for the file part specified in partNumber||
|signedUrls[index].partNumber|integer|The part number for this URL|5|
|signedUrls[index].expirationTime|string|The expiration time for this URL, after which it is unusable. It is possible to request a new URL. A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
 */ MultiplePartUploadFileUrlResponse;
export type GenerateSignedUrlsForMultiplePartFileUploadApiArg = {
  /** File ID */
  id: string;
  multiplePartUploadFileGenerateSignedUrlsRequest: MultiplePartUploadFileGenerateSignedUrlsRequest;
};
export type SaveETagsForMultiplePartFileUploadApiResponse =
  /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
 */ void;
export type SaveETagsForMultiplePartFileUploadApiArg = {
  /** File ID */
  id: string;
  multiplePartUploadFileSaveETagRequest: MultiplePartUploadFileSaveETagRequest;
};
export type CancelMultiplePartUploadFileApiResponse = /** status 204 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
 */ void;
export type CancelMultiplePartUploadFileApiArg = {
  /** File ID */
  id: string;
};
export type CompleteMultiplePartUploadFileApiResponse =
  /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|name|string|||
|mimeType|string|||
|id|string|||
|signedUrl|string|||
 */ DownloadFileUrlResponse;
export type CompleteMultiplePartUploadFileApiArg = {
  /** File ID */
  id: string;
  completeMultiplePartUploadFileRequest: CompleteMultiplePartUploadFileRequest;
};
export type GetGenericEntitySystemHealthCheckApiResponse = /** status 200 OK */ VersionResponse;
export type GetGenericEntitySystemHealthCheckApiArg = void;
export type SearchGenericEntitiesApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|data|array|List of items that match the search request||
|data[index]|array|List of items that match the search request||
|data[index]._name|string|||
|data[index]._id|string|||
|data[index]._ownerOrganization|object|||
|data[index]._ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|data[index]._ownerOrganization.templateName|string|The name of the referenced entity template||
|data[index]._ownerOrganization.name|string|The caption of the referenced entity||
|data[index]._template|object|||
|data[index]._template.name|string|The name of the template||
|data[index]._template.displayName|string|The display name of the template||
|data[index]._template.parentTemplate|object|||
|data[index]._template.parentTemplate.id|string|||
|data[index]._template.parentTemplate.displayName|string|||
|data[index]._template.parentTemplate.name|string|||
|data[index]._template.id|string|The id of the template||
|data[index]._referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|data[index]._creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|data[index]._lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|data[index]._caption|string|||
|metadata|object|||
|metadata.sort|array|Sort that was passed in the request||
|metadata.sort[index]|array|Sort that was passed in the request||
|metadata.sort[index].prop|string|The property name for the sort||
|metadata.sort[index].order|string|The direction of sort. Default DESC Values:ASC,DESC|ASC|
|metadata.filter|object|The filter that was passed in the request||
|metadata.page|object|||
|metadata.page.totalResults|integer|The total number of items that match the query|145|
|metadata.page.page|integer|Page number|3|
|metadata.page.limit|integer|Number of items per page|100|
|metadata.freeTextSearch|string|Free text search strings that was passed in the request|cat dog|
 */ SearchResponseGenericEntityResponse;
export type SearchGenericEntitiesApiArg = {
  /** Search request parameters: filter, sort and page */
  searchRequest?: string;
};
export type CreateGenericEntityApiResponse = /** status 201 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|_name|string|||
|_id|string|||
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_ownerOrganization.name|string|The caption of the referenced entity||
|_template|object|||
|_template.name|string|The name of the template||
|_template.displayName|string|The display name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.name|string|||
|_template.id|string|The id of the template||
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_caption|string|||
 */ GenericEntityResponse;
export type CreateGenericEntityApiArg = {
  createGenericEntityRequest: CreateGenericEntityRequest;
};
export type DeleteGenericEntityApiResponse = /** status 204 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
 */ void;
export type DeleteGenericEntityApiArg = {
  /** Generic Entity ID that needs to be deleted */
  id: string;
};
export type GetGenericEntityApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|_name|string|||
|_id|string|||
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_ownerOrganization.name|string|The caption of the referenced entity||
|_template|object|||
|_template.name|string|The name of the template||
|_template.displayName|string|The display name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.name|string|||
|_template.id|string|The id of the template||
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_caption|string|||
 */ GenericEntityResponse;
export type GetGenericEntityApiArg = {
  /** Generic Entity ID that needs to be fetched */
  id: string;
};
export type UpdateGenericEntityApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|_name|string|||
|_id|string|||
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_ownerOrganization.name|string|The caption of the referenced entity||
|_template|object|||
|_template.name|string|The name of the template||
|_template.displayName|string|The display name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.name|string|||
|_template.id|string|The id of the template||
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_caption|string|||
 */ GenericEntityResponse;
export type UpdateGenericEntityApiArg = {
  /** Generic Entity ID that needs to be updated */
  id: string;
  updateGenericEntityRequest: UpdateGenericEntityRequest;
};
export type CreateGenericEntityByTemplateNameApiResponse =
  /** status 201 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|_name|string|||
|_id|string|||
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_ownerOrganization.name|string|The caption of the referenced entity||
|_template|object|||
|_template.name|string|The name of the template||
|_template.displayName|string|The display name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.name|string|||
|_template.id|string|The id of the template||
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_caption|string|||
 */ GenericEntityResponse;
export type CreateGenericEntityByTemplateNameApiArg = {
  templateName: string;
  createGenericEntityByTemplateNameRequest: CreateGenericEntityByTemplateNameRequest;
};
export type MeasurementhealthCheckApiResponse = /** status 200 OK */ VersionResponse;
export type MeasurementhealthCheckApiArg = void;
export type SaveMeasurementApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|metadata|object|||
|metadata.timestamp|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|metadata.deviceId|string|The device id that sent the measurement|device12345|
|metadata.patientId|string|The patient id that the measurement belongs to|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|metadata.sessionId|string|The session id that the measurement belongs to|6b52af6e-92c8-4827-aaf2-d8805586ab5f|
|data|object|||
 */ MeasurementMessageFromDevice;
export type SaveMeasurementApiArg = {
  measurementMessageFromDevice: MeasurementMessageFromDevice;
};
export type GetMeasurementsApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|attributes|array|||
|attributes[index]|array|||
|attributes[index].attributeName|string|||
|attributes[index].sources|array|||
|attributes[index].sources[index]|array|||
|attributes[index].sources[index].sourceEntityId|string|||
|attributes[index].sources[index].measurementSessions|array|||
|attributes[index].sources[index].measurementSessions[index]|array|||
|attributes[index].sources[index].measurementSessions[index].sessionId|string|||
|attributes[index].sources[index].measurementSessions[index].measurements|array|||
|attributes[index].sources[index].measurementSessions[index].measurements[index]|array|||
|attributes[index].sources[index].measurementSessions[index].measurements[index].timestamp|string|||
|attributes[index].sources[index].measurementSessions[index].measurements[index].average|number|||
|attributes[index].sources[index].measurementSessions[index].measurements[index].standardDeviation|number|||
 */ GetAggregatedMeasurementsResponse;
export type GetMeasurementsApiArg = {
  /** This number defines the aggregation time in seconds. If 6 is provided, it will aggregate all measurements in a 6 seconds interval */
  binIntervalSeconds:
    | "1"
    | "3"
    | "6"
    | "15"
    | "30"
    | "60"
    | "120"
    | "300"
    | "1800"
    | "10800"
    | "21600"
    | "43200"
    | "86400"
    | "172800"
    | "604800"
    | "2592000"
    | "31536000";
  attributes?: string[];
  /** The patient's ID */
  patientId: string;
  /** The ID of the source entity who entered the measurements. Can be a device's id, a doctor's id, etc. If not sent all sources will be returned */
  sourceEntityId?: string;
  /** The session's Id. If not sent all sessions will be returned */
  sessionId?: string;
  /** The wanted start time for the historical measurements. In ISO8601 format */
  startTime: string;
  /** The wanted end time for the historical measurements. In ISO8601 format */
  endTime: string;
};
export type SaveMeasurementsBulkApiResponse =
  /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
 */
  | MeasurementBulkResponse
  | /** status 206 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
 */ MeasurementBulkResponse;
export type SaveMeasurementsBulkApiArg = {
  measurementBulkRequest: MeasurementBulkRequest;
};
export type GetRawMeasurementsApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|attributes|array|||
|attributes[index]|array|||
|attributes[index].attributeName|string|||
|attributes[index].sources|array|||
|attributes[index].sources[index]|array|||
|attributes[index].sources[index].sourceEntityId|string|||
|attributes[index].sources[index].measurementSessions|array|||
|attributes[index].sources[index].measurementSessions[index]|array|||
|attributes[index].sources[index].measurementSessions[index].sessionId|string|||
|attributes[index].sources[index].measurementSessions[index].measurements|array|||
|attributes[index].sources[index].measurementSessions[index].measurements[index]|array|||
|attributes[index].sources[index].measurementSessions[index].measurements[index].timestamp|string|||
|attributes[index].sources[index].measurementSessions[index].measurements[index].frequency|integer|||
|attributes[index].sources[index].measurementSessions[index].measurements[index].numberOfSample|integer|||
|attributes[index].sources[index].measurementSessions[index].measurements[index].data|array|||
 */ GetRawMeasurementsResponse;
export type GetRawMeasurementsApiArg = {
  attributes?: string[];
  /** The patient's ID */
  patientId: string;
  /** The ID of the source entity who entered the measurements. Can be a device's id, a doctor's id, etc. If not sent all sources will be returned */
  sourceEntityId?: string;
  /** The session's Id. If not sent all sessions will be returned */
  sessionId?: string;
  /** The wanted start time for the historical measurements. In ISO8601 format */
  startTime: string;
  /** The wanted end time for the historical measurements. In ISO8601 format */
  endTime: string;
};
export type GetAggregatedMeasurementsApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|data|array|List of items that match the search request||
|data[index]|array|List of items that match the search request||
|data[index].timestamp|object|||
|data[index].timestamp.from|string|||
|data[index].timestamp.to|string|||
|data[index].data|object|||
|data[index].exampleMeasure1|object|||
|data[index].exampleMeasure1.average|number|||
|data[index].exampleMeasure1.standardDeviation|number|||
|data[index].exampleMeasure2|object|||
|data[index].exampleMeasure2.average|number|||
|data[index].exampleMeasure2.standardDeviation|number|||
|data[index].exampleMeasure3|object|||
|data[index].exampleMeasure3.average|number|||
|data[index].exampleMeasure3.standardDeviation|number|||
|metadata|object|||
|metadata.sort|array|Sort that was passed in the request||
|metadata.sort[index]|array|Sort that was passed in the request||
|metadata.sort[index].prop|string|The property name for the sort||
|metadata.sort[index].order|string|The direction of sort. Default DESC Values:ASC,DESC|ASC|
|metadata.filter|object|The filter that was passed in the request||
|metadata.nextToken|string|Next token that should be supplied when requesting a new page, empty of there are no next page||
|metadata.limitPerPage|integer|Limit of items||
 */ SearchResponseTokenBasedMeasurementsAggregationDataV2;
export type GetAggregatedMeasurementsApiArg = {
  /** Search request parameters: filter, sort and page */
  searchRequest: string;
};
export type GetRawMeasurements2ApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|data|array|List of items that match the search request||
|data[index]|array|List of items that match the search request||
|data[index].patientId|string|||
|data[index].sessionId|string|||
|data[index].sourceEntityId|string|||
|data[index].timestamp|string|||
|data[index].data|object|||
|metadata|object|||
|metadata.sort|array|Sort that was passed in the request||
|metadata.sort[index]|array|Sort that was passed in the request||
|metadata.sort[index].prop|string|The property name for the sort||
|metadata.sort[index].order|string|The direction of sort. Default DESC Values:ASC,DESC|ASC|
|metadata.filter|object|The filter that was passed in the request||
|metadata.nextToken|string|Next token that should be supplied when requesting a new page, empty of there are no next page||
|metadata.limitPerPage|integer|Limit of items||
 */ SearchResponseTokenBasedRawMeasurementV2;
export type GetRawMeasurements2ApiArg = {
  /** Search request parameters: filter, sort and page */
  searchRequest: string;
};
export type NotificationhealthCheckApiResponse = /** status 200 OK */ VersionResponse;
export type NotificationhealthCheckApiArg = void;
export type AddAttachmentApiResponse = /** status 200 SUCCESS */ AddAttachmentResponse;
export type AddAttachmentApiArg = {
  body: {
    file: Blob;
  };
};
export type GetConfigurationApiResponse = /** status 200 SUCCESS */ ConfigurationResponse;
export type GetConfigurationApiArg = void;
export type SetConfigurationApiResponse = /** status 200 SUCCESS */ ConfigurationResponse;
export type SetConfigurationApiArg = {
  configurationRequest: ConfigurationRequest;
};
export type GetSmsProviderConfigurationApiResponse = /** status 200 SUCCESS */ SmsProviderConfigurationResponse;
export type GetSmsProviderConfigurationApiArg = void;
export type SendEmailApiResponse = /** status 200 SUCCESS */ void;
export type SendEmailApiArg = {
  emailRequest: EmailRequest;
};
export type SendSmsApiResponse = /** status 200 SUCCESS */ SendSmsResponse;
export type SendSmsApiArg = {
  sendSmsRequest: SendSmsRequest;
};
export type OrganizationhealthCheckApiResponse = /** status 200 OK */ VersionResponse;
export type OrganizationhealthCheckApiArg = void;
export type ResendInvitationApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|userId|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
 */ InvitationResponse;
export type ResendInvitationApiArg = {
  /** The ID of the user */
  userId: string;
};
export type DeleteLandingPagesApiResponse = /** status 204 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
 */ void;
export type DeleteLandingPagesApiArg = {
  /** The type of the landing page. Could be one of the following: [ACCEPT_INVITATION, FORGOT_PASSWORD] */
  landingPageType: "ACCEPT_INVITATION" | "FORGOT_PASSWORD";
  deleteLandingPageRequest: DeleteLandingPageRequest;
};
export type GetLandingPagesApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|type|string| Values:ACCEPT_INVITATION,FORGOT_PASSWORD||
|pages|array|||
|pages[index]|array|||
|pages[index].userType|string|The type of the user. Can be one of the following: [patient, caregiver, organization-user]|patient|
|pages[index].organizationId|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|pages[index].url|string|The landing page URL|https://example.com/auth/invitation|
|pages[index].landingPageType|string| Values:ACCEPT_INVITATION,FORGOT_PASSWORD||
 */ GetLandingPagesResponse;
export type GetLandingPagesApiArg = {
  /** The type of the landing page. Could be one of the following: [ACCEPT_INVITATION, FORGOT_PASSWORD] */
  landingPageType: "ACCEPT_INVITATION" | "FORGOT_PASSWORD";
};
export type SetLandingPagesApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|userType|string|The type of the user. Can be one of the following: [patient, caregiver, organization-user]|patient|
|organizationId|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|url|string|The landing page URL|https://example.com/auth/invitation|
|landingPageType|string| Values:ACCEPT_INVITATION,FORGOT_PASSWORD||
 */ LandingPageResponse;
export type SetLandingPagesApiArg = {
  /** The type of the landing page. Could be one of the following: [ACCEPT_INVITATION, FORGOT_PASSWORD] */
  landingPageType: "ACCEPT_INVITATION" | "FORGOT_PASSWORD";
  setLandingPageRequest: SetLandingPageRequest;
};
export type SearchOrganizationsApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|data|array|List of items that match the search request||
|data[index]|array|List of items that match the search request||
|data[index]._name|string|An organization's name|Example Inc.|
|data[index]._description|string|A description, can be up to 5000 characters long|Lorem Ipsum|
|data[index]._headquarters|object|||
|data[index]._headquarters.countryCode|string|A 2-letter country code defined in ISO-3166|US|
|data[index]._headquarters.state|string|A state|Massachusetts|
|data[index]._headquarters.city|string|A city|Boston|
|data[index]._headquarters.zipCode|string|A zipcode|02101|
|data[index]._headquarters.address1|string|An address|11 Main St.|
|data[index]._headquarters.address2|string|An address's specifics|Entry B, Apartment 1|
|data[index]._phone|string|An E.164 formatted phone number|+12345678901|
|data[index]._timezone|string|A java time zone supported by the java runtime environment|Europe/Oslo|
|data[index]._locale|string|Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase.|en-us|
|data[index]._id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._ownerOrganization|object|||
|data[index]._ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|data[index]._ownerOrganization.templateName|string|The name of the referenced entity template||
|data[index]._ownerOrganization.name|string|The caption of the referenced entity||
|data[index]._creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|data[index]._lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|data[index]._primaryAdministrator|object|||
|data[index]._primaryAdministrator.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._primaryAdministrator.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._primaryAdministrator.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|data[index]._primaryAdministrator.templateName|string|The name of the referenced entity template||
|data[index]._primaryAdministrator.name|string|The caption of the referenced entity||
|data[index]._template|object|||
|data[index]._template.name|string|The name of the template||
|data[index]._template.displayName|string|The display name of the template||
|data[index]._template.parentTemplate|object|||
|data[index]._template.parentTemplate.id|string|||
|data[index]._template.parentTemplate.displayName|string|||
|data[index]._template.parentTemplate.name|string|||
|data[index]._template.id|string|The id of the template||
|data[index]._referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|data[index]._caption|string|||
|metadata|object|||
|metadata.sort|array|Sort that was passed in the request||
|metadata.sort[index]|array|Sort that was passed in the request||
|metadata.sort[index].prop|string|The property name for the sort||
|metadata.sort[index].order|string|The direction of sort. Default DESC Values:ASC,DESC|ASC|
|metadata.filter|object|The filter that was passed in the request||
|metadata.page|object|||
|metadata.page.totalResults|integer|The total number of items that match the query|145|
|metadata.page.page|integer|Page number|3|
|metadata.page.limit|integer|Number of items per page|100|
|metadata.freeTextSearch|string|Free text search strings that was passed in the request|cat dog|
 */ SearchResponseOrganizationResponse;
export type SearchOrganizationsApiArg = {
  /** Search request parameters: filter, sort and page */
  searchRequest?: string;
};
export type CreateOrganizationApiResponse = /** status 201 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Regular custom attribute 1 value||
|&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Regular custom attribute N value||
|_caption|string|||
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_description|string|A description, can be up to 5000 characters long|Lorem Ipsum|
|_headquarters|object|||
|_headquarters.address1|string|An address|11 Main St.|
|_headquarters.address2|string|An address's specifics|Entry B, Apartment 1|
|_headquarters.city|string|A city|Boston|
|_headquarters.countryCode|string|A 2-letter country code defined in ISO-3166|US|
|_headquarters.state|string|A state|Massachusetts|
|_headquarters.zipCode|string|A zipcode|02101|
|_id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_locale|string|Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase.|en-us|
|_name|string|An organization's name|Example Inc.|
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.name|string|The caption of the referenced entity||
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_phone|string|An E.164 formatted phone number|+12345678901|
|_primaryAdministrator|object|||
|_primaryAdministrator.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_primaryAdministrator.name|string|The caption of the referenced entity||
|_primaryAdministrator.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_primaryAdministrator.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_primaryAdministrator.templateName|string|The name of the referenced entity template||
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_template|object|||
|_template.displayName|string|The display name of the template||
|_template.id|string|The id of the template||
|_template.name|string|The name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.name|string|||
|_timezone|string|A java time zone supported by the java runtime environment|Europe/Oslo|
 */ OrganizationResponse;
export type CreateOrganizationApiArg = {
  createOrganizationRequest: CreateOrganizationRequest;
};
export type DeleteOrganizationApiResponse = /** status 204 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
 */ void;
export type DeleteOrganizationApiArg = {
  /** Organization ID that needs to be deleted */
  id: string;
};
export type GetOrganizationApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Regular custom attribute 1 value||
|&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Regular custom attribute N value||
|_caption|string|||
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_description|string|A description, can be up to 5000 characters long|Lorem Ipsum|
|_headquarters|object|||
|_headquarters.address1|string|An address|11 Main St.|
|_headquarters.address2|string|An address's specifics|Entry B, Apartment 1|
|_headquarters.city|string|A city|Boston|
|_headquarters.countryCode|string|A 2-letter country code defined in ISO-3166|US|
|_headquarters.state|string|A state|Massachusetts|
|_headquarters.zipCode|string|A zipcode|02101|
|_id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_locale|string|Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase.|en-us|
|_name|string|An organization's name|Example Inc.|
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.name|string|The caption of the referenced entity||
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_phone|string|An E.164 formatted phone number|+12345678901|
|_primaryAdministrator|object|||
|_primaryAdministrator.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_primaryAdministrator.name|string|The caption of the referenced entity||
|_primaryAdministrator.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_primaryAdministrator.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_primaryAdministrator.templateName|string|The name of the referenced entity template||
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_template|object|||
|_template.displayName|string|The display name of the template||
|_template.id|string|The id of the template||
|_template.name|string|The name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.name|string|||
|_timezone|string|A java time zone supported by the java runtime environment|Europe/Oslo|
 */ OrganizationResponse;
export type GetOrganizationApiArg = {
  /** Organization ID that needs to be fetched */
  id: string;
};
export type UpdateOrganizationApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Regular custom attribute 1 value||
|&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Regular custom attribute N value||
|_caption|string|||
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_description|string|A description, can be up to 5000 characters long|Lorem Ipsum|
|_headquarters|object|||
|_headquarters.address1|string|An address|11 Main St.|
|_headquarters.address2|string|An address's specifics|Entry B, Apartment 1|
|_headquarters.city|string|A city|Boston|
|_headquarters.countryCode|string|A 2-letter country code defined in ISO-3166|US|
|_headquarters.state|string|A state|Massachusetts|
|_headquarters.zipCode|string|A zipcode|02101|
|_id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_locale|string|Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase.|en-us|
|_name|string|An organization's name|Example Inc.|
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.name|string|The caption of the referenced entity||
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_phone|string|An E.164 formatted phone number|+12345678901|
|_primaryAdministrator|object|||
|_primaryAdministrator.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_primaryAdministrator.name|string|The caption of the referenced entity||
|_primaryAdministrator.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_primaryAdministrator.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_primaryAdministrator.templateName|string|The name of the referenced entity template||
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_template|object|||
|_template.displayName|string|The display name of the template||
|_template.id|string|The id of the template||
|_template.name|string|The name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.name|string|||
|_timezone|string|A java time zone supported by the java runtime environment|Europe/Oslo|
 */ OrganizationResponse;
export type UpdateOrganizationApiArg = {
  /** Organization ID that needs to be updated */
  id: string;
  updateOrganizationRequest: UpdateOrganizationRequest;
};
export type ChangeOrganizationAdminApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|_name|string|An organization's name|Example Inc.|
|_description|string|A description, can be up to 5000 characters long|Lorem Ipsum|
|_headquarters|object|||
|_headquarters.countryCode|string|A 2-letter country code defined in ISO-3166|US|
|_headquarters.state|string|A state|Massachusetts|
|_headquarters.city|string|A city|Boston|
|_headquarters.zipCode|string|A zipcode|02101|
|_headquarters.address1|string|An address|11 Main St.|
|_headquarters.address2|string|An address's specifics|Entry B, Apartment 1|
|_phone|string|An E.164 formatted phone number|+12345678901|
|_timezone|string|A java time zone supported by the java runtime environment|Europe/Oslo|
|_locale|string|Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase.|en-us|
|_id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_ownerOrganization.name|string|The caption of the referenced entity||
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_primaryAdministrator|object|||
|_primaryAdministrator.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_primaryAdministrator.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_primaryAdministrator.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_primaryAdministrator.templateName|string|The name of the referenced entity template||
|_primaryAdministrator.name|string|The caption of the referenced entity||
|_template|object|||
|_template.name|string|The name of the template||
|_template.displayName|string|The display name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.name|string|||
|_template.id|string|The id of the template||
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_caption|string|||
 */ OrganizationResponse;
export type ChangeOrganizationAdminApiArg = {
  newAdminId: string;
};
export type CreateOrganizationByTemplateNameApiResponse =
  /** status 201 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Regular custom attribute 1 value||
|&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Regular custom attribute N value||
|_caption|string|||
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_description|string|A description, can be up to 5000 characters long|Lorem Ipsum|
|_headquarters|object|||
|_headquarters.address1|string|An address|11 Main St.|
|_headquarters.address2|string|An address's specifics|Entry B, Apartment 1|
|_headquarters.city|string|A city|Boston|
|_headquarters.countryCode|string|A 2-letter country code defined in ISO-3166|US|
|_headquarters.state|string|A state|Massachusetts|
|_headquarters.zipCode|string|A zipcode|02101|
|_id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_locale|string|Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase.|en-us|
|_name|string|An organization's name|Example Inc.|
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.name|string|The caption of the referenced entity||
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_phone|string|An E.164 formatted phone number|+12345678901|
|_primaryAdministrator|object|||
|_primaryAdministrator.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_primaryAdministrator.name|string|The caption of the referenced entity||
|_primaryAdministrator.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_primaryAdministrator.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_primaryAdministrator.templateName|string|The name of the referenced entity template||
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_template|object|||
|_template.displayName|string|The display name of the template||
|_template.id|string|The id of the template||
|_template.name|string|The name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.name|string|||
|_timezone|string|A java time zone supported by the java runtime environment|Europe/Oslo|
 */ OrganizationResponse;
export type CreateOrganizationByTemplateNameApiArg = {
  templateName: string;
  createOrganizationByTemplateNameRequest: CreateOrganizationByTemplateNameRequest;
};
export type SearchRegistrationCodesApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|data|array|List of items that match the search request||
|data[index]|array|List of items that match the search request||
|data[index]._code|string|||
|data[index]._id|string|||
|data[index]._template|object|||
|data[index]._template.name|string|The name of the template||
|data[index]._template.displayName|string|The display name of the template||
|data[index]._template.parentTemplate|object|||
|data[index]._template.parentTemplate.id|string|||
|data[index]._template.parentTemplate.displayName|string|||
|data[index]._template.parentTemplate.name|string|||
|data[index]._template.id|string|The id of the template||
|data[index]._referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|data[index]._lastModifiedTime|string|||
|data[index]._creationTime|string|||
|data[index]._ownerOrganization|object|||
|data[index]._ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|data[index]._ownerOrganization.templateName|string|The name of the referenced entity template||
|data[index]._ownerOrganization.name|string|The caption of the referenced entity||
|data[index]._caption|string|||
|metadata|object|||
|metadata.sort|array|Sort that was passed in the request||
|metadata.sort[index]|array|Sort that was passed in the request||
|metadata.sort[index].prop|string|The property name for the sort||
|metadata.sort[index].order|string|The direction of sort. Default DESC Values:ASC,DESC|ASC|
|metadata.filter|object|The filter that was passed in the request||
|metadata.page|object|||
|metadata.page.totalResults|integer|The total number of items that match the query|145|
|metadata.page.page|integer|Page number|3|
|metadata.page.limit|integer|Number of items per page|100|
|metadata.freeTextSearch|string|Free text search strings that was passed in the request|cat dog|
 */ SearchResponseRegistrationCodeResponse;
export type SearchRegistrationCodesApiArg = {
  /** Search request parameters: filter, sort and page */
  searchRequest?: string;
};
export type CreateRegistrationCodeApiResponse = /** status 201 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Regular custom attribute 1 value||
|&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Regular custom attribute N value||
|_caption|string|||
|_code|string|||
|_creationTime|string|||
|_id|string|||
|_lastModifiedTime|string|||
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.name|string|The caption of the referenced entity||
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_template|object|||
|_template.displayName|string|The display name of the template||
|_template.id|string|The id of the template||
|_template.name|string|The name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.name|string|||
 */ RegistrationCodeResponse;
export type CreateRegistrationCodeApiArg = {
  createRegistrationCodeRequest: CreateRegistrationCodeRequest;
};
export type DeleteRegistrationCodeApiResponse = /** status 204 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
 */ void;
export type DeleteRegistrationCodeApiArg = {
  /** Registration Code ID that needs to be deleted */
  id: string;
};
export type GetRegistrationCodeApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Regular custom attribute 1 value||
|&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Regular custom attribute N value||
|_caption|string|||
|_code|string|||
|_creationTime|string|||
|_id|string|||
|_lastModifiedTime|string|||
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.name|string|The caption of the referenced entity||
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_template|object|||
|_template.displayName|string|The display name of the template||
|_template.id|string|The id of the template||
|_template.name|string|The name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.name|string|||
 */ RegistrationCodeResponse;
export type GetRegistrationCodeApiArg = {
  /** Registration Code ID that needs to be fetched */
  id: string;
};
export type UpdateRegistrationCodeApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Regular custom attribute 1 value||
|&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Regular custom attribute N value||
|_caption|string|||
|_code|string|||
|_creationTime|string|||
|_id|string|||
|_lastModifiedTime|string|||
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.name|string|The caption of the referenced entity||
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_template|object|||
|_template.displayName|string|The display name of the template||
|_template.id|string|The id of the template||
|_template.name|string|The name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.name|string|||
 */ RegistrationCodeResponse;
export type UpdateRegistrationCodeApiArg = {
  /** Registration Code ID that needs to be updated */
  id: string;
  updateRegistrationCodeRequest: UpdateRegistrationCodeRequest;
};
export type CreateRegistrationCodeByTemplateNameApiResponse =
  /** status 201 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Regular custom attribute 1 value||
|&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Regular custom attribute N value||
|_caption|string|||
|_code|string|||
|_creationTime|string|||
|_id|string|||
|_lastModifiedTime|string|||
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.name|string|The caption of the referenced entity||
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_template|object|||
|_template.displayName|string|The display name of the template||
|_template.id|string|The id of the template||
|_template.name|string|The name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.name|string|||
 */ RegistrationCodeResponse;
export type CreateRegistrationCodeByTemplateNameApiArg = {
  templateName: string;
  createRegistrationCodeByTemplateNameRequest: CreateRegistrationCodeByTemplateNameRequest;
};
export type OrganizationvalidateTokenOperationApiResponse = /** status 200 SUCCESS */ void;
export type OrganizationvalidateTokenOperationApiArg = {
  /** Temporary token for calling this API */
  token: string;
  /** Operation name */
  operation: string;
  /** The entity id of the operation */
  entityId: string;
};
export type OrganizationexecuteTokenOperationApiResponse = /** status 200 SUCCESS */ TokenOperationResponse;
export type OrganizationexecuteTokenOperationApiArg = {
  /** Temporary token for calling this API */
  token: string;
  /** Operation name */
  operation: string;
  /** The entity id of the operation */
  entityId: string;
  body: {
    operationData: {
      [key: string]: object;
    };
  };
};
export type OrganizationexecuteTokenOperationGetApiResponse = /** status 200 SUCCESS */ TokenOperationResponse;
export type OrganizationexecuteTokenOperationGetApiArg = {
  /** Temporary token for calling this API */
  token: string;
  /** Operation name */
  operation: string;
  /** The entity id of the operation */
  entityId: string;
  operationData: {
    [key: string]: object;
  };
};
export type SearchCaregiversApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|data|array|List of items that match the search request||
|data[index]|array|List of items that match the search request||
|data[index]._name|object|||
|data[index]._name.firstName|string|A person's first name|John|
|data[index]._name.lastName|string|A person's last name|Smith|
|data[index]._description|string|A description, can be up to 5000 characters long|Lorem Ipsum|
|data[index]._email|string|An email address in the RFC-5322 specification|john.smith@biot-med.com|
|data[index]._phone|string|A person's phone An E.164 formatted phone number|+12345678901|
|data[index]._locale|string|A person's locale Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase.|en-us|
|data[index]._gender|string|A persons gender Values:MALE,FEMALE,UNDISCLOSED|FEMALE|
|data[index]._dateOfBirth|string|A person's date of birth A UTC date in the ISO-8601 format|Thu Dec 20 00:00:00 UTC 2007|
|data[index]._address|object|||
|data[index]._address.countryCode|string|A 2-letter country code defined in ISO-3166|US|
|data[index]._address.state|string|A state|Massachusetts|
|data[index]._address.city|string|A city|Boston|
|data[index]._address.zipCode|string|A zipcode|02101|
|data[index]._address.address1|string|An address|11 Main St.|
|data[index]._address.address2|string|An address's specifics|Entry B, Apartment 1|
|data[index]._mfa|object|||
|data[index]._mfa.enabled|boolean|MFA login enabled or disabled||
|data[index]._mfa.expirationInMinutes|integer|MFA expiration time in minutes||
|data[index]._credentialType|string|What type of credentials is used when logging in to the system. Only one type can be used. Default:PASSWORD Values:PASSWORD,OTP||
|data[index]._employeeId|string|||
|data[index]._degree|string|An caregiver's name Values:MEDICAL_DOCTOR,DOCTOR_OF_OSTEOPATHY,PHYSICIAN_ASSISTANT,REGISTERED_NURSE,CLINICAL_NURSE_SPECIALISTS,NURSE_PRACTITIONER,LICENSED_PRACTICAL_NURSE,MEDICAL_ASSISTANT,NO_DEGREE,OTHER|PHYSICIAN_ASSISTANT|
|data[index]._id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._ownerOrganization|object|||
|data[index]._ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|data[index]._ownerOrganization.templateName|string|The name of the referenced entity template||
|data[index]._ownerOrganization.name|string|The caption of the referenced entity||
|data[index]._creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|data[index]._lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|data[index]._invitationAccepted|boolean|Has invitation been accepted||
|data[index]._template|object|||
|data[index]._template.name|string|The name of the template||
|data[index]._template.displayName|string|The display name of the template||
|data[index]._template.parentTemplate|object|||
|data[index]._template.parentTemplate.id|string|||
|data[index]._template.parentTemplate.displayName|string|||
|data[index]._template.parentTemplate.name|string|||
|data[index]._template.id|string|The id of the template||
|data[index]._referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|data[index]._enabled|string|Is the user enabled Values:DISABLED,ENABLED|ENABLED|DISABLED|
|data[index]._caption|string|||
|metadata|object|||
|metadata.sort|array|Sort that was passed in the request||
|metadata.sort[index]|array|Sort that was passed in the request||
|metadata.sort[index].prop|string|The property name for the sort||
|metadata.sort[index].order|string|The direction of sort. Default DESC Values:ASC,DESC|ASC|
|metadata.filter|object|The filter that was passed in the request||
|metadata.page|object|||
|metadata.page.totalResults|integer|The total number of items that match the query|145|
|metadata.page.page|integer|Page number|3|
|metadata.page.limit|integer|Number of items per page|100|
|metadata.freeTextSearch|string|Free text search strings that was passed in the request|cat dog|
 */ SearchResponseCaregiverResponse;
export type SearchCaregiversApiArg = {
  /** Search request parameters: filter, sort and page */
  searchRequest?: string;
};
export type CreateCaregiverApiResponse = /** status 201 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Regular custom attribute 1 value||
|&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Regular custom attribute N value||
|_address|object|||
|_address.address1|string|An address|11 Main St.|
|_address.address2|string|An address's specifics|Entry B, Apartment 1|
|_address.city|string|A city|Boston|
|_address.countryCode|string|A 2-letter country code defined in ISO-3166|US|
|_address.state|string|A state|Massachusetts|
|_address.zipCode|string|A zipcode|02101|
|_caption|string|||
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_credentialType|string|What type of credentials is used when logging in to the system. Only one type can be used. Default:PASSWORD Values:PASSWORD,OTP||
|_dateOfBirth|string|A person's date of birth A UTC date in the ISO-8601 format|Thu Dec 20 00:00:00 UTC 2007|
|_degree|string|An caregiver's name Values:MEDICAL_DOCTOR,DOCTOR_OF_OSTEOPATHY,PHYSICIAN_ASSISTANT,REGISTERED_NURSE,CLINICAL_NURSE_SPECIALISTS,NURSE_PRACTITIONER,LICENSED_PRACTICAL_NURSE,MEDICAL_ASSISTANT,NO_DEGREE,OTHER|PHYSICIAN_ASSISTANT|
|_description|string|A description, can be up to 5000 characters long|Lorem Ipsum|
|_email|string|An email address in the RFC-5322 specification|john.smith@biot-med.com|
|_employeeId|string|||
|_enabled|string|Is the user enabled Values:DISABLED,ENABLED|ENABLED|DISABLED|
|_gender|string|A persons gender Values:MALE,FEMALE,UNDISCLOSED|FEMALE|
|_id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_invitationAccepted|boolean|Has invitation been accepted||
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_locale|string|A person's locale Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase.|en-us|
|_mfa|object|||
|_mfa.enabled|boolean|MFA login enabled or disabled||
|_mfa.expirationInMinutes|integer|MFA expiration time in minutes||
|_name|object|||
|_name.firstName|string|A person's first name|John|
|_name.lastName|string|A person's last name|Smith|
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.name|string|The caption of the referenced entity||
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_phone|string|A person's phone An E.164 formatted phone number|+12345678901|
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_template|object|||
|_template.displayName|string|The display name of the template||
|_template.id|string|The id of the template||
|_template.name|string|The name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.name|string|||
 */ CaregiverResponse;
export type CreateCaregiverApiArg = {
  createCaregiverRequest: CreateCaregiverRequest;
};
export type DeleteCaregiverApiResponse = /** status 204 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
 */ void;
export type DeleteCaregiverApiArg = {
  /** Caregiver ID that needs to be deleted */
  id: string;
};
export type GetCaregiverApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Regular custom attribute 1 value||
|&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Regular custom attribute N value||
|_address|object|||
|_address.address1|string|An address|11 Main St.|
|_address.address2|string|An address's specifics|Entry B, Apartment 1|
|_address.city|string|A city|Boston|
|_address.countryCode|string|A 2-letter country code defined in ISO-3166|US|
|_address.state|string|A state|Massachusetts|
|_address.zipCode|string|A zipcode|02101|
|_caption|string|||
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_credentialType|string|What type of credentials is used when logging in to the system. Only one type can be used. Default:PASSWORD Values:PASSWORD,OTP||
|_dateOfBirth|string|A person's date of birth A UTC date in the ISO-8601 format|Thu Dec 20 00:00:00 UTC 2007|
|_degree|string|An caregiver's name Values:MEDICAL_DOCTOR,DOCTOR_OF_OSTEOPATHY,PHYSICIAN_ASSISTANT,REGISTERED_NURSE,CLINICAL_NURSE_SPECIALISTS,NURSE_PRACTITIONER,LICENSED_PRACTICAL_NURSE,MEDICAL_ASSISTANT,NO_DEGREE,OTHER|PHYSICIAN_ASSISTANT|
|_description|string|A description, can be up to 5000 characters long|Lorem Ipsum|
|_email|string|An email address in the RFC-5322 specification|john.smith@biot-med.com|
|_employeeId|string|||
|_enabled|string|Is the user enabled Values:DISABLED,ENABLED|ENABLED|DISABLED|
|_gender|string|A persons gender Values:MALE,FEMALE,UNDISCLOSED|FEMALE|
|_id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_invitationAccepted|boolean|Has invitation been accepted||
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_locale|string|A person's locale Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase.|en-us|
|_mfa|object|||
|_mfa.enabled|boolean|MFA login enabled or disabled||
|_mfa.expirationInMinutes|integer|MFA expiration time in minutes||
|_name|object|||
|_name.firstName|string|A person's first name|John|
|_name.lastName|string|A person's last name|Smith|
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.name|string|The caption of the referenced entity||
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_phone|string|A person's phone An E.164 formatted phone number|+12345678901|
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_template|object|||
|_template.displayName|string|The display name of the template||
|_template.id|string|The id of the template||
|_template.name|string|The name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.name|string|||
 */ CaregiverResponse;
export type GetCaregiverApiArg = {
  /** Caregiver ID that needs to be fetched */
  id: string;
};
export type UpdateCaregiverApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Regular custom attribute 1 value||
|&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Regular custom attribute N value||
|_address|object|||
|_address.address1|string|An address|11 Main St.|
|_address.address2|string|An address's specifics|Entry B, Apartment 1|
|_address.city|string|A city|Boston|
|_address.countryCode|string|A 2-letter country code defined in ISO-3166|US|
|_address.state|string|A state|Massachusetts|
|_address.zipCode|string|A zipcode|02101|
|_caption|string|||
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_credentialType|string|What type of credentials is used when logging in to the system. Only one type can be used. Default:PASSWORD Values:PASSWORD,OTP||
|_dateOfBirth|string|A person's date of birth A UTC date in the ISO-8601 format|Thu Dec 20 00:00:00 UTC 2007|
|_degree|string|An caregiver's name Values:MEDICAL_DOCTOR,DOCTOR_OF_OSTEOPATHY,PHYSICIAN_ASSISTANT,REGISTERED_NURSE,CLINICAL_NURSE_SPECIALISTS,NURSE_PRACTITIONER,LICENSED_PRACTICAL_NURSE,MEDICAL_ASSISTANT,NO_DEGREE,OTHER|PHYSICIAN_ASSISTANT|
|_description|string|A description, can be up to 5000 characters long|Lorem Ipsum|
|_email|string|An email address in the RFC-5322 specification|john.smith@biot-med.com|
|_employeeId|string|||
|_enabled|string|Is the user enabled Values:DISABLED,ENABLED|ENABLED|DISABLED|
|_gender|string|A persons gender Values:MALE,FEMALE,UNDISCLOSED|FEMALE|
|_id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_invitationAccepted|boolean|Has invitation been accepted||
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_locale|string|A person's locale Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase.|en-us|
|_mfa|object|||
|_mfa.enabled|boolean|MFA login enabled or disabled||
|_mfa.expirationInMinutes|integer|MFA expiration time in minutes||
|_name|object|||
|_name.firstName|string|A person's first name|John|
|_name.lastName|string|A person's last name|Smith|
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.name|string|The caption of the referenced entity||
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_phone|string|A person's phone An E.164 formatted phone number|+12345678901|
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_template|object|||
|_template.displayName|string|The display name of the template||
|_template.id|string|The id of the template||
|_template.name|string|The name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.name|string|||
 */ CaregiverResponse;
export type UpdateCaregiverApiArg = {
  /** Caregiver ID that needs to be updated */
  id: string;
  updateCaregiverRequest: UpdateCaregiverRequest;
};
export type ChangeCaregiverEnabledStateApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|_name|object|||
|_name.firstName|string|A person's first name|John|
|_name.lastName|string|A person's last name|Smith|
|_description|string|A description, can be up to 5000 characters long|Lorem Ipsum|
|_email|string|An email address in the RFC-5322 specification|john.smith@biot-med.com|
|_phone|string|A person's phone An E.164 formatted phone number|+12345678901|
|_locale|string|A person's locale Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase.|en-us|
|_gender|string|A persons gender Values:MALE,FEMALE,UNDISCLOSED|FEMALE|
|_dateOfBirth|string|A person's date of birth A UTC date in the ISO-8601 format|Thu Dec 20 00:00:00 UTC 2007|
|_address|object|||
|_address.countryCode|string|A 2-letter country code defined in ISO-3166|US|
|_address.state|string|A state|Massachusetts|
|_address.city|string|A city|Boston|
|_address.zipCode|string|A zipcode|02101|
|_address.address1|string|An address|11 Main St.|
|_address.address2|string|An address's specifics|Entry B, Apartment 1|
|_mfa|object|||
|_mfa.enabled|boolean|MFA login enabled or disabled||
|_mfa.expirationInMinutes|integer|MFA expiration time in minutes||
|_credentialType|string|What type of credentials is used when logging in to the system. Only one type can be used. Default:PASSWORD Values:PASSWORD,OTP||
|_employeeId|string|||
|_degree|string|An caregiver's name Values:MEDICAL_DOCTOR,DOCTOR_OF_OSTEOPATHY,PHYSICIAN_ASSISTANT,REGISTERED_NURSE,CLINICAL_NURSE_SPECIALISTS,NURSE_PRACTITIONER,LICENSED_PRACTICAL_NURSE,MEDICAL_ASSISTANT,NO_DEGREE,OTHER|PHYSICIAN_ASSISTANT|
|_id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_ownerOrganization.name|string|The caption of the referenced entity||
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_invitationAccepted|boolean|Has invitation been accepted||
|_template|object|||
|_template.name|string|The name of the template||
|_template.displayName|string|The display name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.name|string|||
|_template.id|string|The id of the template||
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_enabled|string|Is the user enabled Values:DISABLED,ENABLED|ENABLED|DISABLED|
|_caption|string|||
 */ CaregiverResponse;
export type ChangeCaregiverEnabledStateApiArg = {
  /** Caregiver ID */
  id: string;
  state: "DISABLED" | "ENABLED";
};
export type GetCaregiverSelfApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Regular custom attribute 1 value||
|&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Regular custom attribute N value||
|_address|object|||
|_address.address1|string|An address|11 Main St.|
|_address.address2|string|An address's specifics|Entry B, Apartment 1|
|_address.city|string|A city|Boston|
|_address.countryCode|string|A 2-letter country code defined in ISO-3166|US|
|_address.state|string|A state|Massachusetts|
|_address.zipCode|string|A zipcode|02101|
|_caption|string|||
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_credentialType|string|What type of credentials is used when logging in to the system. Only one type can be used. Default:PASSWORD Values:PASSWORD,OTP||
|_dateOfBirth|string|A person's date of birth A UTC date in the ISO-8601 format|Thu Dec 20 00:00:00 UTC 2007|
|_degree|string|An caregiver's name Values:MEDICAL_DOCTOR,DOCTOR_OF_OSTEOPATHY,PHYSICIAN_ASSISTANT,REGISTERED_NURSE,CLINICAL_NURSE_SPECIALISTS,NURSE_PRACTITIONER,LICENSED_PRACTICAL_NURSE,MEDICAL_ASSISTANT,NO_DEGREE,OTHER|PHYSICIAN_ASSISTANT|
|_description|string|A description, can be up to 5000 characters long|Lorem Ipsum|
|_email|string|An email address in the RFC-5322 specification|john.smith@biot-med.com|
|_employeeId|string|||
|_enabled|string|Is the user enabled Values:DISABLED,ENABLED|ENABLED|DISABLED|
|_gender|string|A persons gender Values:MALE,FEMALE,UNDISCLOSED|FEMALE|
|_id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_invitationAccepted|boolean|Has invitation been accepted||
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_locale|string|A person's locale Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase.|en-us|
|_mfa|object|||
|_mfa.enabled|boolean|MFA login enabled or disabled||
|_mfa.expirationInMinutes|integer|MFA expiration time in minutes||
|_name|object|||
|_name.firstName|string|A person's first name|John|
|_name.lastName|string|A person's last name|Smith|
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.name|string|The caption of the referenced entity||
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_phone|string|A person's phone An E.164 formatted phone number|+12345678901|
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_template|object|||
|_template.displayName|string|The display name of the template||
|_template.id|string|The id of the template||
|_template.name|string|The name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.name|string|||
 */ CaregiverResponse;
export type GetCaregiverSelfApiArg = void;
export type CreateCaregiverByTemplateNameApiResponse = /** status 201 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Regular custom attribute 1 value||
|&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Regular custom attribute N value||
|_address|object|||
|_address.address1|string|An address|11 Main St.|
|_address.address2|string|An address's specifics|Entry B, Apartment 1|
|_address.city|string|A city|Boston|
|_address.countryCode|string|A 2-letter country code defined in ISO-3166|US|
|_address.state|string|A state|Massachusetts|
|_address.zipCode|string|A zipcode|02101|
|_caption|string|||
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_credentialType|string|What type of credentials is used when logging in to the system. Only one type can be used. Default:PASSWORD Values:PASSWORD,OTP||
|_dateOfBirth|string|A person's date of birth A UTC date in the ISO-8601 format|Thu Dec 20 00:00:00 UTC 2007|
|_degree|string|An caregiver's name Values:MEDICAL_DOCTOR,DOCTOR_OF_OSTEOPATHY,PHYSICIAN_ASSISTANT,REGISTERED_NURSE,CLINICAL_NURSE_SPECIALISTS,NURSE_PRACTITIONER,LICENSED_PRACTICAL_NURSE,MEDICAL_ASSISTANT,NO_DEGREE,OTHER|PHYSICIAN_ASSISTANT|
|_description|string|A description, can be up to 5000 characters long|Lorem Ipsum|
|_email|string|An email address in the RFC-5322 specification|john.smith@biot-med.com|
|_employeeId|string|||
|_enabled|string|Is the user enabled Values:DISABLED,ENABLED|ENABLED|DISABLED|
|_gender|string|A persons gender Values:MALE,FEMALE,UNDISCLOSED|FEMALE|
|_id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_invitationAccepted|boolean|Has invitation been accepted||
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_locale|string|A person's locale Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase.|en-us|
|_mfa|object|||
|_mfa.enabled|boolean|MFA login enabled or disabled||
|_mfa.expirationInMinutes|integer|MFA expiration time in minutes||
|_name|object|||
|_name.firstName|string|A person's first name|John|
|_name.lastName|string|A person's last name|Smith|
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.name|string|The caption of the referenced entity||
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_phone|string|A person's phone An E.164 formatted phone number|+12345678901|
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_template|object|||
|_template.displayName|string|The display name of the template||
|_template.id|string|The id of the template||
|_template.name|string|The name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.name|string|||
 */ CaregiverResponse;
export type CreateCaregiverByTemplateNameApiArg = {
  templateName: string;
  createCaregiverByTemplateNameRequest: CreateCaregiverByTemplateNameRequest;
};
export type SearchOrganizationUsersApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|data|array|List of items that match the search request||
|data[index]|array|List of items that match the search request||
|data[index]._name|object|||
|data[index]._name.firstName|string|A person's first name|John|
|data[index]._name.lastName|string|A person's last name|Smith|
|data[index]._description|string|A description, can be up to 5000 characters long|Lorem Ipsum|
|data[index]._email|string|An email address in the RFC-5322 specification|john.smith@biot-med.com|
|data[index]._phone|string|A person's phone An E.164 formatted phone number|+12345678901|
|data[index]._locale|string|A person's locale Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase.|en-us|
|data[index]._gender|string|A persons gender Values:MALE,FEMALE,UNDISCLOSED|FEMALE|
|data[index]._dateOfBirth|string|A person's date of birth A UTC date in the ISO-8601 format|Thu Dec 20 00:00:00 UTC 2007|
|data[index]._address|object|||
|data[index]._address.countryCode|string|A 2-letter country code defined in ISO-3166|US|
|data[index]._address.state|string|A state|Massachusetts|
|data[index]._address.city|string|A city|Boston|
|data[index]._address.zipCode|string|A zipcode|02101|
|data[index]._address.address1|string|An address|11 Main St.|
|data[index]._address.address2|string|An address's specifics|Entry B, Apartment 1|
|data[index]._mfa|object|||
|data[index]._mfa.enabled|boolean|MFA login enabled or disabled||
|data[index]._mfa.expirationInMinutes|integer|MFA expiration time in minutes||
|data[index]._credentialType|string|What type of credentials is used when logging in to the system. Only one type can be used. Default:PASSWORD Values:PASSWORD,OTP||
|data[index]._employeeId|string|||
|data[index]._ownerOrganization|object|||
|data[index]._ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|data[index]._ownerOrganization.templateName|string|The name of the referenced entity template||
|data[index]._ownerOrganization.name|string|The caption of the referenced entity||
|data[index]._id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|data[index]._lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|data[index]._invitationAccepted|boolean|Has invitation been accepted||
|data[index]._template|object|||
|data[index]._template.name|string|The name of the template||
|data[index]._template.displayName|string|The display name of the template||
|data[index]._template.parentTemplate|object|||
|data[index]._template.parentTemplate.id|string|||
|data[index]._template.parentTemplate.displayName|string|||
|data[index]._template.parentTemplate.name|string|||
|data[index]._template.id|string|The id of the template||
|data[index]._referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|data[index]._enabled|string|Is the user enabled Values:DISABLED,ENABLED|ENABLED|DISABLED|
|data[index]._caption|string|||
|metadata|object|||
|metadata.sort|array|Sort that was passed in the request||
|metadata.sort[index]|array|Sort that was passed in the request||
|metadata.sort[index].prop|string|The property name for the sort||
|metadata.sort[index].order|string|The direction of sort. Default DESC Values:ASC,DESC|ASC|
|metadata.filter|object|The filter that was passed in the request||
|metadata.page|object|||
|metadata.page.totalResults|integer|The total number of items that match the query|145|
|metadata.page.page|integer|Page number|3|
|metadata.page.limit|integer|Number of items per page|100|
|metadata.freeTextSearch|string|Free text search strings that was passed in the request|cat dog|
 */ SearchResponseOrganizationUserResponse;
export type SearchOrganizationUsersApiArg = {
  /** Search request parameters: filter, sort and page */
  searchRequest?: string;
};
export type CreateOrganizationUserApiResponse = /** status 201 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Regular custom attribute 1 value||
|&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Regular custom attribute N value||
|_address|object|||
|_address.address1|string|An address|11 Main St.|
|_address.address2|string|An address's specifics|Entry B, Apartment 1|
|_address.city|string|A city|Boston|
|_address.countryCode|string|A 2-letter country code defined in ISO-3166|US|
|_address.state|string|A state|Massachusetts|
|_address.zipCode|string|A zipcode|02101|
|_caption|string|||
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_credentialType|string|What type of credentials is used when logging in to the system. Only one type can be used. Default:PASSWORD Values:PASSWORD,OTP||
|_dateOfBirth|string|A person's date of birth A UTC date in the ISO-8601 format|Thu Dec 20 00:00:00 UTC 2007|
|_description|string|A description, can be up to 5000 characters long|Lorem Ipsum|
|_email|string|An email address in the RFC-5322 specification|john.smith@biot-med.com|
|_employeeId|string|||
|_enabled|string|Is the user enabled Values:DISABLED,ENABLED|ENABLED|DISABLED|
|_gender|string|A persons gender Values:MALE,FEMALE,UNDISCLOSED|FEMALE|
|_id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_invitationAccepted|boolean|Has invitation been accepted||
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_locale|string|A person's locale Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase.|en-us|
|_mfa|object|||
|_mfa.enabled|boolean|MFA login enabled or disabled||
|_mfa.expirationInMinutes|integer|MFA expiration time in minutes||
|_name|object|||
|_name.firstName|string|A person's first name|John|
|_name.lastName|string|A person's last name|Smith|
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.name|string|The caption of the referenced entity||
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_phone|string|A person's phone An E.164 formatted phone number|+12345678901|
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_template|object|||
|_template.displayName|string|The display name of the template||
|_template.id|string|The id of the template||
|_template.name|string|The name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.name|string|||
 */ OrganizationUserResponse;
export type CreateOrganizationUserApiArg = {
  createOrganizationUserRequest: CreateOrganizationUserRequest;
};
export type DeleteOrganizationUserApiResponse = /** status 204 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
 */ void;
export type DeleteOrganizationUserApiArg = {
  /** Organization User ID that needs to be deleted */
  id: string;
};
export type GetOrganizationUserApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Regular custom attribute 1 value||
|&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Regular custom attribute N value||
|_address|object|||
|_address.address1|string|An address|11 Main St.|
|_address.address2|string|An address's specifics|Entry B, Apartment 1|
|_address.city|string|A city|Boston|
|_address.countryCode|string|A 2-letter country code defined in ISO-3166|US|
|_address.state|string|A state|Massachusetts|
|_address.zipCode|string|A zipcode|02101|
|_caption|string|||
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_credentialType|string|What type of credentials is used when logging in to the system. Only one type can be used. Default:PASSWORD Values:PASSWORD,OTP||
|_dateOfBirth|string|A person's date of birth A UTC date in the ISO-8601 format|Thu Dec 20 00:00:00 UTC 2007|
|_description|string|A description, can be up to 5000 characters long|Lorem Ipsum|
|_email|string|An email address in the RFC-5322 specification|john.smith@biot-med.com|
|_employeeId|string|||
|_enabled|string|Is the user enabled Values:DISABLED,ENABLED|ENABLED|DISABLED|
|_gender|string|A persons gender Values:MALE,FEMALE,UNDISCLOSED|FEMALE|
|_id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_invitationAccepted|boolean|Has invitation been accepted||
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_locale|string|A person's locale Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase.|en-us|
|_mfa|object|||
|_mfa.enabled|boolean|MFA login enabled or disabled||
|_mfa.expirationInMinutes|integer|MFA expiration time in minutes||
|_name|object|||
|_name.firstName|string|A person's first name|John|
|_name.lastName|string|A person's last name|Smith|
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.name|string|The caption of the referenced entity||
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_phone|string|A person's phone An E.164 formatted phone number|+12345678901|
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_template|object|||
|_template.displayName|string|The display name of the template||
|_template.id|string|The id of the template||
|_template.name|string|The name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.name|string|||
 */ OrganizationUserResponse;
export type GetOrganizationUserApiArg = {
  /** Organization User ID that needs to be fetched */
  id: string;
};
export type UpdateOrganizationUserApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Regular custom attribute 1 value||
|&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Regular custom attribute N value||
|_address|object|||
|_address.address1|string|An address|11 Main St.|
|_address.address2|string|An address's specifics|Entry B, Apartment 1|
|_address.city|string|A city|Boston|
|_address.countryCode|string|A 2-letter country code defined in ISO-3166|US|
|_address.state|string|A state|Massachusetts|
|_address.zipCode|string|A zipcode|02101|
|_caption|string|||
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_credentialType|string|What type of credentials is used when logging in to the system. Only one type can be used. Default:PASSWORD Values:PASSWORD,OTP||
|_dateOfBirth|string|A person's date of birth A UTC date in the ISO-8601 format|Thu Dec 20 00:00:00 UTC 2007|
|_description|string|A description, can be up to 5000 characters long|Lorem Ipsum|
|_email|string|An email address in the RFC-5322 specification|john.smith@biot-med.com|
|_employeeId|string|||
|_enabled|string|Is the user enabled Values:DISABLED,ENABLED|ENABLED|DISABLED|
|_gender|string|A persons gender Values:MALE,FEMALE,UNDISCLOSED|FEMALE|
|_id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_invitationAccepted|boolean|Has invitation been accepted||
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_locale|string|A person's locale Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase.|en-us|
|_mfa|object|||
|_mfa.enabled|boolean|MFA login enabled or disabled||
|_mfa.expirationInMinutes|integer|MFA expiration time in minutes||
|_name|object|||
|_name.firstName|string|A person's first name|John|
|_name.lastName|string|A person's last name|Smith|
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.name|string|The caption of the referenced entity||
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_phone|string|A person's phone An E.164 formatted phone number|+12345678901|
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_template|object|||
|_template.displayName|string|The display name of the template||
|_template.id|string|The id of the template||
|_template.name|string|The name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.name|string|||
 */ OrganizationUserResponse;
export type UpdateOrganizationUserApiArg = {
  /** Organization User ID that needs to be updated */
  id: string;
  updateOrganizationUserRequest: UpdateOrganizationUserRequest;
};
export type ChangeOrganizationUserEnabledStateApiResponse =
  /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|_name|object|||
|_name.firstName|string|A person's first name|John|
|_name.lastName|string|A person's last name|Smith|
|_description|string|A description, can be up to 5000 characters long|Lorem Ipsum|
|_email|string|An email address in the RFC-5322 specification|john.smith@biot-med.com|
|_phone|string|A person's phone An E.164 formatted phone number|+12345678901|
|_locale|string|A person's locale Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase.|en-us|
|_gender|string|A persons gender Values:MALE,FEMALE,UNDISCLOSED|FEMALE|
|_dateOfBirth|string|A person's date of birth A UTC date in the ISO-8601 format|Thu Dec 20 00:00:00 UTC 2007|
|_address|object|||
|_address.countryCode|string|A 2-letter country code defined in ISO-3166|US|
|_address.state|string|A state|Massachusetts|
|_address.city|string|A city|Boston|
|_address.zipCode|string|A zipcode|02101|
|_address.address1|string|An address|11 Main St.|
|_address.address2|string|An address's specifics|Entry B, Apartment 1|
|_mfa|object|||
|_mfa.enabled|boolean|MFA login enabled or disabled||
|_mfa.expirationInMinutes|integer|MFA expiration time in minutes||
|_credentialType|string|What type of credentials is used when logging in to the system. Only one type can be used. Default:PASSWORD Values:PASSWORD,OTP||
|_employeeId|string|||
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_ownerOrganization.name|string|The caption of the referenced entity||
|_id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_invitationAccepted|boolean|Has invitation been accepted||
|_template|object|||
|_template.name|string|The name of the template||
|_template.displayName|string|The display name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.name|string|||
|_template.id|string|The id of the template||
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_enabled|string|Is the user enabled Values:DISABLED,ENABLED|ENABLED|DISABLED|
|_caption|string|||
 */ OrganizationUserResponse;
export type ChangeOrganizationUserEnabledStateApiArg = {
  /** Organization User ID */
  id: string;
  state: "DISABLED" | "ENABLED";
};
export type GetOrganizationUserSelfApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Regular custom attribute 1 value||
|&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Regular custom attribute N value||
|_address|object|||
|_address.address1|string|An address|11 Main St.|
|_address.address2|string|An address's specifics|Entry B, Apartment 1|
|_address.city|string|A city|Boston|
|_address.countryCode|string|A 2-letter country code defined in ISO-3166|US|
|_address.state|string|A state|Massachusetts|
|_address.zipCode|string|A zipcode|02101|
|_caption|string|||
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_credentialType|string|What type of credentials is used when logging in to the system. Only one type can be used. Default:PASSWORD Values:PASSWORD,OTP||
|_dateOfBirth|string|A person's date of birth A UTC date in the ISO-8601 format|Thu Dec 20 00:00:00 UTC 2007|
|_description|string|A description, can be up to 5000 characters long|Lorem Ipsum|
|_email|string|An email address in the RFC-5322 specification|john.smith@biot-med.com|
|_employeeId|string|||
|_enabled|string|Is the user enabled Values:DISABLED,ENABLED|ENABLED|DISABLED|
|_gender|string|A persons gender Values:MALE,FEMALE,UNDISCLOSED|FEMALE|
|_id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_invitationAccepted|boolean|Has invitation been accepted||
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_locale|string|A person's locale Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase.|en-us|
|_mfa|object|||
|_mfa.enabled|boolean|MFA login enabled or disabled||
|_mfa.expirationInMinutes|integer|MFA expiration time in minutes||
|_name|object|||
|_name.firstName|string|A person's first name|John|
|_name.lastName|string|A person's last name|Smith|
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.name|string|The caption of the referenced entity||
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_phone|string|A person's phone An E.164 formatted phone number|+12345678901|
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_template|object|||
|_template.displayName|string|The display name of the template||
|_template.id|string|The id of the template||
|_template.name|string|The name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.name|string|||
 */ OrganizationUserResponse;
export type GetOrganizationUserSelfApiArg = void;
export type CreateOrganizationUserByTemplateNameApiResponse =
  /** status 201 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|&lt;customAttribute1&gt;|&lt;customAttribute1Type&gt;|Regular custom attribute 1 value||
|&lt;customAttributeN&gt;|&lt;customAttributeNType&gt;|Regular custom attribute N value||
|_address|object|||
|_address.address1|string|An address|11 Main St.|
|_address.address2|string|An address's specifics|Entry B, Apartment 1|
|_address.city|string|A city|Boston|
|_address.countryCode|string|A 2-letter country code defined in ISO-3166|US|
|_address.state|string|A state|Massachusetts|
|_address.zipCode|string|A zipcode|02101|
|_caption|string|||
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_credentialType|string|What type of credentials is used when logging in to the system. Only one type can be used. Default:PASSWORD Values:PASSWORD,OTP||
|_dateOfBirth|string|A person's date of birth A UTC date in the ISO-8601 format|Thu Dec 20 00:00:00 UTC 2007|
|_description|string|A description, can be up to 5000 characters long|Lorem Ipsum|
|_email|string|An email address in the RFC-5322 specification|john.smith@biot-med.com|
|_employeeId|string|||
|_enabled|string|Is the user enabled Values:DISABLED,ENABLED|ENABLED|DISABLED|
|_gender|string|A persons gender Values:MALE,FEMALE,UNDISCLOSED|FEMALE|
|_id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_invitationAccepted|boolean|Has invitation been accepted||
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_locale|string|A person's locale Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase.|en-us|
|_mfa|object|||
|_mfa.enabled|boolean|MFA login enabled or disabled||
|_mfa.expirationInMinutes|integer|MFA expiration time in minutes||
|_name|object|||
|_name.firstName|string|A person's first name|John|
|_name.lastName|string|A person's last name|Smith|
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.name|string|The caption of the referenced entity||
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_phone|string|A person's phone An E.164 formatted phone number|+12345678901|
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_template|object|||
|_template.displayName|string|The display name of the template||
|_template.id|string|The id of the template||
|_template.name|string|The name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.name|string|||
 */ OrganizationUserResponse;
export type CreateOrganizationUserByTemplateNameApiArg = {
  templateName: string;
  createOrganizationUserByTemplateNameRequest: CreateOrganizationUserByTemplateNameRequest;
};
export type SearchPatientsApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|data|array|List of items that match the search request||
|data[index]|array|List of items that match the search request||
|data[index]._name|object|||
|data[index]._name.firstName|string|A person's first name|John|
|data[index]._name.lastName|string|A person's last name|Smith|
|data[index]._description|string|A description, can be up to 5000 characters long|Lorem Ipsum|
|data[index]._email|string|An email address in the RFC-5322 specification|john.smith@biot-med.com|
|data[index]._phone|string|A person's phone An E.164 formatted phone number|+12345678901|
|data[index]._locale|string|A person's locale Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase.|en-us|
|data[index]._gender|string|A persons gender Values:MALE,FEMALE,UNDISCLOSED|FEMALE|
|data[index]._dateOfBirth|string|A person's date of birth A UTC date in the ISO-8601 format|Thu Dec 20 00:00:00 UTC 2007|
|data[index]._address|object|||
|data[index]._address.countryCode|string|A 2-letter country code defined in ISO-3166|US|
|data[index]._address.state|string|A state|Massachusetts|
|data[index]._address.city|string|A city|Boston|
|data[index]._address.zipCode|string|A zipcode|02101|
|data[index]._address.address1|string|An address|11 Main St.|
|data[index]._address.address2|string|An address's specifics|Entry B, Apartment 1|
|data[index]._mfa|object|||
|data[index]._mfa.enabled|boolean|MFA login enabled or disabled||
|data[index]._mfa.expirationInMinutes|integer|MFA expiration time in minutes||
|data[index]._credentialType|string|What type of credentials is used when logging in to the system. Only one type can be used. Default:PASSWORD Values:PASSWORD,OTP||
|data[index]._additionalPhone|string|An E.164 formatted phone number|+12345678901|
|data[index]._nationalId|string|A person's national ID|123456789|
|data[index]._id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._ownerOrganization|object|||
|data[index]._ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|data[index]._ownerOrganization.templateName|string|The name of the referenced entity template||
|data[index]._ownerOrganization.name|string|The caption of the referenced entity||
|data[index]._caregiver|object|||
|data[index]._caregiver.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._caregiver.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._caregiver.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|data[index]._caregiver.templateName|string|The name of the referenced entity template||
|data[index]._caregiver.name|string|The caption of the referenced entity||
|data[index]._creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|data[index]._lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|data[index]._invitationAccepted|boolean|Has invitation been accepted||
|data[index]._template|object|||
|data[index]._template.name|string|The name of the template||
|data[index]._template.displayName|string|The display name of the template||
|data[index]._template.parentTemplate|object|||
|data[index]._template.parentTemplate.id|string|||
|data[index]._template.parentTemplate.displayName|string|||
|data[index]._template.parentTemplate.name|string|||
|data[index]._template.id|string|The id of the template||
|data[index]._referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|data[index]._enabled|string|Is the user enabled Values:DISABLED,ENABLED|ENABLED|DISABLED|
|data[index]._username|string|User's username. Can be an email or a regular username. With this username you login to the system.|john@biotmail.com or john123|
|data[index]._registrationSource|string|The source of the registration. Possible values: INVITATION / SELF|INVITATION|
|data[index]._canLogin|boolean|Determine whether a patient has the ability to login to the system or not||
|data[index]._nickname|string|The patient nickname. Used for anonymous users.||
|data[index]._caption|string|||
|metadata|object|||
|metadata.sort|array|Sort that was passed in the request||
|metadata.sort[index]|array|Sort that was passed in the request||
|metadata.sort[index].prop|string|The property name for the sort||
|metadata.sort[index].order|string|The direction of sort. Default DESC Values:ASC,DESC|ASC|
|metadata.filter|object|The filter that was passed in the request||
|metadata.page|object|||
|metadata.page.totalResults|integer|The total number of items that match the query|145|
|metadata.page.page|integer|Page number|3|
|metadata.page.limit|integer|Number of items per page|100|
|metadata.freeTextSearch|string|Free text search strings that was passed in the request|cat dog|
 */ SearchResponsePatientResponse;
export type SearchPatientsApiArg = {
  /** Search request parameters: filter, sort and page */
  searchRequest?: string;
};
export type CreatePatientApiResponse = /** status 201 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|_name|object|||
|_name.firstName|string|A person's first name|John|
|_name.lastName|string|A person's last name|Smith|
|_description|string|A description, can be up to 5000 characters long|Lorem Ipsum|
|_email|string|An email address in the RFC-5322 specification|john.smith@biot-med.com|
|_phone|string|A person's phone An E.164 formatted phone number|+12345678901|
|_locale|string|A person's locale Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase.|en-us|
|_gender|string|A persons gender Values:MALE,FEMALE,UNDISCLOSED|FEMALE|
|_dateOfBirth|string|A person's date of birth A UTC date in the ISO-8601 format|Thu Dec 20 00:00:00 UTC 2007|
|_address|object|||
|_address.countryCode|string|A 2-letter country code defined in ISO-3166|US|
|_address.state|string|A state|Massachusetts|
|_address.city|string|A city|Boston|
|_address.zipCode|string|A zipcode|02101|
|_address.address1|string|An address|11 Main St.|
|_address.address2|string|An address's specifics|Entry B, Apartment 1|
|_mfa|object|||
|_mfa.enabled|boolean|MFA login enabled or disabled||
|_mfa.expirationInMinutes|integer|MFA expiration time in minutes||
|_credentialType|string|What type of credentials is used when logging in to the system. Only one type can be used. Default:PASSWORD Values:PASSWORD,OTP||
|_additionalPhone|string|An E.164 formatted phone number|+12345678901|
|_nationalId|string|A person's national ID|123456789|
|_id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_ownerOrganization.name|string|The caption of the referenced entity||
|_caregiver|object|||
|_caregiver.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_caregiver.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_caregiver.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_caregiver.templateName|string|The name of the referenced entity template||
|_caregiver.name|string|The caption of the referenced entity||
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_invitationAccepted|boolean|Has invitation been accepted||
|_template|object|||
|_template.name|string|The name of the template||
|_template.displayName|string|The display name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.name|string|||
|_template.id|string|The id of the template||
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_enabled|string|Is the user enabled Values:DISABLED,ENABLED|ENABLED|DISABLED|
|_username|string|User's username. Can be an email or a regular username. With this username you login to the system.|john@biotmail.com or john123|
|_registrationSource|string|The source of the registration. Possible values: INVITATION / SELF|INVITATION|
|_canLogin|boolean|Determine whether a patient has the ability to login to the system or not||
|_nickname|string|The patient nickname. Used for anonymous users.||
|_caption|string|||
|&lt;Last Measurement Custom Attribute 1&gt;.value|&lt;Last Measurement Custom Attribute 1 Type&gt;|The value of the last measurement||
|&lt;Last Measurement Custom Attribute 1&gt;.timestamp|string|The UTC timestamp of the last measurement in a ISO-8601 format|2007-12-20T10:15:30Z|
|&lt;Last Measurement Custom Attribute N&gt;.value|&lt;Last Measurement Custom Attribute N Type&gt;|The value of the last measurement||
|&lt;Last Measurement Custom Attribute N&gt;.timestamp|string|The UTC timestamp of the last measurement in a ISO-8601 format|2007-12-20T10:15:30Z|
 */ OrganizationPatientResponse;
export type CreatePatientApiArg = {
  createPatientRequest: CreatePatientRequest;
};
export type DeletePatientApiResponse = /** status 204 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
 */ void;
export type DeletePatientApiArg = {
  /** Patient ID that needs to be deleted */
  id: string;
};
export type GetPatientApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|_name|object|||
|_name.firstName|string|A person's first name|John|
|_name.lastName|string|A person's last name|Smith|
|_description|string|A description, can be up to 5000 characters long|Lorem Ipsum|
|_email|string|An email address in the RFC-5322 specification|john.smith@biot-med.com|
|_phone|string|A person's phone An E.164 formatted phone number|+12345678901|
|_locale|string|A person's locale Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase.|en-us|
|_gender|string|A persons gender Values:MALE,FEMALE,UNDISCLOSED|FEMALE|
|_dateOfBirth|string|A person's date of birth A UTC date in the ISO-8601 format|Thu Dec 20 00:00:00 UTC 2007|
|_address|object|||
|_address.countryCode|string|A 2-letter country code defined in ISO-3166|US|
|_address.state|string|A state|Massachusetts|
|_address.city|string|A city|Boston|
|_address.zipCode|string|A zipcode|02101|
|_address.address1|string|An address|11 Main St.|
|_address.address2|string|An address's specifics|Entry B, Apartment 1|
|_mfa|object|||
|_mfa.enabled|boolean|MFA login enabled or disabled||
|_mfa.expirationInMinutes|integer|MFA expiration time in minutes||
|_credentialType|string|What type of credentials is used when logging in to the system. Only one type can be used. Default:PASSWORD Values:PASSWORD,OTP||
|_additionalPhone|string|An E.164 formatted phone number|+12345678901|
|_nationalId|string|A person's national ID|123456789|
|_id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_ownerOrganization.name|string|The caption of the referenced entity||
|_caregiver|object|||
|_caregiver.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_caregiver.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_caregiver.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_caregiver.templateName|string|The name of the referenced entity template||
|_caregiver.name|string|The caption of the referenced entity||
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_invitationAccepted|boolean|Has invitation been accepted||
|_template|object|||
|_template.name|string|The name of the template||
|_template.displayName|string|The display name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.name|string|||
|_template.id|string|The id of the template||
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_enabled|string|Is the user enabled Values:DISABLED,ENABLED|ENABLED|DISABLED|
|_username|string|User's username. Can be an email or a regular username. With this username you login to the system.|john@biotmail.com or john123|
|_registrationSource|string|The source of the registration. Possible values: INVITATION / SELF|INVITATION|
|_canLogin|boolean|Determine whether a patient has the ability to login to the system or not||
|_nickname|string|The patient nickname. Used for anonymous users.||
|_caption|string|||
|&lt;Last Measurement Custom Attribute 1&gt;.value|&lt;Last Measurement Custom Attribute 1 Type&gt;|The value of the last measurement||
|&lt;Last Measurement Custom Attribute 1&gt;.timestamp|string|The UTC timestamp of the last measurement in a ISO-8601 format|2007-12-20T10:15:30Z|
|&lt;Last Measurement Custom Attribute N&gt;.value|&lt;Last Measurement Custom Attribute N Type&gt;|The value of the last measurement||
|&lt;Last Measurement Custom Attribute N&gt;.timestamp|string|The UTC timestamp of the last measurement in a ISO-8601 format|2007-12-20T10:15:30Z|
 */ OrganizationPatientResponse;
export type GetPatientApiArg = {
  /** Patient ID that needs to be fetched */
  id: string;
};
export type UpdatePatientApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|_name|object|||
|_name.firstName|string|A person's first name|John|
|_name.lastName|string|A person's last name|Smith|
|_description|string|A description, can be up to 5000 characters long|Lorem Ipsum|
|_email|string|An email address in the RFC-5322 specification|john.smith@biot-med.com|
|_phone|string|A person's phone An E.164 formatted phone number|+12345678901|
|_locale|string|A person's locale Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase.|en-us|
|_gender|string|A persons gender Values:MALE,FEMALE,UNDISCLOSED|FEMALE|
|_dateOfBirth|string|A person's date of birth A UTC date in the ISO-8601 format|Thu Dec 20 00:00:00 UTC 2007|
|_address|object|||
|_address.countryCode|string|A 2-letter country code defined in ISO-3166|US|
|_address.state|string|A state|Massachusetts|
|_address.city|string|A city|Boston|
|_address.zipCode|string|A zipcode|02101|
|_address.address1|string|An address|11 Main St.|
|_address.address2|string|An address's specifics|Entry B, Apartment 1|
|_mfa|object|||
|_mfa.enabled|boolean|MFA login enabled or disabled||
|_mfa.expirationInMinutes|integer|MFA expiration time in minutes||
|_credentialType|string|What type of credentials is used when logging in to the system. Only one type can be used. Default:PASSWORD Values:PASSWORD,OTP||
|_additionalPhone|string|An E.164 formatted phone number|+12345678901|
|_nationalId|string|A person's national ID|123456789|
|_id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_ownerOrganization.name|string|The caption of the referenced entity||
|_caregiver|object|||
|_caregiver.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_caregiver.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_caregiver.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_caregiver.templateName|string|The name of the referenced entity template||
|_caregiver.name|string|The caption of the referenced entity||
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_invitationAccepted|boolean|Has invitation been accepted||
|_template|object|||
|_template.name|string|The name of the template||
|_template.displayName|string|The display name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.name|string|||
|_template.id|string|The id of the template||
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_enabled|string|Is the user enabled Values:DISABLED,ENABLED|ENABLED|DISABLED|
|_username|string|User's username. Can be an email or a regular username. With this username you login to the system.|john@biotmail.com or john123|
|_registrationSource|string|The source of the registration. Possible values: INVITATION / SELF|INVITATION|
|_canLogin|boolean|Determine whether a patient has the ability to login to the system or not||
|_nickname|string|The patient nickname. Used for anonymous users.||
|_caption|string|||
|&lt;Last Measurement Custom Attribute 1&gt;.value|&lt;Last Measurement Custom Attribute 1 Type&gt;|The value of the last measurement||
|&lt;Last Measurement Custom Attribute 1&gt;.timestamp|string|The UTC timestamp of the last measurement in a ISO-8601 format|2007-12-20T10:15:30Z|
|&lt;Last Measurement Custom Attribute N&gt;.value|&lt;Last Measurement Custom Attribute N Type&gt;|The value of the last measurement||
|&lt;Last Measurement Custom Attribute N&gt;.timestamp|string|The UTC timestamp of the last measurement in a ISO-8601 format|2007-12-20T10:15:30Z|
 */ OrganizationPatientResponse;
export type UpdatePatientApiArg = {
  /** Patient ID that needs to be updated */
  id: string;
  updatePatientRequest: UpdatePatientRequest;
};
export type ChangePatientEnabledStateApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|_name|object|||
|_name.firstName|string|A person's first name|John|
|_name.lastName|string|A person's last name|Smith|
|_description|string|A description, can be up to 5000 characters long|Lorem Ipsum|
|_email|string|An email address in the RFC-5322 specification|john.smith@biot-med.com|
|_phone|string|A person's phone An E.164 formatted phone number|+12345678901|
|_locale|string|A person's locale Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase.|en-us|
|_gender|string|A persons gender Values:MALE,FEMALE,UNDISCLOSED|FEMALE|
|_dateOfBirth|string|A person's date of birth A UTC date in the ISO-8601 format|Thu Dec 20 00:00:00 UTC 2007|
|_address|object|||
|_address.countryCode|string|A 2-letter country code defined in ISO-3166|US|
|_address.state|string|A state|Massachusetts|
|_address.city|string|A city|Boston|
|_address.zipCode|string|A zipcode|02101|
|_address.address1|string|An address|11 Main St.|
|_address.address2|string|An address's specifics|Entry B, Apartment 1|
|_mfa|object|||
|_mfa.enabled|boolean|MFA login enabled or disabled||
|_mfa.expirationInMinutes|integer|MFA expiration time in minutes||
|_credentialType|string|What type of credentials is used when logging in to the system. Only one type can be used. Default:PASSWORD Values:PASSWORD,OTP||
|_additionalPhone|string|An E.164 formatted phone number|+12345678901|
|_nationalId|string|A person's national ID|123456789|
|_id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_ownerOrganization.name|string|The caption of the referenced entity||
|_caregiver|object|||
|_caregiver.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_caregiver.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_caregiver.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_caregiver.templateName|string|The name of the referenced entity template||
|_caregiver.name|string|The caption of the referenced entity||
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_invitationAccepted|boolean|Has invitation been accepted||
|_template|object|||
|_template.name|string|The name of the template||
|_template.displayName|string|The display name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.name|string|||
|_template.id|string|The id of the template||
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_enabled|string|Is the user enabled Values:DISABLED,ENABLED|ENABLED|DISABLED|
|_username|string|User's username. Can be an email or a regular username. With this username you login to the system.|john@biotmail.com or john123|
|_registrationSource|string|The source of the registration. Possible values: INVITATION / SELF|INVITATION|
|_canLogin|boolean|Determine whether a patient has the ability to login to the system or not||
|_nickname|string|The patient nickname. Used for anonymous users.||
|_caption|string|||
 */ OrganizationPatientResponse;
export type ChangePatientEnabledStateApiArg = {
  /** Patient ID */
  id: string;
  state: "DISABLED" | "ENABLED";
};
export type OrganizationcreateAlertApiResponse = /** status 201 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|_state|string|The alert wanted state Values:ACTIVE,CLEARED,SUSPENDED Default:ACTIVE|ACTIVE|
|_severity|string|The alert wanted severity Values:CRITICAL,MAJOR,MINOR,INFO Default:INFO|MAJOR|
|_clearNotes|string|Clear notes||
|_name|string|The name of the alert||
|_id|string|The id of the alert instance|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_template|object|||
|_template.name|string|The name of the template||
|_template.displayName|string|The display name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.name|string|||
|_template.id|string|The id of the template||
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_ownerOrganization.name|string|The caption of the referenced entity||
|_clearDateTime|string|Clear Date time of the alert|2007-12-20T10:15:30Z|
|_clearTrigger|string|The alert cleared trigger type Values:MANUAL,AUTOMATIC|AUTOMATIC|
|_clearedBy|object|||
|_clearedBy.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_clearedBy.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_clearedBy.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_clearedBy.templateName|string|The name of the referenced entity template||
|_clearedBy.name|string|The caption of the referenced entity||
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_patient|object|||
|_patient.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_patient.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_patient.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_patient.templateName|string|The name of the referenced entity template||
|_patient.name|string|The caption of the referenced entity||
|_setDateTime|string|Set Date time of the alert|2007-12-20T10:15:30Z|
|_caption|string|||
 */ PatientAlertResponse;
export type OrganizationcreateAlertApiArg = {
  patientId: string;
  createAlertRequest: CreateAlertRequest;
};
export type OrganizationdeleteAlertApiResponse = /** status 204 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
 */ void;
export type OrganizationdeleteAlertApiArg = {
  patientId: string;
  /** Patient Alert ID that needs to be deleted */
  id: string;
};
export type OrganizationgetAlertApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|_state|string|The alert wanted state Values:ACTIVE,CLEARED,SUSPENDED Default:ACTIVE|ACTIVE|
|_severity|string|The alert wanted severity Values:CRITICAL,MAJOR,MINOR,INFO Default:INFO|MAJOR|
|_clearNotes|string|Clear notes||
|_name|string|The name of the alert||
|_id|string|The id of the alert instance|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_template|object|||
|_template.name|string|The name of the template||
|_template.displayName|string|The display name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.name|string|||
|_template.id|string|The id of the template||
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_ownerOrganization.name|string|The caption of the referenced entity||
|_clearDateTime|string|Clear Date time of the alert|2007-12-20T10:15:30Z|
|_clearTrigger|string|The alert cleared trigger type Values:MANUAL,AUTOMATIC|AUTOMATIC|
|_clearedBy|object|||
|_clearedBy.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_clearedBy.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_clearedBy.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_clearedBy.templateName|string|The name of the referenced entity template||
|_clearedBy.name|string|The caption of the referenced entity||
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_patient|object|||
|_patient.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_patient.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_patient.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_patient.templateName|string|The name of the referenced entity template||
|_patient.name|string|The caption of the referenced entity||
|_setDateTime|string|Set Date time of the alert|2007-12-20T10:15:30Z|
|_caption|string|||
 */ PatientAlertResponse;
export type OrganizationgetAlertApiArg = {
  patientId: string;
  /** Patient Alert ID that needs to be fetched */
  id: string;
};
export type OrganizationupdateAlertApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|_state|string|The alert wanted state Values:ACTIVE,CLEARED,SUSPENDED Default:ACTIVE|ACTIVE|
|_severity|string|The alert wanted severity Values:CRITICAL,MAJOR,MINOR,INFO Default:INFO|MAJOR|
|_clearNotes|string|Clear notes||
|_name|string|The name of the alert||
|_id|string|The id of the alert instance|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_template|object|||
|_template.name|string|The name of the template||
|_template.displayName|string|The display name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.name|string|||
|_template.id|string|The id of the template||
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_ownerOrganization.name|string|The caption of the referenced entity||
|_clearDateTime|string|Clear Date time of the alert|2007-12-20T10:15:30Z|
|_clearTrigger|string|The alert cleared trigger type Values:MANUAL,AUTOMATIC|AUTOMATIC|
|_clearedBy|object|||
|_clearedBy.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_clearedBy.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_clearedBy.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_clearedBy.templateName|string|The name of the referenced entity template||
|_clearedBy.name|string|The caption of the referenced entity||
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_patient|object|||
|_patient.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_patient.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_patient.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_patient.templateName|string|The name of the referenced entity template||
|_patient.name|string|The caption of the referenced entity||
|_setDateTime|string|Set Date time of the alert|2007-12-20T10:15:30Z|
|_caption|string|||
 */ PatientAlertResponse;
export type OrganizationupdateAlertApiArg = {
  patientId: string;
  /** Patient Alert ID that needs to be updated */
  id: string;
  updateAlertRequest: UpdateAlertRequest;
};
export type OrganizationcreateAlertByTemplateNameApiResponse =
  /** status 201 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|_state|string|The alert wanted state Values:ACTIVE,CLEARED,SUSPENDED Default:ACTIVE|ACTIVE|
|_severity|string|The alert wanted severity Values:CRITICAL,MAJOR,MINOR,INFO Default:INFO|MAJOR|
|_clearNotes|string|Clear notes||
|_name|string|The name of the alert||
|_id|string|The id of the alert instance|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_template|object|||
|_template.name|string|The name of the template||
|_template.displayName|string|The display name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.name|string|||
|_template.id|string|The id of the template||
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_ownerOrganization.name|string|The caption of the referenced entity||
|_clearDateTime|string|Clear Date time of the alert|2007-12-20T10:15:30Z|
|_clearTrigger|string|The alert cleared trigger type Values:MANUAL,AUTOMATIC|AUTOMATIC|
|_clearedBy|object|||
|_clearedBy.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_clearedBy.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_clearedBy.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_clearedBy.templateName|string|The name of the referenced entity template||
|_clearedBy.name|string|The caption of the referenced entity||
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_patient|object|||
|_patient.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_patient.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_patient.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_patient.templateName|string|The name of the referenced entity template||
|_patient.name|string|The caption of the referenced entity||
|_setDateTime|string|Set Date time of the alert|2007-12-20T10:15:30Z|
|_caption|string|||
 */ PatientAlertResponse;
export type OrganizationcreateAlertByTemplateNameApiArg = {
  patientId: string;
  templateName: string;
  createAlertByTemplateNameRequest: CreateAlertByTemplateNameRequest;
};
export type OrganizationsearchAlertsApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|data|array|List of items that match the search request||
|data[index]|array|List of items that match the search request||
|data[index]._state|string|The alert wanted state Values:ACTIVE,CLEARED,SUSPENDED Default:ACTIVE|ACTIVE|
|data[index]._severity|string|The alert wanted severity Values:CRITICAL,MAJOR,MINOR,INFO Default:INFO|MAJOR|
|data[index]._clearNotes|string|Clear notes||
|data[index]._name|string|The name of the alert||
|data[index]._id|string|The id of the alert instance|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._template|object|||
|data[index]._template.name|string|The name of the template||
|data[index]._template.displayName|string|The display name of the template||
|data[index]._template.parentTemplate|object|||
|data[index]._template.parentTemplate.id|string|||
|data[index]._template.parentTemplate.displayName|string|||
|data[index]._template.parentTemplate.name|string|||
|data[index]._template.id|string|The id of the template||
|data[index]._referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|data[index]._ownerOrganization|object|||
|data[index]._ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|data[index]._ownerOrganization.templateName|string|The name of the referenced entity template||
|data[index]._ownerOrganization.name|string|The caption of the referenced entity||
|data[index]._clearDateTime|string|Clear Date time of the alert|2007-12-20T10:15:30Z|
|data[index]._clearTrigger|string|The alert cleared trigger type Values:MANUAL,AUTOMATIC|AUTOMATIC|
|data[index]._clearedBy|object|||
|data[index]._clearedBy.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._clearedBy.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._clearedBy.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|data[index]._clearedBy.templateName|string|The name of the referenced entity template||
|data[index]._clearedBy.name|string|The caption of the referenced entity||
|data[index]._creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|data[index]._lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|data[index]._patient|object|||
|data[index]._patient.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._patient.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._patient.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|data[index]._patient.templateName|string|The name of the referenced entity template||
|data[index]._patient.name|string|The caption of the referenced entity||
|data[index]._setDateTime|string|Set Date time of the alert|2007-12-20T10:15:30Z|
|data[index]._caption|string|||
|metadata|object|||
|metadata.sort|array|Sort that was passed in the request||
|metadata.sort[index]|array|Sort that was passed in the request||
|metadata.sort[index].prop|string|The property name for the sort||
|metadata.sort[index].order|string|The direction of sort. Default DESC Values:ASC,DESC|ASC|
|metadata.filter|object|The filter that was passed in the request||
|metadata.page|object|||
|metadata.page.totalResults|integer|The total number of items that match the query|145|
|metadata.page.page|integer|Page number|3|
|metadata.page.limit|integer|Number of items per page|100|
|metadata.freeTextSearch|string|Free text search strings that was passed in the request|cat dog|
 */ SearchResponsePatientAlertResponse;
export type OrganizationsearchAlertsApiArg = {
  /** Search request parameters: filter, sort and page */
  searchRequest?: string;
};
export type OrganizationsearchCurrentAlertsApiResponse =
  /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|data|array|List of items that match the search request||
|data[index]|array|List of items that match the search request||
|data[index]._patient|object|||
|data[index]._patient._name|object|||
|data[index]._patient._name.firstName|string|A person's first name|John|
|data[index]._patient._name.lastName|string|A person's last name|Smith|
|data[index]._patient._description|string|A description, can be up to 5000 characters long|Lorem Ipsum|
|data[index]._patient._email|string|An email address in the RFC-5322 specification|john.smith@biot-med.com|
|data[index]._patient._phone|string|A person's phone An E.164 formatted phone number|+12345678901|
|data[index]._patient._locale|string|A person's locale Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase.|en-us|
|data[index]._patient._gender|string|A persons gender Values:MALE,FEMALE,UNDISCLOSED|FEMALE|
|data[index]._patient._dateOfBirth|string|A person's date of birth A UTC date in the ISO-8601 format|Thu Dec 20 00:00:00 UTC 2007|
|data[index]._patient._address|object|||
|data[index]._patient._address.countryCode|string|A 2-letter country code defined in ISO-3166|US|
|data[index]._patient._address.state|string|A state|Massachusetts|
|data[index]._patient._address.city|string|A city|Boston|
|data[index]._patient._address.zipCode|string|A zipcode|02101|
|data[index]._patient._address.address1|string|An address|11 Main St.|
|data[index]._patient._address.address2|string|An address's specifics|Entry B, Apartment 1|
|data[index]._patient._mfa|object|||
|data[index]._patient._mfa.enabled|boolean|MFA login enabled or disabled||
|data[index]._patient._mfa.expirationInMinutes|integer|MFA expiration time in minutes||
|data[index]._patient._credentialType|string|What type of credentials is used when logging in to the system. Only one type can be used. Default:PASSWORD Values:PASSWORD,OTP||
|data[index]._patient._additionalPhone|string|An E.164 formatted phone number|+12345678901|
|data[index]._patient._nationalId|string|A person's national ID|123456789|
|data[index]._patient._id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._patient._ownerOrganization|object|||
|data[index]._patient._ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._patient._ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._patient._ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|data[index]._patient._ownerOrganization.templateName|string|The name of the referenced entity template||
|data[index]._patient._ownerOrganization.name|string|The caption of the referenced entity||
|data[index]._patient._caregiver|object|||
|data[index]._patient._caregiver.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._patient._caregiver.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._patient._caregiver.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|data[index]._patient._caregiver.templateName|string|The name of the referenced entity template||
|data[index]._patient._caregiver.name|string|The caption of the referenced entity||
|data[index]._patient._creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|data[index]._patient._lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|data[index]._patient._invitationAccepted|boolean|Has invitation been accepted||
|data[index]._patient._template|object|||
|data[index]._patient._template.name|string|The name of the template||
|data[index]._patient._template.displayName|string|The display name of the template||
|data[index]._patient._template.parentTemplate|object|||
|data[index]._patient._template.parentTemplate.id|string|||
|data[index]._patient._template.parentTemplate.displayName|string|||
|data[index]._patient._template.parentTemplate.name|string|||
|data[index]._patient._template.id|string|The id of the template||
|data[index]._patient._referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|data[index]._patient._enabled|string|Is the user enabled Values:DISABLED,ENABLED|ENABLED|DISABLED|
|data[index]._patient._username|string|User's username. Can be an email or a regular username. With this username you login to the system.|john@biotmail.com or john123|
|data[index]._patient._registrationSource|string|The source of the registration. Possible values: INVITATION / SELF|INVITATION|
|data[index]._patient._canLogin|boolean|Determine whether a patient has the ability to login to the system or not||
|data[index]._patient._nickname|string|The patient nickname. Used for anonymous users.||
|data[index]._patient._caption|string|||
|data[index]._alerts|array|||
|data[index]._alerts[index]|array|||
|data[index]._alerts[index]._state|string|The alert wanted state Values:ACTIVE,CLEARED,SUSPENDED Default:ACTIVE|ACTIVE|
|data[index]._alerts[index]._severity|string|The alert wanted severity Values:CRITICAL,MAJOR,MINOR,INFO Default:INFO|MAJOR|
|data[index]._alerts[index]._clearNotes|string|Clear notes||
|data[index]._alerts[index]._name|string|The name of the alert||
|data[index]._alerts[index]._id|string|The id of the alert instance|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._alerts[index]._template|object|||
|data[index]._alerts[index]._template.name|string|The name of the template||
|data[index]._alerts[index]._template.displayName|string|The display name of the template||
|data[index]._alerts[index]._template.parentTemplate|object|||
|data[index]._alerts[index]._template.parentTemplate.id|string|||
|data[index]._alerts[index]._template.parentTemplate.displayName|string|||
|data[index]._alerts[index]._template.parentTemplate.name|string|||
|data[index]._alerts[index]._template.id|string|The id of the template||
|data[index]._alerts[index]._referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|data[index]._alerts[index]._ownerOrganization|object|||
|data[index]._alerts[index]._ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._alerts[index]._ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._alerts[index]._ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|data[index]._alerts[index]._ownerOrganization.templateName|string|The name of the referenced entity template||
|data[index]._alerts[index]._ownerOrganization.name|string|The caption of the referenced entity||
|data[index]._alerts[index]._clearDateTime|string|Clear Date time of the alert|2007-12-20T10:15:30Z|
|data[index]._alerts[index]._clearTrigger|string|The alert cleared trigger type Values:MANUAL,AUTOMATIC|AUTOMATIC|
|data[index]._alerts[index]._clearedBy|object|||
|data[index]._alerts[index]._clearedBy.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._alerts[index]._clearedBy.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._alerts[index]._clearedBy.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|data[index]._alerts[index]._clearedBy.templateName|string|The name of the referenced entity template||
|data[index]._alerts[index]._clearedBy.name|string|The caption of the referenced entity||
|data[index]._alerts[index]._creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|data[index]._alerts[index]._lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|data[index]._alerts[index]._patient|object|||
|data[index]._alerts[index]._patient.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._alerts[index]._patient.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._alerts[index]._patient.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|data[index]._alerts[index]._patient.templateName|string|The name of the referenced entity template||
|data[index]._alerts[index]._patient.name|string|The caption of the referenced entity||
|data[index]._alerts[index]._setDateTime|string|Set Date time of the alert|2007-12-20T10:15:30Z|
|data[index]._alerts[index]._caption|string|||
|metadata|object|||
|metadata.sort|array|Sort that was passed in the request||
|metadata.sort[index]|array|Sort that was passed in the request||
|metadata.sort[index].prop|string|The property name for the sort||
|metadata.sort[index].order|string|The direction of sort. Default DESC Values:ASC,DESC|ASC|
|metadata.filter|object|The filter that was passed in the request||
|metadata.page|object|||
|metadata.page.totalResults|integer|The total number of items that match the query|145|
|metadata.page.page|integer|Page number|3|
|metadata.page.limit|integer|Number of items per page|100|
|metadata.freeTextSearch|string|Free text search strings that was passed in the request|cat dog|
 */ SearchResponsePatientOwnedAlertResponse;
export type OrganizationsearchCurrentAlertsApiArg = {
  /** Search request parameters: filter, sort and page */
  searchRequest?: string;
};
export type GetPatientSelfApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|_name|object|||
|_name.firstName|string|A person's first name|John|
|_name.lastName|string|A person's last name|Smith|
|_description|string|A description, can be up to 5000 characters long|Lorem Ipsum|
|_email|string|An email address in the RFC-5322 specification|john.smith@biot-med.com|
|_phone|string|A person's phone An E.164 formatted phone number|+12345678901|
|_locale|string|A person's locale Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase.|en-us|
|_gender|string|A persons gender Values:MALE,FEMALE,UNDISCLOSED|FEMALE|
|_dateOfBirth|string|A person's date of birth A UTC date in the ISO-8601 format|Thu Dec 20 00:00:00 UTC 2007|
|_address|object|||
|_address.countryCode|string|A 2-letter country code defined in ISO-3166|US|
|_address.state|string|A state|Massachusetts|
|_address.city|string|A city|Boston|
|_address.zipCode|string|A zipcode|02101|
|_address.address1|string|An address|11 Main St.|
|_address.address2|string|An address's specifics|Entry B, Apartment 1|
|_mfa|object|||
|_mfa.enabled|boolean|MFA login enabled or disabled||
|_mfa.expirationInMinutes|integer|MFA expiration time in minutes||
|_credentialType|string|What type of credentials is used when logging in to the system. Only one type can be used. Default:PASSWORD Values:PASSWORD,OTP||
|_additionalPhone|string|An E.164 formatted phone number|+12345678901|
|_nationalId|string|A person's national ID|123456789|
|_id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_ownerOrganization.name|string|The caption of the referenced entity||
|_caregiver|object|||
|_caregiver.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_caregiver.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_caregiver.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_caregiver.templateName|string|The name of the referenced entity template||
|_caregiver.name|string|The caption of the referenced entity||
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_invitationAccepted|boolean|Has invitation been accepted||
|_template|object|||
|_template.name|string|The name of the template||
|_template.displayName|string|The display name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.name|string|||
|_template.id|string|The id of the template||
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_enabled|string|Is the user enabled Values:DISABLED,ENABLED|ENABLED|DISABLED|
|_username|string|User's username. Can be an email or a regular username. With this username you login to the system.|john@biotmail.com or john123|
|_registrationSource|string|The source of the registration. Possible values: INVITATION / SELF|INVITATION|
|_canLogin|boolean|Determine whether a patient has the ability to login to the system or not||
|_nickname|string|The patient nickname. Used for anonymous users.||
|_caption|string|||
|&lt;Last Measurement Custom Attribute 1&gt;.value|&lt;Last Measurement Custom Attribute 1 Type&gt;|The value of the last measurement||
|&lt;Last Measurement Custom Attribute 1&gt;.timestamp|string|The UTC timestamp of the last measurement in a ISO-8601 format|2007-12-20T10:15:30Z|
|&lt;Last Measurement Custom Attribute N&gt;.value|&lt;Last Measurement Custom Attribute N Type&gt;|The value of the last measurement||
|&lt;Last Measurement Custom Attribute N&gt;.timestamp|string|The UTC timestamp of the last measurement in a ISO-8601 format|2007-12-20T10:15:30Z|
 */ OrganizationPatientResponse;
export type GetPatientSelfApiArg = void;
export type SearchAvailableOrganizationsForSignUpApiResponse =
  /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|data|array|List of items that match the search request||
|data[index]|array|List of items that match the search request||
|data[index]._name|string|An organization's name|Example Inc.|
|data[index]._description|string|A description, can be up to 5000 characters long|Lorem Ipsum|
|data[index]._id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index]._creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|data[index]._lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|data[index]._caption|string|||
|metadata|object|||
|metadata.sort|array|Sort that was passed in the request||
|metadata.sort[index]|array|Sort that was passed in the request||
|metadata.sort[index].prop|string|The property name for the sort||
|metadata.sort[index].order|string|The direction of sort. Default DESC Values:ASC,DESC|ASC|
|metadata.filter|object|The filter that was passed in the request||
|metadata.page|object|||
|metadata.page.totalResults|integer|The total number of items that match the query|145|
|metadata.page.page|integer|Page number|3|
|metadata.page.limit|integer|Number of items per page|100|
|metadata.freeTextSearch|string|Free text search strings that was passed in the request|cat dog|
 */ SearchResponseBasicOrganizationResponse;
export type SearchAvailableOrganizationsForSignUpApiArg = {
  /** Search request parameters: filter, sort and page */
  searchRequest?: string;
};
export type CreatePatientByTemplateNameApiResponse = /** status 201 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|_name|object|||
|_name.firstName|string|A person's first name|John|
|_name.lastName|string|A person's last name|Smith|
|_description|string|A description, can be up to 5000 characters long|Lorem Ipsum|
|_email|string|An email address in the RFC-5322 specification|john.smith@biot-med.com|
|_phone|string|A person's phone An E.164 formatted phone number|+12345678901|
|_locale|string|A person's locale Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase.|en-us|
|_gender|string|A persons gender Values:MALE,FEMALE,UNDISCLOSED|FEMALE|
|_dateOfBirth|string|A person's date of birth A UTC date in the ISO-8601 format|Thu Dec 20 00:00:00 UTC 2007|
|_address|object|||
|_address.countryCode|string|A 2-letter country code defined in ISO-3166|US|
|_address.state|string|A state|Massachusetts|
|_address.city|string|A city|Boston|
|_address.zipCode|string|A zipcode|02101|
|_address.address1|string|An address|11 Main St.|
|_address.address2|string|An address's specifics|Entry B, Apartment 1|
|_mfa|object|||
|_mfa.enabled|boolean|MFA login enabled or disabled||
|_mfa.expirationInMinutes|integer|MFA expiration time in minutes||
|_credentialType|string|What type of credentials is used when logging in to the system. Only one type can be used. Default:PASSWORD Values:PASSWORD,OTP||
|_additionalPhone|string|An E.164 formatted phone number|+12345678901|
|_nationalId|string|A person's national ID|123456789|
|_id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_ownerOrganization.name|string|The caption of the referenced entity||
|_caregiver|object|||
|_caregiver.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_caregiver.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_caregiver.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_caregiver.templateName|string|The name of the referenced entity template||
|_caregiver.name|string|The caption of the referenced entity||
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_invitationAccepted|boolean|Has invitation been accepted||
|_template|object|||
|_template.name|string|The name of the template||
|_template.displayName|string|The display name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.name|string|||
|_template.id|string|The id of the template||
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_enabled|string|Is the user enabled Values:DISABLED,ENABLED|ENABLED|DISABLED|
|_username|string|User's username. Can be an email or a regular username. With this username you login to the system.|john@biotmail.com or john123|
|_registrationSource|string|The source of the registration. Possible values: INVITATION / SELF|INVITATION|
|_canLogin|boolean|Determine whether a patient has the ability to login to the system or not||
|_nickname|string|The patient nickname. Used for anonymous users.||
|_caption|string|||
|&lt;Last Measurement Custom Attribute 1&gt;.value|&lt;Last Measurement Custom Attribute 1 Type&gt;|The value of the last measurement||
|&lt;Last Measurement Custom Attribute 1&gt;.timestamp|string|The UTC timestamp of the last measurement in a ISO-8601 format|2007-12-20T10:15:30Z|
|&lt;Last Measurement Custom Attribute N&gt;.value|&lt;Last Measurement Custom Attribute N Type&gt;|The value of the last measurement||
|&lt;Last Measurement Custom Attribute N&gt;.timestamp|string|The UTC timestamp of the last measurement in a ISO-8601 format|2007-12-20T10:15:30Z|
 */ OrganizationPatientResponse;
export type CreatePatientByTemplateNameApiArg = {
  templateName: string;
  createPatientByTemplateNameRequest: CreatePatientByTemplateNameRequest;
};
export type GetSelfApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|_userType|string|The user type Values:organization-user,caregiver,patient|organization-user|
|_id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|_enabled|string|Is the user enabled Values:DISABLED,ENABLED|ENABLED|DISABLED|
|_credentialType|string| Values:PASSWORD,OTP||
|_invitationAccepted|boolean|Has invitation been accepted||
|_template|object|||
|_template.name|string|The name of the template||
|_template.displayName|string|The display name of the template||
|_template.parentTemplate|object|||
|_template.parentTemplate.id|string|||
|_template.parentTemplate.displayName|string|||
|_template.parentTemplate.name|string|||
|_template.id|string|The id of the template||
|_referencers|object|An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1)||
|_ownerOrganization|object|||
|_ownerOrganization.id|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.templateId|string|The id of a template that is configured in the settings service.|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|_ownerOrganization.parentEntityId|string|The id of the parent entity (appears only for child entities)||
|_ownerOrganization.templateName|string|The name of the referenced entity template||
|_ownerOrganization.name|string|The caption of the referenced entity||
|_name|object|||
|_name.firstName|string|A person's first name|John|
|_name.lastName|string|A person's last name|Smith|
|_address|object|||
|_address.countryCode|string|A 2-letter country code defined in ISO-3166|US|
|_address.state|string|A state|Massachusetts|
|_address.city|string|A city|Boston|
|_address.zipCode|string|A zipcode|02101|
|_address.address1|string|An address|11 Main St.|
|_address.address2|string|An address's specifics|Entry B, Apartment 1|
|_locale|string|A person's locale Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase.|en-us|
|_description|string|A description, can be up to 5000 characters long|Lorem Ipsum|
|_email|string|An email address in the RFC-5322 specification|john.smith@biot-med.com|
|_phone|string|A person's phone An E.164 formatted phone number|+12345678901|
|_mfa|object|||
|_mfa.enabled|boolean|MFA login enabled or disabled||
|_mfa.expirationInMinutes|integer|MFA expiration time in minutes||
|_gender|string|A persons gender Values:MALE,FEMALE,UNDISCLOSED|FEMALE|
|_dateOfBirth|string|A person's date of birth A UTC date in the ISO-8601 format|Thu Dec 20 00:00:00 UTC 2007|
|_caption|string|||
 */ UserResponse;
export type GetSelfApiArg = void;
export type XxxApiResponse = /** status 200 xx */ SearchRequestV2;
export type XxxApiArg = {
  /** Search request parameters: filter, sort and page */
  searchRequest?: string;
};
export type SettingshealthCheckApiResponse = /** status 200 OK */ VersionResponse;
export type SettingshealthCheckApiArg = void;
export type Search3ApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|data|array|List of items that match the search request||
|data[index]|array|List of items that match the search request||
|data[index].name|string|The name of the code snippet|User is nurse|
|data[index].description|string|The description of the code snippet|Returns true if the user template name is called nurse|
|data[index].language|string|The code language Values:JAVASCRIPT|JAVASCRIPT|
|data[index].code|string|The actual code snippet|user._template.name === 'nurse'|
|data[index].id|string|||
|data[index].lastModifiedTime|string|||
|data[index].creationTime|string|||
|metadata|object|||
|metadata.sort|array|Sort that was passed in the request||
|metadata.sort[index]|array|Sort that was passed in the request||
|metadata.sort[index].prop|string|The property name for the sort||
|metadata.sort[index].order|string|The direction of sort. Default DESC Values:ASC,DESC|ASC|
|metadata.filter|object|The filter that was passed in the request||
|metadata.page|object|||
|metadata.page.totalResults|integer|The total number of items that match the query|145|
|metadata.page.page|integer|Page number|3|
|metadata.page.limit|integer|Number of items per page|100|
|metadata.freeTextSearch|string|Free text search strings that was passed in the request|cat dog|
 */ SearchResponseCodeSnippetResponse;
export type Search3ApiArg = {
  /** Search request parameters: filter, sort and page */
  searchRequest?: string;
};
export type CreateCodeSnippetApiResponse = /** status 201 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|name|string|The name of the code snippet|User is nurse|
|description|string|The description of the code snippet|Returns true if the user template name is called nurse|
|language|string|The code language Values:JAVASCRIPT|JAVASCRIPT|
|code|string|The actual code snippet|user._template.name === 'nurse'|
|id|string|||
|lastModifiedTime|string|||
|creationTime|string|||
 */ CodeSnippetResponse;
export type CreateCodeSnippetApiArg = {
  createCodeSnippetRequest: CreateCodeSnippetRequest;
};
export type DeleteCodeSnippetApiResponse = /** status 204 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
 */ void;
export type DeleteCodeSnippetApiArg = {
  /** Code snippet ID that needs to be deleted */
  id: string;
};
export type GetCodeSnippetApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|name|string|The name of the code snippet|User is nurse|
|description|string|The description of the code snippet|Returns true if the user template name is called nurse|
|language|string|The code language Values:JAVASCRIPT|JAVASCRIPT|
|code|string|The actual code snippet|user._template.name === 'nurse'|
|id|string|||
|lastModifiedTime|string|||
|creationTime|string|||
 */ CodeSnippetResponse;
export type GetCodeSnippetApiArg = {
  /** Code snippet ID that needs to be fetched */
  id: string;
};
export type GetLastExportExecutionApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|id|string|||
|name|string|||
|description|string|||
|status|string| Values:IN_PROGRESS,FAILED,SUCCESS||
|errorMessage|string|||
|lastModifiedTime|string|||
|creationTime|string|||
 */ ExportExecutionResponse;
export type GetLastExportExecutionApiArg = void;
export type GetExportsMetadataApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|filesMetadata|array|||
|filesMetadata[index]|array|||
|filesMetadata[index].id|string|||
|filesMetadata[index].environment|string|||
|filesMetadata[index].name|string|||
|filesMetadata[index].description|string|||
|filesMetadata[index].biotVersion|string|||
|filesMetadata[index].creationTime|string|||
 */ ExportsMetadataResponse;
export type GetExportsMetadataApiArg = void;
export type StartExportApiResponse = /** status 201 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|id|string|||
|name|string|||
|description|string|||
|status|string| Values:IN_PROGRESS,FAILED,SUCCESS||
|errorMessage|string|||
|lastModifiedTime|string|||
|creationTime|string|||
 */ ExportExecutionResponse;
export type StartExportApiArg = {
  startExportConfigurationRequest: StartExportConfigurationRequest;
};
export type GetLastImportExecutionApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|id|string|||
|name|string|||
|description|string|||
|status|string| Values:IN_PROGRESS,FAILED,SUCCESS||
|importType|string| Values:CLEAN_IMPORT||
|errorMessage|string|||
|lastModifiedTime|string|||
|creationTime|string|||
 */ ImportExecutionResponse;
export type GetLastImportExecutionApiArg = void;
export type StartImportApiResponse = /** status 201 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|id|string|||
|name|string|||
|description|string|||
|status|string| Values:IN_PROGRESS,FAILED,SUCCESS||
|importType|string| Values:CLEAN_IMPORT||
|errorMessage|string|||
|lastModifiedTime|string|||
|creationTime|string|||
 */ ImportExecutionResponse;
export type StartImportApiArg = {
  startImportConfigurationRequest: StartImportConfigurationRequest;
};
export type GetEntityTypesApiResponse = /** status 200 SUCCESS */ GetEntityTypesResponse;
export type GetEntityTypesApiArg = void;
export type GetNotifiableActions1ApiResponse = /** status 200 SUCCESS */ GetNotifiableActions;
export type GetNotifiableActions1ApiArg = void;
export type Search2ApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|data|array|List of items that match the search request||
|data[index]|array|List of items that match the search request||
|data[index].entityTypeName|string|||
|data[index].servicePrefix|string|||
|data[index].apiId|string|||
|metadata|object|||
|metadata.sort|array|Sort that was passed in the request||
|metadata.sort[index]|array|Sort that was passed in the request||
|metadata.sort[index].prop|string|The property name for the sort||
|metadata.sort[index].order|string|The direction of sort. Default DESC Values:ASC,DESC|ASC|
|metadata.filter|object|The filter that was passed in the request||
|metadata.page|object|||
|metadata.page.totalResults|integer|The total number of items that match the query|145|
|metadata.page.page|integer|Page number|3|
|metadata.page.limit|integer|Number of items per page|100|
|metadata.freeTextSearch|string|Free text search strings that was passed in the request|cat dog|
 */ SearchResponseInterceptionConfigurationResponse;
export type Search2ApiArg = {
  /** Search request parameters: filter, sort and page */
  searchRequest?: string;
};
export type AddLocaleApiResponse = /** status 201 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|availableLocales|array|||
|availableLocales[index]|array|||
|availableLocales[index].code|string|Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase.|en-us|
|availableLocales[index].hidden|boolean||false|
|availableLocales[index].translationFallbackTypes|array|Valid array values: DEFAULT_LOCALE,SYSTEM_LOCALE. Allow to control the fallback mechanism. If not provided(null) then the default behavior is the following fallback order: -> DEFAULT_LOCALE -> SYSTEM_LOCALE. The recommended value is null. When all of the fallback types return an empty value, no translation will be made, i.e. the original value will be retained||
|defaultLocaleCode|string|Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase.|en-us|
|systemLocaleCode|string|||
 */ LocalesResponse;
export type AddLocaleApiArg = {
  addLocaleRequest: AddLocaleRequest;
};
export type DeleteLocaleApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|availableLocales|array|||
|availableLocales[index]|array|||
|availableLocales[index].code|string|Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase.|en-us|
|availableLocales[index].hidden|boolean||false|
|availableLocales[index].translationFallbackTypes|array|Valid array values: DEFAULT_LOCALE,SYSTEM_LOCALE. Allow to control the fallback mechanism. If not provided(null) then the default behavior is the following fallback order: -> DEFAULT_LOCALE -> SYSTEM_LOCALE. The recommended value is null. When all of the fallback types return an empty value, no translation will be made, i.e. the original value will be retained||
|defaultLocaleCode|string|Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase.|en-us|
|systemLocaleCode|string|||
 */ LocalesResponse;
export type DeleteLocaleApiArg = {
  /** Locale ID */
  id: string;
};
export type GetLocalesApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|availableLocales|array|||
|availableLocales[index]|array|||
|availableLocales[index].code|string|Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase.|en-us|
|availableLocales[index].hidden|boolean||false|
|availableLocales[index].translationFallbackTypes|array|Valid array values: DEFAULT_LOCALE,SYSTEM_LOCALE. Allow to control the fallback mechanism. If not provided(null) then the default behavior is the following fallback order: -> DEFAULT_LOCALE -> SYSTEM_LOCALE. The recommended value is null. When all of the fallback types return an empty value, no translation will be made, i.e. the original value will be retained||
|defaultLocaleCode|string|Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase.|en-us|
|systemLocaleCode|string|||
 */ LocalesResponse;
export type GetLocalesApiArg = void;
export type UpdateLocalesApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|availableLocales|array|||
|availableLocales[index]|array|||
|availableLocales[index].code|string|Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase.|en-us|
|availableLocales[index].hidden|boolean||false|
|availableLocales[index].translationFallbackTypes|array|Valid array values: DEFAULT_LOCALE,SYSTEM_LOCALE. Allow to control the fallback mechanism. If not provided(null) then the default behavior is the following fallback order: -> DEFAULT_LOCALE -> SYSTEM_LOCALE. The recommended value is null. When all of the fallback types return an empty value, no translation will be made, i.e. the original value will be retained||
|defaultLocaleCode|string|Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase.|en-us|
|systemLocaleCode|string|||
 */ LocalesResponse;
export type UpdateLocalesApiArg = {
  updateLocalesRequest: UpdateLocalesRequest;
};
export type BackupApiResponse = /** status 201 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|name|string|The name of the backup, it will also be the folder in which the backup is saved|Backup-01-02-2024|
|backupVersion|string|The biot version of the backup|2.3.11|
|errorMessage|string|An error thrown in the backup/restore process|No internet connection|
|buildNumber|integer|The build number of the backup/restore job in the pipeline|12345|
|lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|description|string|The description of the backup|Backup after entity creation|
|status|string|The status of the backup|SUCCESS|
 */ BackupResponse;
export type BackupApiArg = {
  backupRequest: BackupRequest;
};
export type SearchBackupExecutionsApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|data|array|List of items that match the search request||
|data[index]|array|List of items that match the search request||
|data[index].name|string|The name of the backup, it will also be the folder in which the backup is saved|Backup-01-02-2024|
|data[index].backupVersion|string|The biot version of the backup|2.3.11|
|data[index].errorMessage|string|An error thrown in the backup/restore process|No internet connection|
|data[index].buildNumber|integer|The build number of the backup/restore job in the pipeline|12345|
|data[index].lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|data[index].creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|data[index].description|string|The description of the backup|Backup after entity creation|
|data[index].status|string|The status of the backup|SUCCESS|
|metadata|object|||
|metadata.sort|array|Sort that was passed in the request||
|metadata.sort[index]|array|Sort that was passed in the request||
|metadata.sort[index].prop|string|The property name for the sort||
|metadata.sort[index].order|string|The direction of sort. Default DESC Values:ASC,DESC|ASC|
|metadata.filter|object|The filter that was passed in the request||
|metadata.page|object|||
|metadata.page.totalResults|integer|The total number of items that match the query|145|
|metadata.page.page|integer|Page number|3|
|metadata.page.limit|integer|Number of items per page|100|
|metadata.freeTextSearch|string|Free text search strings that was passed in the request|cat dog|
 */ SearchResponseBackupResponse;
export type SearchBackupExecutionsApiArg = {
  /** Search request parameters: filter, sort and page */
  searchRequest?: string;
};
export type GetSystemPropertiesApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|biotVersion|string|System's main version||
 */ SystemPropertiesResponse;
export type GetSystemPropertiesApiArg = void;
export type ResetSystemApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
 */ void;
export type ResetSystemApiArg = {
  resetSystemRequest: ResetSystemRequest;
};
export type SearchRestoreExecutionsApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|data|array|List of items that match the search request||
|data[index]|array|List of items that match the search request||
|data[index].name|string|The name of the backup, it will also be the folder in which the backup is saved|Backup-01-02-2024|
|data[index].backupVersion|string|The biot version of the backup|2.3.11|
|data[index].errorMessage|string|An error thrown in the backup/restore process|No internet connection|
|data[index].buildNumber|integer|The build number of the backup/restore job in the pipeline|12345|
|data[index].lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|data[index].creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|data[index].status|string|The status of the restore|SUCCESS|
|metadata|object|||
|metadata.sort|array|Sort that was passed in the request||
|metadata.sort[index]|array|Sort that was passed in the request||
|metadata.sort[index].prop|string|The property name for the sort||
|metadata.sort[index].order|string|The direction of sort. Default DESC Values:ASC,DESC|ASC|
|metadata.filter|object|The filter that was passed in the request||
|metadata.page|object|||
|metadata.page.totalResults|integer|The total number of items that match the query|145|
|metadata.page.page|integer|Page number|3|
|metadata.page.limit|integer|Number of items per page|100|
|metadata.freeTextSearch|string|Free text search strings that was passed in the request|cat dog|
 */ SearchResponseRestoreResponse;
export type SearchRestoreExecutionsApiArg = {
  /** Search request parameters: filter, sort and page */
  searchRequest?: string;
};
export type Search1ApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|data|array|List of items that match the search request||
|data[index]|array|List of items that match the search request||
|data[index].displayName|string|||
|data[index].name|string| Pattern:[a-zA-Z]\w*||
|data[index].description|string|||
|data[index].ownerOrganizationId|string|||
|data[index].id|string|||
|data[index].entityTypeName|string|||
|data[index].removable|boolean|||
|data[index].creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|data[index].lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|data[index].parentTemplate|object|||
|data[index].parentTemplate.id|string|||
|data[index].parentTemplate.displayName|string|||
|data[index].parentTemplate.name|string|||
|data[index].parentTemplateId|string|||
|data[index].customAttributes|array|||
|data[index].customAttributes[index]|array|||
|data[index].customAttributes[index].displayName|string|||
|data[index].customAttributes[index].phi|boolean|||
|data[index].customAttributes[index].referenceConfiguration|object|||
|data[index].customAttributes[index].referenceConfiguration.uniquely|boolean|||
|data[index].customAttributes[index].referenceConfiguration.referencedSideAttributeName|string|||
|data[index].customAttributes[index].referenceConfiguration.referencedSideAttributeDisplayName|string|||
|data[index].customAttributes[index].referenceConfiguration.validTemplatesToReference|array|||
|data[index].customAttributes[index].referenceConfiguration.entityType|string|||
|data[index].customAttributes[index].linkConfiguration|object|||
|data[index].customAttributes[index].linkConfiguration.entityTypeName|string|||
|data[index].customAttributes[index].linkConfiguration.templateId|string|||
|data[index].customAttributes[index].linkConfiguration.attributeId|string|||
|data[index].customAttributes[index].name|string| Pattern:[a-zA-Z]\w*||
|data[index].customAttributes[index].type|string| Values:LABEL,PARAGRAPH,INTEGER,DECIMAL,BOOLEAN,SINGLE_SELECT,MULTI_SELECT,ADDRESS,NAME,PHONE,EMAIL,DATE_TIME,DATE,REFERENCE,TIMEZONE,LOCALE,FILE,IMAGE,LINK,WAVEFORM||
|data[index].customAttributes[index].validation|object|||
|data[index].customAttributes[index].validation.mandatory|boolean|||
|data[index].customAttributes[index].validation.defaultValue|object|||
|data[index].customAttributes[index].validation.min|number|||
|data[index].customAttributes[index].validation.max|number|||
|data[index].customAttributes[index].validation.regex|string|||
|data[index].customAttributes[index].numericMetaData|object|||
|data[index].customAttributes[index].numericMetaData.units|string|||
|data[index].customAttributes[index].numericMetaData.upperRange|number|||
|data[index].customAttributes[index].numericMetaData.lowerRange|number|||
|data[index].customAttributes[index].numericMetaData.subType|string| Values:INTEGER,DECIMAL||
|data[index].customAttributes[index].id|string|||
|data[index].customAttributes[index].selectableValues|array|||
|data[index].customAttributes[index].selectableValues[index]|array|||
|data[index].customAttributes[index].selectableValues[index].name|string| Pattern:[a-zA-Z]\w*||
|data[index].customAttributes[index].selectableValues[index].displayName|string|||
|data[index].customAttributes[index].selectableValues[index].id|string|||
|data[index].customAttributes[index].category|object|||
|data[index].customAttributes[index].category.name|string|||
|data[index].customAttributes[index].category.displayName|string|||
|data[index].customAttributes[index].basePath|string|||
|data[index].customAttributes[index].typeEnum|string| Values:LABEL,PARAGRAPH,INTEGER,DECIMAL,BOOLEAN,SINGLE_SELECT,MULTI_SELECT,ADDRESS,NAME,PHONE,EMAIL,DATE_TIME,DATE,REFERENCE,TIMEZONE,LOCALE,FILE,IMAGE,LINK,WAVEFORM||
|data[index].builtInAttributes|array|||
|data[index].builtInAttributes[index]|array|||
|data[index].builtInAttributes[index].name|string|||
|data[index].builtInAttributes[index].basePath|string|||
|data[index].builtInAttributes[index].id|string|||
|data[index].builtInAttributes[index].displayName|string|||
|data[index].builtInAttributes[index].phi|boolean|||
|data[index].builtInAttributes[index].referenceConfiguration|object|||
|data[index].builtInAttributes[index].referenceConfiguration.uniquely|boolean|||
|data[index].builtInAttributes[index].referenceConfiguration.referencedSideAttributeName|string|||
|data[index].builtInAttributes[index].referenceConfiguration.referencedSideAttributeDisplayName|string|||
|data[index].builtInAttributes[index].referenceConfiguration.validTemplatesToReference|array|||
|data[index].builtInAttributes[index].referenceConfiguration.entityType|string|||
|data[index].builtInAttributes[index].linkConfiguration|object|||
|data[index].builtInAttributes[index].linkConfiguration.entityTypeName|string|||
|data[index].builtInAttributes[index].linkConfiguration.templateId|string|||
|data[index].builtInAttributes[index].linkConfiguration.attributeId|string|||
|data[index].builtInAttributes[index].validation|object|||
|data[index].builtInAttributes[index].validation.mandatory|boolean|||
|data[index].builtInAttributes[index].validation.defaultValue|object|||
|data[index].builtInAttributes[index].validation.min|number|||
|data[index].builtInAttributes[index].validation.max|number|||
|data[index].builtInAttributes[index].validation.regex|string|||
|data[index].builtInAttributes[index].numericMetaData|object|||
|data[index].builtInAttributes[index].numericMetaData.units|string|||
|data[index].builtInAttributes[index].numericMetaData.upperRange|number|||
|data[index].builtInAttributes[index].numericMetaData.lowerRange|number|||
|data[index].builtInAttributes[index].numericMetaData.subType|string| Values:INTEGER,DECIMAL||
|data[index].builtInAttributes[index].type|string| Values:LABEL,PARAGRAPH,INTEGER,DECIMAL,BOOLEAN,SINGLE_SELECT,MULTI_SELECT,ADDRESS,NAME,PHONE,EMAIL,DATE_TIME,DATE,REFERENCE,TIMEZONE,LOCALE,FILE,IMAGE,LINK,WAVEFORM||
|data[index].builtInAttributes[index].category|object|||
|data[index].builtInAttributes[index].category.name|string|||
|data[index].builtInAttributes[index].category.displayName|string|||
|data[index].builtInAttributes[index].validationMetadata|object|||
|data[index].builtInAttributes[index].validationMetadata.mandatoryReadOnly|boolean|||
|data[index].builtInAttributes[index].validationMetadata.systemMandatory|boolean|||
|data[index].builtInAttributes[index].validationMetadata.phiReadOnly|boolean|||
|data[index].builtInAttributes[index].selectableValues|array|||
|data[index].builtInAttributes[index].selectableValues[index]|array|||
|data[index].builtInAttributes[index].selectableValues[index].name|string| Pattern:[a-zA-Z]\w*||
|data[index].builtInAttributes[index].selectableValues[index].displayName|string|||
|data[index].builtInAttributes[index].readOnly|boolean|||
|data[index].builtInAttributes[index].typeEnum|string| Values:LABEL,PARAGRAPH,INTEGER,DECIMAL,BOOLEAN,SINGLE_SELECT,MULTI_SELECT,ADDRESS,NAME,PHONE,EMAIL,DATE_TIME,DATE,REFERENCE,TIMEZONE,LOCALE,FILE,IMAGE,LINK,WAVEFORM||
|data[index].templateAttributes|array|||
|data[index].templateAttributes[index]|array|||
|data[index].templateAttributes[index].name|string|||
|data[index].templateAttributes[index].basePath|string|||
|data[index].templateAttributes[index].id|string|||
|data[index].templateAttributes[index].displayName|string|||
|data[index].templateAttributes[index].phi|boolean|||
|data[index].templateAttributes[index].referenceConfiguration|object|||
|data[index].templateAttributes[index].referenceConfiguration.uniquely|boolean|||
|data[index].templateAttributes[index].referenceConfiguration.referencedSideAttributeName|string|||
|data[index].templateAttributes[index].referenceConfiguration.referencedSideAttributeDisplayName|string|||
|data[index].templateAttributes[index].referenceConfiguration.validTemplatesToReference|array|||
|data[index].templateAttributes[index].referenceConfiguration.entityType|string|||
|data[index].templateAttributes[index].linkConfiguration|object|||
|data[index].templateAttributes[index].linkConfiguration.entityTypeName|string|||
|data[index].templateAttributes[index].linkConfiguration.templateId|string|||
|data[index].templateAttributes[index].linkConfiguration.attributeId|string|||
|data[index].templateAttributes[index].value|object|||
|data[index].templateAttributes[index].type|string| Values:LABEL,PARAGRAPH,INTEGER,DECIMAL,BOOLEAN,SINGLE_SELECT,MULTI_SELECT,ADDRESS,NAME,PHONE,EMAIL,DATE_TIME,DATE,REFERENCE,TIMEZONE,LOCALE,FILE,IMAGE,LINK,WAVEFORM||
|data[index].templateAttributes[index].category|object|||
|data[index].templateAttributes[index].category.name|string|||
|data[index].templateAttributes[index].category.displayName|string|||
|data[index].templateAttributes[index].selectableValues|array|||
|data[index].templateAttributes[index].selectableValues[index]|array|||
|data[index].templateAttributes[index].selectableValues[index].name|string| Pattern:[a-zA-Z]\w*||
|data[index].templateAttributes[index].selectableValues[index].displayName|string|||
|data[index].templateAttributes[index].validation|object|||
|data[index].templateAttributes[index].validation.mandatory|boolean|||
|data[index].templateAttributes[index].validation.defaultValue|object|||
|data[index].templateAttributes[index].validation.min|number|||
|data[index].templateAttributes[index].validation.max|number|||
|data[index].templateAttributes[index].validation.regex|string|||
|data[index].templateAttributes[index].numericMetaData|object|||
|data[index].templateAttributes[index].numericMetaData.units|string|||
|data[index].templateAttributes[index].numericMetaData.upperRange|number|||
|data[index].templateAttributes[index].numericMetaData.lowerRange|number|||
|data[index].templateAttributes[index].numericMetaData.subType|string| Values:INTEGER,DECIMAL||
|data[index].templateAttributes[index].organizationSelection|object|||
|data[index].templateAttributes[index].organizationSelection.allowed|boolean|||
|data[index].templateAttributes[index].organizationSelection.configuration|object|||
|data[index].templateAttributes[index].organizationSelection.configuration.selected|array|||
|data[index].templateAttributes[index].organizationSelection.configuration.selected[index]|array|||
|data[index].templateAttributes[index].organizationSelection.configuration.selected[index].id|string|||
|data[index].templateAttributes[index].organizationSelection.configuration.all|boolean|||
|data[index].templateAttributes[index].typeEnum|string| Values:LABEL,PARAGRAPH,INTEGER,DECIMAL,BOOLEAN,SINGLE_SELECT,MULTI_SELECT,ADDRESS,NAME,PHONE,EMAIL,DATE_TIME,DATE,REFERENCE,TIMEZONE,LOCALE,FILE,IMAGE,LINK,WAVEFORM||
|metadata|object|||
|metadata.sort|array|Sort that was passed in the request||
|metadata.sort[index]|array|Sort that was passed in the request||
|metadata.sort[index].prop|string|The property name for the sort||
|metadata.sort[index].order|string|The direction of sort. Default DESC Values:ASC,DESC|ASC|
|metadata.filter|object|The filter that was passed in the request||
|metadata.page|object|||
|metadata.page.totalResults|integer|The total number of items that match the query|145|
|metadata.page.page|integer|Page number|3|
|metadata.page.limit|integer|Number of items per page|100|
|metadata.freeTextSearch|string|Free text search strings that was passed in the request|cat dog|
 */ SearchResponseGetTemplateResponse;
export type Search1ApiArg = {
  /** Search request parameters: filter, sort and page */
  searchRequest?: string;
};
export type CreateTemplateApiResponse = /** status 201 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|displayName|string|||
|name|string| Pattern:[a-zA-Z]\w*||
|description|string|||
|ownerOrganizationId|string|||
|id|string|||
|entityTypeName|string|||
|removable|boolean|||
|creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|parentTemplate|object|||
|parentTemplate.id|string|||
|parentTemplate.displayName|string|||
|parentTemplate.name|string|||
|parentTemplateId|string|||
|customAttributes|array|||
|customAttributes[index]|array|||
|customAttributes[index].displayName|string|||
|customAttributes[index].phi|boolean|||
|customAttributes[index].referenceConfiguration|object|||
|customAttributes[index].referenceConfiguration.uniquely|boolean|||
|customAttributes[index].referenceConfiguration.referencedSideAttributeName|string|||
|customAttributes[index].referenceConfiguration.referencedSideAttributeDisplayName|string|||
|customAttributes[index].referenceConfiguration.validTemplatesToReference|array|||
|customAttributes[index].referenceConfiguration.entityType|string|||
|customAttributes[index].linkConfiguration|object|||
|customAttributes[index].linkConfiguration.entityTypeName|string|||
|customAttributes[index].linkConfiguration.templateId|string|||
|customAttributes[index].linkConfiguration.attributeId|string|||
|customAttributes[index].name|string| Pattern:[a-zA-Z]\w*||
|customAttributes[index].type|string| Values:LABEL,PARAGRAPH,INTEGER,DECIMAL,BOOLEAN,SINGLE_SELECT,MULTI_SELECT,ADDRESS,NAME,PHONE,EMAIL,DATE_TIME,DATE,REFERENCE,TIMEZONE,LOCALE,FILE,IMAGE,LINK,WAVEFORM||
|customAttributes[index].validation|object|||
|customAttributes[index].validation.mandatory|boolean|||
|customAttributes[index].validation.defaultValue|object|||
|customAttributes[index].validation.min|number|||
|customAttributes[index].validation.max|number|||
|customAttributes[index].validation.regex|string|||
|customAttributes[index].numericMetaData|object|||
|customAttributes[index].numericMetaData.units|string|||
|customAttributes[index].numericMetaData.upperRange|number|||
|customAttributes[index].numericMetaData.lowerRange|number|||
|customAttributes[index].numericMetaData.subType|string| Values:INTEGER,DECIMAL||
|customAttributes[index].id|string|||
|customAttributes[index].selectableValues|array|||
|customAttributes[index].selectableValues[index]|array|||
|customAttributes[index].selectableValues[index].name|string| Pattern:[a-zA-Z]\w*||
|customAttributes[index].selectableValues[index].displayName|string|||
|customAttributes[index].selectableValues[index].id|string|||
|customAttributes[index].category|object|||
|customAttributes[index].category.name|string|||
|customAttributes[index].category.displayName|string|||
|customAttributes[index].basePath|string|||
|customAttributes[index].typeEnum|string| Values:LABEL,PARAGRAPH,INTEGER,DECIMAL,BOOLEAN,SINGLE_SELECT,MULTI_SELECT,ADDRESS,NAME,PHONE,EMAIL,DATE_TIME,DATE,REFERENCE,TIMEZONE,LOCALE,FILE,IMAGE,LINK,WAVEFORM||
|builtInAttributes|array|||
|builtInAttributes[index]|array|||
|builtInAttributes[index].name|string|||
|builtInAttributes[index].basePath|string|||
|builtInAttributes[index].id|string|||
|builtInAttributes[index].displayName|string|||
|builtInAttributes[index].phi|boolean|||
|builtInAttributes[index].referenceConfiguration|object|||
|builtInAttributes[index].referenceConfiguration.uniquely|boolean|||
|builtInAttributes[index].referenceConfiguration.referencedSideAttributeName|string|||
|builtInAttributes[index].referenceConfiguration.referencedSideAttributeDisplayName|string|||
|builtInAttributes[index].referenceConfiguration.validTemplatesToReference|array|||
|builtInAttributes[index].referenceConfiguration.entityType|string|||
|builtInAttributes[index].linkConfiguration|object|||
|builtInAttributes[index].linkConfiguration.entityTypeName|string|||
|builtInAttributes[index].linkConfiguration.templateId|string|||
|builtInAttributes[index].linkConfiguration.attributeId|string|||
|builtInAttributes[index].validation|object|||
|builtInAttributes[index].validation.mandatory|boolean|||
|builtInAttributes[index].validation.defaultValue|object|||
|builtInAttributes[index].validation.min|number|||
|builtInAttributes[index].validation.max|number|||
|builtInAttributes[index].validation.regex|string|||
|builtInAttributes[index].numericMetaData|object|||
|builtInAttributes[index].numericMetaData.units|string|||
|builtInAttributes[index].numericMetaData.upperRange|number|||
|builtInAttributes[index].numericMetaData.lowerRange|number|||
|builtInAttributes[index].numericMetaData.subType|string| Values:INTEGER,DECIMAL||
|builtInAttributes[index].type|string| Values:LABEL,PARAGRAPH,INTEGER,DECIMAL,BOOLEAN,SINGLE_SELECT,MULTI_SELECT,ADDRESS,NAME,PHONE,EMAIL,DATE_TIME,DATE,REFERENCE,TIMEZONE,LOCALE,FILE,IMAGE,LINK,WAVEFORM||
|builtInAttributes[index].category|object|||
|builtInAttributes[index].category.name|string|||
|builtInAttributes[index].category.displayName|string|||
|builtInAttributes[index].validationMetadata|object|||
|builtInAttributes[index].validationMetadata.mandatoryReadOnly|boolean|||
|builtInAttributes[index].validationMetadata.systemMandatory|boolean|||
|builtInAttributes[index].validationMetadata.phiReadOnly|boolean|||
|builtInAttributes[index].selectableValues|array|||
|builtInAttributes[index].selectableValues[index]|array|||
|builtInAttributes[index].selectableValues[index].name|string| Pattern:[a-zA-Z]\w*||
|builtInAttributes[index].selectableValues[index].displayName|string|||
|builtInAttributes[index].readOnly|boolean|||
|builtInAttributes[index].typeEnum|string| Values:LABEL,PARAGRAPH,INTEGER,DECIMAL,BOOLEAN,SINGLE_SELECT,MULTI_SELECT,ADDRESS,NAME,PHONE,EMAIL,DATE_TIME,DATE,REFERENCE,TIMEZONE,LOCALE,FILE,IMAGE,LINK,WAVEFORM||
|templateAttributes|array|||
|templateAttributes[index]|array|||
|templateAttributes[index].name|string|||
|templateAttributes[index].basePath|string|||
|templateAttributes[index].id|string|||
|templateAttributes[index].displayName|string|||
|templateAttributes[index].phi|boolean|||
|templateAttributes[index].referenceConfiguration|object|||
|templateAttributes[index].referenceConfiguration.uniquely|boolean|||
|templateAttributes[index].referenceConfiguration.referencedSideAttributeName|string|||
|templateAttributes[index].referenceConfiguration.referencedSideAttributeDisplayName|string|||
|templateAttributes[index].referenceConfiguration.validTemplatesToReference|array|||
|templateAttributes[index].referenceConfiguration.entityType|string|||
|templateAttributes[index].linkConfiguration|object|||
|templateAttributes[index].linkConfiguration.entityTypeName|string|||
|templateAttributes[index].linkConfiguration.templateId|string|||
|templateAttributes[index].linkConfiguration.attributeId|string|||
|templateAttributes[index].value|object|||
|templateAttributes[index].type|string| Values:LABEL,PARAGRAPH,INTEGER,DECIMAL,BOOLEAN,SINGLE_SELECT,MULTI_SELECT,ADDRESS,NAME,PHONE,EMAIL,DATE_TIME,DATE,REFERENCE,TIMEZONE,LOCALE,FILE,IMAGE,LINK,WAVEFORM||
|templateAttributes[index].category|object|||
|templateAttributes[index].category.name|string|||
|templateAttributes[index].category.displayName|string|||
|templateAttributes[index].selectableValues|array|||
|templateAttributes[index].selectableValues[index]|array|||
|templateAttributes[index].selectableValues[index].name|string| Pattern:[a-zA-Z]\w*||
|templateAttributes[index].selectableValues[index].displayName|string|||
|templateAttributes[index].validation|object|||
|templateAttributes[index].validation.mandatory|boolean|||
|templateAttributes[index].validation.defaultValue|object|||
|templateAttributes[index].validation.min|number|||
|templateAttributes[index].validation.max|number|||
|templateAttributes[index].validation.regex|string|||
|templateAttributes[index].numericMetaData|object|||
|templateAttributes[index].numericMetaData.units|string|||
|templateAttributes[index].numericMetaData.upperRange|number|||
|templateAttributes[index].numericMetaData.lowerRange|number|||
|templateAttributes[index].numericMetaData.subType|string| Values:INTEGER,DECIMAL||
|templateAttributes[index].organizationSelection|object|||
|templateAttributes[index].organizationSelection.allowed|boolean|||
|templateAttributes[index].organizationSelection.configuration|object|||
|templateAttributes[index].organizationSelection.configuration.selected|array|||
|templateAttributes[index].organizationSelection.configuration.selected[index]|array|||
|templateAttributes[index].organizationSelection.configuration.selected[index].id|string|||
|templateAttributes[index].organizationSelection.configuration.all|boolean|||
|templateAttributes[index].typeEnum|string| Values:LABEL,PARAGRAPH,INTEGER,DECIMAL,BOOLEAN,SINGLE_SELECT,MULTI_SELECT,ADDRESS,NAME,PHONE,EMAIL,DATE_TIME,DATE,REFERENCE,TIMEZONE,LOCALE,FILE,IMAGE,LINK,WAVEFORM||
 */ GetTemplateResponse;
export type CreateTemplateApiArg = {
  /** Sometimes modifying the system's templates can cause side effects to other components. The 'force' flag indicates whether or not to force the template changes even if those side effects were to occur. For example: changing templates will cause Analytics DB to exit syncing data mode. */
  force?: boolean;
  createTemplateRequest: CreateTemplateRequest;
};
export type DeleteTemplateApiResponse = /** status 204 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
 */ void;
export type DeleteTemplateApiArg = {
  templateId: string;
  /** Sometimes modifying the system's templates can cause side effects to other components. The 'force' flag indicates whether or not to force the template changes even if those side effects were to occur. For example: changing templates will cause Analytics DB to exit syncing data mode. */
  force?: boolean;
};
export type GetTemplateApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|displayName|string|||
|name|string| Pattern:[a-zA-Z]\w*||
|description|string|||
|ownerOrganizationId|string|||
|id|string|||
|entityTypeName|string|||
|removable|boolean|||
|creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|parentTemplate|object|||
|parentTemplate.id|string|||
|parentTemplate.displayName|string|||
|parentTemplate.name|string|||
|parentTemplateId|string|||
|customAttributes|array|||
|customAttributes[index]|array|||
|customAttributes[index].displayName|string|||
|customAttributes[index].phi|boolean|||
|customAttributes[index].referenceConfiguration|object|||
|customAttributes[index].referenceConfiguration.uniquely|boolean|||
|customAttributes[index].referenceConfiguration.referencedSideAttributeName|string|||
|customAttributes[index].referenceConfiguration.referencedSideAttributeDisplayName|string|||
|customAttributes[index].referenceConfiguration.validTemplatesToReference|array|||
|customAttributes[index].referenceConfiguration.entityType|string|||
|customAttributes[index].linkConfiguration|object|||
|customAttributes[index].linkConfiguration.entityTypeName|string|||
|customAttributes[index].linkConfiguration.templateId|string|||
|customAttributes[index].linkConfiguration.attributeId|string|||
|customAttributes[index].name|string| Pattern:[a-zA-Z]\w*||
|customAttributes[index].type|string| Values:LABEL,PARAGRAPH,INTEGER,DECIMAL,BOOLEAN,SINGLE_SELECT,MULTI_SELECT,ADDRESS,NAME,PHONE,EMAIL,DATE_TIME,DATE,REFERENCE,TIMEZONE,LOCALE,FILE,IMAGE,LINK,WAVEFORM||
|customAttributes[index].validation|object|||
|customAttributes[index].validation.mandatory|boolean|||
|customAttributes[index].validation.defaultValue|object|||
|customAttributes[index].validation.min|number|||
|customAttributes[index].validation.max|number|||
|customAttributes[index].validation.regex|string|||
|customAttributes[index].numericMetaData|object|||
|customAttributes[index].numericMetaData.units|string|||
|customAttributes[index].numericMetaData.upperRange|number|||
|customAttributes[index].numericMetaData.lowerRange|number|||
|customAttributes[index].numericMetaData.subType|string| Values:INTEGER,DECIMAL||
|customAttributes[index].id|string|||
|customAttributes[index].selectableValues|array|||
|customAttributes[index].selectableValues[index]|array|||
|customAttributes[index].selectableValues[index].name|string| Pattern:[a-zA-Z]\w*||
|customAttributes[index].selectableValues[index].displayName|string|||
|customAttributes[index].selectableValues[index].id|string|||
|customAttributes[index].category|object|||
|customAttributes[index].category.name|string|||
|customAttributes[index].category.displayName|string|||
|customAttributes[index].basePath|string|||
|customAttributes[index].typeEnum|string| Values:LABEL,PARAGRAPH,INTEGER,DECIMAL,BOOLEAN,SINGLE_SELECT,MULTI_SELECT,ADDRESS,NAME,PHONE,EMAIL,DATE_TIME,DATE,REFERENCE,TIMEZONE,LOCALE,FILE,IMAGE,LINK,WAVEFORM||
|builtInAttributes|array|||
|builtInAttributes[index]|array|||
|builtInAttributes[index].name|string|||
|builtInAttributes[index].basePath|string|||
|builtInAttributes[index].id|string|||
|builtInAttributes[index].displayName|string|||
|builtInAttributes[index].phi|boolean|||
|builtInAttributes[index].referenceConfiguration|object|||
|builtInAttributes[index].referenceConfiguration.uniquely|boolean|||
|builtInAttributes[index].referenceConfiguration.referencedSideAttributeName|string|||
|builtInAttributes[index].referenceConfiguration.referencedSideAttributeDisplayName|string|||
|builtInAttributes[index].referenceConfiguration.validTemplatesToReference|array|||
|builtInAttributes[index].referenceConfiguration.entityType|string|||
|builtInAttributes[index].linkConfiguration|object|||
|builtInAttributes[index].linkConfiguration.entityTypeName|string|||
|builtInAttributes[index].linkConfiguration.templateId|string|||
|builtInAttributes[index].linkConfiguration.attributeId|string|||
|builtInAttributes[index].validation|object|||
|builtInAttributes[index].validation.mandatory|boolean|||
|builtInAttributes[index].validation.defaultValue|object|||
|builtInAttributes[index].validation.min|number|||
|builtInAttributes[index].validation.max|number|||
|builtInAttributes[index].validation.regex|string|||
|builtInAttributes[index].numericMetaData|object|||
|builtInAttributes[index].numericMetaData.units|string|||
|builtInAttributes[index].numericMetaData.upperRange|number|||
|builtInAttributes[index].numericMetaData.lowerRange|number|||
|builtInAttributes[index].numericMetaData.subType|string| Values:INTEGER,DECIMAL||
|builtInAttributes[index].type|string| Values:LABEL,PARAGRAPH,INTEGER,DECIMAL,BOOLEAN,SINGLE_SELECT,MULTI_SELECT,ADDRESS,NAME,PHONE,EMAIL,DATE_TIME,DATE,REFERENCE,TIMEZONE,LOCALE,FILE,IMAGE,LINK,WAVEFORM||
|builtInAttributes[index].category|object|||
|builtInAttributes[index].category.name|string|||
|builtInAttributes[index].category.displayName|string|||
|builtInAttributes[index].validationMetadata|object|||
|builtInAttributes[index].validationMetadata.mandatoryReadOnly|boolean|||
|builtInAttributes[index].validationMetadata.systemMandatory|boolean|||
|builtInAttributes[index].validationMetadata.phiReadOnly|boolean|||
|builtInAttributes[index].selectableValues|array|||
|builtInAttributes[index].selectableValues[index]|array|||
|builtInAttributes[index].selectableValues[index].name|string| Pattern:[a-zA-Z]\w*||
|builtInAttributes[index].selectableValues[index].displayName|string|||
|builtInAttributes[index].readOnly|boolean|||
|builtInAttributes[index].typeEnum|string| Values:LABEL,PARAGRAPH,INTEGER,DECIMAL,BOOLEAN,SINGLE_SELECT,MULTI_SELECT,ADDRESS,NAME,PHONE,EMAIL,DATE_TIME,DATE,REFERENCE,TIMEZONE,LOCALE,FILE,IMAGE,LINK,WAVEFORM||
|templateAttributes|array|||
|templateAttributes[index]|array|||
|templateAttributes[index].name|string|||
|templateAttributes[index].basePath|string|||
|templateAttributes[index].id|string|||
|templateAttributes[index].displayName|string|||
|templateAttributes[index].phi|boolean|||
|templateAttributes[index].referenceConfiguration|object|||
|templateAttributes[index].referenceConfiguration.uniquely|boolean|||
|templateAttributes[index].referenceConfiguration.referencedSideAttributeName|string|||
|templateAttributes[index].referenceConfiguration.referencedSideAttributeDisplayName|string|||
|templateAttributes[index].referenceConfiguration.validTemplatesToReference|array|||
|templateAttributes[index].referenceConfiguration.entityType|string|||
|templateAttributes[index].linkConfiguration|object|||
|templateAttributes[index].linkConfiguration.entityTypeName|string|||
|templateAttributes[index].linkConfiguration.templateId|string|||
|templateAttributes[index].linkConfiguration.attributeId|string|||
|templateAttributes[index].value|object|||
|templateAttributes[index].type|string| Values:LABEL,PARAGRAPH,INTEGER,DECIMAL,BOOLEAN,SINGLE_SELECT,MULTI_SELECT,ADDRESS,NAME,PHONE,EMAIL,DATE_TIME,DATE,REFERENCE,TIMEZONE,LOCALE,FILE,IMAGE,LINK,WAVEFORM||
|templateAttributes[index].category|object|||
|templateAttributes[index].category.name|string|||
|templateAttributes[index].category.displayName|string|||
|templateAttributes[index].selectableValues|array|||
|templateAttributes[index].selectableValues[index]|array|||
|templateAttributes[index].selectableValues[index].name|string| Pattern:[a-zA-Z]\w*||
|templateAttributes[index].selectableValues[index].displayName|string|||
|templateAttributes[index].validation|object|||
|templateAttributes[index].validation.mandatory|boolean|||
|templateAttributes[index].validation.defaultValue|object|||
|templateAttributes[index].validation.min|number|||
|templateAttributes[index].validation.max|number|||
|templateAttributes[index].validation.regex|string|||
|templateAttributes[index].numericMetaData|object|||
|templateAttributes[index].numericMetaData.units|string|||
|templateAttributes[index].numericMetaData.upperRange|number|||
|templateAttributes[index].numericMetaData.lowerRange|number|||
|templateAttributes[index].numericMetaData.subType|string| Values:INTEGER,DECIMAL||
|templateAttributes[index].organizationSelection|object|||
|templateAttributes[index].organizationSelection.allowed|boolean|||
|templateAttributes[index].organizationSelection.configuration|object|||
|templateAttributes[index].organizationSelection.configuration.selected|array|||
|templateAttributes[index].organizationSelection.configuration.selected[index]|array|||
|templateAttributes[index].organizationSelection.configuration.selected[index].id|string|||
|templateAttributes[index].organizationSelection.configuration.all|boolean|||
|templateAttributes[index].typeEnum|string| Values:LABEL,PARAGRAPH,INTEGER,DECIMAL,BOOLEAN,SINGLE_SELECT,MULTI_SELECT,ADDRESS,NAME,PHONE,EMAIL,DATE_TIME,DATE,REFERENCE,TIMEZONE,LOCALE,FILE,IMAGE,LINK,WAVEFORM||
 */ GetTemplateResponse;
export type GetTemplateApiArg = {
  templateId: string;
};
export type UpdateTemplateApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|displayName|string|||
|name|string| Pattern:[a-zA-Z]\w*||
|description|string|||
|ownerOrganizationId|string|||
|id|string|||
|entityTypeName|string|||
|removable|boolean|||
|creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|parentTemplate|object|||
|parentTemplate.id|string|||
|parentTemplate.displayName|string|||
|parentTemplate.name|string|||
|parentTemplateId|string|||
|customAttributes|array|||
|customAttributes[index]|array|||
|customAttributes[index].displayName|string|||
|customAttributes[index].phi|boolean|||
|customAttributes[index].referenceConfiguration|object|||
|customAttributes[index].referenceConfiguration.uniquely|boolean|||
|customAttributes[index].referenceConfiguration.referencedSideAttributeName|string|||
|customAttributes[index].referenceConfiguration.referencedSideAttributeDisplayName|string|||
|customAttributes[index].referenceConfiguration.validTemplatesToReference|array|||
|customAttributes[index].referenceConfiguration.entityType|string|||
|customAttributes[index].linkConfiguration|object|||
|customAttributes[index].linkConfiguration.entityTypeName|string|||
|customAttributes[index].linkConfiguration.templateId|string|||
|customAttributes[index].linkConfiguration.attributeId|string|||
|customAttributes[index].name|string| Pattern:[a-zA-Z]\w*||
|customAttributes[index].type|string| Values:LABEL,PARAGRAPH,INTEGER,DECIMAL,BOOLEAN,SINGLE_SELECT,MULTI_SELECT,ADDRESS,NAME,PHONE,EMAIL,DATE_TIME,DATE,REFERENCE,TIMEZONE,LOCALE,FILE,IMAGE,LINK,WAVEFORM||
|customAttributes[index].validation|object|||
|customAttributes[index].validation.mandatory|boolean|||
|customAttributes[index].validation.defaultValue|object|||
|customAttributes[index].validation.min|number|||
|customAttributes[index].validation.max|number|||
|customAttributes[index].validation.regex|string|||
|customAttributes[index].numericMetaData|object|||
|customAttributes[index].numericMetaData.units|string|||
|customAttributes[index].numericMetaData.upperRange|number|||
|customAttributes[index].numericMetaData.lowerRange|number|||
|customAttributes[index].numericMetaData.subType|string| Values:INTEGER,DECIMAL||
|customAttributes[index].id|string|||
|customAttributes[index].selectableValues|array|||
|customAttributes[index].selectableValues[index]|array|||
|customAttributes[index].selectableValues[index].name|string| Pattern:[a-zA-Z]\w*||
|customAttributes[index].selectableValues[index].displayName|string|||
|customAttributes[index].selectableValues[index].id|string|||
|customAttributes[index].category|object|||
|customAttributes[index].category.name|string|||
|customAttributes[index].category.displayName|string|||
|customAttributes[index].basePath|string|||
|customAttributes[index].typeEnum|string| Values:LABEL,PARAGRAPH,INTEGER,DECIMAL,BOOLEAN,SINGLE_SELECT,MULTI_SELECT,ADDRESS,NAME,PHONE,EMAIL,DATE_TIME,DATE,REFERENCE,TIMEZONE,LOCALE,FILE,IMAGE,LINK,WAVEFORM||
|builtInAttributes|array|||
|builtInAttributes[index]|array|||
|builtInAttributes[index].name|string|||
|builtInAttributes[index].basePath|string|||
|builtInAttributes[index].id|string|||
|builtInAttributes[index].displayName|string|||
|builtInAttributes[index].phi|boolean|||
|builtInAttributes[index].referenceConfiguration|object|||
|builtInAttributes[index].referenceConfiguration.uniquely|boolean|||
|builtInAttributes[index].referenceConfiguration.referencedSideAttributeName|string|||
|builtInAttributes[index].referenceConfiguration.referencedSideAttributeDisplayName|string|||
|builtInAttributes[index].referenceConfiguration.validTemplatesToReference|array|||
|builtInAttributes[index].referenceConfiguration.entityType|string|||
|builtInAttributes[index].linkConfiguration|object|||
|builtInAttributes[index].linkConfiguration.entityTypeName|string|||
|builtInAttributes[index].linkConfiguration.templateId|string|||
|builtInAttributes[index].linkConfiguration.attributeId|string|||
|builtInAttributes[index].validation|object|||
|builtInAttributes[index].validation.mandatory|boolean|||
|builtInAttributes[index].validation.defaultValue|object|||
|builtInAttributes[index].validation.min|number|||
|builtInAttributes[index].validation.max|number|||
|builtInAttributes[index].validation.regex|string|||
|builtInAttributes[index].numericMetaData|object|||
|builtInAttributes[index].numericMetaData.units|string|||
|builtInAttributes[index].numericMetaData.upperRange|number|||
|builtInAttributes[index].numericMetaData.lowerRange|number|||
|builtInAttributes[index].numericMetaData.subType|string| Values:INTEGER,DECIMAL||
|builtInAttributes[index].type|string| Values:LABEL,PARAGRAPH,INTEGER,DECIMAL,BOOLEAN,SINGLE_SELECT,MULTI_SELECT,ADDRESS,NAME,PHONE,EMAIL,DATE_TIME,DATE,REFERENCE,TIMEZONE,LOCALE,FILE,IMAGE,LINK,WAVEFORM||
|builtInAttributes[index].category|object|||
|builtInAttributes[index].category.name|string|||
|builtInAttributes[index].category.displayName|string|||
|builtInAttributes[index].validationMetadata|object|||
|builtInAttributes[index].validationMetadata.mandatoryReadOnly|boolean|||
|builtInAttributes[index].validationMetadata.systemMandatory|boolean|||
|builtInAttributes[index].validationMetadata.phiReadOnly|boolean|||
|builtInAttributes[index].selectableValues|array|||
|builtInAttributes[index].selectableValues[index]|array|||
|builtInAttributes[index].selectableValues[index].name|string| Pattern:[a-zA-Z]\w*||
|builtInAttributes[index].selectableValues[index].displayName|string|||
|builtInAttributes[index].readOnly|boolean|||
|builtInAttributes[index].typeEnum|string| Values:LABEL,PARAGRAPH,INTEGER,DECIMAL,BOOLEAN,SINGLE_SELECT,MULTI_SELECT,ADDRESS,NAME,PHONE,EMAIL,DATE_TIME,DATE,REFERENCE,TIMEZONE,LOCALE,FILE,IMAGE,LINK,WAVEFORM||
|templateAttributes|array|||
|templateAttributes[index]|array|||
|templateAttributes[index].name|string|||
|templateAttributes[index].basePath|string|||
|templateAttributes[index].id|string|||
|templateAttributes[index].displayName|string|||
|templateAttributes[index].phi|boolean|||
|templateAttributes[index].referenceConfiguration|object|||
|templateAttributes[index].referenceConfiguration.uniquely|boolean|||
|templateAttributes[index].referenceConfiguration.referencedSideAttributeName|string|||
|templateAttributes[index].referenceConfiguration.referencedSideAttributeDisplayName|string|||
|templateAttributes[index].referenceConfiguration.validTemplatesToReference|array|||
|templateAttributes[index].referenceConfiguration.entityType|string|||
|templateAttributes[index].linkConfiguration|object|||
|templateAttributes[index].linkConfiguration.entityTypeName|string|||
|templateAttributes[index].linkConfiguration.templateId|string|||
|templateAttributes[index].linkConfiguration.attributeId|string|||
|templateAttributes[index].value|object|||
|templateAttributes[index].type|string| Values:LABEL,PARAGRAPH,INTEGER,DECIMAL,BOOLEAN,SINGLE_SELECT,MULTI_SELECT,ADDRESS,NAME,PHONE,EMAIL,DATE_TIME,DATE,REFERENCE,TIMEZONE,LOCALE,FILE,IMAGE,LINK,WAVEFORM||
|templateAttributes[index].category|object|||
|templateAttributes[index].category.name|string|||
|templateAttributes[index].category.displayName|string|||
|templateAttributes[index].selectableValues|array|||
|templateAttributes[index].selectableValues[index]|array|||
|templateAttributes[index].selectableValues[index].name|string| Pattern:[a-zA-Z]\w*||
|templateAttributes[index].selectableValues[index].displayName|string|||
|templateAttributes[index].validation|object|||
|templateAttributes[index].validation.mandatory|boolean|||
|templateAttributes[index].validation.defaultValue|object|||
|templateAttributes[index].validation.min|number|||
|templateAttributes[index].validation.max|number|||
|templateAttributes[index].validation.regex|string|||
|templateAttributes[index].numericMetaData|object|||
|templateAttributes[index].numericMetaData.units|string|||
|templateAttributes[index].numericMetaData.upperRange|number|||
|templateAttributes[index].numericMetaData.lowerRange|number|||
|templateAttributes[index].numericMetaData.subType|string| Values:INTEGER,DECIMAL||
|templateAttributes[index].organizationSelection|object|||
|templateAttributes[index].organizationSelection.allowed|boolean|||
|templateAttributes[index].organizationSelection.configuration|object|||
|templateAttributes[index].organizationSelection.configuration.selected|array|||
|templateAttributes[index].organizationSelection.configuration.selected[index]|array|||
|templateAttributes[index].organizationSelection.configuration.selected[index].id|string|||
|templateAttributes[index].organizationSelection.configuration.all|boolean|||
|templateAttributes[index].typeEnum|string| Values:LABEL,PARAGRAPH,INTEGER,DECIMAL,BOOLEAN,SINGLE_SELECT,MULTI_SELECT,ADDRESS,NAME,PHONE,EMAIL,DATE_TIME,DATE,REFERENCE,TIMEZONE,LOCALE,FILE,IMAGE,LINK,WAVEFORM||
 */ GetTemplateResponse;
export type UpdateTemplateApiArg = {
  templateId: string;
  /** Sometimes modifying the system's templates can cause side effects to other components. The 'force' flag indicates whether or not to force the template changes even if those side effects were to occur. For example: changing templates will cause Analytics DB to exit syncing data mode. If 'force' is not provided fallback is the 'forceUpdate' value inside 'templateRequest' */
  force?: boolean;
  updateTemplateRequest: UpdateTemplateRequest;
};
export type GetTemplateOverviewApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|statistics|object|||
|statistics.entitiesCount|integer|||
|referencedByAttributes|array|||
|referencedByAttributes[index]|array|||
|referencedByAttributes[index].id|string|||
|referencedByAttributes[index].name|string|||
|referencedByAttributes[index].displayName|string|||
|referencedByAttributes[index].basePath|string|||
|referencedByAttributes[index].referenceConfiguration|object|||
|referencedByAttributes[index].referenceConfiguration.uniquely|boolean|||
|referencedByAttributes[index].referenceConfiguration.referencedSideAttributeName|string|||
|referencedByAttributes[index].referenceConfiguration.referencedSideAttributeDisplayName|string|||
|referencedByAttributes[index].referenceConfiguration.validTemplatesToReference|array|||
|referencedByAttributes[index].referenceConfiguration.entityType|string|||
|referencedByAttributes[index].template|object|||
|referencedByAttributes[index].template.id|string|||
|referencedByAttributes[index].template.name|string|||
|referencedByAttributes[index].template.displayName|string|||
|referencedByAttributes[index].template.entityTypeName|string|||
 */ TemplateOverviewResponse;
export type GetTemplateOverviewApiArg = {
  templateId: string;
};
export type MinimalSearchApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|data|array|List of items that match the search request||
|data[index]|array|List of items that match the search request||
|data[index].displayName|string|||
|data[index].name|string| Pattern:[a-zA-Z]\w*||
|data[index].description|string|||
|data[index].ownerOrganizationId|string|||
|data[index].id|string|||
|data[index].entityTypeName|string|||
|data[index].removable|boolean|||
|data[index].creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|data[index].lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|data[index].parentTemplate|object|||
|data[index].parentTemplate.id|string|||
|data[index].parentTemplate.displayName|string|||
|data[index].parentTemplate.name|string|||
|data[index].parentTemplateId|string|||
|metadata|object|||
|metadata.sort|array|Sort that was passed in the request||
|metadata.sort[index]|array|Sort that was passed in the request||
|metadata.sort[index].prop|string|The property name for the sort||
|metadata.sort[index].order|string|The direction of sort. Default DESC Values:ASC,DESC|ASC|
|metadata.filter|object|The filter that was passed in the request||
|metadata.page|object|||
|metadata.page.totalResults|integer|The total number of items that match the query|145|
|metadata.page.page|integer|Page number|3|
|metadata.page.limit|integer|Number of items per page|100|
|metadata.freeTextSearch|string|Free text search strings that was passed in the request|cat dog|
 */ SearchResponseTemplateMinimizedResponse;
export type MinimalSearchApiArg = {
  /** Search request parameters: filter, sort and page */
  searchRequest?: string;
};
export type DeleteLocaleTranslationsApiResponse = /** status 204 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
 */ void;
export type DeleteLocaleTranslationsApiArg = {
  locale: string;
};
export type DownloadLocaleTranslationFileApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
 */ Blob;
export type DownloadLocaleTranslationFileApiArg = {
  locale: string;
};
export type UpdateLocaleTranslationsApiResponse =
  /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
 */
  | UpdateLocaleTranslationsResponse
  | /** status 206 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
 */ UpdateLocaleTranslationsResponse;
export type UpdateLocaleTranslationsApiArg = {
  locale: string;
  body: {
    file: Blob;
  };
};
export type ValidateLocaleTranslationsApiResponse =
  /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
 */
  | ValidateLocaleTranslationsResponse
  | /** status 206 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
 */ ValidateLocaleTranslationsResponse;
export type ValidateLocaleTranslationsApiArg = {
  locale: string;
  body: {
    file: Blob;
  };
};
export type SearchLocaleTranslationOverviewsApiResponse =
  /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|data|array|List of items that match the search request||
|data[index]|array|List of items that match the search request||
|data[index].locale|string|||
|data[index].coverage|object|||
|data[index].coverage.numberOfAvailableKeys|integer|||
|data[index].coverage.numberOfTranslatedKeys|integer|||
|data[index].lastTranslationTime|string|||
|metadata|object|||
|metadata.sort|array|Sort that was passed in the request||
|metadata.sort[index]|array|Sort that was passed in the request||
|metadata.sort[index].prop|string|The property name for the sort||
|metadata.sort[index].order|string|The direction of sort. Default DESC Values:ASC,DESC|ASC|
|metadata.filter|object|The filter that was passed in the request||
|metadata.page|object|||
|metadata.page.totalResults|integer|The total number of items that match the query|145|
|metadata.page.page|integer|Page number|3|
|metadata.page.limit|integer|Number of items per page|100|
|metadata.freeTextSearch|string|Free text search strings that was passed in the request|cat dog|
 */ SearchResponseLocaleTranslationsOverview;
export type SearchLocaleTranslationOverviewsApiArg = {
  /** Search request parameters: filter, sort and page */
  searchRequest?: string;
};
export type SearchEntityTypesApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|data|array|List of items that match the search request||
|data[index]|array|List of items that match the search request||
|data[index].name|string|||
|data[index].displayName|string|||
|data[index].builtInActions|array|||
|data[index].builtInActions[index]|array|||
|data[index].builtInActions[index].name|string|||
|data[index].builtInActions[index].basePath|string|||
|data[index].builtInActions[index].displayName|string|||
|data[index].builtInActions[index].enableNotification|boolean|||
|data[index].builtInActions[index].enableLog|boolean|||
|data[index].builtInActions[index].timeoutInSeconds|integer|||
|data[index].builtInActions[index].source|string|||
|data[index].builtInActions[index].category|object|||
|data[index].builtInActions[index].category.name|string|||
|data[index].builtInActions[index].category.displayName|string|||
|data[index].children|array|||
|data[index].children[index]|array|||
|data[index].attributeCategories|array|||
|data[index].attributeCategories[index]|array|||
|data[index].attributeCategories[index].name|string|||
|data[index].attributeCategories[index].displayName|string|||
|data[index].attributeCategories[index].builtInSupportedTypes|array|||
|data[index].attributeCategories[index].customSupportedTypes|array|||
|data[index].attributeCategories[index].allowedCategoriesToLinkTo|array|||
|data[index].attributeCategories[index].supportMandatoryValidation|boolean|||
|data[index].attributeCategories[index].customBasePath|string|||
|data[index].builtInAttributes|array|||
|data[index].builtInAttributes[index]|array|||
|data[index].builtInAttributes[index].name|string|||
|data[index].builtInAttributes[index].basePath|string|||
|data[index].builtInAttributes[index].type|string| Values:LABEL,PARAGRAPH,INTEGER,DECIMAL,BOOLEAN,SINGLE_SELECT,MULTI_SELECT,ADDRESS,NAME,PHONE,EMAIL,DATE_TIME,DATE,REFERENCE,TIMEZONE,LOCALE,FILE,IMAGE,LINK,WAVEFORM||
|data[index].builtInAttributes[index].displayName|string|||
|data[index].builtInAttributes[index].phi|boolean|||
|data[index].builtInAttributes[index].validation|object|||
|data[index].builtInAttributes[index].validation.mandatory|boolean|||
|data[index].builtInAttributes[index].validation.defaultValue|object|||
|data[index].builtInAttributes[index].validation.min|number|||
|data[index].builtInAttributes[index].validation.max|number|||
|data[index].builtInAttributes[index].validation.regex|string|||
|data[index].builtInAttributes[index].validationMetadata|object|||
|data[index].builtInAttributes[index].validationMetadata.mandatoryReadOnly|boolean|||
|data[index].builtInAttributes[index].validationMetadata.systemMandatory|boolean|||
|data[index].builtInAttributes[index].validationMetadata.phiReadOnly|boolean|||
|data[index].builtInAttributes[index].selectableValues|array|||
|data[index].builtInAttributes[index].selectableValues[index]|array|||
|data[index].builtInAttributes[index].selectableValues[index].name|string| Pattern:[a-zA-Z]\w*||
|data[index].builtInAttributes[index].selectableValues[index].displayName|string|||
|data[index].builtInAttributes[index].readOnly|boolean|||
|data[index].builtInAttributes[index].referenceConfiguration|object|||
|data[index].builtInAttributes[index].referenceConfiguration.uniquely|boolean|||
|data[index].builtInAttributes[index].referenceConfiguration.referencedSideAttributeName|string|||
|data[index].builtInAttributes[index].referenceConfiguration.referencedSideAttributeDisplayName|string|||
|data[index].builtInAttributes[index].referenceConfiguration.validTemplatesToReference|array|||
|data[index].builtInAttributes[index].referenceConfiguration.entityType|string|||
|data[index].builtInAttributes[index].numericMetaData|object|||
|data[index].builtInAttributes[index].numericMetaData.units|string|||
|data[index].builtInAttributes[index].numericMetaData.upperRange|number|||
|data[index].builtInAttributes[index].numericMetaData.lowerRange|number|||
|data[index].builtInAttributes[index].numericMetaData.subType|string| Values:INTEGER,DECIMAL||
|data[index].builtInAttributes[index].category|object|||
|data[index].builtInAttributes[index].category.name|string|||
|data[index].builtInAttributes[index].category.displayName|string|||
|data[index].builtInAttributes[index].typeEnum|string| Values:LABEL,PARAGRAPH,INTEGER,DECIMAL,BOOLEAN,SINGLE_SELECT,MULTI_SELECT,ADDRESS,NAME,PHONE,EMAIL,DATE_TIME,DATE,REFERENCE,TIMEZONE,LOCALE,FILE,IMAGE,LINK,WAVEFORM||
|data[index].templateAttributes|array|||
|data[index].templateAttributes[index]|array|||
|data[index].templateAttributes[index].name|string|||
|data[index].templateAttributes[index].basePath|string|||
|data[index].templateAttributes[index].type|string| Values:LABEL,PARAGRAPH,INTEGER,DECIMAL,BOOLEAN,SINGLE_SELECT,MULTI_SELECT,ADDRESS,NAME,PHONE,EMAIL,DATE_TIME,DATE,REFERENCE,TIMEZONE,LOCALE,FILE,IMAGE,LINK,WAVEFORM||
|data[index].templateAttributes[index].displayName|string|||
|data[index].templateAttributes[index].phi|boolean|||
|data[index].templateAttributes[index].validation|object|||
|data[index].templateAttributes[index].validation.mandatory|boolean|||
|data[index].templateAttributes[index].validation.defaultValue|object|||
|data[index].templateAttributes[index].validation.min|number|||
|data[index].templateAttributes[index].validation.max|number|||
|data[index].templateAttributes[index].validation.regex|string|||
|data[index].templateAttributes[index].selectableValues|array|||
|data[index].templateAttributes[index].selectableValues[index]|array|||
|data[index].templateAttributes[index].selectableValues[index].name|string| Pattern:[a-zA-Z]\w*||
|data[index].templateAttributes[index].selectableValues[index].displayName|string|||
|data[index].templateAttributes[index].referenceConfiguration|object|||
|data[index].templateAttributes[index].referenceConfiguration.uniquely|boolean|||
|data[index].templateAttributes[index].referenceConfiguration.referencedSideAttributeName|string|||
|data[index].templateAttributes[index].referenceConfiguration.referencedSideAttributeDisplayName|string|||
|data[index].templateAttributes[index].referenceConfiguration.validTemplatesToReference|array|||
|data[index].templateAttributes[index].referenceConfiguration.entityType|string|||
|data[index].templateAttributes[index].numericMetaData|object|||
|data[index].templateAttributes[index].numericMetaData.units|string|||
|data[index].templateAttributes[index].numericMetaData.upperRange|number|||
|data[index].templateAttributes[index].numericMetaData.lowerRange|number|||
|data[index].templateAttributes[index].numericMetaData.subType|string| Values:INTEGER,DECIMAL||
|data[index].templateAttributes[index].value|object|||
|data[index].templateAttributes[index].organizationSelection|object|||
|data[index].templateAttributes[index].organizationSelection.allowed|boolean|||
|data[index].templateAttributes[index].organizationSelection.configuration|object|||
|data[index].templateAttributes[index].organizationSelection.configuration.selected|array|||
|data[index].templateAttributes[index].organizationSelection.configuration.selected[index]|array|||
|data[index].templateAttributes[index].organizationSelection.configuration.selected[index].id|string|||
|data[index].templateAttributes[index].organizationSelection.configuration.all|boolean|||
|data[index].templateAttributes[index].category|object|||
|data[index].templateAttributes[index].category.name|string|||
|data[index].templateAttributes[index].category.displayName|string|||
|data[index].templateAttributes[index].typeEnum|string| Values:LABEL,PARAGRAPH,INTEGER,DECIMAL,BOOLEAN,SINGLE_SELECT,MULTI_SELECT,ADDRESS,NAME,PHONE,EMAIL,DATE_TIME,DATE,REFERENCE,TIMEZONE,LOCALE,FILE,IMAGE,LINK,WAVEFORM||
|data[index].parentTemplateType|string|||
|data[index].captionAttributes|array|||
|data[index].captionAttributes[index]|array|||
|data[index].captionAttributes[index].name|string|||
|data[index].captionAttributes[index].basePath|string|||
|data[index].reservedTemplateNames|array|||
|data[index].addingCustomAttributeReferenceTypeSupported|boolean|||
|data[index].addingTemplatesSupported|boolean|||
|metadata|object|||
|metadata.sort|array|Sort that was passed in the request||
|metadata.sort[index]|array|Sort that was passed in the request||
|metadata.sort[index].prop|string|The property name for the sort||
|metadata.sort[index].order|string|The direction of sort. Default DESC Values:ASC,DESC|ASC|
|metadata.filter|object|The filter that was passed in the request||
|metadata.page|object|||
|metadata.page.totalResults|integer|The total number of items that match the query|145|
|metadata.page.page|integer|Page number|3|
|metadata.page.limit|integer|Number of items per page|100|
|metadata.freeTextSearch|string|Free text search strings that was passed in the request|cat dog|
 */ SearchResponseEntityType;
export type SearchEntityTypesApiArg = {
  /** Search request parameters: filter, sort and page */
  searchRequest?: string;
};
export type GetNotifiableActionsApiResponse = /** status 200 SUCCESS */ GetNotifiableActions;
export type GetNotifiableActionsApiArg = void;
export type SearchApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|data|array|List of items that match the search request||
|data[index]|array|List of items that match the search request||
|data[index].name|string|The plugin's name, the prefix 'Plugin-' will be prepended to it Pattern:[a-zA-Z0-9-_]+|My-Plugin_3|
|data[index].displayName|string|The plugins display name, it will be added to as the value of environment variable BIOT_APP_NAME|My Plugin 3|
|data[index].version|integer|If code is updated this number must be changed, and be larger than the previous number. Note, for zip deployment package type a code is considered to be updated if you provided a file for the code parameter, but for image deployment package type a code is considered to be updated if the imageTag field was provided (the server will not check if the imageTag is the same as the current imageTag that this plugin is using, so you can just not providing this field if you didn't change anything, in order not to be forced to increment the version field)|1|
|data[index].runtime|string|For deploymentPackageType = ZIP this field is mandatory, and for deploymentPackageType = IMAGE it's mandatory if imageTag was not provided, otherwise it will be ignored. The runtime that the plugin will run on. Only certain values are supported and only certain values are supported without sending a code file/imageTag, check the documentation for specifics.|python3.13|
|data[index].handler|string|Relevant only for deploymentPackageType = ZIP(mandatory), it will be ignored for IMAGE type. The entry point to the plugin, E.g. 'index.handler' means method 'handler' in file 'index' on the root of the plugin. The default is index.handler|index.handler|
|data[index].timeout|integer|The max time in seconds that the plugin may run, after which it will be aborted. The default is 3||
|data[index].memorySize|integer|The max amount of memory in MB that the plugin will have. The default is 128||
|data[index].environmentVariables|object|||
|data[index].subscriptions|object|||
|data[index].subscriptions.interceptionOrder|integer|The order in which the all interceptions for this plugin will be run in their respective apis. This can be overridden in each interception's data. Must be a positive number. Default is 1||
|data[index].subscriptions.interceptions|array|||
|data[index].subscriptions.interceptions[index]|array|||
|data[index].subscriptions.interceptions[index].type|string|The type of interception to create for this plugin Values:PRE_REQUEST,POST_REQUEST,ADAPT_ENTITY||
|data[index].subscriptions.interceptions[index].apiId|string|The id of the api for which to create the interception. Check interception configuration API for supported values||
|data[index].subscriptions.interceptions[index].entityTypeName|string|The entity for which to create the interception. Check interception configuration API for supported values|device|
|data[index].subscriptions.interceptions[index].order|integer|An order to override for this specific interception. Must be a positive number||
|data[index].subscriptions.notifications|array|||
|data[index].subscriptions.notifications[index]|array|||
|data[index].subscriptions.notifications[index].entityTypeName|string|The entity for which to create the notification. Check get all notifiable actions API for supported values|device|
|data[index].subscriptions.notifications[index].actionName|string|The action for which to create the notification. Check get all notifiable actions API for supported values|_create|
|data[index].enabledState|string|The activation state of the plugin. The default is ENABLED Values:DISABLED,ENABLED||
|data[index].cronSchedule|string|A six field cron expression separated with whitespaces, for fields: minutes,hours,day-of-month,month,day-of-week,year. Further details in https://docs.aws.amazon.com/eventbridge/latest/userguide/eb-cron-expressions.html Pattern:^(?:(?:(?:(?:[0-5]?[0-9])|[*])(?:(?:[-](?:(?:[0-5]?[0-9])|[*]))|(?:[\/][0-9]+))?(?:[,](?:(?:[0-5]?[0-9])|[*])(?:(?:[-](?:(?:[0-5]?[0-9])|[*]))|(?:[\/][0-9]+))?)*)[ ]+(?:(?:(?:[0-2]?[0-9])|[*])(?:(?:[-](?:(?:[0-2]?[0-9])|[*]))|(?:[\/][0-9]+))?(?:[,](?:(?:[0-2]?[0-9])|[*])(?:(?:[-](?:(?:[0-2]?[0-9])|[*]))|(?:[\/][0-9]+))?)*)[ ]+(?:(?:[?][ ]+(?:(?:(?:[1]?[0-9])|(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)|[*])(?:(?:[-](?:(?:[1]?[0-9])|(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)|[*])(?:[\/][0-9]+)?)|(?:[\/][0-9]+))?(?:[,](?:(?:[1]?[0-9])|(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)|[*])(?:(?:[-](?:(?:[1]?[0-9])|(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)|[*])(?:[\/][0-9]+)?)|(?:[\/][0-9]+))?)*)[ ]+(?:(?:(?:[1-7]|(?:SUN|MON|TUE|WED|THU|FRI|SAT))[#][0-5])|(?:(?:(?:(?:[1-7]|(?:SUN|MON|TUE|WED|THU|FRI|SAT))L?)|[L*])(?:(?:[-](?:(?:(?:[1-7]|(?:SUN|MON|TUE|WED|THU|FRI|SAT))L?)|[L*]))|(?:[\/][0-9]+))?(?:[,](?:(?:(?:[1-7]|(?:SUN|MON|TUE|WED|THU|FRI|SAT))L?)|[L*])(?:(?:[-](?:(?:(?:[1-7]|(?:SUN|MON|TUE|WED|THU|FRI|SAT))L?)|[L*]))|(?:[\/][0-9]+))?)*)))|(?:(?:(?:(?:(?:[1-3]?[0-9])W?)|LW|[L*])(?:(?:[-](?:(?:(?:[1-3]?[0-9])W?)|LW|[L*]))|(?:[\/][0-9]+))?(?:[,](?:(?:(?:[1-3]?[0-9])W?)|LW|[L*])(?:(?:[-](?:(?:(?:[1-3]?[0-9])W?)|LW|[L*]))|(?:[\/][0-9]+))?)*)[ ]+(?:(?:(?:[1]?[0-9])|(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)|[*])(?:(?:[-](?:(?:[1]?[0-9])|(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)|[*])(?:[\/][0-9]+)?)|(?:[\/][0-9]+))?(?:[,](?:(?:[1]?[0-9])|(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)|[*])(?:(?:[-](?:(?:[1]?[0-9])|(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)|[*])(?:[\/][0-9]+)?)|(?:[\/][0-9]+))?)*)[ ]+[?]))[ ]+(?:(?:(?:[12][0-9]{3})|[*])(?:(?:[-](?:(?:[12][0-9]{3})|[*]))|(?:[\/][0-9]+))?(?:[,](?:(?:[12][0-9]{3})|[*])(?:(?:[-](?:(?:[12][0-9]{3})|[*]))|(?:[\/][0-9]+))?)*))$|45 1/12 1-5 JAN,OCT ? *|
|data[index].deploymentPackageType|string|The deployment package type of the plugin. Cannot be changed after the creation. The default is ZIP. Values:ZIP,IMAGE||
|data[index].analyticsDbAccess|boolean|Flag that if true allows direct Analytics DB access from the plugin.||
|data[index].endpointUrl|string|The URL from which the plugin is accessible||
|data[index].linkToConsole|string|A link to the cloud providers console||
|data[index].lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|data[index].creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|metadata|object|||
|metadata.sort|array|Sort that was passed in the request||
|metadata.sort[index]|array|Sort that was passed in the request||
|metadata.sort[index].prop|string|The property name for the sort||
|metadata.sort[index].order|string|The direction of sort. Default DESC Values:ASC,DESC|ASC|
|metadata.filter|object|The filter that was passed in the request||
|metadata.page|object|||
|metadata.page.totalResults|integer|The total number of items that match the query|145|
|metadata.page.page|integer|Page number|3|
|metadata.page.limit|integer|Number of items per page|100|
|metadata.freeTextSearch|string|Free text search strings that was passed in the request|cat dog|
 */ SearchResponsePluginResponse;
export type SearchApiArg = {
  /** Search request parameters: filter, sort and page */
  searchRequest?: string;
};
export type CreateApiResponse = /** status 201 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|name|string|The plugin's name, the prefix 'Plugin-' will be prepended to it Pattern:[a-zA-Z0-9-_]+|My-Plugin_3|
|displayName|string|The plugins display name, it will be added to as the value of environment variable BIOT_APP_NAME|My Plugin 3|
|version|integer|If code is updated this number must be changed, and be larger than the previous number. Note, for zip deployment package type a code is considered to be updated if you provided a file for the code parameter, but for image deployment package type a code is considered to be updated if the imageTag field was provided (the server will not check if the imageTag is the same as the current imageTag that this plugin is using, so you can just not providing this field if you didn't change anything, in order not to be forced to increment the version field)|1|
|runtime|string|For deploymentPackageType = ZIP this field is mandatory, and for deploymentPackageType = IMAGE it's mandatory if imageTag was not provided, otherwise it will be ignored. The runtime that the plugin will run on. Only certain values are supported and only certain values are supported without sending a code file/imageTag, check the documentation for specifics.|python3.13|
|handler|string|Relevant only for deploymentPackageType = ZIP(mandatory), it will be ignored for IMAGE type. The entry point to the plugin, E.g. 'index.handler' means method 'handler' in file 'index' on the root of the plugin. The default is index.handler|index.handler|
|timeout|integer|The max time in seconds that the plugin may run, after which it will be aborted. The default is 3||
|memorySize|integer|The max amount of memory in MB that the plugin will have. The default is 128||
|environmentVariables|object|||
|subscriptions|object|||
|subscriptions.interceptionOrder|integer|The order in which the all interceptions for this plugin will be run in their respective apis. This can be overridden in each interception's data. Must be a positive number. Default is 1||
|subscriptions.interceptions|array|||
|subscriptions.interceptions[index]|array|||
|subscriptions.interceptions[index].type|string|The type of interception to create for this plugin Values:PRE_REQUEST,POST_REQUEST,ADAPT_ENTITY||
|subscriptions.interceptions[index].apiId|string|The id of the api for which to create the interception. Check interception configuration API for supported values||
|subscriptions.interceptions[index].entityTypeName|string|The entity for which to create the interception. Check interception configuration API for supported values|device|
|subscriptions.interceptions[index].order|integer|An order to override for this specific interception. Must be a positive number||
|subscriptions.notifications|array|||
|subscriptions.notifications[index]|array|||
|subscriptions.notifications[index].entityTypeName|string|The entity for which to create the notification. Check get all notifiable actions API for supported values|device|
|subscriptions.notifications[index].actionName|string|The action for which to create the notification. Check get all notifiable actions API for supported values|_create|
|enabledState|string|The activation state of the plugin. The default is ENABLED Values:DISABLED,ENABLED||
|cronSchedule|string|A six field cron expression separated with whitespaces, for fields: minutes,hours,day-of-month,month,day-of-week,year. Further details in https://docs.aws.amazon.com/eventbridge/latest/userguide/eb-cron-expressions.html Pattern:^(?:(?:(?:(?:[0-5]?[0-9])|[*])(?:(?:[-](?:(?:[0-5]?[0-9])|[*]))|(?:[\/][0-9]+))?(?:[,](?:(?:[0-5]?[0-9])|[*])(?:(?:[-](?:(?:[0-5]?[0-9])|[*]))|(?:[\/][0-9]+))?)*)[ ]+(?:(?:(?:[0-2]?[0-9])|[*])(?:(?:[-](?:(?:[0-2]?[0-9])|[*]))|(?:[\/][0-9]+))?(?:[,](?:(?:[0-2]?[0-9])|[*])(?:(?:[-](?:(?:[0-2]?[0-9])|[*]))|(?:[\/][0-9]+))?)*)[ ]+(?:(?:[?][ ]+(?:(?:(?:[1]?[0-9])|(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)|[*])(?:(?:[-](?:(?:[1]?[0-9])|(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)|[*])(?:[\/][0-9]+)?)|(?:[\/][0-9]+))?(?:[,](?:(?:[1]?[0-9])|(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)|[*])(?:(?:[-](?:(?:[1]?[0-9])|(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)|[*])(?:[\/][0-9]+)?)|(?:[\/][0-9]+))?)*)[ ]+(?:(?:(?:[1-7]|(?:SUN|MON|TUE|WED|THU|FRI|SAT))[#][0-5])|(?:(?:(?:(?:[1-7]|(?:SUN|MON|TUE|WED|THU|FRI|SAT))L?)|[L*])(?:(?:[-](?:(?:(?:[1-7]|(?:SUN|MON|TUE|WED|THU|FRI|SAT))L?)|[L*]))|(?:[\/][0-9]+))?(?:[,](?:(?:(?:[1-7]|(?:SUN|MON|TUE|WED|THU|FRI|SAT))L?)|[L*])(?:(?:[-](?:(?:(?:[1-7]|(?:SUN|MON|TUE|WED|THU|FRI|SAT))L?)|[L*]))|(?:[\/][0-9]+))?)*)))|(?:(?:(?:(?:(?:[1-3]?[0-9])W?)|LW|[L*])(?:(?:[-](?:(?:(?:[1-3]?[0-9])W?)|LW|[L*]))|(?:[\/][0-9]+))?(?:[,](?:(?:(?:[1-3]?[0-9])W?)|LW|[L*])(?:(?:[-](?:(?:(?:[1-3]?[0-9])W?)|LW|[L*]))|(?:[\/][0-9]+))?)*)[ ]+(?:(?:(?:[1]?[0-9])|(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)|[*])(?:(?:[-](?:(?:[1]?[0-9])|(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)|[*])(?:[\/][0-9]+)?)|(?:[\/][0-9]+))?(?:[,](?:(?:[1]?[0-9])|(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)|[*])(?:(?:[-](?:(?:[1]?[0-9])|(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)|[*])(?:[\/][0-9]+)?)|(?:[\/][0-9]+))?)*)[ ]+[?]))[ ]+(?:(?:(?:[12][0-9]{3})|[*])(?:(?:[-](?:(?:[12][0-9]{3})|[*]))|(?:[\/][0-9]+))?(?:[,](?:(?:[12][0-9]{3})|[*])(?:(?:[-](?:(?:[12][0-9]{3})|[*]))|(?:[\/][0-9]+))?)*))$|45 1/12 1-5 JAN,OCT ? *|
|deploymentPackageType|string|The deployment package type of the plugin. Cannot be changed after the creation. The default is ZIP. Values:ZIP,IMAGE||
|analyticsDbAccess|boolean|Flag that if true allows direct Analytics DB access from the plugin.||
|endpointUrl|string|The URL from which the plugin is accessible||
|linkToConsole|string|A link to the cloud providers console||
|lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
 */ PluginResponse;
export type CreateApiArg = {
  body: {
    code?: Blob;
    config?: CreatePluginRequest;
  };
};
export type DeleteSettingsV2PluginsByNameApiResponse = /** status 204 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
 */ void;
export type DeleteSettingsV2PluginsByNameApiArg = {
  name: string;
};
export type GetSettingsV2PluginsByNameApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|name|string|The plugin's name, the prefix 'Plugin-' will be prepended to it Pattern:[a-zA-Z0-9-_]+|My-Plugin_3|
|displayName|string|The plugins display name, it will be added to as the value of environment variable BIOT_APP_NAME|My Plugin 3|
|version|integer|If code is updated this number must be changed, and be larger than the previous number. Note, for zip deployment package type a code is considered to be updated if you provided a file for the code parameter, but for image deployment package type a code is considered to be updated if the imageTag field was provided (the server will not check if the imageTag is the same as the current imageTag that this plugin is using, so you can just not providing this field if you didn't change anything, in order not to be forced to increment the version field)|1|
|runtime|string|For deploymentPackageType = ZIP this field is mandatory, and for deploymentPackageType = IMAGE it's mandatory if imageTag was not provided, otherwise it will be ignored. The runtime that the plugin will run on. Only certain values are supported and only certain values are supported without sending a code file/imageTag, check the documentation for specifics.|python3.13|
|handler|string|Relevant only for deploymentPackageType = ZIP(mandatory), it will be ignored for IMAGE type. The entry point to the plugin, E.g. 'index.handler' means method 'handler' in file 'index' on the root of the plugin. The default is index.handler|index.handler|
|timeout|integer|The max time in seconds that the plugin may run, after which it will be aborted. The default is 3||
|memorySize|integer|The max amount of memory in MB that the plugin will have. The default is 128||
|environmentVariables|object|||
|subscriptions|object|||
|subscriptions.interceptionOrder|integer|The order in which the all interceptions for this plugin will be run in their respective apis. This can be overridden in each interception's data. Must be a positive number. Default is 1||
|subscriptions.interceptions|array|||
|subscriptions.interceptions[index]|array|||
|subscriptions.interceptions[index].type|string|The type of interception to create for this plugin Values:PRE_REQUEST,POST_REQUEST,ADAPT_ENTITY||
|subscriptions.interceptions[index].apiId|string|The id of the api for which to create the interception. Check interception configuration API for supported values||
|subscriptions.interceptions[index].entityTypeName|string|The entity for which to create the interception. Check interception configuration API for supported values|device|
|subscriptions.interceptions[index].order|integer|An order to override for this specific interception. Must be a positive number||
|subscriptions.notifications|array|||
|subscriptions.notifications[index]|array|||
|subscriptions.notifications[index].entityTypeName|string|The entity for which to create the notification. Check get all notifiable actions API for supported values|device|
|subscriptions.notifications[index].actionName|string|The action for which to create the notification. Check get all notifiable actions API for supported values|_create|
|enabledState|string|The activation state of the plugin. The default is ENABLED Values:DISABLED,ENABLED||
|cronSchedule|string|A six field cron expression separated with whitespaces, for fields: minutes,hours,day-of-month,month,day-of-week,year. Further details in https://docs.aws.amazon.com/eventbridge/latest/userguide/eb-cron-expressions.html Pattern:^(?:(?:(?:(?:[0-5]?[0-9])|[*])(?:(?:[-](?:(?:[0-5]?[0-9])|[*]))|(?:[\/][0-9]+))?(?:[,](?:(?:[0-5]?[0-9])|[*])(?:(?:[-](?:(?:[0-5]?[0-9])|[*]))|(?:[\/][0-9]+))?)*)[ ]+(?:(?:(?:[0-2]?[0-9])|[*])(?:(?:[-](?:(?:[0-2]?[0-9])|[*]))|(?:[\/][0-9]+))?(?:[,](?:(?:[0-2]?[0-9])|[*])(?:(?:[-](?:(?:[0-2]?[0-9])|[*]))|(?:[\/][0-9]+))?)*)[ ]+(?:(?:[?][ ]+(?:(?:(?:[1]?[0-9])|(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)|[*])(?:(?:[-](?:(?:[1]?[0-9])|(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)|[*])(?:[\/][0-9]+)?)|(?:[\/][0-9]+))?(?:[,](?:(?:[1]?[0-9])|(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)|[*])(?:(?:[-](?:(?:[1]?[0-9])|(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)|[*])(?:[\/][0-9]+)?)|(?:[\/][0-9]+))?)*)[ ]+(?:(?:(?:[1-7]|(?:SUN|MON|TUE|WED|THU|FRI|SAT))[#][0-5])|(?:(?:(?:(?:[1-7]|(?:SUN|MON|TUE|WED|THU|FRI|SAT))L?)|[L*])(?:(?:[-](?:(?:(?:[1-7]|(?:SUN|MON|TUE|WED|THU|FRI|SAT))L?)|[L*]))|(?:[\/][0-9]+))?(?:[,](?:(?:(?:[1-7]|(?:SUN|MON|TUE|WED|THU|FRI|SAT))L?)|[L*])(?:(?:[-](?:(?:(?:[1-7]|(?:SUN|MON|TUE|WED|THU|FRI|SAT))L?)|[L*]))|(?:[\/][0-9]+))?)*)))|(?:(?:(?:(?:(?:[1-3]?[0-9])W?)|LW|[L*])(?:(?:[-](?:(?:(?:[1-3]?[0-9])W?)|LW|[L*]))|(?:[\/][0-9]+))?(?:[,](?:(?:(?:[1-3]?[0-9])W?)|LW|[L*])(?:(?:[-](?:(?:(?:[1-3]?[0-9])W?)|LW|[L*]))|(?:[\/][0-9]+))?)*)[ ]+(?:(?:(?:[1]?[0-9])|(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)|[*])(?:(?:[-](?:(?:[1]?[0-9])|(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)|[*])(?:[\/][0-9]+)?)|(?:[\/][0-9]+))?(?:[,](?:(?:[1]?[0-9])|(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)|[*])(?:(?:[-](?:(?:[1]?[0-9])|(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)|[*])(?:[\/][0-9]+)?)|(?:[\/][0-9]+))?)*)[ ]+[?]))[ ]+(?:(?:(?:[12][0-9]{3})|[*])(?:(?:[-](?:(?:[12][0-9]{3})|[*]))|(?:[\/][0-9]+))?(?:[,](?:(?:[12][0-9]{3})|[*])(?:(?:[-](?:(?:[12][0-9]{3})|[*]))|(?:[\/][0-9]+))?)*))$|45 1/12 1-5 JAN,OCT ? *|
|deploymentPackageType|string|The deployment package type of the plugin. Cannot be changed after the creation. The default is ZIP. Values:ZIP,IMAGE||
|analyticsDbAccess|boolean|Flag that if true allows direct Analytics DB access from the plugin.||
|endpointUrl|string|The URL from which the plugin is accessible||
|linkToConsole|string|A link to the cloud providers console||
|lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
 */ PluginResponse;
export type GetSettingsV2PluginsByNameApiArg = {
  name: string;
};
export type PartialUpdateApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|name|string|The plugin's name, the prefix 'Plugin-' will be prepended to it Pattern:[a-zA-Z0-9-_]+|My-Plugin_3|
|displayName|string|The plugins display name, it will be added to as the value of environment variable BIOT_APP_NAME|My Plugin 3|
|version|integer|If code is updated this number must be changed, and be larger than the previous number. Note, for zip deployment package type a code is considered to be updated if you provided a file for the code parameter, but for image deployment package type a code is considered to be updated if the imageTag field was provided (the server will not check if the imageTag is the same as the current imageTag that this plugin is using, so you can just not providing this field if you didn't change anything, in order not to be forced to increment the version field)|1|
|runtime|string|For deploymentPackageType = ZIP this field is mandatory, and for deploymentPackageType = IMAGE it's mandatory if imageTag was not provided, otherwise it will be ignored. The runtime that the plugin will run on. Only certain values are supported and only certain values are supported without sending a code file/imageTag, check the documentation for specifics.|python3.13|
|handler|string|Relevant only for deploymentPackageType = ZIP(mandatory), it will be ignored for IMAGE type. The entry point to the plugin, E.g. 'index.handler' means method 'handler' in file 'index' on the root of the plugin. The default is index.handler|index.handler|
|timeout|integer|The max time in seconds that the plugin may run, after which it will be aborted. The default is 3||
|memorySize|integer|The max amount of memory in MB that the plugin will have. The default is 128||
|environmentVariables|object|||
|subscriptions|object|||
|subscriptions.interceptionOrder|integer|The order in which the all interceptions for this plugin will be run in their respective apis. This can be overridden in each interception's data. Must be a positive number. Default is 1||
|subscriptions.interceptions|array|||
|subscriptions.interceptions[index]|array|||
|subscriptions.interceptions[index].type|string|The type of interception to create for this plugin Values:PRE_REQUEST,POST_REQUEST,ADAPT_ENTITY||
|subscriptions.interceptions[index].apiId|string|The id of the api for which to create the interception. Check interception configuration API for supported values||
|subscriptions.interceptions[index].entityTypeName|string|The entity for which to create the interception. Check interception configuration API for supported values|device|
|subscriptions.interceptions[index].order|integer|An order to override for this specific interception. Must be a positive number||
|subscriptions.notifications|array|||
|subscriptions.notifications[index]|array|||
|subscriptions.notifications[index].entityTypeName|string|The entity for which to create the notification. Check get all notifiable actions API for supported values|device|
|subscriptions.notifications[index].actionName|string|The action for which to create the notification. Check get all notifiable actions API for supported values|_create|
|enabledState|string|The activation state of the plugin. The default is ENABLED Values:DISABLED,ENABLED||
|cronSchedule|string|A six field cron expression separated with whitespaces, for fields: minutes,hours,day-of-month,month,day-of-week,year. Further details in https://docs.aws.amazon.com/eventbridge/latest/userguide/eb-cron-expressions.html Pattern:^(?:(?:(?:(?:[0-5]?[0-9])|[*])(?:(?:[-](?:(?:[0-5]?[0-9])|[*]))|(?:[\/][0-9]+))?(?:[,](?:(?:[0-5]?[0-9])|[*])(?:(?:[-](?:(?:[0-5]?[0-9])|[*]))|(?:[\/][0-9]+))?)*)[ ]+(?:(?:(?:[0-2]?[0-9])|[*])(?:(?:[-](?:(?:[0-2]?[0-9])|[*]))|(?:[\/][0-9]+))?(?:[,](?:(?:[0-2]?[0-9])|[*])(?:(?:[-](?:(?:[0-2]?[0-9])|[*]))|(?:[\/][0-9]+))?)*)[ ]+(?:(?:[?][ ]+(?:(?:(?:[1]?[0-9])|(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)|[*])(?:(?:[-](?:(?:[1]?[0-9])|(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)|[*])(?:[\/][0-9]+)?)|(?:[\/][0-9]+))?(?:[,](?:(?:[1]?[0-9])|(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)|[*])(?:(?:[-](?:(?:[1]?[0-9])|(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)|[*])(?:[\/][0-9]+)?)|(?:[\/][0-9]+))?)*)[ ]+(?:(?:(?:[1-7]|(?:SUN|MON|TUE|WED|THU|FRI|SAT))[#][0-5])|(?:(?:(?:(?:[1-7]|(?:SUN|MON|TUE|WED|THU|FRI|SAT))L?)|[L*])(?:(?:[-](?:(?:(?:[1-7]|(?:SUN|MON|TUE|WED|THU|FRI|SAT))L?)|[L*]))|(?:[\/][0-9]+))?(?:[,](?:(?:(?:[1-7]|(?:SUN|MON|TUE|WED|THU|FRI|SAT))L?)|[L*])(?:(?:[-](?:(?:(?:[1-7]|(?:SUN|MON|TUE|WED|THU|FRI|SAT))L?)|[L*]))|(?:[\/][0-9]+))?)*)))|(?:(?:(?:(?:(?:[1-3]?[0-9])W?)|LW|[L*])(?:(?:[-](?:(?:(?:[1-3]?[0-9])W?)|LW|[L*]))|(?:[\/][0-9]+))?(?:[,](?:(?:(?:[1-3]?[0-9])W?)|LW|[L*])(?:(?:[-](?:(?:(?:[1-3]?[0-9])W?)|LW|[L*]))|(?:[\/][0-9]+))?)*)[ ]+(?:(?:(?:[1]?[0-9])|(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)|[*])(?:(?:[-](?:(?:[1]?[0-9])|(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)|[*])(?:[\/][0-9]+)?)|(?:[\/][0-9]+))?(?:[,](?:(?:[1]?[0-9])|(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)|[*])(?:(?:[-](?:(?:[1]?[0-9])|(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)|[*])(?:[\/][0-9]+)?)|(?:[\/][0-9]+))?)*)[ ]+[?]))[ ]+(?:(?:(?:[12][0-9]{3})|[*])(?:(?:[-](?:(?:[12][0-9]{3})|[*]))|(?:[\/][0-9]+))?(?:[,](?:(?:[12][0-9]{3})|[*])(?:(?:[-](?:(?:[12][0-9]{3})|[*]))|(?:[\/][0-9]+))?)*))$|45 1/12 1-5 JAN,OCT ? *|
|deploymentPackageType|string|The deployment package type of the plugin. Cannot be changed after the creation. The default is ZIP. Values:ZIP,IMAGE||
|analyticsDbAccess|boolean|Flag that if true allows direct Analytics DB access from the plugin.||
|endpointUrl|string|The URL from which the plugin is accessible||
|linkToConsole|string|A link to the cloud providers console||
|lastModifiedTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
|creationTime|string|A UTC date-time in the ISO-8601 format|2007-12-20T10:15:30Z|
 */ PluginResponse;
export type PartialUpdateApiArg = {
  name: string;
  body: {
    code?: Blob;
    config?: PartialUpdatePluginRequest;
  };
};
export type GetDockerRepositoryTempCredentialsApiResponse =
  /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|credentials|object|||
|credentials.accessKeyId|string|||
|credentials.secretAccessKey|string|||
|credentials.sessionToken|string|||
|credentials.expiration|string|||
|region|string|||
|repositoryUri|string|||
 */ DockerRepositoryTempCredentialsResponse;
export type GetDockerRepositoryTempCredentialsApiArg = void;
export type UmshealthCheckApiResponse = /** status 200 OK */ VersionResponse;
export type UmshealthCheckApiArg = void;
export type GetPublicKeyApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|publicKey|string|||
 */ GetPublicKeyResponse;
export type GetPublicKeyApiArg = void;
export type GetTempCredentialsForOrganizationApiResponse = /** status 200 SUCCESS */ TemporaryMqttCredentialsResponse;
export type GetTempCredentialsForOrganizationApiArg = void;
export type UmsvalidateTokenOperationApiResponse = /** status 200 SUCCESS */ void;
export type UmsvalidateTokenOperationApiArg = {
  /** Temporary token for calling this API */
  token: string;
  /** Operation name */
  operation: string;
  /** The entity id of the operation */
  entityId: string;
};
export type UmsexecuteTokenOperationApiResponse = /** status 200 SUCCESS */ TokenOperationResponse;
export type UmsexecuteTokenOperationApiArg = {
  /** Temporary token for calling this API */
  token: string;
  /** Operation name */
  operation: string;
  /** The entity id of the operation */
  entityId: string;
  body: {
    operationData: {
      [key: string]: object;
    };
  };
};
export type UmsexecuteTokenOperationGetApiResponse = /** status 200 SUCCESS */ TokenOperationResponse;
export type UmsexecuteTokenOperationGetApiArg = {
  /** Temporary token for calling this API */
  token: string;
  /** Operation name */
  operation: string;
  /** The entity id of the operation */
  entityId: string;
  operationData: {
    [key: string]: object;
  };
};
export type SearchServiceUsersApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|data|array|List of items that match the search request||
|data[index]|array|List of items that match the search request||
|data[index].active|boolean|||
|data[index].roleId|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index].type|string| Values:INTERNAL_SERVICE,EXTERNAL_SERVICE||
|data[index].ownerOrganizationId|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|data[index].name|string|||
|data[index].accessTokenExpirationInMinutes|integer|||
|data[index].id|string|||
|data[index].secretKeys|array|||
|data[index].secretKeys[index]|array|||
|data[index].secretKeys[index].id|string|||
|data[index].secretKeys[index].creationTime|string|||
|metadata|object|||
|metadata.sort|array|Sort that was passed in the request||
|metadata.sort[index]|array|Sort that was passed in the request||
|metadata.sort[index].prop|string|The property name for the sort||
|metadata.sort[index].order|string|The direction of sort. Default DESC Values:ASC,DESC|ASC|
|metadata.filter|object|The filter that was passed in the request||
|metadata.page|object|||
|metadata.page.totalResults|integer|The total number of items that match the query|145|
|metadata.page.page|integer|Page number|3|
|metadata.page.limit|integer|Number of items per page|100|
|metadata.freeTextSearch|string|Free text search strings that was passed in the request|cat dog|
 */ SearchResponseGetServiceUserV2Response;
export type SearchServiceUsersApiArg = {
  /** Search request parameters: filter, sort and page */
  searchRequest?: string;
};
export type CreateServiceUserApiResponse = /** status 201 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
 */ CreateServiceUserResponse;
export type CreateServiceUserApiArg = {
  createServiceUserRequest: CreateServiceUserRequest;
};
export type DeleteServiceUserApiResponse = /** status 204 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
 */ void;
export type DeleteServiceUserApiArg = {
  /** Service User ID that needs to be deleted */
  id: string;
};
export type GetServiceUserByIdApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|active|boolean|||
|roleId|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|type|string| Values:INTERNAL_SERVICE,EXTERNAL_SERVICE||
|ownerOrganizationId|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|name|string|||
|accessTokenExpirationInMinutes|integer|||
|id|string|||
|secretKeys|array|||
|secretKeys[index]|array|||
|secretKeys[index].id|string|||
|secretKeys[index].creationTime|string|||
 */ GetServiceUserV2Response;
export type GetServiceUserByIdApiArg = {
  /** Service User ID that needs to be fetched */
  id: string;
};
export type UpdateServiceUserApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|active|boolean|||
|roleId|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|type|string| Values:INTERNAL_SERVICE,EXTERNAL_SERVICE||
|ownerOrganizationId|string|A UUID formatted string|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|name|string|||
|accessTokenExpirationInMinutes|integer|||
|id|string|||
|secretKeys|array|||
|secretKeys[index]|array|||
|secretKeys[index].id|string|||
|secretKeys[index].creationTime|string|||
 */ UpdateServiceUserV2Response;
export type UpdateServiceUserApiArg = {
  /** Service User ID that needs to be updated */
  id: string;
  updateServiceUserV2Request: UpdateServiceUserV2Request;
};
export type CreateSecretKeyApiResponse = /** status 201 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|id|string|||
|creationTime|string|||
|secretKey|string|||
 */ CreateSecretKeyResponse;
export type CreateSecretKeyApiArg = {
  /** Service User ID */
  id: string;
};
export type DeleteSecretKeyApiResponse = /** status 204 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
 */ void;
export type DeleteSecretKeyApiArg = {
  /** Service User ID */
  id: string;
  /** Secret Key ID */
  secretKeyId: string;
};
export type ServiceUserLoginApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|accessToken|string|||
|accessTokenExpiration|string|||
 */ ServiceUserAccessTokenResponse;
export type ServiceUserLoginApiArg = {
  serviceUserAccessTokenRequest: ServiceUserAccessTokenRequest;
};
export type UmssearchApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|data|array|List of items that match the search request||
|data[index]|array|List of items that match the search request||
|data[index].username|string|user's username. If the credential type is OTP, should be a valid phone (An E.164 formatted phone number e.g +12345678901)||
|data[index].id|string|||
|data[index].ownerOrganizationId|string|||
|data[index].groups|array|||
|data[index].groups[index]|array|||
|data[index].groups[index].id|string|||
|data[index].groups[index].name|string|||
|data[index].locked|boolean|||
|data[index].active|boolean|||
|data[index].mfa|object|||
|data[index].mfa.enabled|boolean|||
|data[index].mfa.phone|string|An E.164 formatted phone number|+12345678901|
|data[index].mfa.expirationInMinutes|integer|||
|data[index].loginTimestamp|string|||
|data[index].credentialType|string| Values:PASSWORD,OTP||
|data[index].userIdPs|array|||
|metadata|object|||
|metadata.sort|array|Sort that was passed in the request||
|metadata.sort[index]|array|Sort that was passed in the request||
|metadata.sort[index].prop|string|The property name for the sort||
|metadata.sort[index].order|string|The direction of sort. Default DESC Values:ASC,DESC|ASC|
|metadata.filter|object|The filter that was passed in the request||
|metadata.page|object|||
|metadata.page.totalResults|integer|The total number of items that match the query|145|
|metadata.page.page|integer|Page number|3|
|metadata.page.limit|integer|Number of items per page|100|
|metadata.freeTextSearch|string|Free text search strings that was passed in the request|cat dog|
 */ SearchResponseUserResponse;
export type UmssearchApiArg = {
  /** Search request parameters: filter, sort and page */
  searchRequest?: string;
};
export type UmsdeleteApiResponse = /** status 204 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
 */ void;
export type UmsdeleteApiArg = {
  /** User ID that needs to be deleted */
  id: string;
};
export type GetUserApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|username|string|user's username. If the credential type is OTP, should be a valid phone (An E.164 formatted phone number e.g +12345678901)||
|id|string|||
|ownerOrganizationId|string|||
|groups|array|||
|groups[index]|array|||
|groups[index].id|string|||
|groups[index].name|string|||
|locked|boolean|||
|active|boolean|||
|mfa|object|||
|mfa.enabled|boolean|||
|mfa.phone|string|An E.164 formatted phone number|+12345678901|
|mfa.expirationInMinutes|integer|||
|loginTimestamp|string|||
|credentialType|string| Values:PASSWORD,OTP||
|userIdPs|array|||
 */ UmsUserResponse;
export type GetUserApiArg = {
  /** User ID that needs to be fetched */
  id: string;
};
export type UpdateUserApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|username|string|user's username. If the credential type is OTP, should be a valid phone (An E.164 formatted phone number e.g +12345678901)||
|id|string|||
|ownerOrganizationId|string|||
|groups|array|||
|groups[index]|array|||
|groups[index].id|string|||
|groups[index].name|string|||
|locked|boolean|||
|active|boolean|||
|mfa|object|||
|mfa.enabled|boolean|||
|mfa.phone|string|An E.164 formatted phone number|+12345678901|
|mfa.expirationInMinutes|integer|||
|loginTimestamp|string|||
|credentialType|string| Values:PASSWORD,OTP||
|userIdPs|array|||
 */ UmsUserResponse;
export type UpdateUserApiArg = {
  /** User ID that needs to be updated */
  id: string;
  updateUserRequest: UpdateUserRequest;
};
export type GenerateUserPasswordApiResponse = /** status 201 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|userId|string|||
|userPassword|string|||
 */ GenerateUserPasswordResponse;
export type GenerateUserPasswordApiArg = {
  /** User ID */
  id: string;
};
export type ValidateUserCredentialsApiResponse =
  /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|success|boolean|||
|message|string|||
|code|string|||
|passwordStrength|object|||
|passwordStrength.score|integer|The score of the password. minimum score of 0 and maximum score of 4. Higher number means stronger password||
|passwordStrength.suggestions|string|A possibly-empty list of suggestions to help choose a less guessable password. eg. 'Add another word or two'||
|passwordStrength.warningMessage|string|Explains what's wrong, eg. 'this is a top-10 common password'. not always set -- sometimes an empty string||
 */
  | ValidateUserCredentialsResponse
  | /** status 201 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|success|boolean|||
|message|string|||
|code|string|||
|passwordStrength|object|||
|passwordStrength.score|integer|The score of the password. minimum score of 0 and maximum score of 4. Higher number means stronger password||
|passwordStrength.suggestions|string|A possibly-empty list of suggestions to help choose a less guessable password. eg. 'Add another word or two'||
|passwordStrength.warningMessage|string|Explains what's wrong, eg. 'this is a top-10 common password'. not always set -- sometimes an empty string||
 */ ValidateUserCredentialsResponse;
export type ValidateUserCredentialsApiArg = {
  validateUserCredentialsRequest: ValidateUserCredentialsRequest;
};
export type LoginApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|userId|string|||
|ownerOrganizationId|string|||
|accessJwt|object|||
|accessJwt.token|string|||
|accessJwt.expiration|string|||
|refreshJwt|object|||
|refreshJwt.token|string|||
|refreshJwt.expiration|string|||
|mfaRequired|boolean|||
|mfaExpiration|string|||
|passwordResetRequired|boolean|||
|phone|string|||
 */ LoginResponse;
export type LoginApiArg = {
  loginRequestV2: LoginRequestV2;
};
export type MfaLoginApiResponse = /** status 200 SUCCESS */ LoginResponse;
export type MfaLoginApiArg = {
  mfaLoginRequestV2: MfaLoginRequestV2;
};
export type MfaResendApiResponse = /** status 200 SUCCESS */ ResendMfaResponse;
export type MfaResendApiArg = void;
export type LogoutApiResponse = /** status 200 SUCCESS */ void;
export type LogoutApiArg = {
  logoutRequest: LogoutRequest;
};
export type GenerateOtpApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|requestId|string|It should be used in the OTP login API along with the code sent to your phone|3fa85f64-5717-4562-b3fc-2c963f66afa6|
|phone|string|A masked phone number|******8901|
 */ GenerateOtpResponse;
export type GenerateOtpApiArg = {
  generateOtpRequest: GenerateOtpRequest;
};
export type OtpLoginApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|userId|string|||
|ownerOrganizationId|string|||
|accessJwt|object|||
|accessJwt.token|string|||
|accessJwt.expiration|string|||
|refreshJwt|object|||
|refreshJwt.token|string|||
|refreshJwt.expiration|string|||
|mfaRequired|boolean|||
|mfaExpiration|string|||
|passwordResetRequired|boolean|||
|phone|string|||
 */ LoginResponse;
export type OtpLoginApiArg = {
  otpLoginRequest: OtpLoginRequest;
};
export type SelfDeleteUserApiResponse = /** status 204 NO_CONTENT */ void;
export type SelfDeleteUserApiArg = void;
export type SelfGetUserApiResponse = /** status 200 SUCCESS */ UmsUserResponse;
export type SelfGetUserApiArg = void;
export type SelfUpdateUserApiResponse = /** status 200 SUCCESS */ UmsUserResponse;
export type SelfUpdateUserApiArg = {
  selfUpdateUserRequest: SelfUpdateUserRequest;
};
export type SelfRegisterUserApiResponse = /** status 201 CREATED */ UmsUserResponse;
export type SelfRegisterUserApiArg = {
  "Owner-Organization-Id"?: string;
  selfRegisterUserRequest: SelfRegisterUserRequest;
};
export type ForgotPasswordApiResponse = /** status 202 SUCCESS */ void;
export type ForgotPasswordApiArg = {
  forgotPasswordRequestV2: ForgotPasswordRequestV2;
};
export type TokenLoginApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|userId|string|||
|ownerOrganizationId|string|||
|accessJwt|object|||
|accessJwt.token|string|||
|accessJwt.expiration|string|||
|refreshJwt|object|||
|refreshJwt.token|string|||
|refreshJwt.expiration|string|||
|mfaRequired|boolean|||
|mfaExpiration|string|||
|passwordResetRequired|boolean|||
|phone|string|||
 */ LoginResponse;
export type TokenLoginApiArg = {
  loginWithTokenRequest: LoginWithTokenRequest;
};
export type RefreshTokenApiResponse = /** status 200 The below table describes the response parameters:

| Parameter   |Type   |Description          | Example   |
|-------------|-------|---------------------|-----------|
|userId|string|||
|ownerOrganizationId|string|||
|accessJwt|object|||
|accessJwt.token|string|||
|accessJwt.expiration|string|||
|refreshJwt|object|||
|refreshJwt.token|string|||
|refreshJwt.expiration|string|||
|mfaRequired|boolean|||
|mfaExpiration|string|||
|passwordResetRequired|boolean|||
|phone|string|||
 */ LoginResponse;
export type RefreshTokenApiArg = {
  refreshTokenRequest: RefreshTokenRequest;
};
export type VersionResponse = {
  version?: string;
  springVersion?: string;
  traceId?: string;
};
export type ErrorResponse = {
  code?: string;
  details?: {
    [key: string]: object;
  };
  environment?: string;
  message?: string;
  serviceName?: string;
  traceId?: string;
};
export type BasicReferencedEntityDataUuidId = {
  /** The caption of the referenced entity */
  name: string;
  /** A UUID formatted string */
  id: string;
  /** The id of the parent entity (appears only for child entities) */
  parentEntityId?: string;
  /** The id of a template that is configured in the settings service. */
  templateId: string;
  /** The name of the referenced entity template */
  templateName: string;
};
export type BasicReferencedUuidId = {
  /** A UUID formatted string */
  id: string;
};

export type BasicEntityData = {
  name: string;
  id: string;
  parentEntityId?: string;
};
export type ReferencedSideAttributeInformation = {
  /** The reference side attribute name from the attribute reference configuration */
  name: string;
  /** Attribute ID of the referencer */
  attributeId: string;
  /** Total count of all the referencers from this specific template and attribute */
  count: number;
  /** The reference side attribute display name from the attribute reference configuration */
  displayName: string;
  referrer: BasicEntityData;
  /** Template ID of the referencer */
  templateId: string;
};
export type ConnectionStatus = {
  /** If the device is connected to the MQTT the value is true, otherwise false */
  _connected?: boolean;
  /** The IP Address of the connected device */
  _ipAddress?: string;
  /** The last time that the device was connected */
  _lastConnectedTime?: string;
};
export type DeviceOperationalStatusResponse = {
  /** Operational status message */
  _message?: string;
  /** Operational status of the device */
  _status?: "OK" | "MINOR" | "MAJOR" | "CRITICAL";
};
export type DeviceStatus = {
  /** A UTC date in the ISO-8601 format */
  _bootTime?: string;
  _certificateStatus?: "NOT_INSTALLED" | "BOOTSTRAP" | "PERMANENT";
  _connection?: ConnectionStatus;
  _fwVersion?: string;
  _hwVersion?: string;
  _operational?: DeviceOperationalStatusResponse;
};
export type ParentTemplateResponse = {
  name?: string;
  displayName?: string;
  id?: string;
};
export type BasicTemplateData = {
  /** The name of the template */
  name?: string;
  /** The display name of the template */
  displayName?: string;
  /** The id of the template */
  id?: string;
  parentTemplate?: ParentTemplateResponse;
};
export type DeviceResponse = {
  /** The caption of the command instance */
  _caption: string;
  /** An object that holds the entity configuration attributes */
  _configuration?: {
    [key: string]: object;
  };
  /** A UTC date-time in the ISO-8601 format */
  _creationTime: string;
  /** Device description */
  _description?: string;
  /** The id of the device */
  _id: string;
  /** A UTC date-time in the ISO-8601 format */
  _lastModifiedTime: string;
  _ownerOrganization: BasicReferencedEntityDataUuidId;
  _patient?: BasicReferencedEntityDataUuidId;
  /** An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1) */
  _referencers?: {
    [key: string]: ReferencedSideAttributeInformation;
  };
  _registrationCode?: BasicReferencedEntityDataUuidId;
  _status?: DeviceStatus;
  _template?: BasicTemplateData;
  /** A java time zone supported by the java runtime environment */
  _timezone?: string;
};
export type AssignDeviceFacadeRequest = {
  /** The registration code entity that is attached to the device */
  deviceRegistrationCode: string;
};
export type Address = {
  /** An address */
  address1?: string;
  /** An address's specifics */
  address2?: string;
  /** A city */
  city?: string;
  /** A 2-letter country code defined in ISO-3166 */
  countryCode: string;
  /** A state */
  state?: string;
  /** A zipcode */
  zipCode?: string;
};
export type MfaDto = {
  /** MFA login enabled or disabled */
  enabled: boolean;
  /** MFA expiration time in minutes */
  expirationInMinutes?: number;
};
export type Name = {
  /** A person's first name */
  firstName: string;
  /** A person's last name */
  lastName: string;
};
export type PatientResponse = {
  /** An E.164 formatted phone number */
  _additionalPhone?: string;
  _address?: Address;
  /** Determine whether a patient has the ability to login to the system or not */
  _canLogin?: boolean;
  _caption?: string;
  _caregiver: BasicReferencedEntityDataUuidId;
  /** A UTC date-time in the ISO-8601 format */
  _creationTime: string;
  /** What type of credentials is used when logging in to the system. Default:PASSWORD */
  _credentialType?: "PASSWORD" | "OTP";
  /** A person's date of birth A UTC date in the ISO-8601 format */
  _dateOfBirth?: string;
  /** A description, can be up to 5000 characters long */
  _description?: string;
  /** An email address in the RFC-5322 specification */
  _email: string;
  /** Is the user enabled */
  _enabled?: "DISABLED" | "ENABLED";
  /** A persons gender */
  _gender?: "MALE" | "FEMALE" | "UNDISCLOSED";
  /** A UUID formatted string */
  _id: string;
  /** Has invitation been accepted */
  _invitationAccepted: boolean;
  /** A UTC date-time in the ISO-8601 format */
  _lastModifiedTime: string;
  /** A person's locale Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase. */
  _locale?: string;
  _mfa?: MfaDto;
  _name: Name;
  /** A person's national ID */
  _nationalId?: string;
  /** The patient nickname. Used for anonymous users. */
  _nickname?: string;
  _ownerOrganization: BasicReferencedEntityDataUuidId;
  /** A person's phone An E.164 formatted phone number */
  _phone?: string;
  /** An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1) */
  _referencers?: {
    [key: string]: ReferencedSideAttributeInformation;
  };
  /** The source of the registration. Possible values: INVITATION / SELF */
  _registrationSource?: string;
  _template?: BasicTemplateData;
  /** User's username. Can be an email or a regular username. With this username you login to the system. */
  _username?: string;
};
export type PatientSelfSignUpFacadeResponse = {
  device: DeviceResponse;
  patient: PatientResponse;
};
export type FacadeReferenceAttributeUuidIdRequest = {
  /** A UUID formatted string */
  id: string;
};
export type PatientSelfSignUpFacadeRequest = {
  /** An E.164 formatted phone number */
  _additionalPhone?: string;
  _address?: Address;
  _caregiver?: FacadeReferenceAttributeUuidIdRequest;
  /** What type of credentials is used when logging in to the system. Default:PASSWORD */
  _credentialType?: "PASSWORD" | "OTP";
  /** A person's date of birth A UTC date in the ISO-8601 format */
  _dateOfBirth?: string;
  /** A description, can be up to 5000 characters long */
  _description?: string;
  /** The registration code entity that is attached to the device */
  _deviceRegistrationCode?: string;
  /** An email address in the RFC-5322 specification */
  _email: string;
  /** A persons gender */
  _gender?: "MALE" | "FEMALE" | "UNDISCLOSED";
  /** A person's locale Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase. */
  _locale?: string;
  _mfa?: MfaDto;
  _name: Name;
  /** A person's national ID */
  _nationalId?: string;
  _ownerOrganization: FacadeReferenceAttributeUuidIdRequest;
  /** A password */
  _password: string;
  /** A person's phone An E.164 formatted phone number */
  _phone?: string;
  /** User's username. Can be an email or a regular username. With this username you login to the system. */
  _username: string;
};
export type PatientAnonymousSelfSignUpFacadeRequest = {
  /** The registration code entity that is attached to the device */
  _deviceRegistrationCode: string;
  /** The nickname of the user */
  _nickname?: string;
  /** A password */
  _password: string;
  /** User's username. Can be an email or a regular username. With this username you login to the system. */
  _username: string;
};
export type BasicReferencedEntityDataStringId = {
  /** The caption of the referenced entity */
  name: string;
  id: string;
  /** The id of the parent entity (appears only for child entities) */
  parentEntityId?: string;
  /** The id of a template that is configured in the settings service. */
  templateId: string;
  /** The name of the referenced entity template */
  templateName: string;
};
export type DeviceAlertResponse = {
  _caption?: string;
  /** Clear Date time of the alert */
  _clearDateTime?: string;
  /** Clear notes */
  _clearNotes?: string;
  /** The alert cleared trigger type */
  _clearTrigger: "MANUAL" | "AUTOMATIC";
  _clearedBy: BasicReferencedEntityDataUuidId;
  /** A UTC date-time in the ISO-8601 format */
  _creationTime: string;
  _device: BasicReferencedEntityDataStringId;
  /** The id of the alert instance */
  _id: string;
  /** A UTC date-time in the ISO-8601 format */
  _lastModifiedTime: string;
  /** The name of the alert */
  _name?: string;
  _ownerOrganization: BasicReferencedEntityDataUuidId;
  /** An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1) */
  _referencers?: {
    [key: string]: ReferencedSideAttributeInformation;
  };
  /** Set Date time of the alert */
  _setDateTime: string;
  /** The alert wanted severity */
  _severity?: "CRITICAL" | "MAJOR" | "MINOR" | "INFO";
  /** The alert wanted state */
  _state?: "ACTIVE" | "CLEARED" | "SUSPENDED";
  _template?: BasicTemplateData;
};
export type CreateAlertRequest = {
  /** Clear notes */
  _clearNotes?: string;
  /** The name of the alert */
  _name?: string;
  /** The alert wanted severity */
  _severity?: "CRITICAL" | "MAJOR" | "MINOR" | "INFO";
  /** The alert wanted state */
  _state?: "ACTIVE" | "CLEARED" | "SUSPENDED";
  /** The id of a template that is configured in the settings service. */
  _templateId: string;
};
export type UpdateAlertRequest = {
  /** Clear notes */
  _clearNotes?: string;
  /** The name of the alert */
  _name?: string;
  /** The alert wanted severity */
  _severity?: "CRITICAL" | "MAJOR" | "MINOR" | "INFO";
  /** The alert wanted state */
  _state?: "ACTIVE" | "CLEARED" | "SUSPENDED";
};
export type CreateAlertByTemplateNameRequest = {
  /** Clear notes */
  _clearNotes?: string;
  /** The name of the alert */
  _name?: string;
  /** The alert wanted severity */
  _severity?: "CRITICAL" | "MAJOR" | "MINOR" | "INFO";
  /** The alert wanted state */
  _state?: "ACTIVE" | "CLEARED" | "SUSPENDED";
};
export type CommandResponse = {
  _caption?: string;
  /** An object that holds the entity configuration attributes */
  _configuration?: {
    [key: string]: object;
  };
  /** A UTC date-time in the ISO-8601 format */
  _creationTime: string;
  _device: BasicReferencedEntityDataStringId;
  /** A UTC date-time in the ISO-8601 format */
  _endTime?: string;
  /** Error message */
  _errorMessage?: string;
  /** A UUID formatted string */
  _id: string;
  /** A UTC date-time in the ISO-8601 format */
  _lastModifiedTime: string;
  /** The name of the command */
  _name?: string;
  _ownerOrganization: BasicReferencedEntityDataUuidId;
  /** An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1) */
  _referencers?: {
    [key: string]: ReferencedSideAttributeInformation;
  };
  /** A UTC date-time in the ISO-8601 format */
  _startTime: string;
  /** The Action state */
  _state: "STARTING" | "IN_PROGRESS" | "COMPLETED" | "FAILED" | "TIMEOUT" | "STOPPING" | "ABORTED";
  _status?: {
    [key: string]: object;
  };
  _summary?: {
    [key: string]: object;
  };
  /** Is the template support stop command */
  _supportStop: boolean;
  _template?: BasicTemplateData;
  /** The timeout of the command in seconds */
  _timeoutInSeconds: number;
};
export type StartCommandByTemplateNameRequest = {
  /** An object that holds the entity configuration attributes */
  _configuration?: {
    [key: string]: object;
  };
  /** The name of the command */
  _name?: string;
};
export type StartCommandRequest = {
  /** An object that holds the entity configuration attributes */
  _configuration?: {
    [key: string]: object;
  };
  /** The name of the command */
  _name?: string;
  /** The id of a template that is configured in the settings service. */
  _templateId: string;
};
export type SessionSummary = {
  /** The reason the session was stopped */
  _stopReason?: string;
  /** The code of the stop reason */
  _stopReasonCode?: "COMPLETION" | "GENERAL_DEVICE_ERROR" | "TIMEOUT";
};
export type SessionResponseV2 = {
  _caption?: string;
  /** An object that holds the entity configuration attributes */
  _configuration?: {
    [key: string]: object;
  };
  /** A UTC date-time in the ISO-8601 format */
  _creationTime: string;
  _device: BasicReferencedEntityDataStringId;
  /** A UTC date-time in the ISO-8601 format */
  _endTime?: string;
  /** Session ID */
  _id: string;
  /** What API initiated the session */
  _initiator: "REMOTE_CONTROL" | "EXTERNAL";
  /** A UTC date-time in the ISO-8601 format */
  _lastModifiedTime: string;
  /** The name of the session */
  _name?: string;
  _ownerOrganization: BasicReferencedEntityDataUuidId;
  _patient: BasicReferencedEntityDataUuidId;
  /** An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1) */
  _referencers?: {
    [key: string]: ReferencedSideAttributeInformation;
  };
  /** The interval between measurements in milliseconds */
  _requiredMeasurementIntervalMilliseconds: number;
  /** The context that is linked to the current session and should be sent in a measurement message */
  _sessionContext?: string;
  /** A UTC date-time in the ISO-8601 format */
  _startTime: string;
  /** The Sessions state */
  _state: "ACTIVE" | "DONE" | "PAUSED" | "ACTIVATING" | "PAUSING" | "RESUMING" | "STOPPING";
  _summary: SessionSummary;
  _template?: BasicTemplateData;
};
export type ReferenceAttributeUuidIdRequest = {
  /** A UUID formatted string */
  id: string;
};
export type CreateSessionRequestV2 = {
  /** An object that holds the entity configuration attributes */
  _configuration?: {
    [key: string]: object;
  };
  /** A UTC date-time in the ISO-8601 format */
  _endTime?: string;
  /** The name of the session */
  _name?: string;
  _patient?: ReferenceAttributeUuidIdRequest;
  /** A UTC date-time in the ISO-8601 format */
  _startTime: string;
  /** The Sessions state */
  _state: "ACTIVE" | "DONE" | "PAUSED" | "ACTIVATING" | "PAUSING" | "RESUMING" | "STOPPING";
  _summary?: SessionSummary;
  /** The id of a template that is configured in the settings service. */
  _templateId: string;
};
export type SessionSummaryUpdateRequest = {
  /** The reason the session was stopped */
  _stopReason?: string;
  /** The code of the stop reason */
  _stopReasonCode?: "COMPLETION" | "GENERAL_DEVICE_ERROR" | "TIMEOUT";
};
export type UpdateSessionRequestV2 = {
  /** An object that holds the entity configuration attributes */
  _configuration?: {
    [key: string]: object;
  };
  /** A UTC date-time in the ISO-8601 format */
  _endTime?: string;
  /** The name of the session */
  _name?: string;
  /** A UTC date-time in the ISO-8601 format */
  _startTime?: string;
  /** The Sessions state */
  _state?: "ACTIVE" | "DONE" | "PAUSED" | "ACTIVATING" | "PAUSING" | "RESUMING" | "STOPPING";
  _summary?: SessionSummaryUpdateRequest;
};
export type StartSessionRequestV2 = {
  /** An object that holds the entity configuration attributes */
  _configuration?: {
    [key: string]: object;
  };
  /** The name of the session */
  _name?: string;
  _patient?: ReferenceAttributeUuidIdRequest;
  /** The id of a template that is configured in the settings service. */
  _templateId: string;
};
export type CreateSessionByUsageTypeRequestV2 = {
  /** An object that holds the entity configuration attributes */
  _configuration?: {
    [key: string]: object;
  };
  /** A UTC date-time in the ISO-8601 format */
  _endTime?: string;
  /** The name of the session */
  _name?: string;
  _patient?: ReferenceAttributeUuidIdRequest;
  /** A UTC date-time in the ISO-8601 format */
  _startTime: string;
  /** The Sessions state */
  _state: "ACTIVE" | "DONE" | "PAUSED" | "ACTIVATING" | "PAUSING" | "RESUMING" | "STOPPING";
  _summary?: SessionSummary;
};
export type FilterV2 = {
  /** Value for the EQUAL (=) operator, string, numeric, boolean or object */
  eq?: object;
  /** Used for complex logic with filters. Must be supplied only when using with map keys $OR, $AND, $NOT */
  filter?: {
    [key: string]: FilterV2;
  };
  /** Value for the DATE RANGE FROM operator, date value only,A UTC date in the ISO-8601 format */
  from?: string;
  /** Value for the GREATER THAN operator (>), numeric value only */
  gt?: number;
  /** Value for the GREATER THAN OR EQUAL operator (>=), numeric value only */
  gte?: number;
  /** List of values for the IN operator */
  in?: string[];
  /** If set to true, checks if the field's value is not null */
  isNotNull?: boolean;
  /** If set to true, checks if the field's value is null */
  isNull?: boolean;
  /** Value for the CONTAINS operator (substring), string value only */
  like?: string;
  /** Value for the LESS THAN (<) operator, numeric value only */
  lt?: number;
  /** Value for the LESS THAN OR EQUAL operator (<=), numeric value only */
  lte?: number;
  /** Value for the NOT EQUAL (!=) operator, string, numeric, boolean or object */
  not?: object;
  /** List of values for the NOT IN operator */
  notIn?: string[];
  /** Value for the DATE RANGE TO operator, date value only,A UTC date in the ISO-8601 format */
  to?: string;
};
export type PageMetadata = {
  /** Number of items per page */
  limit?: number;
  /** Page number */
  page?: number;
  /** The total number of items that match the query */
  totalResults?: number;
};
export type Order = {
  /** The direction of sort. Default DESC */
  order?: "ASC" | "DESC";
  /** The property name for the sort */
  prop: string;
};
export type Metadata = {
  /** The filter that was passed in the request */
  filter?: {
    [key: string]: FilterV2;
  };
  /** Free text search strings that was passed in the request */
  freeTextSearch?: string;
  page?: PageMetadata;
  /** Sort that was passed in the request */
  sort?: Order[];
};
export type SearchResponseDeviceAlertResponse = {
  /** List of items that match the search request */
  data: DeviceAlertResponse[];
  metadata: Metadata;
};
export type SearchResponseCommandResponse = {
  /** List of items that match the search request */
  data: CommandResponse[];
  metadata: Metadata;
};
export type DeviceOwnedAlertResponse = {
  _alerts: DeviceAlertResponse[];
  _device: DeviceResponse;
};
export type SearchResponseDeviceOwnedAlertResponse = {
  /** List of items that match the search request */
  data: DeviceOwnedAlertResponse[];
  metadata: Metadata;
};
export type DeviceSessionsResponseV2 = {
  _device: DeviceResponse;
  _sessions: SessionResponseV2[];
};
export type SearchResponseDeviceSessionsResponseV2 = {
  /** List of items that match the search request */
  data: DeviceSessionsResponseV2[];
  metadata: Metadata;
};
export type SearchResponseSessionResponseV2 = {
  /** List of items that match the search request */
  data: SessionResponseV2[];
  metadata: Metadata;
};
export type DeleteOrphanSessionsResponse = {
  deletedSessions: SessionResponseV2[];
};
export type EndpointResponse = {
  endpoint?: string;
};
export type TokenOperationResponse = {
  operationData?: {
    [key: string]: object;
  };
};
export type Credentials = {
  accessKeyId?: string;
  expiration?: string;
  secretAccessKey?: string;
  sessionToken?: string;
};
export type TempCredentialsForOrganizationClientResponse = {
  credentials?: Credentials;
  endpoint?: string;
  region?: string;
  topic?: string;
};
export type SearchResponseDeviceResponse = {
  /** List of items that match the search request */
  data: DeviceResponse[];
  metadata: Metadata;
};
export type RegisterDeviceRequest = {
  /** An object that holds the entity configuration attributes */
  _configuration?: {
    [key: string]: object;
  };
  /** Device description */
  _description?: string;
  _id: string;
  _ownerOrganization?: ReferenceAttributeUuidIdRequest;
  _patient?: ReferenceAttributeUuidIdRequest;
  _registrationCode?: ReferenceAttributeUuidIdRequest;
  /** The id of a template that is configured in the settings service. */
  _templateId: string;
  /** A java time zone supported by the java runtime environment */
  _timezone?: string;
};
export type UpdateDeviceRequest = {
  /** An object that holds the entity configuration attributes */
  _configuration?: {
    [key: string]: object;
  };
  /** Device description */
  _description?: string;
  _ownerOrganization?: ReferenceAttributeUuidIdRequest;
  _patient?: ReferenceAttributeUuidIdRequest;
  _registrationCode?: ReferenceAttributeUuidIdRequest;
  /** A java time zone supported by the java runtime environment */
  _timezone?: string;
};
export type GenerateCertificateResponse = {
  /** MQTT credentials - CA Root certificate */
  caCertificate?: string;
  /** MQTT credentials - certificate */
  certificate?: string;
  /** The ID of the certificate */
  certificateId?: string;
  /** MQTT client ID */
  connectionClientId?: string;
  /** MQTT endpoint */
  endPointUrl?: string;
  /** MQTT credentials -  private key */
  privateKey?: string;
};
export type TopicInfo = {
  actionEnum?: "STATUS" | "MEASUREMENT" | "TOKEN";
  fromDevice?: string;
  toDevice?: string;
};
export type DeviceInfo = {
  connectionClientId?: string;
  topicInfoList?: TopicInfo[];
};
export type TempCredentialsForDeviceResponse = {
  connectionClientId?: string;
  credentials?: Credentials;
  endpoint?: string;
  region?: string;
};
export type RegisterDeviceByTemplateNameRequest = {
  /** An object that holds the entity configuration attributes */
  _configuration?: {
    [key: string]: object;
  };
  /** Device description */
  _description?: string;
  _id: string;
  _ownerOrganization?: ReferenceAttributeUuidIdRequest;
  _patient?: ReferenceAttributeUuidIdRequest;
  _registrationCode?: ReferenceAttributeUuidIdRequest;
  /** A java time zone supported by the java runtime environment */
  _timezone?: string;
};
export type InterceptionResponse = {
  type: "PRE_REQUEST" | "POST_REQUEST" | "ADAPT_ENTITY";
  /** Should only be provided if type=PRE_REQUEST or type=POST_REQUEST */
  apiId: string;
  /** A UTC date-time in the ISO-8601 format */
  creationTime: string;
  endpoint: string;
  /** Should only be provided if type=ADAPT_ENTITY */
  entityName: string;
  executionOrder: number;
  /** A UUID formatted string */
  id: string;
  /** A UTC date-time in the ISO-8601 format */
  lastModifiedTime: string;
};
export type SearchResponseInterceptionResponse = {
  /** List of items that match the search request */
  data: InterceptionResponse[];
  metadata: Metadata;
};
export type CreateInterceptionRequest = {
  type: "PRE_REQUEST" | "POST_REQUEST" | "ADAPT_ENTITY";
  /** Should only be provided if type=PRE_REQUEST or type=POST_REQUEST */
  apiId: string;
  endpoint: string;
  /** Should only be provided if type=ADAPT_ENTITY */
  entityName: string;
  /** If not provided, the default value will be taken from the environment variable: EXECUTIONORDER_DEFAULT.
    Subscription with the same executionOrder cannot exist simultaneously.
    If an interception is created or updated to have the same executionOrder as an existing interception (including existing ones with default executionOrder),
    It will be set with that executionOrder and the existing interception's executionOrder will be incremented.
    If that interception's new executionOrder clashes with another the other one will be incremented as well, and so forth. */
  executionOrder?: number;
};
export type DeleteInterceptionRequest = {
  type: "PRE_REQUEST" | "POST_REQUEST" | "ADAPT_ENTITY";
  /** Should only be provided if type=PRE_REQUEST or type=POST_REQUEST */
  apiId: string;
  endpoint: string;
  /** Should only be provided if type=ADAPT_ENTITY */
  entityName: string;
};
export type SubscribeResponse = {
  actionName:
    | "_create"
    | "_update"
    | "_delete"
    | "_list"
    | "_command"
    | "_generateCertificate"
    | "_activateCertificate"
    | "_revokeCertificate"
    | "_operate"
    | "_read"
    | "_start"
    | "_stop"
    | "_remoteStart"
    | "_remoteStop"
    | "_remoteResume"
    | "_remotePause"
    | "_updateAdmin"
    | "_updateEnabledState"
    | "_login"
    | "_logout"
    | "_clear"
    | "_manage"
    | "_assign"
    | "_saveMeasurement"
    | "_monitor"
    | "_view"
    | "_saveMeasurementBulk"
    | "_incomingSms";
  endpoint: string;
  entityTypeName:
    | "device"
    | "organization"
    | "organization-user"
    | "caregiver"
    | "patient"
    | "usage-session"
    | "generic-entity"
    | "command"
    | "device-alert"
    | "patient-alert"
    | "registration-code";
  id?: string;
};
export type SearchResponseSubscribeResponse = {
  /** List of items that match the search request */
  data: SubscribeResponse[];
  metadata: Metadata;
};
export type SubscribeRequest = {
  actionName:
    | "_create"
    | "_update"
    | "_delete"
    | "_list"
    | "_command"
    | "_generateCertificate"
    | "_activateCertificate"
    | "_revokeCertificate"
    | "_operate"
    | "_read"
    | "_start"
    | "_stop"
    | "_remoteStart"
    | "_remoteStop"
    | "_remoteResume"
    | "_remotePause"
    | "_updateAdmin"
    | "_updateEnabledState"
    | "_login"
    | "_logout"
    | "_clear"
    | "_manage"
    | "_assign"
    | "_saveMeasurement"
    | "_monitor"
    | "_view"
    | "_saveMeasurementBulk"
    | "_incomingSms";
  endpoint: string;
  entityTypeName:
    | "device"
    | "organization"
    | "organization-user"
    | "caregiver"
    | "patient"
    | "usage-session"
    | "generic-entity"
    | "command"
    | "device-alert"
    | "patient-alert"
    | "registration-code";
};
export type UnsubscribeRequest = {
  actionName:
    | "_create"
    | "_update"
    | "_delete"
    | "_list"
    | "_command"
    | "_generateCertificate"
    | "_activateCertificate"
    | "_revokeCertificate"
    | "_operate"
    | "_read"
    | "_start"
    | "_stop"
    | "_remoteStart"
    | "_remoteStop"
    | "_remoteResume"
    | "_remotePause"
    | "_updateAdmin"
    | "_updateEnabledState"
    | "_login"
    | "_logout"
    | "_clear"
    | "_manage"
    | "_assign"
    | "_saveMeasurement"
    | "_monitor"
    | "_view"
    | "_saveMeasurementBulk"
    | "_incomingSms";
  endpoint: string;
  entityTypeName:
    | "device"
    | "organization"
    | "organization-user"
    | "caregiver"
    | "patient"
    | "usage-session"
    | "generic-entity"
    | "command"
    | "device-alert"
    | "patient-alert"
    | "registration-code";
};
export type AnalyticsDbConnectionDetailsResponse = {
  databaseName?: string;
  host?: string;
  password?: string;
  port?: number;
  searchPath?: string;
  userId?: string;
  username?: string;
};
export type AnalyticsDbInformationResponse = {
  /** The activation state of the analytics DB */
  activationState?:
    | "INACTIVE"
    | "INITIALIZING"
    | "STOPPING_INITIALIZATION"
    | "ACTIVE_AND_SYNC_ON"
    | "ACTIVE_AND_SYNC_OFF";
  /** A UTC date-time in the ISO-8601 format */
  creationTime: string;
  /** The deployment state of the analytics DB */
  deploymentState?: "NOT_DEPLOYED" | "DEPLOYED";
  /** A UTC date-time in the ISO-8601 format */
  lastModifiedTime: string;
};
export type ReportLocations = object;
export type ReportFileOutput = {
  /** An object that holds for each data type exported, A list containing the paths to it's files */
  filesLocation?: {
    [key: string]: ReportLocations;
  };
  /** A UTC date-time in the ISO-8601 format */
  urlExpirationTime: string;
};
export type ReportOutputMetadata = {
  /** The format in which to export the report */
  exportFormat: "JSON" | "CSV";
  /** The maximum size (in bytes) that each output file should not exceed */
  maxFileSizeInBytes?: number;
};
export type ReportQuery = {
  /** Data Type to be exported. */
  dataType:
    | "device"
    | "device-alert"
    | "usage-session"
    | "command"
    | "organization"
    | "patient"
    | "organization-user"
    | "caregiver"
    | "patient-alert"
    | "generic-entity"
    | "measurements"
    | "registration-code";
  /** Each additionalProp can filter one field, inside additionalProp there are many optional conditions that can be used for filtering that field. When multiple conditions are specified, they are bundled together using logical AND operators, this means that only the items that match all filter conditions for that field will be returned */
  filter?: {
    [key: string]: FilterV2;
  };
  /** Results can be sorted by multiple fields, the order of the fields in the sort request governs the hierarchy of the sort.The first field is the primary sort, the second is used when two values of the first field are the same, and so forth */
  sort?: Order[];
};
export type ReportInitiatorResponse = {
  /** The owner organization ID of the initiator of the report */
  ownerOrganizationId?: string;
  /** The template ID of the initiator of the report */
  templateId?: string;
  /** The entity type of the initiator of the report */
  userEntityType?: string;
  /** The user ID of the initiator of the report */
  userId?: string;
};
export type ReportResponse = {
  /** Name of the report */
  name?: string;
  /** URL endpoint to call when export process is finished */
  callbackEndpoint?: string;
  creationTime: string;
  errorMessage?: string;
  fileOutput?: ReportFileOutput;
  /** A UUID formatted string */
  id: string;
  lastModifiedTime: string;
  outputMetadata: ReportOutputMetadata;
  /** A list that containing queries (filter) on the wanted data export. Supported filters: [_lastModifiedTime, _creationTime, _templateId]. Supported sorts: [_creationTime] */
  queries?: ReportQuery[];
  reportInitiator?: ReportInitiatorResponse;
  /** The report current status */
  status: "IN_PROGRESS" | "COMPLETED" | "FAILED" | "CANCELING" | "CANCELED";
};
export type SearchResponseReportResponse = {
  /** List of items that match the search request */
  data: ReportResponse[];
  metadata: Metadata;
};
export type CreateReportRequest = {
  /** Name of the report */
  name?: string;
  /** URL endpoint to call when export process is finished */
  callbackEndpoint?: string;
  outputMetadata: ReportOutputMetadata;
  /** A list that containing queries (filter) on the wanted data export. Supported filters: [_lastModifiedTime, _creationTime, _templateId]. Supported sorts: [_creationTime] */
  queries?: ReportQuery[];
};
export type DownloadFileUrlResponse = {
  name: string;
  id?: string;
  mimeType: string;
  signedUrl?: string;
};
export type UploadFileUrlResponse = {
  name: string;
  id?: string;
  mimeType: string;
  signedUrl?: string;
};
export type UploadFileUrlRequest = {
  name: string;
  mimeType: string;
};
export type MultiplePartSignedUrl = {
  /** The expiration time for this URL, after which it is unusable. It is possible to request a new URL. A UTC date-time in the ISO-8601 format */
  expirationTime: string;
  /** The part number for this URL */
  partNumber: number;
  /** The URL for which to send a PUT request with the file data as a binary stream, for the file part specified in partNumber */
  signedUrl: string;
};
export type MultiplePartUploadFileUrlResponse = {
  name: string;
  /** A UUID formatted string */
  id: string;
  mimeType: string;
  /** The total number of parts currently requested for this multiple part file upload. More can be requested */
  parts: number;
  signedUrls: MultiplePartSignedUrl[];
};
export type MultiplePartUploadFileUrlRequest = {
  name: string;
  mimeType: string;
  /** For how many parts to initially generate links, not all must be used and more can be generated later */
  parts: number;
};
export type MultiplePartUploadFileGenerateSignedUrlsRequest = {
  /** The part number to generate from, inclusive */
  fromPart: number;
  /** The part number to generate to, inclusive */
  toPart: number;
};
export type MultiplePartFileUploadPart = {
  etag?: string;
  /** The part number for which to save the eTag */
  partNumber: number;
};
export type MultiplePartUploadFileSaveETagRequest = {
  parts: MultiplePartFileUploadPart[];
};
export type CompleteMultiplePartUploadFileRequest = {
  parts: MultiplePartFileUploadPart[];
};
export type GenericEntityResponse = {
  _caption: string;
  /** A UTC date-time in the ISO-8601 format */
  _creationTime: string;
  _id: string;
  /** A UTC date-time in the ISO-8601 format */
  _lastModifiedTime: string;
  _name: string;
  _ownerOrganization: BasicReferencedEntityDataUuidId;
  /** An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1) */
  _referencers?: {
    [key: string]: ReferencedSideAttributeInformation;
  };
  _template?: BasicTemplateData;
};
export type SearchResponseGenericEntityResponse = {
  /** List of items that match the search request */
  data: GenericEntityResponse[];
  metadata: Metadata;
};
export type GenericEntityReferenceAttributeUuidIdRequest = {
  /** A UUID formatted string */
  id: string;
};
export type CreateGenericEntityRequest = {
  _name: string;
  _ownerOrganization: GenericEntityReferenceAttributeUuidIdRequest;
  /** The id of a template that is configured in the settings service. */
  _templateId: string;
};
export type UpdateGenericEntityRequest = {
  _name: string;
  _ownerOrganization?: GenericEntityReferenceAttributeUuidIdRequest;
};
export type CreateGenericEntityByTemplateNameRequest = {
  _name: string;
  _ownerOrganization: GenericEntityReferenceAttributeUuidIdRequest;
};
export type MeasurementDataSchemaExample = {
  measurement1?: object;
  measurement2?: object;
  measurement3?: object;
};
export type MeasurementFromDeviceMetadata = {
  /** The device id that sent the measurement */
  deviceId?: string;
  /** The patient id that the measurement belongs to */
  patientId?: string;
  /** The session id that the measurement belongs to */
  sessionId?: string;
  /** A UTC date-time in the ISO-8601 format */
  timestamp: string;
};
export type MeasurementMessageFromDevice = {
  data?: MeasurementDataSchemaExample;
  metadata?: MeasurementFromDeviceMetadata;
};
export type Measurement = {
  average?: number;
  standardDeviation?: number;
  timestamp?: string;
};
export type MeasurementSession = {
  measurements: Measurement[];
  sessionId: string;
};
export type MeasurementSource = {
  measurementSessions: MeasurementSession[];
  sourceEntityId: string;
};
export type MeasurementAttributes = {
  attributeName: string;
  sources: MeasurementSource[];
};
export type GetAggregatedMeasurementsResponse = {
  attributes: MeasurementAttributes[];
};
export type FailureData = {
  /** Describing the reason that a specific measurement failed to be written to the DB */
  description?: string;
  /** The name of the attribute that failed the measurement */
  attributeName?: string;
  /** The code of the exception that failed the measurement to be written to the DB */
  code?: string;
  /** Specifies if some data from the message was registered */
  entireMessageFailure?: "ENTIRE_MESSAGE_FAILURE" | "PARTIAL_MESSAGE_FAILURE" | "UNKNOWN";
};
export type FailedMeasurementMessageFromDevice = {
  data?: {
    [key: string]: object;
  };
  failureData?: FailureData[];
  metadata?: MeasurementFromDeviceMetadata;
};
export type MeasurementBulkMetadata = {
  /** The number of measurement failed to be written to the DB */
  numberOfMeasuresFailed?: number;
  /** The number of measurement successfully written to the DB */
  numberOfMeasuresSaved?: number;
};
export type MeasurementBulkResponse = {
  /** List of measurement sent by the user and failed to be written to the DB */
  failedMeasures?: FailedMeasurementMessageFromDevice[];
  metadata?: MeasurementBulkMetadata;
};
export type MeasurementBulkRequest = {
  /** List of measurement to be written to  the DB */
  measures?: MeasurementMessageFromDevice[];
};
export type RawMeasurement = {
  data: number[];
  frequency: number;
  numberOfSample: number;
  timestamp: string;
};
export type RawMeasurementSessions = {
  measurements: RawMeasurement[];
  sessionId: string;
};
export type MeasurementRawSource = {
  measurementSessions: RawMeasurementSessions[];
  sourceEntityId: string;
};
export type MeasurementRawAttributes = {
  attributeName: string;
  sources: MeasurementRawSource[];
};
export type GetRawMeasurementsResponse = {
  attributes: MeasurementRawAttributes[];
};
export type MeasurementAggregationData = {
  average?: number;
  standardDeviation?: number;
};
export type TimestampRange = {
  from?: string;
  to?: string;
};
export type MeasurementsAggregationDataV2 = {
  data?: {
    [key: string]: MeasurementAggregationData;
  };
  exampleMeasure1?: MeasurementAggregationData;
  exampleMeasure2?: MeasurementAggregationData;
  exampleMeasure3?: MeasurementAggregationData;
  timestamp?: TimestampRange;
};
export type MetadataTokenBased = {
  /** The filter that was passed in the request */
  filter?: {
    [key: string]: FilterV2;
  };
  /** Limit of items */
  limitPerPage?: number;
  /** Next token that should be supplied when requesting a new page, empty of there are no next page */
  nextToken?: string;
  /** Sort that was passed in the request */
  sort?: Order[];
};
export type SearchResponseTokenBasedMeasurementsAggregationDataV2 = {
  /** List of items that match the search request */
  data: MeasurementsAggregationDataV2[];
  metadata?: MetadataTokenBased;
};
export type RawMeasurementV2 = {
  data?: {
    [key: string]: object;
  };
  patientId?: string;
  sessionId?: string;
  sourceEntityId?: string;
  timestamp?: string;
};
export type SearchResponseTokenBasedRawMeasurementV2 = {
  /** List of items that match the search request */
  data: RawMeasurementV2[];
  metadata?: MetadataTokenBased;
};
export type AddAttachmentResponse = {
  key?: string;
};
export type ConfigurationResponse = {
  emailSenderAddress: string;
  emailSenderDisplayName: string;
};
export type ConfigurationRequest = {
  emailSenderAddress: string;
  emailSenderDisplayName: string;
};
export type SmsProviderConfigurationResponse = {
  configured?: boolean;
};
export type EmailTemplate = {
  components?: EmailTemplate[];
  markingFields?: {
    [key: string]: string;
  };
  templateId?: string;
};
export type EmailRequest = {
  addressesBCC?: string[];
  addressesCC?: string[];
  addressesTo?: string[];
  attachmentsKeysAndNames?: {
    [key: string]: string;
  };
  emailTemplate?: EmailTemplate;
  locale?: string;
  subject?: string;
};
export type SendSmsResponse = {
  messageId?: string;
};
export type SendSmsRequest = {
  message: string;
  phoneNumber: string;
};
export type InvitationResponse = {
  /** A UTC date-time in the ISO-8601 format */
  creationTime?: string;
  /** A UTC date-time in the ISO-8601 format */
  lastModifiedTime?: string;
  /** A UUID formatted string */
  userId?: string;
};
export type DeleteLandingPageRequest = {
  /** A UUID formatted string */
  organizationId: string;
  /** The type of the user. Can be one of the following: [patient, caregiver, organization-user] */
  userType: string;
};
export type LandingPageResponse = {
  landingPageType?: "ACCEPT_INVITATION" | "FORGOT_PASSWORD";
  /** A UUID formatted string */
  organizationId: string;
  /** The landing page URL */
  url: string;
  /** The type of the user. Can be one of the following: [patient, caregiver, organization-user] */
  userType: string;
};
export type GetLandingPagesResponse = {
  type?: "ACCEPT_INVITATION" | "FORGOT_PASSWORD";
  pages?: LandingPageResponse[];
};
export type SetLandingPageRequest = {
  /** A UUID formatted string */
  organizationId: string;
  /** The landing page URL */
  url: string;
  /** The type of the user. Can be one of the following: [patient, caregiver, organization-user] */
  userType: string;
};
export type OrganizationResponse = {
  _caption?: string;
  /** A UTC date-time in the ISO-8601 format */
  _creationTime: string;
  /** A description, can be up to 5000 characters long */
  _description?: string;
  _headquarters?: Address;
  /** A UUID formatted string */
  _id: string;
  /** A UTC date-time in the ISO-8601 format */
  _lastModifiedTime: string;
  /** Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase. */
  _locale?: string;
  /** An organization's name */
  _name: string;
  _ownerOrganization: BasicReferencedEntityDataUuidId;
  /** An E.164 formatted phone number */
  _phone?: string;
  _primaryAdministrator: BasicReferencedEntityDataUuidId;
  /** An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1) */
  _referencers?: {
    [key: string]: ReferencedSideAttributeInformation;
  };
  _template?: BasicTemplateData;
  /** A java time zone supported by the java runtime environment */
  _timezone?: string;
};
export type SearchResponseOrganizationResponse = {
  /** List of items that match the search request */
  data: OrganizationResponse[];
  metadata: Metadata;
};
export type OrganizationAdminUserRequest = {
  _address?: Address;
  /** What type of credentials is used when logging in to the system. Only one type can be used. Default:PASSWORD */
  _credentialType?: "PASSWORD" | "OTP";
  /** A person's date of birth A UTC date in the ISO-8601 format */
  _dateOfBirth?: string;
  /** A description, can be up to 5000 characters long */
  _description?: string;
  /** An email address in the RFC-5322 specification */
  _email: string;
  _employeeId: string;
  /** A persons gender */
  _gender?: "MALE" | "FEMALE" | "UNDISCLOSED";
  /** A person's locale Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase. */
  _locale?: string;
  _mfa?: MfaDto;
  _name: Name;
  /** A person's phone An E.164 formatted phone number */
  _phone?: string;
};
export type CreateOrganizationRequest = {
  /** A description, can be up to 5000 characters long */
  _description?: string;
  _headquarters?: Address;
  /** Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase. */
  _locale?: string;
  /** An organization's name */
  _name: string;
  /** An E.164 formatted phone number */
  _phone?: string;
  _primaryAdministrator: OrganizationAdminUserRequest;
  /** The id of a template that is configured in the settings service. */
  _templateId: string;
  /** A java time zone supported by the java runtime environment */
  _timezone?: string;
};
export type AddressUpdateRequest = {
  /** An address */
  address1?: string;
  /** An address's specifics */
  address2?: string;
  /** A city */
  city?: string;
  /** A 2-letter country code defined in ISO-3166 */
  countryCode: string;
  /** A state */
  state?: string;
  /** A zipcode */
  zipCode?: string;
};
export type UpdateOrganizationRequest = {
  /** A description, can be up to 5000 characters long */
  _description?: string;
  _headquarters?: AddressUpdateRequest;
  /** Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase. */
  _locale?: string;
  /** An organization's name */
  _name?: string;
  /** An E.164 formatted phone number */
  _phone?: string;
  /** A java time zone supported by the java runtime environment */
  _timezone?: string;
};
export type CreateOrganizationByTemplateNameRequest = {
  /** A description, can be up to 5000 characters long */
  _description?: string;
  _headquarters?: Address;
  /** Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase. */
  _locale?: string;
  /** An organization's name */
  _name: string;
  /** An E.164 formatted phone number */
  _phone?: string;
  _primaryAdministrator: OrganizationAdminUserRequest;
  /** A java time zone supported by the java runtime environment */
  _timezone?: string;
};
export type RegistrationCodeResponse = {
  _caption?: string;
  _code: string;
  _creationTime: string;
  _id: string;
  _lastModifiedTime: string;
  _ownerOrganization: BasicReferencedEntityDataUuidId;
  /** An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1) */
  _referencers?: {
    [key: string]: ReferencedSideAttributeInformation;
  };
  _template?: BasicTemplateData;
};
export type SearchResponseRegistrationCodeResponse = {
  /** List of items that match the search request */
  data: RegistrationCodeResponse[];
  metadata: Metadata;
};
export type OrganizationReferenceAttributeUuidIdRequest = {
  /** A UUID formatted string */
  id: string;
};
export type CreateRegistrationCodeRequest = {
  /** The registration code entity that is attached to the device */
  _code: string;
  _ownerOrganization: OrganizationReferenceAttributeUuidIdRequest;
  /** The id of a template that is configured in the settings service. */
  _templateId: string;
};
export type UpdateRegistrationCodeRequest = {
  /** The registration code entity that is attached to the device */
  _code: string;
  _ownerOrganization: OrganizationReferenceAttributeUuidIdRequest;
};
export type CreateRegistrationCodeByTemplateNameRequest = {
  /** The registration code entity that is attached to the device */
  _code: string;
  _ownerOrganization: OrganizationReferenceAttributeUuidIdRequest;
};
export type CaregiverResponse = {
  _address?: Address;
  _caption?: string;
  /** A UTC date-time in the ISO-8601 format */
  _creationTime: string;
  /** What type of credentials is used when logging in to the system. Only one type can be used. Default:PASSWORD */
  _credentialType?: "PASSWORD" | "OTP";
  /** A person's date of birth A UTC date in the ISO-8601 format */
  _dateOfBirth?: string;
  /** An caregiver's name */
  _degree?:
    | "MEDICAL_DOCTOR"
    | "DOCTOR_OF_OSTEOPATHY"
    | "PHYSICIAN_ASSISTANT"
    | "REGISTERED_NURSE"
    | "CLINICAL_NURSE_SPECIALISTS"
    | "NURSE_PRACTITIONER"
    | "LICENSED_PRACTICAL_NURSE"
    | "MEDICAL_ASSISTANT"
    | "NO_DEGREE"
    | "OTHER";
  /** A description, can be up to 5000 characters long */
  _description?: string;
  /** An email address in the RFC-5322 specification */
  _email: string;
  _employeeId: string;
  /** Is the user enabled */
  _enabled?: "DISABLED" | "ENABLED";
  /** A persons gender */
  _gender?: "MALE" | "FEMALE" | "UNDISCLOSED";
  /** A UUID formatted string */
  _id: string;
  /** Has invitation been accepted */
  _invitationAccepted: boolean;
  /** A UTC date-time in the ISO-8601 format */
  _lastModifiedTime: string;
  /** A person's locale Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase. */
  _locale?: string;
  _mfa?: MfaDto;
  _name: Name;
  _ownerOrganization: BasicReferencedEntityDataUuidId;
  /** A person's phone An E.164 formatted phone number */
  _phone?: string;
  /** An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1) */
  _referencers?: {
    [key: string]: ReferencedSideAttributeInformation;
  };
  _template?: BasicTemplateData;
  role?: "user_manager" | "restricted_user" | "patient_viewer" | "patient_manager";
};
export type SearchResponseCaregiverResponse = {
  /** List of items that match the search request */
  data: CaregiverResponse[];
  metadata: Metadata;
};
export type CreateCaregiverRequest = {
  _address?: Address;
  /** What type of credentials is used when logging in to the system. Only one type can be used. Default:PASSWORD */
  _credentialType?: "PASSWORD" | "OTP";
  /** A person's date of birth A UTC date in the ISO-8601 format */
  _dateOfBirth?: string;
  /** An caregiver's name */
  _degree?:
    | "MEDICAL_DOCTOR"
    | "DOCTOR_OF_OSTEOPATHY"
    | "PHYSICIAN_ASSISTANT"
    | "REGISTERED_NURSE"
    | "CLINICAL_NURSE_SPECIALISTS"
    | "NURSE_PRACTITIONER"
    | "LICENSED_PRACTICAL_NURSE"
    | "MEDICAL_ASSISTANT"
    | "NO_DEGREE"
    | "OTHER";
  /** A description, can be up to 5000 characters long */
  _description?: string;
  /** An email address in the RFC-5322 specification */
  _email: string;
  _employeeId: string;
  /** A persons gender */
  _gender?: "MALE" | "FEMALE" | "UNDISCLOSED";
  /** A person's locale Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase. */
  _locale?: string;
  _mfa?: MfaDto;
  _name: Name;
  _ownerOrganization: OrganizationReferenceAttributeUuidIdRequest;
  /** A person's phone An E.164 formatted phone number */
  _phone?: string;
  /** The id of a template that is configured in the settings service. */
  _templateId: string;
};
export type MfaUpdateRequest = {
  /** Is mfa enabled in login */
  enabled: boolean;
  /** Mfa expiration in minutes */
  expirationInMinutes?: number;
};
export type NameUpdateRequest = {
  /** A person's first name */
  firstName: string;
  /** A person's last name */
  lastName: string;
};
export type UpdateCaregiverRequest = {
  _address?: AddressUpdateRequest;
  /** A UTC date in the ISO-8601 format */
  _dateOfBirth?: string;
  /** An caregiver's name */
  _degree?:
    | "MEDICAL_DOCTOR"
    | "DOCTOR_OF_OSTEOPATHY"
    | "PHYSICIAN_ASSISTANT"
    | "REGISTERED_NURSE"
    | "CLINICAL_NURSE_SPECIALISTS"
    | "NURSE_PRACTITIONER"
    | "LICENSED_PRACTICAL_NURSE"
    | "MEDICAL_ASSISTANT"
    | "NO_DEGREE"
    | "OTHER";
  /** A description, can be up to 5000 characters long */
  _description?: string;
  /** An email address in the RFC-5322 specification */
  _email?: string;
  _employeeId?: string;
  /** A persons gender */
  _gender?: "MALE" | "FEMALE" | "UNDISCLOSED";
  /** Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase. */
  _locale?: string;
  _mfa?: MfaUpdateRequest;
  _name?: NameUpdateRequest;
  _ownerOrganization?: OrganizationReferenceAttributeUuidIdRequest;
  /** An E.164 formatted phone number */
  _phone?: string;
};
export type CreateCaregiverByTemplateNameRequest = {
  _address?: Address;
  /** What type of credentials is used when logging in to the system. Only one type can be used. Default:PASSWORD */
  _credentialType?: "PASSWORD" | "OTP";
  /** A person's date of birth A UTC date in the ISO-8601 format */
  _dateOfBirth?: string;
  /** An caregiver's name */
  _degree?:
    | "MEDICAL_DOCTOR"
    | "DOCTOR_OF_OSTEOPATHY"
    | "PHYSICIAN_ASSISTANT"
    | "REGISTERED_NURSE"
    | "CLINICAL_NURSE_SPECIALISTS"
    | "NURSE_PRACTITIONER"
    | "LICENSED_PRACTICAL_NURSE"
    | "MEDICAL_ASSISTANT"
    | "NO_DEGREE"
    | "OTHER";
  /** A description, can be up to 5000 characters long */
  _description?: string;
  /** An email address in the RFC-5322 specification */
  _email: string;
  _employeeId: string;
  /** A persons gender */
  _gender?: "MALE" | "FEMALE" | "UNDISCLOSED";
  /** A person's locale Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase. */
  _locale?: string;
  _mfa?: MfaDto;
  _name: Name;
  _ownerOrganization: OrganizationReferenceAttributeUuidIdRequest;
  /** A person's phone An E.164 formatted phone number */
  _phone?: string;
};
export type OrganizationUserResponse = {
  _address?: Address;
  _caption?: string;
  /** A UTC date-time in the ISO-8601 format */
  _creationTime: string;
  /** What type of credentials is used when logging in to the system. Only one type can be used. Default:PASSWORD */
  _credentialType?: "PASSWORD" | "OTP";
  /** A person's date of birth A UTC date in the ISO-8601 format */
  _dateOfBirth?: string;
  /** A description, can be up to 5000 characters long */
  _description?: string;
  /** An email address in the RFC-5322 specification */
  _email: string;
  _employeeId: string;
  /** Is the user enabled */
  _enabled?: "DISABLED" | "ENABLED";
  /** A persons gender */
  _gender?: "MALE" | "FEMALE" | "UNDISCLOSED";
  /** A UUID formatted string */
  _id: string;
  /** Has invitation been accepted */
  _invitationAccepted: boolean;
  /** A UTC date-time in the ISO-8601 format */
  _lastModifiedTime: string;
  /** A person's locale Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase. */
  _locale?: string;
  _mfa?: MfaDto;
  _name: Name;
  _ownerOrganization: BasicReferencedEntityDataUuidId;
  /** A person's phone An E.164 formatted phone number */
  _phone?: string;
  /** An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1) */
  _referencers?: {
    [key: string]: ReferencedSideAttributeInformation;
  };
  _template?: BasicTemplateData;
};
export type SearchResponseOrganizationUserResponse = {
  /** List of items that match the search request */
  data: OrganizationUserResponse[];
  metadata: Metadata;
};
export type CreateOrganizationUserRequest = {
  _address?: Address;
  /** What type of credentials is used when logging in to the system. Only one type can be used. Default:PASSWORD */
  _credentialType?: "PASSWORD" | "OTP";
  /** A person's date of birth A UTC date in the ISO-8601 format */
  _dateOfBirth?: string;
  /** A description, can be up to 5000 characters long */
  _description?: string;
  /** An email address in the RFC-5322 specification */
  _email: string;
  _employeeId: string;
  /** A persons gender */
  _gender?: "MALE" | "FEMALE" | "UNDISCLOSED";
  /** A person's locale Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase. */
  _locale?: string;
  _mfa?: MfaDto;
  _name: Name;
  _ownerOrganization: OrganizationReferenceAttributeUuidIdRequest;
  /** A person's phone An E.164 formatted phone number */
  _phone?: string;
  /** The id of a template that is configured in the settings service. */
  _templateId: string;
};
export type UpdateOrganizationUserRequest = {
  _address?: AddressUpdateRequest;
  /** A UTC date in the ISO-8601 format */
  _dateOfBirth?: string;
  /** A description, can be up to 5000 characters long */
  _description?: string;
  /** An email address in the RFC-5322 specification */
  _email?: string;
  _employeeId?: string;
  /** A persons gender */
  _gender?: "MALE" | "FEMALE" | "UNDISCLOSED";
  /** Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase. */
  _locale?: string;
  _mfa?: MfaUpdateRequest;
  _name?: NameUpdateRequest;
  _ownerOrganization?: OrganizationReferenceAttributeUuidIdRequest;
  /** An E.164 formatted phone number */
  _phone?: string;
};
export type CreateOrganizationUserByTemplateNameRequest = {
  _address?: Address;
  /** What type of credentials is used when logging in to the system. Only one type can be used. Default:PASSWORD */
  _credentialType?: "PASSWORD" | "OTP";
  /** A person's date of birth A UTC date in the ISO-8601 format */
  _dateOfBirth?: string;
  /** A description, can be up to 5000 characters long */
  _description?: string;
  /** An email address in the RFC-5322 specification */
  _email: string;
  _employeeId: string;
  /** A persons gender */
  _gender?: "MALE" | "FEMALE" | "UNDISCLOSED";
  /** A person's locale Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase. */
  _locale?: string;
  _mfa?: MfaDto;
  _name: Name;
  _ownerOrganization: OrganizationReferenceAttributeUuidIdRequest;
  /** A person's phone An E.164 formatted phone number */
  _phone?: string;
};
export type OrganizationPatientResponse = {
  /** An E.164 formatted phone number */
  _additionalPhone?: string;
  _address?: Address;
  /** Determine whether a patient has the ability to login to the system or not */
  _canLogin?: boolean;
  _caption?: string;
  _caregiver: BasicReferencedEntityDataUuidId;
  /** A UTC date-time in the ISO-8601 format */
  _creationTime: string;
  /** What type of credentials is used when logging in to the system. Only one type can be used. Default:PASSWORD */
  _credentialType?: "PASSWORD" | "OTP";
  /** A person's date of birth A UTC date in the ISO-8601 format */
  _dateOfBirth?: string;
  /** A description, can be up to 5000 characters long */
  _description?: string;
  /** An email address in the RFC-5322 specification */
  _email: string;
  /** Is the user enabled */
  _enabled?: "DISABLED" | "ENABLED";
  /** A persons gender */
  _gender?: "MALE" | "FEMALE" | "UNDISCLOSED";
  /** A UUID formatted string */
  _id: string;
  /** Has invitation been accepted */
  _invitationAccepted: boolean;
  /** A UTC date-time in the ISO-8601 format */
  _lastModifiedTime: string;
  /** A person's locale Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase. */
  _locale?: string;
  _mfa?: MfaDto;
  _name: Name;
  /** A person's national ID */
  _nationalId?: string;
  /** The patient nickname. Used for anonymous users. */
  _nickname?: string;
  _ownerOrganization: BasicReferencedEntityDataUuidId;
  /** A person's phone An E.164 formatted phone number */
  _phone?: string;
  /** An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1) */
  _referencers?: {
    [key: string]: ReferencedSideAttributeInformation;
  };
  /** The source of the registration. Possible values: INVITATION / SELF */
  _registrationSource?: string;
  _template?: BasicTemplateData;
  /** User's username. Can be an email or a regular username. With this username you login to the system. */
  _username?: string;

  /** delivery_status */
  /* TODO: move these into a type guard */
  delivery_status?: "pending_device" | "withdraw" | "none";
  preferred_contact_method?: "phone" | "email";
  trained?: string;
  hospital_number?: string;
  entia_patient_id?: string;
  nhs_number?: string;
  oncologist?: string;
  enrollment_date?: string;
  enrolled_by?: Maybe<BasicReferencedEntityDataUuidId>;
  withdrawn_by?: Maybe<BasicReferencedEntityDataUuidId>;
  withdrawn_date?: string;
  sex: "male" | "female";
  phone_number?: string;
  additional_phone_number?: string;
};
export type SearchResponsePatientResponse = {
  /** List of items that match the search request */
  data: OrganizationPatientResponse[];
  metadata: Metadata;
};
export type CreatePatientRequest = {
  /** An E.164 formatted phone number */
  _additionalPhone?: string;
  _address?: Address;
  /** Determine whether a patient has the ability to login to the system or not */
  _canLogin?: boolean;
  _caregiver?: OrganizationReferenceAttributeUuidIdRequest;
  /** What type of credentials is used when logging in to the system. Only one type can be used. Default:PASSWORD */
  _credentialType?: "PASSWORD" | "OTP";
  /** A person's date of birth A UTC date in the ISO-8601 format */
  _dateOfBirth?: string;
  /** A description, can be up to 5000 characters long */
  _description?: string;
  /** An email address in the RFC-5322 specification */
  _email: string;
  /** A persons gender */
  _gender?: "MALE" | "FEMALE" | "UNDISCLOSED";
  /** A person's locale Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase. */
  _locale?: string;
  _mfa?: MfaDto;
  _name: Name;
  /** A person's national ID */
  _nationalId?: string;
  _ownerOrganization: OrganizationReferenceAttributeUuidIdRequest;
  /** A person's phone An E.164 formatted phone number */
  _phone?: string;
  /** The id of a template that is configured in the settings service. */
  _templateId: string;
};
export type UpdatePatientRequest = {
  /** An E.164 formatted phone number */
  _additionalPhone?: string;
  _address?: AddressUpdateRequest;
  /** Determine whether a patient has the ability to login to the system or not */
  _canLogin?: boolean;
  _caregiver?: OrganizationReferenceAttributeUuidIdRequest;
  /** A UTC date in the ISO-8601 format */
  _dateOfBirth?: string;
  /** A description, can be up to 5000 characters long */
  _description?: string;
  /** An email address in the RFC-5322 specification */
  _email?: string;
  /** A persons gender */
  _gender?: "MALE" | "FEMALE" | "UNDISCLOSED";
  /** Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase. */
  _locale?: string;
  _mfa?: MfaUpdateRequest;
  _name?: NameUpdateRequest;
  /** A person's national ID */
  _nationalId?: string;
  _ownerOrganization?: OrganizationReferenceAttributeUuidIdRequest;
  /** An E.164 formatted phone number */
  _phone?: string;
  /** delivery_status */
  /* TODO: move these into a type guard */
  // delivery_status?: "pending_device" | "withdraw" | "none";
  preferred_contact_method?: "phone" | "email";
  trained?: Maybe<string>;
  hospital_number?: string;
  entia_patient_id?: string;
  nhs_number?: string;
  oncologist?: string;
  enrollment_date?: Maybe<string>;
  enrolled_by?: Maybe<BasicReferencedUuidId>;
  withdrawn_by?: Maybe<BasicReferencedUuidId>;
  withdrawn_date?: Maybe<string>;
  sex?: "male" | "female";
};
export type PatientAlertResponse = {
  _caption?: string;
  /** Clear Date time of the alert */
  _clearDateTime?: string;
  /** Clear notes */
  _clearNotes?: string;
  /** The alert cleared trigger type */
  _clearTrigger: "MANUAL" | "AUTOMATIC";
  _clearedBy: BasicReferencedEntityDataUuidId;
  /** A UTC date-time in the ISO-8601 format */
  _creationTime: string;
  /** The id of the alert instance */
  _id: string;
  /** A UTC date-time in the ISO-8601 format */
  _lastModifiedTime: string;
  /** The name of the alert */
  _name?: string;
  _ownerOrganization: BasicReferencedEntityDataUuidId;
  _patient: BasicReferencedEntityDataUuidId;
  /** An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1) */
  _referencers?: {
    [key: string]: ReferencedSideAttributeInformation;
  };
  /** Set Date time of the alert */
  _setDateTime: string;
  /** The alert wanted severity */
  _severity?: "CRITICAL" | "MAJOR" | "MINOR" | "INFO";
  /** The alert wanted state */
  _state?: "ACTIVE" | "CLEARED" | "SUSPENDED";
  _template?: BasicTemplateData;
};
export type SearchResponsePatientAlertResponse = {
  /** List of items that match the search request */
  data: PatientAlertResponse[];
  metadata: Metadata;
};
export type PatientOwnedAlertResponse = {
  _alerts: PatientAlertResponse[];
  _patient: OrganizationPatientResponse;
};
export type SearchResponsePatientOwnedAlertResponse = {
  /** List of items that match the search request */
  data: PatientOwnedAlertResponse[];
  metadata: Metadata;
};
export type BasicOrganizationResponse = {
  _caption?: string;
  /** A UTC date-time in the ISO-8601 format */
  _creationTime?: string;
  /** A description, can be up to 5000 characters long */
  _description?: string;
  /** A UUID formatted string */
  _id?: string;
  /** A UTC date-time in the ISO-8601 format */
  _lastModifiedTime?: string;
  /** An organization's name */
  _name?: string;
};
export type SearchResponseBasicOrganizationResponse = {
  /** List of items that match the search request */
  data: BasicOrganizationResponse[];
  metadata: Metadata;
};
export type CreatePatientByTemplateNameRequest = {
  /** An E.164 formatted phone number */
  _additionalPhone?: string;
  _address?: Address;
  /** Determine whether a patient has the ability to login to the system or not */
  _canLogin?: boolean;
  _caregiver?: OrganizationReferenceAttributeUuidIdRequest;
  /** What type of credentials is used when logging in to the system. Only one type can be used. Default:PASSWORD */
  _credentialType?: "PASSWORD" | "OTP";
  /** A person's date of birth A UTC date in the ISO-8601 format */
  _dateOfBirth?: string;
  /** A description, can be up to 5000 characters long */
  _description?: string;
  /** An email address in the RFC-5322 specification */
  _email: string;
  /** A persons gender */
  _gender?: "MALE" | "FEMALE" | "UNDISCLOSED";
  /** A person's locale Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase. */
  _locale?: string;
  _mfa?: MfaDto;
  _name: Name;
  /** A person's national ID */
  _nationalId?: string;
  _ownerOrganization: OrganizationReferenceAttributeUuidIdRequest;
  /** A person's phone An E.164 formatted phone number */
  _phone?: string;
};
export type UserResponse = {
  _address?: Address;
  _caption?: string;
  /** A UTC date-time in the ISO-8601 format */
  _creationTime: string;
  _credentialType?: "PASSWORD" | "OTP";
  /** A person's date of birth A UTC date in the ISO-8601 format */
  _dateOfBirth?: string;
  /** A description, can be up to 5000 characters long */
  _description?: string;
  /** An email address in the RFC-5322 specification */
  _email: string;
  /** Is the user enabled */
  _enabled?: "DISABLED" | "ENABLED";
  /** A persons gender */
  _gender?: "MALE" | "FEMALE" | "UNDISCLOSED";
  /** A UUID formatted string */
  _id: string;
  /** Has invitation been accepted */
  _invitationAccepted: boolean;
  /** A UTC date-time in the ISO-8601 format */
  _lastModifiedTime: string;
  /** A person's locale Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase. */
  _locale?: string;
  _mfa?: MfaDto;
  _name: Name;
  _ownerOrganization: BasicReferencedEntityDataUuidId;
  /** A person's phone An E.164 formatted phone number */
  _phone?: string;
  /** An object that contains all the referencers of this entity. Each referencer is the RSAN and it's an object that contains the count of the referrers, and information of the referrer (in case count = 1) */
  _referencers?: {
    [key: string]: ReferencedSideAttributeInformation;
  };
  _template?: BasicTemplateData;
  /** The user type */
  _userType?: "organization-user" | "caregiver" | "patient";
  role?: "user_manager" | "restricted_user" | "patient_viewer" | "patient_manager";
};
export type SearchRequestV2 = {
  /** Each additionalProp can filter one field, inside additionalProp there are many optional conditions that can be used for filtering that field. When multiple conditions are specified, they are bundled together using logical AND operators, this means that only the items that match all filter conditions for that field will be returned */
  filter?: {
    [key: string]: FilterV2;
  };
  /** Free text search strings - will be bundled to the filters with the logical AND operator. Possible to pass a few strings with space between them, the search will return a result if one of strings appears in the data entity (OR operator). */
  freeTextSearch?: string;
  limit?: number;
  page?: number;
  /** Results can be sorted by multiple fields, the order of the fields in the sort request governs the hierarchy of the sort.The first field is the primary sort, the second is used when two values of the first field are the same, and so forth */
  sort?: Order[];
};
export type CodeSnippetResponse = {
  /** The name of the code snippet */
  name?: string;
  /** The description of the code snippet */
  description?: string;
  /** The actual code snippet */
  code: string;
  creationTime?: string;
  id?: string;
  /** The code language */
  language: "JAVASCRIPT";
  lastModifiedTime?: string;
};
export type SearchResponseCodeSnippetResponse = {
  /** List of items that match the search request */
  data: CodeSnippetResponse[];
  metadata: Metadata;
};
export type CreateCodeSnippetRequest = {
  /** The name of the code snippet */
  name?: string;
  /** The description of the code snippet */
  description?: string;
  /** The actual code snippet */
  code: string;
  /** The code language */
  language: "JAVASCRIPT";
};
export type ExportExecutionResponse = {
  name?: string;
  description?: string;
  creationTime?: string;
  errorMessage?: string;
  id?: string;
  lastModifiedTime?: string;
  status?: "IN_PROGRESS" | "FAILED" | "SUCCESS";
};
export type FileConfigurationMetadataResponse = {
  name?: string;
  description?: string;
  biotVersion?: string;
  creationTime?: string;
  environment?: string;
  id?: string;
};
export type ExportsMetadataResponse = {
  filesMetadata?: FileConfigurationMetadataResponse[];
};
export type StartExportConfigurationRequest = {
  name: string;
  description?: string;
};
export type ImportExecutionResponse = {
  name?: string;
  description?: string;
  creationTime?: string;
  errorMessage?: string;
  id?: string;
  importType?: "CLEAN_IMPORT";
  lastModifiedTime?: string;
  status?: "IN_PROGRESS" | "FAILED" | "SUCCESS";
};
export type StartImportConfigurationRequest = {
  exportId: string;
  importType: "CLEAN_IMPORT";
};
export type GetCategoryResponse = {
  name: string;
  allowedCategoriesToLinkTo?: string[];
  builtInSupportedTypes?: (
    | "LABEL"
    | "PARAGRAPH"
    | "INTEGER"
    | "DECIMAL"
    | "BOOLEAN"
    | "SINGLE_SELECT"
    | "MULTI_SELECT"
    | "ADDRESS"
    | "NAME"
    | "PHONE"
    | "EMAIL"
    | "DATE_TIME"
    | "DATE"
    | "REFERENCE"
    | "TIMEZONE"
    | "LOCALE"
    | "FILE"
    | "IMAGE"
    | "LINK"
    | "WAVEFORM"
  )[];
  customBasePath?: string;
  customSupportedTypes?: (
    | "LABEL"
    | "PARAGRAPH"
    | "INTEGER"
    | "DECIMAL"
    | "BOOLEAN"
    | "SINGLE_SELECT"
    | "MULTI_SELECT"
    | "ADDRESS"
    | "NAME"
    | "PHONE"
    | "EMAIL"
    | "DATE_TIME"
    | "DATE"
    | "REFERENCE"
    | "TIMEZONE"
    | "LOCALE"
    | "FILE"
    | "IMAGE"
    | "LINK"
    | "WAVEFORM"
  )[];
  displayName: string;
  supportMandatoryValidation?: boolean;
};
export type Category = {
  name: string;
  displayName: string;
};
export type EntityTypeBuiltInAction = {
  name: string;
  basePath?: string;
  category?: Category;
  displayName?: string;
  enableLog?: boolean;
  enableNotification?: boolean;
  source?: string;
  timeoutInSeconds?: number;
};
export type NumericMetaData = {
  lowerRange?: number;
  subType?: "INTEGER" | "DECIMAL";
  units?: string;
  upperRange?: number;
};
export type ReferenceConfiguration = {
  entityType: string;
  referencedSideAttributeDisplayName?: string;
  referencedSideAttributeName?: string;
  uniquely?: boolean;
  validTemplatesToReference?: string[];
};
export type BaseSelectableValue = {
  name: string;
  displayName: string;
};
export type ValidationDefinitionObject = {
  defaultValue?: object;
  mandatory: boolean;
  max?: number;
  min?: number;
  regex?: string;
};
export type ValidationDefinitionMetadataObject = {
  mandatoryReadOnly?: boolean;
  phiReadOnly?: boolean;
  systemMandatory?: boolean;
};
export type EntityTypeBuiltInAttribute = {
  name: string;
  type?:
    | "LABEL"
    | "PARAGRAPH"
    | "INTEGER"
    | "DECIMAL"
    | "BOOLEAN"
    | "SINGLE_SELECT"
    | "MULTI_SELECT"
    | "ADDRESS"
    | "NAME"
    | "PHONE"
    | "EMAIL"
    | "DATE_TIME"
    | "DATE"
    | "REFERENCE"
    | "TIMEZONE"
    | "LOCALE"
    | "FILE"
    | "IMAGE"
    | "LINK"
    | "WAVEFORM";
  basePath?: string;
  category?: Category;
  displayName?: string;
  numericMetaData?: NumericMetaData;
  phi?: boolean;
  readOnly?: boolean;
  referenceConfiguration?: ReferenceConfiguration;
  selectableValues?: BaseSelectableValue[];
  typeEnum?:
    | "LABEL"
    | "PARAGRAPH"
    | "INTEGER"
    | "DECIMAL"
    | "BOOLEAN"
    | "SINGLE_SELECT"
    | "MULTI_SELECT"
    | "ADDRESS"
    | "NAME"
    | "PHONE"
    | "EMAIL"
    | "DATE_TIME"
    | "DATE"
    | "REFERENCE"
    | "TIMEZONE"
    | "LOCALE"
    | "FILE"
    | "IMAGE"
    | "LINK"
    | "WAVEFORM";
  validation?: ValidationDefinitionObject;
  validationMetadata?: ValidationDefinitionMetadataObject;
};
export type AttributeIdentifier = {
  name: string;
  basePath?: string;
};
export type SelectedOrganization = {
  id: string;
};
export type OrganizationSelectionConfiguration = {
  all?: boolean;
  selected?: SelectedOrganization[];
};
export type OrganizationSelection = {
  allowed?: boolean;
  configuration?: OrganizationSelectionConfiguration;
};
export type EntityTypeTemplateAttribute = {
  name: string;
  type:
    | "LABEL"
    | "PARAGRAPH"
    | "INTEGER"
    | "DECIMAL"
    | "BOOLEAN"
    | "SINGLE_SELECT"
    | "MULTI_SELECT"
    | "ADDRESS"
    | "NAME"
    | "PHONE"
    | "EMAIL"
    | "DATE_TIME"
    | "DATE"
    | "REFERENCE"
    | "TIMEZONE"
    | "LOCALE"
    | "FILE"
    | "IMAGE"
    | "LINK"
    | "WAVEFORM";
  basePath?: string;
  category: Category;
  displayName: string;
  numericMetaData?: NumericMetaData;
  organizationSelection?: OrganizationSelection;
  phi?: boolean;
  referenceConfiguration?: ReferenceConfiguration;
  selectableValues?: BaseSelectableValue[];
  typeEnum?:
    | "LABEL"
    | "PARAGRAPH"
    | "INTEGER"
    | "DECIMAL"
    | "BOOLEAN"
    | "SINGLE_SELECT"
    | "MULTI_SELECT"
    | "ADDRESS"
    | "NAME"
    | "PHONE"
    | "EMAIL"
    | "DATE_TIME"
    | "DATE"
    | "REFERENCE"
    | "TIMEZONE"
    | "LOCALE"
    | "FILE"
    | "IMAGE"
    | "LINK"
    | "WAVEFORM";
  validation: ValidationDefinitionObject;
  value: object;
};
export type EntityType = {
  name: string;
  addingCustomAttributeReferenceTypeSupported?: boolean;
  addingTemplatesSupported?: boolean;
  attributeCategories?: GetCategoryResponse[];
  builtInActions?: EntityTypeBuiltInAction[];
  builtInAttributes?: EntityTypeBuiltInAttribute[];
  captionAttributes?: AttributeIdentifier[];
  children?: EntityType[];
  displayName: string;
  parentTemplateType?: string;
  reservedTemplateNames?: string[];
  templateAttributes?: EntityTypeTemplateAttribute[];
};
export type GetEntityTypesResponse = {
  entityTypes?: EntityType[];
};
export type EntityNotifiableAction = {
  actionDisplayName: string;
  actionName: string;
  entityDisplayName: string;
  entityName: string;
};
export type GetNotifiableActions = {
  entityTypes?: EntityNotifiableAction[];
};
export type InterceptionConfigurationResponse = {
  apiId?: string;
  entityTypeName: string;
  servicePrefix: string;
};
export type SearchResponseInterceptionConfigurationResponse = {
  /** List of items that match the search request */
  data: InterceptionConfigurationResponse[];
  metadata: Metadata;
};
export type BaseLocale = {
  /** Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase. */
  code: string;
  hidden?: boolean;
  /** Valid array values: DEFAULT_LOCALE,SYSTEM_LOCALE. Allow to control the fallback mechanism. If not provided(null) then the default behavior is the following fallback order: -> DEFAULT_LOCALE -> SYSTEM_LOCALE. The recommended value is null. When all of the fallback types return an empty value, no translation will be made, i.e. the original value will be retained */
  translationFallbackTypes?: ("DEFAULT_LOCALE" | "SYSTEM_LOCALE")[];
};
export type LocalesResponse = {
  availableLocales?: BaseLocale[];
  /** Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase. */
  defaultLocaleCode?: string;
  systemLocaleCode?: string;
};
export type AddLocaleRequest = {
  /** Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase. */
  code: string;
  hidden?: boolean;
  /** Valid array values: DEFAULT_LOCALE,SYSTEM_LOCALE. Allow to control the fallback mechanism. If not provided(null) then the default behavior is the following fallback order: -> DEFAULT_LOCALE -> SYSTEM_LOCALE. The recommended value is null. When all of the fallback types return an empty value, no translation will be made, i.e. the original value will be retained */
  translationFallbackTypes?: ("DEFAULT_LOCALE" | "SYSTEM_LOCALE")[];
};
export type UpdateLocalesRequest = {
  availableLocales?: BaseLocale[];
  /** Locale in the following format: {language-ISO639}-{countryCode-ISO3166} lowercase. */
  defaultLocaleCode?: string;
};
export type BackupResponse = {
  /** The name of the backup, it will also be the folder in which the backup is saved */
  name: string;
  /** The description of the backup */
  description?: string;
  /** The biot version of the backup */
  backupVersion: string;
  /** The build number of the backup/restore job in the pipeline */
  buildNumber: number;
  /** A UTC date-time in the ISO-8601 format */
  creationTime: string;
  /** An error thrown in the backup/restore process */
  errorMessage?: string;
  /** A UTC date-time in the ISO-8601 format */
  lastModifiedTime: string;
  /** The status of the backup */
  status: string;
};
export type BackupRequest = {
  /** The name of the backup, it will also be the folder in which the backup is saved */
  name: string;
  /** The description of the backup */
  description?: string;
};
export type SearchResponseBackupResponse = {
  /** List of items that match the search request */
  data: BackupResponse[];
  metadata: Metadata;
};
export type SystemPropertiesResponse = {
  /** System's main version */
  biotVersion?: string;
};
export type PrimaryAdministrator = {
  /** An email address in the RFC-5322 specification */
  email: string;
  /** A person's first name */
  firstName: string;
  /** A person's last name */
  lastName: string;
  /** A password */
  password: string;
};
export type ResetSystemRequest = {
  primaryAdministrator: PrimaryAdministrator;
};
export type RestoreResponse = {
  /** The name of the backup, it will also be the folder in which the backup is saved */
  name: string;
  /** The biot version of the backup */
  backupVersion: string;
  /** The build number of the backup/restore job in the pipeline */
  buildNumber: number;
  /** A UTC date-time in the ISO-8601 format */
  creationTime: string;
  /** An error thrown in the backup/restore process */
  errorMessage?: string;
  /** A UTC date-time in the ISO-8601 format */
  lastModifiedTime: string;
  /** The status of the restore */
  status: string;
};
export type SearchResponseRestoreResponse = {
  /** List of items that match the search request */
  data: RestoreResponse[];
  metadata: Metadata;
};
export type LinkConfiguration = {
  attributeId: string;
  entityTypeName: string;
  templateId: string;
};
export type BuiltInAttribute = {
  name: string;
  type?:
    | "LABEL"
    | "PARAGRAPH"
    | "INTEGER"
    | "DECIMAL"
    | "BOOLEAN"
    | "SINGLE_SELECT"
    | "MULTI_SELECT"
    | "ADDRESS"
    | "NAME"
    | "PHONE"
    | "EMAIL"
    | "DATE_TIME"
    | "DATE"
    | "REFERENCE"
    | "TIMEZONE"
    | "LOCALE"
    | "FILE"
    | "IMAGE"
    | "LINK"
    | "WAVEFORM";
  basePath?: string;
  category?: Category;
  displayName: string;
  id?: string;
  linkConfiguration?: LinkConfiguration;
  numericMetaData?: NumericMetaData;
  phi?: boolean;
  readOnly?: boolean;
  referenceConfiguration?: ReferenceConfiguration;
  selectableValues?: BaseSelectableValue[];
  typeEnum?:
    | "LABEL"
    | "PARAGRAPH"
    | "INTEGER"
    | "DECIMAL"
    | "BOOLEAN"
    | "SINGLE_SELECT"
    | "MULTI_SELECT"
    | "ADDRESS"
    | "NAME"
    | "PHONE"
    | "EMAIL"
    | "DATE_TIME"
    | "DATE"
    | "REFERENCE"
    | "TIMEZONE"
    | "LOCALE"
    | "FILE"
    | "IMAGE"
    | "LINK"
    | "WAVEFORM";
  validation?: ValidationDefinitionObject;
  validationMetadata?: ValidationDefinitionMetadataObject;
};
export type SelectableValue = {
  name: string;
  displayName: string;
  id?: string;
};
export type CustomAttribute = {
  name: string;
  type:
    | "LABEL"
    | "PARAGRAPH"
    | "INTEGER"
    | "DECIMAL"
    | "BOOLEAN"
    | "SINGLE_SELECT"
    | "MULTI_SELECT"
    | "ADDRESS"
    | "NAME"
    | "PHONE"
    | "EMAIL"
    | "DATE_TIME"
    | "DATE"
    | "REFERENCE"
    | "TIMEZONE"
    | "LOCALE"
    | "FILE"
    | "IMAGE"
    | "LINK"
    | "WAVEFORM";
  basePath?: string;
  category: Category;
  displayName: string;
  id: string;
  linkConfiguration?: LinkConfiguration;
  numericMetaData?: NumericMetaData;
  phi?: boolean;
  referenceConfiguration?: ReferenceConfiguration;
  selectableValues?: SelectableValue[];
  typeEnum?:
    | "LABEL"
    | "PARAGRAPH"
    | "INTEGER"
    | "DECIMAL"
    | "BOOLEAN"
    | "SINGLE_SELECT"
    | "MULTI_SELECT"
    | "ADDRESS"
    | "NAME"
    | "PHONE"
    | "EMAIL"
    | "DATE_TIME"
    | "DATE"
    | "REFERENCE"
    | "TIMEZONE"
    | "LOCALE"
    | "FILE"
    | "IMAGE"
    | "LINK"
    | "WAVEFORM";
  validation?: ValidationDefinitionObject;
};
export type SettingsParentTemplateResponse = {
  name?: string;
  displayName?: string;
  id?: string;
};
export type TemplateAttribute = {
  name: string;
  type?:
    | "LABEL"
    | "PARAGRAPH"
    | "INTEGER"
    | "DECIMAL"
    | "BOOLEAN"
    | "SINGLE_SELECT"
    | "MULTI_SELECT"
    | "ADDRESS"
    | "NAME"
    | "PHONE"
    | "EMAIL"
    | "DATE_TIME"
    | "DATE"
    | "REFERENCE"
    | "TIMEZONE"
    | "LOCALE"
    | "FILE"
    | "IMAGE"
    | "LINK"
    | "WAVEFORM";
  basePath?: string;
  category?: Category;
  displayName: string;
  id?: string;
  linkConfiguration?: LinkConfiguration;
  numericMetaData?: NumericMetaData;
  organizationSelection?: OrganizationSelection;
  phi?: boolean;
  referenceConfiguration?: ReferenceConfiguration;
  selectableValues?: BaseSelectableValue[];
  typeEnum?:
    | "LABEL"
    | "PARAGRAPH"
    | "INTEGER"
    | "DECIMAL"
    | "BOOLEAN"
    | "SINGLE_SELECT"
    | "MULTI_SELECT"
    | "ADDRESS"
    | "NAME"
    | "PHONE"
    | "EMAIL"
    | "DATE_TIME"
    | "DATE"
    | "REFERENCE"
    | "TIMEZONE"
    | "LOCALE"
    | "FILE"
    | "IMAGE"
    | "LINK"
    | "WAVEFORM";
  validation?: ValidationDefinitionObject;
  value?: object;
};
export type GetTemplateResponse = {
  name: string;
  description?: string;
  builtInAttributes?: BuiltInAttribute[];
  /** A UTC date-time in the ISO-8601 format */
  creationTime: string;
  customAttributes?: CustomAttribute[];
  displayName: string;
  entityTypeName?: string;
  id?: string;
  /** A UTC date-time in the ISO-8601 format */
  lastModifiedTime: string;
  ownerOrganizationId?: string;
  parentTemplate?: SettingsParentTemplateResponse;
  parentTemplateId?: string;
  removable?: boolean;
  templateAttributes?: TemplateAttribute[];
};
export type SearchResponseGetTemplateResponse = {
  /** List of items that match the search request */
  data: GetTemplateResponse[];
  metadata: Metadata;
};
export type CreateBuiltInAttribute = {
  name: string;
  basePath?: string;
  displayName: string;
  linkConfiguration?: LinkConfiguration;
  numericMetaData?: NumericMetaData;
  phi?: boolean;
  referenceConfiguration?: ReferenceConfiguration;
  validation?: ValidationDefinitionObject;
};
export type CreateCustomAttribute = {
  name: string;
  type:
    | "LABEL"
    | "PARAGRAPH"
    | "INTEGER"
    | "DECIMAL"
    | "BOOLEAN"
    | "SINGLE_SELECT"
    | "MULTI_SELECT"
    | "ADDRESS"
    | "NAME"
    | "PHONE"
    | "EMAIL"
    | "DATE_TIME"
    | "DATE"
    | "REFERENCE"
    | "TIMEZONE"
    | "LOCALE"
    | "FILE"
    | "IMAGE"
    | "LINK"
    | "WAVEFORM";
  category: string;
  displayName: string;
  linkConfiguration?: LinkConfiguration;
  numericMetaData?: NumericMetaData;
  phi?: boolean;
  referenceConfiguration?: ReferenceConfiguration;
  selectableValues?: BaseSelectableValue[];
  validation?: ValidationDefinitionObject;
};
export type CreateTemplateAttribute = {
  name: string;
  basePath?: string;
  displayName: string;
  linkConfiguration?: LinkConfiguration;
  organizationSelectionConfiguration?: OrganizationSelectionConfiguration;
  phi?: boolean;
  referenceConfiguration?: ReferenceConfiguration;
  value?: object;
};
export type CreateTemplateRequest = {
  name: string;
  description?: string;
  builtInAttributes?: CreateBuiltInAttribute[];
  customAttributes?: CreateCustomAttribute[];
  displayName: string;
  entityType: string;
  ownerOrganizationId?: string;
  parentTemplateId?: string;
  templateAttributes?: CreateTemplateAttribute[];
};
export type UpdateBuiltInAttribute = {
  displayName: string;
  id: string;
  linkConfiguration?: LinkConfiguration;
  numericMetaData?: NumericMetaData;
  phi?: boolean;
  referenceConfiguration?: ReferenceConfiguration;
  validation?: ValidationDefinitionObject;
};
export type UpdateCustomAttribute = {
  name: string;
  type:
    | "LABEL"
    | "PARAGRAPH"
    | "INTEGER"
    | "DECIMAL"
    | "BOOLEAN"
    | "SINGLE_SELECT"
    | "MULTI_SELECT"
    | "ADDRESS"
    | "NAME"
    | "PHONE"
    | "EMAIL"
    | "DATE_TIME"
    | "DATE"
    | "REFERENCE"
    | "TIMEZONE"
    | "LOCALE"
    | "FILE"
    | "IMAGE"
    | "LINK"
    | "WAVEFORM";
  category: string;
  displayName: string;
  id?: string;
  linkConfiguration?: LinkConfiguration;
  numericMetaData?: NumericMetaData;
  phi?: boolean;
  referenceConfiguration?: ReferenceConfiguration;
  selectableValues?: SelectableValue[];
  validation?: ValidationDefinitionObject;
};
export type UpdateTemplateAttribute = {
  displayName: string;
  id: string;
  linkConfiguration?: LinkConfiguration;
  organizationSelectionConfiguration?: OrganizationSelectionConfiguration;
  phi?: boolean;
  referenceConfiguration?: ReferenceConfiguration;
  value?: object;
};
export type UpdateTemplateRequest = {
  name: string;
  description?: string;
  builtInAttributes?: UpdateBuiltInAttribute[];
  customAttributes?: UpdateCustomAttribute[];
  displayName: string;
  forceUpdate?: boolean;
  ownerOrganizationId?: string;
  parentTemplateId?: string;
  templateAttributes?: UpdateTemplateAttribute[];
};
export type SettingsBasicTemplateData = {
  name?: string;
  displayName?: string;
  entityTypeName?: string;
  id?: string;
};
export type BasicAttributeData = {
  name?: string;
  basePath?: string;
  displayName?: string;
  id?: string;
  referenceConfiguration?: ReferenceConfiguration;
  template?: SettingsBasicTemplateData;
};
export type TemplateStatistics = {
  entitiesCount?: number;
};
export type TemplateOverviewResponse = {
  referencedByAttributes?: BasicAttributeData[];
  statistics?: TemplateStatistics;
};
export type TemplateMinimizedResponse = {
  name: string;
  description?: string;
  /** A UTC date-time in the ISO-8601 format */
  creationTime: string;
  displayName: string;
  entityTypeName?: string;
  id?: string;
  /** A UTC date-time in the ISO-8601 format */
  lastModifiedTime: string;
  ownerOrganizationId?: string;
  parentTemplate?: SettingsParentTemplateResponse;
  parentTemplateId?: string;
  removable?: boolean;
};
export type SearchResponseTemplateMinimizedResponse = {
  /** List of items that match the search request */
  data: TemplateMinimizedResponse[];
  metadata: Metadata;
};
export type InvalidTranslation = {
  error?: string;
  translationKey?: string;
};
export type UpdateLocaleTranslationsResponse = {
  invalidTranslations?: InvalidTranslation[];
};
export type ValidateLocaleTranslationsResponse = {
  invalidTranslations?: InvalidTranslation[];
};
export type LocaleTranslationsCoverage = {
  numberOfAvailableKeys?: number;
  numberOfTranslatedKeys?: number;
};
export type LocaleTranslationsOverview = {
  coverage?: LocaleTranslationsCoverage;
  lastTranslationTime?: string;
  locale?: string;
};
export type SearchResponseLocaleTranslationsOverview = {
  /** List of items that match the search request */
  data: LocaleTranslationsOverview[];
  metadata: Metadata;
};
export type SearchResponseEntityType = {
  /** List of items that match the search request */
  data: EntityType[];
  metadata: Metadata;
};
export type InterceptionSubscriptionDto = {
  /** The type of interception to create for this plugin */
  type: "PRE_REQUEST" | "POST_REQUEST" | "ADAPT_ENTITY";
  /** The id of the api for which to create the interception. Check interception configuration API for supported values */
  apiId?: string;
  /** The entity for which to create the interception. Check interception configuration API for supported values */
  entityTypeName?: string;
  /** An order to override for this specific interception. Must be a positive number */
  order?: number;
};
export type NotificationSubscriptionDto = {
  /** The action for which to create the notification. Check get all notifiable actions API for supported values */
  actionName: string;
  /** The entity for which to create the notification. Check get all notifiable actions API for supported values */
  entityTypeName: string;
};
export type SubscriptionDto = {
  /** The order in which the all interceptions for this plugin will be run in their respective apis. This can be overridden in each interception's data. Must be a positive number. Default is 1 */
  interceptionOrder: number;
  interceptions: InterceptionSubscriptionDto[];
  notifications: NotificationSubscriptionDto[];
};
export type PluginResponse = {
  /** The plugin's name, the prefix 'Plugin-' will be prepended to it */
  name: string;
  /** If code is updated this number must be changed, and be larger than the previous number. Note, for zip deployment package type a code is considered to be updated if you provided a file for the code parameter, but for image deployment package type a code is considered to be updated if the imageTag field was provided (the server will not check if the imageTag is the same as the current imageTag that this plugin is using, so you can just not providing this field if you didn't change anything, in order not to be forced to increment the version field) */
  version: number;
  /** Flag that if true allows direct Analytics DB access from the plugin. */
  analyticsDbAccess: boolean;
  /** A UTC date-time in the ISO-8601 format */
  creationTime: string;
  /** A six field cron expression separated with whitespaces, for fields: minutes,hours,day-of-month,month,day-of-week,year. Further details in https://docs.aws.amazon.com/eventbridge/latest/userguide/eb-cron-expressions.html */
  cronSchedule?: string;
  /** The deployment package type of the plugin. Cannot be changed after the creation. The default is ZIP. */
  deploymentPackageType: "ZIP" | "IMAGE";
  /** The plugins display name, it will be added to as the value of environment variable BIOT_APP_NAME */
  displayName: string;
  /** The activation state of the plugin. The default is ENABLED */
  enabledState: "DISABLED" | "ENABLED";
  /** The URL from which the plugin is accessible */
  endpointUrl: string;
  environmentVariables: {
    [key: string]: string;
  };
  /** Relevant only for deploymentPackageType = ZIP(mandatory), it will be ignored for IMAGE type. The entry point to the plugin, E.g. 'index.handler' means method 'handler' in file 'index' on the root of the plugin. The default is index.handler */
  handler?: string;
  /** A UTC date-time in the ISO-8601 format */
  lastModifiedTime: string;
  /** A link to the cloud providers console */
  linkToConsole: string;
  /** The max amount of memory in MB that the plugin will have. The default is 128 */
  memorySize: number;
  /** For deploymentPackageType = ZIP this field is mandatory, and for deploymentPackageType = IMAGE it's mandatory if imageTag was not provided, otherwise it will be ignored. The runtime that the plugin will run on. Only certain values are supported and only certain values are supported without sending a code file/imageTag, check the documentation for specifics. */
  runtime?: string;
  subscriptions: SubscriptionDto;
  /** The max time in seconds that the plugin may run, after which it will be aborted. The default is 3 */
  timeout: number;
};
export type SearchResponsePluginResponse = {
  /** List of items that match the search request */
  data: PluginResponse[];
  metadata: Metadata;
};
export type CreatePluginRequest = {
  /** The plugin's name, the prefix 'Plugin-' will be prepended to it */
  name: string;
  /** If code is updated this number must be changed, and be larger than the previous number. Note, for zip deployment package type a code is considered to be updated if you provided a file for the code parameter, but for image deployment package type a code is considered to be updated if the imageTag field was provided (the server will not check if the imageTag is the same as the current imageTag that this plugin is using, so you can just not providing this field if you didn't change anything, in order not to be forced to increment the version field) */
  version: number;
  /** Flag that if true allows direct Analytics DB access from the plugin. */
  analyticsDbAccess: boolean;
  /** A six field cron expression separated with whitespaces, for fields: minutes,hours,day-of-month,month,day-of-week,year. Further details in https://docs.aws.amazon.com/eventbridge/latest/userguide/eb-cron-expressions.html */
  cronSchedule?: string;
  /** The deployment package type of the plugin. Cannot be changed after the creation. The default is ZIP. */
  deploymentPackageType: "ZIP" | "IMAGE";
  /** The plugins display name, it will be added to as the value of environment variable BIOT_APP_NAME */
  displayName: string;
  /** The activation state of the plugin. The default is ENABLED */
  enabledState: "DISABLED" | "ENABLED";
  environmentVariables: {
    [key: string]: string;
  };
  /** Relevant only for deploymentPackageType = ZIP(mandatory), it will be ignored for IMAGE type. The entry point to the plugin, E.g. 'index.handler' means method 'handler' in file 'index' on the root of the plugin. The default is index.handler */
  handler?: string;
  /** Relevant only for deploymentPackageType = IMAGE. Specify the tag you used when you uploaded the image using the docker push command. After being attach to the plugin, the image will be managed by the server */
  imageTag?: string;
  /** The max amount of memory in MB that the plugin will have. The default is 128 */
  memorySize: number;
  /** For deploymentPackageType = ZIP this field is mandatory, and for deploymentPackageType = IMAGE it's mandatory if imageTag was not provided, otherwise it will be ignored. The runtime that the plugin will run on. Only certain values are supported and only certain values are supported without sending a code file/imageTag, check the documentation for specifics. */
  runtime?: string;
  subscriptions: SubscriptionDto;
  /** The max time in seconds that the plugin may run, after which it will be aborted. The default is 3 */
  timeout: number;
};
export type PartialUpdateSubscriptionDto = {
  /** The order in which the all interceptions for this plugin will be run in their respective apis. This can be overridden in each interception's data. Must be a positive number. Default is 1 */
  interceptionOrder: number;
  interceptions: InterceptionSubscriptionDto[];
  notifications: NotificationSubscriptionDto[];
};
export type PartialUpdatePluginRequest = {
  /** If code is updated this number must be changed, and be larger than the previous number. Note, for zip deployment package type a code is considered to be updated if you provided a file for the code parameter, but for image deployment package type a code is considered to be updated if the imageTag field was provided (the server will not check if the imageTag is the same as the current imageTag that this plugin is using, so you can just not providing this field if you didn't change anything, in order not to be forced to increment the version field) */
  version: number;
  /** Flag that if true allows direct Analytics DB access from the plugin. */
  analyticsDbAccess: boolean;
  /** A six field cron expression separated with whitespaces, for fields: minutes,hours,day-of-month,month,day-of-week,year. Further details in https://docs.aws.amazon.com/eventbridge/latest/userguide/eb-cron-expressions.html */
  cronSchedule?: string;
  /** The plugins display name, it will be added to as the value of environment variable BIOT_APP_NAME */
  displayName: string;
  /** The activation state of the plugin. The default is ENABLED */
  enabledState: "DISABLED" | "ENABLED";
  environmentVariables: {
    [key: string]: object;
  };
  /** Relevant only for deploymentPackageType = ZIP(mandatory), it will be ignored for IMAGE type. The entry point to the plugin, E.g. 'index.handler' means method 'handler' in file 'index' on the root of the plugin. The default is index.handler */
  handler: string;
  /** Relevant only for deploymentPackageType = IMAGE. Specify the tag you used when you uploaded the image using the docker push command. After being attach to the plugin, the image will be managed by the server */
  imageTag: string;
  /** The max amount of memory in MB that the plugin will have. The default is 128 */
  memorySize: number;
  /** For deploymentPackageType = ZIP this field is mandatory, and for deploymentPackageType = IMAGE it's mandatory if imageTag was not provided, otherwise it will be ignored. The runtime that the plugin will run on. Only certain values are supported and only certain values are supported without sending a code file/imageTag, check the documentation for specifics. */
  runtime: string;
  subscriptions: PartialUpdateSubscriptionDto;
  /** The max time in seconds that the plugin may run, after which it will be aborted. The default is 3 */
  timeout: number;
};
export type DockerRepositoryTempCredentialsResponse = {
  credentials?: Credentials;
  region?: string;
  repositoryUri?: string;
};
export type GetPublicKeyResponse = {
  publicKey?: string;
};
export type TemporaryMqttCredentialsResponse = {
  credentials?: Credentials;
  endpoint?: string;
  region?: string;
  topic?: string;
};
export type SecretKeyData = {
  creationTime?: string;
  id?: string;
};
export type GetServiceUserV2Response = {
  name?: string;
  type: "INTERNAL_SERVICE" | "EXTERNAL_SERVICE";
  accessTokenExpirationInMinutes?: number;
  active?: boolean;
  id?: string;
  /** A UUID formatted string */
  ownerOrganizationId?: string;
  /** A UUID formatted string */
  roleId: string;
  secretKeys?: SecretKeyData[];
};
export type SearchResponseGetServiceUserV2Response = {
  /** List of items that match the search request */
  data: GetServiceUserV2Response[];
  metadata: Metadata;
};
export type CreateSecretKeyResponse = {
  creationTime?: string;
  id?: string;
  secretKey?: string;
};
export type CreateServiceUserResponse = {
  name?: string;
  type: "INTERNAL_SERVICE" | "EXTERNAL_SERVICE";
  accessTokenExpirationInMinutes?: number;
  active?: boolean;
  id?: string;
  /** A UUID formatted string */
  ownerOrganizationId?: string;
  /** A UUID formatted string */
  roleId: string;
  secretKeyData?: CreateSecretKeyResponse;
};
export type CreateServiceUserRequest = {
  name?: string;
  type: "INTERNAL_SERVICE" | "EXTERNAL_SERVICE";
  accessTokenExpirationInMinutes?: number;
  active?: boolean;
  /** A UUID formatted string */
  ownerOrganizationId?: string;
  /** A UUID formatted string */
  roleId: string;
};
export type UpdateServiceUserV2Response = {
  name?: string;
  type: "INTERNAL_SERVICE" | "EXTERNAL_SERVICE";
  accessTokenExpirationInMinutes?: number;
  active?: boolean;
  id?: string;
  /** A UUID formatted string */
  ownerOrganizationId?: string;
  /** A UUID formatted string */
  roleId: string;
  secretKeys?: SecretKeyData[];
};
export type UpdateServiceUserV2Request = {
  active?: boolean;
  /** A UUID formatted string */
  roleId?: string;
};
export type ServiceUserAccessTokenResponse = {
  accessToken?: string;
  accessTokenExpiration?: string;
};
export type ServiceUserAccessTokenRequest = {
  /** A UUID formatted string */
  id: string;
  secretKey: string;
};
export type GroupObject = {
  name?: string;
  id?: string;
};
export type Mfa = {
  enabled: boolean;
  expirationInMinutes?: number;
  /** An E.164 formatted phone number */
  phone: string;
};
export type UmsUserResponse = {
  active?: boolean;
  credentialType?: "PASSWORD" | "OTP";
  groups?: GroupObject[];
  id?: string;
  locked?: boolean;
  loginTimestamp?: string;
  mfa?: Mfa;
  ownerOrganizationId?: string;
  userIdPs?: "UMS"[];
  /** user's username. If the credential type is OTP, should be a valid phone (An E.164 formatted phone number e.g +12345678901) */
  username: string;
};
export type SearchResponseUserResponse = {
  /** List of items that match the search request */
  data: UmsUserResponse[];
  metadata: Metadata;
};
export type UpdateUserRequest = {
  active?: boolean;
  groupIds?: string[];
  idPs?: "UMS"[];
  locked?: boolean;
  mfa?: Mfa;
  /** user's username. If the credential type is OTP, should be a valid phone (An E.164 formatted phone number e.g +12345678901) */
  username?: string;
};
export type GenerateUserPasswordResponse = {
  userId?: string;
  userPassword?: string;
};
export type PasswordStrengthResponse = {
  /** The score of the password. minimum score of 0 and maximum score of 4. Higher number means stronger password */
  score?: number;
  /** A possibly-empty list of suggestions to help choose a less guessable password. eg. 'Add another word or two' */
  suggestions?: string;
  /** Explains what's wrong, eg. 'this is a top-10 common password'. not always set -- sometimes an empty string */
  warningMessage?: string;
};
export type ValidateUserCredentialsResponse = {
  code?: string;
  message?: string;
  passwordStrength?: PasswordStrengthResponse;
  success?: boolean;
};
export type ValidateUserCredentialsRequest = {
  credentialType?: "PASSWORD" | "OTP";
  password: string;
  /** user's username. If the credential type is OTP, should be a valid phone (An E.164 formatted phone number e.g +12345678901) */
  username?: string;
};
export type JwtToken = {
  expiration: string;
  token: string;
};
export type LoginResponse = {
  accessJwt: JwtToken;
  mfaExpiration?: string;
  mfaRequired?: boolean;
  ownerOrganizationId?: string;
  passwordResetRequired?: boolean;
  phone?: string;
  refreshJwt?: JwtToken;
  userId?: string;
};
export type LoginRequestV2 = {
  password?: string;
  username: string;
};
export type MfaLoginRequestV2 = {
  code?: string;
};
export type ResendMfaResponse = {
  mfaExpiration?: string;
};
export type LogoutRequest = {
  refreshToken: string;
};
export type GenerateOtpResponse = {
  /** A masked phone number */
  phone?: string;
  /** It should be used in the OTP login API along with the code sent to your phone */
  requestId?: string;
};
export type GenerateOtpRequest = {
  /** An E.164 formatted phone number */
  phone: string;
};
export type OtpLoginRequest = {
  /** The code you received in the SMS sent to you when calling to the /otp/generate API */
  code: string;
  /** The request id you received when calling to the generate otp login code API */
  requestId: string;
};
export type Password = {
  current: string;
  new: string;
};
export type SelfUpdateUserRequest = {
  mfa?: Mfa;
  password?: Password;
};
export type SelfRegisterUserRequest = {
  credentialType?: "PASSWORD" | "OTP";
  idPs?: "UMS"[];
  password: string;
  /** user's username. If the credential type is OTP, should be a valid phone (An E.164 formatted phone number e.g +12345678901) */
  username: string;
};
export type ForgotPasswordRequestV2 = {
  username: string;
};
export type LoginWithTokenRequest = {
  refreshToken: string;
};
export type RefreshTokenRequest = {
  refreshToken: string;
};
export const {
  useFacadehealthCheckQuery,
  useAssignDeviceMutation,
  usePatientSelfSignUpMutation,
  usePatientAnonymousSelfSignUpMutation,
  useHealthCheckQuery,
  useCreateAlertMutation,
  useDeleteAlertMutation,
  useGetAlertQuery,
  useUpdateAlertMutation,
  useCreateAlertByTemplateNameMutation,
  useDeleteCommandMutation,
  useGetCommandQuery,
  useStopCommandMutation,
  useStartCommandByTemplateNameMutation,
  useStartCommandMutation,
  useCreateSessionMutation,
  useDeleteSessionMutation,
  useGetSessionQuery,
  useUpdateSessionMutation,
  usePauseSessionMutation,
  useResumeSessionMutation,
  useStopSessionMutation,
  useStartSessionMutation,
  useCreateSessionByUsageTypeMutation,
  useSearchAlertsQuery,
  useSearchCommandsQuery,
  useSearchCurrentAlertsQuery,
  useSearchDeviceSessionsQuery,
  useSearchSessionsQuery,
  useDeleteOrphanSessionsMutation,
  useGetEndPointQuery,
  useValidateTokenOperationQuery,
  useExecuteTokenOperationMutation,
  useExecuteTokenOperationGetQuery,
  useGetTempCredentialsForOrganizationClientQuery,
  useSearchDevicesQuery,
  useRegisterDeviceMutation,
  useDeleteDeviceMutation,
  useGetDeviceQuery,
  useUpdateDeviceMutation,
  useDeleteCertificateMutation,
  useCreateCertificateMutation,
  useActivateCertificateMutation,
  useGetConnectionDetailsQuery,
  useGetTempCredentialsForDeviceQuery,
  useRegisterDeviceWithTemplateNameMutation,
  useDispatcherhealthCheckQuery,
  useSearchInterceptionsQuery,
  useCreateInterceptionMutation,
  useDeleteInterceptionMutation,
  useSearchSubscriptionsQuery,
  useSubscribeMutation,
  useUnsubscribeMutation,
  useDmshealthCheckQuery,
  useGetAnalyticsDbConnectionDetailsQuery,
  useGetAnalyticsDbConnectionDetailsOldQuery,
  useGetAnalyticsDbInformationOldQuery,
  useStartAnalyticsDbInitializationOldMutation,
  useStopAnalyticsDbInitializationOldMutation,
  useGetAnalyticsDbStateQuery,
  useStartAnalyticsDbInitializationMutation,
  useStopAnalyticsDbInitializationMutation,
  useStopAnalyticsDbSynchronizationMutation,
  useStopAnalyticsDbSynchronizationOldMutation,
  useSearchReportsQuery,
  useDeleteReportMutation,
  useGetReportQuery,
  useCancelReportMutation,
  useCreateReportMutation,
  useDmsvalidateTokenOperationQuery,
  useDmsexecuteTokenOperationMutation,
  useDmsexecuteTokenOperationGetQuery,
  useEntityhealthCheckQuery,
  useFilehealthCheckQuery,
  useGetDownloadFileUrlQuery,
  useCreateUploadFileUrlMutation,
  useCreateMultiplePartUploadFileUrlMutation,
  useGenerateSignedUrlsForMultiplePartFileUploadMutation,
  useSaveETagsForMultiplePartFileUploadMutation,
  useCancelMultiplePartUploadFileMutation,
  useCompleteMultiplePartUploadFileMutation,
  useGetGenericEntitySystemHealthCheckQuery,
  useSearchGenericEntitiesQuery,
  useCreateGenericEntityMutation,
  useDeleteGenericEntityMutation,
  useGetGenericEntityQuery,
  useUpdateGenericEntityMutation,
  useCreateGenericEntityByTemplateNameMutation,
  useMeasurementhealthCheckQuery,
  useSaveMeasurementMutation,
  useGetMeasurementsQuery,
  useSaveMeasurementsBulkMutation,
  useGetRawMeasurementsQuery,
  useGetAggregatedMeasurementsQuery,
  useGetRawMeasurements2Query,
  useNotificationhealthCheckQuery,
  useAddAttachmentMutation,
  useGetConfigurationQuery,
  useSetConfigurationMutation,
  useGetSmsProviderConfigurationQuery,
  useSendEmailMutation,
  useSendSmsMutation,
  useOrganizationhealthCheckQuery,
  useResendInvitationMutation,
  useDeleteLandingPagesMutation,
  useGetLandingPagesQuery,
  useSetLandingPagesMutation,
  useSearchOrganizationsQuery,
  useCreateOrganizationMutation,
  useDeleteOrganizationMutation,
  useGetOrganizationQuery,
  useUpdateOrganizationMutation,
  useChangeOrganizationAdminMutation,
  useCreateOrganizationByTemplateNameMutation,
  useSearchRegistrationCodesQuery,
  useCreateRegistrationCodeMutation,
  useDeleteRegistrationCodeMutation,
  useGetRegistrationCodeQuery,
  useUpdateRegistrationCodeMutation,
  useCreateRegistrationCodeByTemplateNameMutation,
  useOrganizationvalidateTokenOperationQuery,
  useOrganizationexecuteTokenOperationMutation,
  useOrganizationexecuteTokenOperationGetQuery,
  useSearchCaregiversQuery,
  useCreateCaregiverMutation,
  useDeleteCaregiverMutation,
  useGetCaregiverQuery,
  useUpdateCaregiverMutation,
  useChangeCaregiverEnabledStateMutation,
  useGetCaregiverSelfQuery,
  useCreateCaregiverByTemplateNameMutation,
  useSearchOrganizationUsersQuery,
  useCreateOrganizationUserMutation,
  useDeleteOrganizationUserMutation,
  useGetOrganizationUserQuery,
  useUpdateOrganizationUserMutation,
  useChangeOrganizationUserEnabledStateMutation,
  useGetOrganizationUserSelfQuery,
  useCreateOrganizationUserByTemplateNameMutation,
  useSearchPatientsQuery,
  useCreatePatientMutation,
  useDeletePatientMutation,
  useGetPatientQuery,
  useUpdatePatientMutation,
  useChangePatientEnabledStateMutation,
  useOrganizationcreateAlertMutation,
  useOrganizationdeleteAlertMutation,
  useOrganizationgetAlertQuery,
  useOrganizationupdateAlertMutation,
  useOrganizationcreateAlertByTemplateNameMutation,
  useOrganizationsearchAlertsQuery,
  useOrganizationsearchCurrentAlertsQuery,
  useGetPatientSelfQuery,
  useSearchAvailableOrganizationsForSignUpQuery,
  useCreatePatientByTemplateNameMutation,
  useGetSelfQuery,
  useXxxQuery,
  useSettingshealthCheckQuery,
  useSearch3Query,
  useCreateCodeSnippetMutation,
  useDeleteCodeSnippetMutation,
  useGetCodeSnippetQuery,
  useGetLastExportExecutionQuery,
  useGetExportsMetadataQuery,
  useStartExportMutation,
  useGetLastImportExecutionQuery,
  useStartImportMutation,
  useGetEntityTypesQuery,
  useGetNotifiableActions1Query,
  useSearch2Query,
  useAddLocaleMutation,
  useDeleteLocaleMutation,
  useGetLocalesQuery,
  useUpdateLocalesMutation,
  useBackupMutation,
  useSearchBackupExecutionsQuery,
  useGetSystemPropertiesQuery,
  useResetSystemMutation,
  useSearchRestoreExecutionsQuery,
  useSearch1Query,
  useCreateTemplateMutation,
  useDeleteTemplateMutation,
  useGetTemplateQuery,
  useUpdateTemplateMutation,
  useGetTemplateOverviewQuery,
  useMinimalSearchQuery,
  useDeleteLocaleTranslationsMutation,
  useDownloadLocaleTranslationFileQuery,
  useUpdateLocaleTranslationsMutation,
  useValidateLocaleTranslationsMutation,
  useSearchLocaleTranslationOverviewsQuery,
  useSearchEntityTypesQuery,
  useGetNotifiableActionsQuery,
  useSearchQuery,
  useCreateMutation,
  useDeleteSettingsV2PluginsByNameMutation,
  useGetSettingsV2PluginsByNameQuery,
  usePartialUpdateMutation,
  useGetDockerRepositoryTempCredentialsQuery,
  useUmshealthCheckQuery,
  useGetPublicKeyQuery,
  useGetTempCredentialsForOrganizationQuery,
  useUmsvalidateTokenOperationQuery,
  useUmsexecuteTokenOperationMutation,
  useUmsexecuteTokenOperationGetQuery,
  useSearchServiceUsersQuery,
  useCreateServiceUserMutation,
  useDeleteServiceUserMutation,
  useGetServiceUserByIdQuery,
  useUpdateServiceUserMutation,
  useCreateSecretKeyMutation,
  useDeleteSecretKeyMutation,
  useServiceUserLoginMutation,
  useUmssearchQuery,
  useUmsdeleteMutation,
  useGetUserQuery,
  useUpdateUserMutation,
  useGenerateUserPasswordMutation,
  useValidateUserCredentialsMutation,
  useLoginMutation,
  useMfaLoginMutation,
  useMfaResendMutation,
  useLogoutMutation,
  useGenerateOtpMutation,
  useOtpLoginMutation,
  useSelfDeleteUserMutation,
  useSelfGetUserQuery,
  useSelfUpdateUserMutation,
  useSelfRegisterUserMutation,
  useForgotPasswordMutation,
  useTokenLoginMutation,
  useRefreshTokenMutation,
} = injectedRtkApi;
